var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames,
    i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty,
    o = (e, t) => () => (t || (e((t = {exports: {}}).exports, t), e = null), t.exports), s = (e, i, o, s) => {
        if (i && typeof i == `object` || typeof i == `function`) for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
            get: (e => i[e]).bind(null, d),
            enumerable: !(s = n(i, d)) || s.enumerable
        });
        return e
    }, c = (n, r, a) => (a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, `default`, {
        value: n,
        enumerable: !0
    }) : a, n));
(function () {
    let e = document.createElement(`link`).relList;
    if (e && e.supports && e.supports(`modulepreload`)) return;
    for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) n(e);
    new MutationObserver(e => {
        for (let t of e) if (t.type === `childList`) for (let e of t.addedNodes) e.tagName === `LINK` && e.rel === `modulepreload` && n(e)
    }).observe(document, {childList: !0, subtree: !0});

    function t(e) {
        let t = {};
        return e.integrity && (t.integrity = e.integrity), e.referrerPolicy && (t.referrerPolicy = e.referrerPolicy), e.crossOrigin === `use-credentials` ? t.credentials = `include` : e.crossOrigin === `anonymous` ? t.credentials = `omit` : t.credentials = `same-origin`, t
    }

    function n(e) {
        if (e.ep) return;
        e.ep = !0;
        let n = t(e);
        fetch(e.href, n)
    }
})();
var l = o((e => {
    var t = Symbol.for(`react.transitional.element`), n = Symbol.for(`react.portal`), r = Symbol.for(`react.fragment`),
        i = Symbol.for(`react.strict_mode`), a = Symbol.for(`react.profiler`), o = Symbol.for(`react.consumer`),
        s = Symbol.for(`react.context`), c = Symbol.for(`react.forward_ref`), l = Symbol.for(`react.suspense`),
        u = Symbol.for(`react.memo`), d = Symbol.for(`react.lazy`), f = Symbol.for(`react.activity`),
        p = Symbol.iterator;

    function m(e) {
        return typeof e != `object` || !e ? null : (e = p && e[p] || e[`@@iterator`], typeof e == `function` ? e : null)
    }

    var h = {
        isMounted: function () {
            return !1
        }, enqueueForceUpdate: function () {
        }, enqueueReplaceState: function () {
        }, enqueueSetState: function () {
        }
    }, g = Object.assign, _ = {};

    function v(e, t, n) {
        this.props = e, this.context = t, this.refs = _, this.updater = n || h
    }

    v.prototype.isReactComponent = {}, v.prototype.setState = function (e, t) {
        if (typeof e != `object` && typeof e != `function` && e != null) throw Error(`takes an object of state variables to update or a function which returns an object of state variables.`);
        this.updater.enqueueSetState(this, e, t, `setState`)
    }, v.prototype.forceUpdate = function (e) {
        this.updater.enqueueForceUpdate(this, e, `forceUpdate`)
    };

    function y() {
    }

    y.prototype = v.prototype;

    function b(e, t, n) {
        this.props = e, this.context = t, this.refs = _, this.updater = n || h
    }

    var x = b.prototype = new y;
    x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
    var S = Array.isArray;

    function C() {
    }

    var w = {H: null, A: null, T: null, S: null}, ee = Object.prototype.hasOwnProperty;

    function T(e, n, r) {
        var i = r.ref;
        return {$$typeof: t, type: e, key: n, ref: i === void 0 ? null : i, props: r}
    }

    function te(e, t) {
        return T(e.type, t, e.props)
    }

    function ne(e) {
        return typeof e == `object` && !!e && e.$$typeof === t
    }

    function re(e) {
        var t = {"=": `=0`, ":": `=2`};
        return `$` + e.replace(/[=:]/g, function (e) {
            return t[e]
        })
    }

    var ie = /\/+/g;

    function ae(e, t) {
        return typeof e == `object` && e && e.key != null ? re(`` + e.key) : t.toString(36)
    }

    function oe(e) {
        switch (e.status) {
            case`fulfilled`:
                return e.value;
            case`rejected`:
                throw e.reason;
            default:
                switch (typeof e.status == `string` ? e.then(C, C) : (e.status = `pending`, e.then(function (t) {
                    e.status === `pending` && (e.status = `fulfilled`, e.value = t)
                }, function (t) {
                    e.status === `pending` && (e.status = `rejected`, e.reason = t)
                })), e.status) {
                    case`fulfilled`:
                        return e.value;
                    case`rejected`:
                        throw e.reason
                }
        }
        throw e
    }

    function se(e, r, i, a, o) {
        var s = typeof e;
        (s === `undefined` || s === `boolean`) && (e = null);
        var c = !1;
        if (e === null) c = !0; else switch (s) {
            case`bigint`:
            case`string`:
            case`number`:
                c = !0;
                break;
            case`object`:
                switch (e.$$typeof) {
                    case t:
                    case n:
                        c = !0;
                        break;
                    case d:
                        return c = e._init, se(c(e._payload), r, i, a, o)
                }
        }
        if (c) return o = o(e), c = a === `` ? `.` + ae(e, 0) : a, S(o) ? (i = ``, c != null && (i = c.replace(ie, `$&/`) + `/`), se(o, r, i, ``, function (e) {
            return e
        })) : o != null && (ne(o) && (o = te(o, i + (o.key == null || e && e.key === o.key ? `` : (`` + o.key).replace(ie, `$&/`) + `/`) + c)), r.push(o)), 1;
        c = 0;
        var l = a === `` ? `.` : a + `:`;
        if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + ae(a, u), c += se(a, r, i, s, o); else if (u = m(e), typeof u == `function`) for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + ae(a, u++), c += se(a, r, i, s, o); else if (s === `object`) {
            if (typeof e.then == `function`) return se(oe(e), r, i, a, o);
            throw r = String(e), Error(`Objects are not valid as a React child (found: ` + (r === `[object Object]` ? `object with keys {` + Object.keys(e).join(`, `) + `}` : r) + `). If you meant to render a collection of children, use an array instead.`)
        }
        return c
    }

    function E(e, t, n) {
        if (e == null) return e;
        var r = [], i = 0;
        return se(e, r, ``, ``, function (e) {
            return t.call(n, e, i++)
        }), r
    }

    function D(e) {
        if (e._status === -1) {
            var t = e._result;
            t = t(), t.then(function (t) {
                (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t)
            }, function (t) {
                (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t)
            }), e._status === -1 && (e._status = 0, e._result = t)
        }
        if (e._status === 1) return e._result.default;
        throw e._result
    }

    var ce = typeof reportError == `function` ? reportError : function (e) {
        if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
            var t = new window.ErrorEvent(`error`, {
                bubbles: !0,
                cancelable: !0,
                message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
                error: e
            });
            if (!window.dispatchEvent(t)) return
        } else if (typeof process == `object` && typeof process.emit == `function`) {
            process.emit(`uncaughtException`, e);
            return
        }
        console.error(e)
    }, le = {
        map: E, forEach: function (e, t, n) {
            E(e, function () {
                t.apply(this, arguments)
            }, n)
        }, count: function (e) {
            var t = 0;
            return E(e, function () {
                t++
            }), t
        }, toArray: function (e) {
            return E(e, function (e) {
                return e
            }) || []
        }, only: function (e) {
            if (!ne(e)) throw Error(`React.Children.only expected to receive a single React element child.`);
            return e
        }
    };
    e.Activity = f, e.Children = le, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
        __proto__: null,
        c: function (e) {
            return w.H.useMemoCache(e)
        }
    }, e.cache = function (e) {
        return function () {
            return e.apply(null, arguments)
        }
    }, e.cacheSignal = function () {
        return null
    }, e.cloneElement = function (e, t, n) {
        if (e == null) throw Error(`The argument must be a React element, but you passed ` + e + `.`);
        var r = g({}, e.props), i = e.key;
        if (t != null) for (a in t.key !== void 0 && (i = `` + t.key), t) !ee.call(t, a) || a === `key` || a === `__self` || a === `__source` || a === `ref` && t.ref === void 0 || (r[a] = t[a]);
        var a = arguments.length - 2;
        if (a === 1) r.children = n; else if (1 < a) {
            for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
            r.children = o
        }
        return T(e.type, i, r)
    }, e.createContext = function (e) {
        return e = {
            $$typeof: s,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        }, e.Provider = e, e.Consumer = {$$typeof: o, _context: e}, e
    }, e.createElement = function (e, t, n) {
        var r, i = {}, a = null;
        if (t != null) for (r in t.key !== void 0 && (a = `` + t.key), t) ee.call(t, r) && r !== `key` && r !== `__self` && r !== `__source` && (i[r] = t[r]);
        var o = arguments.length - 2;
        if (o === 1) i.children = n; else if (1 < o) {
            for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
            i.children = s
        }
        if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
        return T(e, a, i)
    }, e.createRef = function () {
        return {current: null}
    }, e.forwardRef = function (e) {
        return {$$typeof: c, render: e}
    }, e.isValidElement = ne, e.lazy = function (e) {
        return {$$typeof: d, _payload: {_status: -1, _result: e}, _init: D}
    }, e.memo = function (e, t) {
        return {$$typeof: u, type: e, compare: t === void 0 ? null : t}
    }, e.startTransition = function (e) {
        var t = w.T, n = {};
        w.T = n;
        try {
            var r = e(), i = w.S;
            i !== null && i(n, r), typeof r == `object` && r && typeof r.then == `function` && r.then(C, ce)
        } catch (e) {
            ce(e)
        } finally {
            t !== null && n.types !== null && (t.types = n.types), w.T = t
        }
    }, e.unstable_useCacheRefresh = function () {
        return w.H.useCacheRefresh()
    }, e.use = function (e) {
        return w.H.use(e)
    }, e.useActionState = function (e, t, n) {
        return w.H.useActionState(e, t, n)
    }, e.useCallback = function (e, t) {
        return w.H.useCallback(e, t)
    }, e.useContext = function (e) {
        return w.H.useContext(e)
    }, e.useDebugValue = function () {
    }, e.useDeferredValue = function (e, t) {
        return w.H.useDeferredValue(e, t)
    }, e.useEffect = function (e, t) {
        return w.H.useEffect(e, t)
    }, e.useEffectEvent = function (e) {
        return w.H.useEffectEvent(e)
    }, e.useId = function () {
        return w.H.useId()
    }, e.useImperativeHandle = function (e, t, n) {
        return w.H.useImperativeHandle(e, t, n)
    }, e.useInsertionEffect = function (e, t) {
        return w.H.useInsertionEffect(e, t)
    }, e.useLayoutEffect = function (e, t) {
        return w.H.useLayoutEffect(e, t)
    }, e.useMemo = function (e, t) {
        return w.H.useMemo(e, t)
    }, e.useOptimistic = function (e, t) {
        return w.H.useOptimistic(e, t)
    }, e.useReducer = function (e, t, n) {
        return w.H.useReducer(e, t, n)
    }, e.useRef = function (e) {
        return w.H.useRef(e)
    }, e.useState = function (e) {
        return w.H.useState(e)
    }, e.useSyncExternalStore = function (e, t, n) {
        return w.H.useSyncExternalStore(e, t, n)
    }, e.useTransition = function () {
        return w.H.useTransition()
    }, e.version = `19.2.6`
})), u = o(((e, t) => {
    t.exports = l()
})), d = `modulepreload`, f = function (e, t) {
    return new URL(e, t).href
}, p = {}, m = function (e, t, n) {
    let r = Promise.resolve();
    if (t && t.length > 0) {
        let e = document.getElementsByTagName(`link`), i = document.querySelector(`meta[property=csp-nonce]`),
            a = i?.nonce || i?.getAttribute(`nonce`);

        function o(e) {
            return Promise.all(e.map(e => Promise.resolve(e).then(e => ({
                status: `fulfilled`,
                value: e
            }), e => ({status: `rejected`, reason: e}))))
        }

        r = o(t.map(t => {
            if (t = f(t, n), t in p) return;
            p[t] = !0;
            let r = t.endsWith(`.css`), i = r ? `[rel="stylesheet"]` : ``;
            if (n) for (let n = e.length - 1; n >= 0; n--) {
                let i = e[n];
                if (i.href === t && (!r || i.rel === `stylesheet`)) return
            } else if (document.querySelector(`link[href="${t}"]${i}`)) return;
            let o = document.createElement(`link`);
            if (o.rel = r ? `stylesheet` : d, r || (o.as = `script`), o.crossOrigin = ``, o.href = t, a && o.setAttribute(`nonce`, a), document.head.appendChild(o), r) return new Promise((e, n) => {
                o.addEventListener(`load`, e), o.addEventListener(`error`, () => n(Error(`Unable to preload CSS for ${t}`)))
            })
        }))
    }

    function i(e) {
        let t = new Event(`vite:preloadError`, {cancelable: !0});
        if (t.payload = e, window.dispatchEvent(t), !t.defaultPrevented) throw e
    }

    return r.then(t => {
        for (let e of t || []) e.status === `rejected` && i(e.reason);
        return e().catch(i)
    })
}, h = c(u(), 1), g = `popstate`;

function _(e) {
    return typeof e == `object` && !!e && `pathname` in e && `search` in e && `hash` in e && `state` in e && `key` in e
}

function v(e = {}) {
    function t(e, t) {
        let n = t.state?.masked, {pathname: r, search: i, hash: a} = n || e.location;
        return C(``, {
            pathname: r,
            search: i,
            hash: a
        }, t.state && t.state.usr || null, t.state && t.state.key || `default`, n ? {
            pathname: e.location.pathname,
            search: e.location.search,
            hash: e.location.hash
        } : void 0)
    }

    function n(e, t) {
        return typeof t == `string` ? t : w(t)
    }

    return T(t, n, null, e)
}

function y(e, t) {
    if (e === !1 || e == null) throw Error(t)
}

function b(e, t) {
    if (!e) {
        typeof console < `u` && console.warn(t);
        try {
            throw Error(t)
        } catch {
        }
    }
}

function x() {
    return Math.random().toString(36).substring(2, 10)
}

function S(e, t) {
    return {
        usr: e.state,
        key: e.key,
        idx: t,
        masked: e.mask ? {pathname: e.pathname, search: e.search, hash: e.hash} : void 0
    }
}

function C(e, t, n = null, r, i) {
    return {
        pathname: typeof e == `string` ? e : e.pathname,
        search: ``,
        hash: ``, ...typeof t == `string` ? ee(t) : t,
        state: n,
        key: t && t.key || r || x(),
        mask: i
    }
}

function w({pathname: e = `/`, search: t = ``, hash: n = ``}) {
    return t && t !== `?` && (e += t.charAt(0) === `?` ? t : `?` + t), n && n !== `#` && (e += n.charAt(0) === `#` ? n : `#` + n), e
}

function ee(e) {
    let t = {};
    if (e) {
        let n = e.indexOf(`#`);
        n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
        let r = e.indexOf(`?`);
        r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e)
    }
    return t
}

function T(e, t, n, r = {}) {
    let {window: i = document.defaultView, v5Compat: a = !1} = r, o = i.history, s = `POP`, c = null, l = u();
    l ?? (l = 0, o.replaceState({...o.state, idx: l}, ``));

    function u() {
        return (o.state || {idx: null}).idx
    }

    function d() {
        s = `POP`;
        let e = u(), t = e == null ? null : e - l;
        l = e, c && c({action: s, location: h.location, delta: t})
    }

    function f(e, t) {
        s = `PUSH`;
        let r = _(e) ? e : C(h.location, e, t);
        n && n(r, e), l = u() + 1;
        let d = S(r, l), f = h.createHref(r.mask || r);
        try {
            o.pushState(d, ``, f)
        } catch (e) {
            if (e instanceof DOMException && e.name === `DataCloneError`) throw e;
            i.location.assign(f)
        }
        a && c && c({action: s, location: h.location, delta: 1})
    }

    function p(e, t) {
        s = `REPLACE`;
        let r = _(e) ? e : C(h.location, e, t);
        n && n(r, e), l = u();
        let i = S(r, l), d = h.createHref(r.mask || r);
        o.replaceState(i, ``, d), a && c && c({action: s, location: h.location, delta: 0})
    }

    function m(e) {
        return te(i, e)
    }

    let h = {
        get action() {
            return s
        }, get location() {
            return e(i, o)
        }, listen(e) {
            if (c) throw Error(`A history only accepts one active listener`);
            return i.addEventListener(g, d), c = e, () => {
                i.removeEventListener(g, d), c = null
            }
        }, createHref(e) {
            return t(i, e)
        }, createURL: m, encodeLocation(e) {
            let t = m(e);
            return {pathname: t.pathname, search: t.search, hash: t.hash}
        }, push: f, replace: p, go(e) {
            return o.go(e)
        }
    };
    return h
}

function te(e, t, n = !1) {
    let r = `http://localhost`;
    e && (r = e.location.origin === `null` ? e.location.href : e.location.origin), y(r, `No window.location.(origin|href) available to create URL`);
    let i = typeof t == `string` ? t : w(t);
    return i = i.replace(/ $/, `%20`), !n && i.startsWith(`//`) && (i = r + i), new URL(i, r)
}

function ne(e, t, n = `/`) {
    return re(e, t, n, !1)
}

function re(e, t, n, r, i) {
    let a = ye((typeof t == `string` ? ee(t) : t).pathname || `/`, n);
    if (a == null) return null;
    let o = i ?? ae(e), s = null, c = ve(a);
    for (let e = 0; s == null && e < o.length; ++e) s = he(o[e], c, r);
    return s
}

function ie(e, t) {
    let {route: n, pathname: r, params: i} = e;
    return {id: n.id, pathname: r, params: i, data: t[n.id], loaderData: t[n.id], handle: n.handle}
}

function ae(e) {
    let t = oe(e);
    return E(t), t
}

function oe(e, t = [], n = [], r = ``, i = !1) {
    let a = (e, a, o = i, s) => {
        let c = {
            relativePath: s === void 0 ? e.path || `` : s,
            caseSensitive: e.caseSensitive === !0,
            childrenIndex: a,
            route: e
        };
        if (c.relativePath.startsWith(`/`)) {
            if (!c.relativePath.startsWith(r) && o) return;
            y(c.relativePath.startsWith(r), `Absolute route path "${c.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`), c.relativePath = c.relativePath.slice(r.length)
        }
        let l = Oe([r, c.relativePath]), u = n.concat(c);
        e.children && e.children.length > 0 && (y(e.index !== !0, `Index routes must not have child routes. Please remove all child routes from route path "${l}".`), oe(e.children, t, u, l, o)), !(e.path == null && !e.index) && t.push({
            path: l,
            score: pe(l, e.index),
            routesMeta: u
        })
    };
    return e.forEach((e, t) => {
        if (e.path === `` || !e.path?.includes(`?`)) a(e, t); else for (let n of se(e.path)) a(e, t, !0, n)
    }), t
}

function se(e) {
    let t = e.split(`/`);
    if (t.length === 0) return [];
    let [n, ...r] = t, i = n.endsWith(`?`), a = n.replace(/\?$/, ``);
    if (r.length === 0) return i ? [a, ``] : [a];
    let o = se(r.join(`/`)), s = [];
    return s.push(...o.map(e => e === `` ? a : [a, e].join(`/`))), i && s.push(...o), s.map(t => e.startsWith(`/`) && t === `` ? `/` : t)
}

function E(e) {
    e.sort((e, t) => e.score === t.score ? me(e.routesMeta.map(e => e.childrenIndex), t.routesMeta.map(e => e.childrenIndex)) : t.score - e.score)
}

var D = /^:[\w-]+$/, ce = 3, le = 2, ue = 1, de = 10, fe = -2, O = e => e === `*`;

function pe(e, t) {
    let n = e.split(`/`), r = n.length;
    return n.some(O) && (r += fe), t && (r += le), n.filter(e => !O(e)).reduce((e, t) => e + (D.test(t) ? ce : t === `` ? ue : de), r)
}

function me(e, t) {
    return e.length === t.length && e.slice(0, -1).every((e, n) => e === t[n]) ? e[e.length - 1] - t[t.length - 1] : 0
}

function he(e, t, n = !1) {
    let {routesMeta: r} = e, i = {}, a = `/`, o = [];
    for (let e = 0; e < r.length; ++e) {
        let s = r[e], c = e === r.length - 1, l = a === `/` ? t : t.slice(a.length) || `/`,
            u = ge({path: s.relativePath, caseSensitive: s.caseSensitive, end: c}, l), d = s.route;
        if (!u && c && n && !r[r.length - 1].route.index && (u = ge({
            path: s.relativePath,
            caseSensitive: s.caseSensitive,
            end: !1
        }, l)), !u) return null;
        Object.assign(i, u.params), o.push({
            params: i,
            pathname: Oe([a, u.pathname]),
            pathnameBase: Ae(Oe([a, u.pathnameBase])),
            route: d
        }), u.pathnameBase !== `/` && (a = Oe([a, u.pathnameBase]))
    }
    return o
}

function ge(e, t) {
    typeof e == `string` && (e = {path: e, caseSensitive: !1, end: !0});
    let [n, r] = _e(e.path, e.caseSensitive, e.end), i = t.match(n);
    if (!i) return null;
    let a = i[0], o = a.replace(/(.)\/+$/, `$1`), s = i.slice(1);
    return {
        params: r.reduce((e, {paramName: t, isOptional: n}, r) => {
            if (t === `*`) {
                let e = s[r] || ``;
                o = a.slice(0, a.length - e.length).replace(/(.)\/+$/, `$1`)
            }
            let i = s[r];
            return n && !i ? e[t] = void 0 : e[t] = (i || ``).replace(/%2F/g, `/`), e
        }, {}), pathname: a, pathnameBase: o, pattern: e
    }
}

function _e(e, t = !1, n = !0) {
    b(e === `*` || !e.endsWith(`*`) || e.endsWith(`/*`), `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, `/*`)}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, `/*`)}".`);
    let r = [],
        i = `^` + e.replace(/\/*\*?$/, ``).replace(/^\/*/, `/`).replace(/[\\.*+^${}|()[\]]/g, `\\$&`).replace(/\/:([\w-]+)(\?)?/g, (e, t, n, i, a) => {
            if (r.push({paramName: t, isOptional: n != null}), n) {
                let t = a.charAt(i + e.length);
                return t && t !== `/` ? `/([^\\/]*)` : `(?:/([^\\/]*))?`
            }
            return `/([^\\/]+)`
        }).replace(/\/([\w-]+)\?(\/|$)/g, `(/$1)?$2`);
    return e.endsWith(`*`) ? (r.push({paramName: `*`}), i += e === `*` || e === `/*` ? `(.*)$` : `(?:\\/(.+)|\\/*)$`) : n ? i += `\\/*$` : e !== `` && e !== `/` && (i += `(?:(?=\\/|$))`), [new RegExp(i, t ? void 0 : `i`), r]
}

function ve(e) {
    try {
        return e.split(`/`).map(e => decodeURIComponent(e).replace(/\//g, `%2F`)).join(`/`)
    } catch (t) {
        return b(!1, `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`), e
    }
}

function ye(e, t) {
    if (t === `/`) return e;
    if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
    let n = t.endsWith(`/`) ? t.length - 1 : t.length, r = e.charAt(n);
    return r && r !== `/` ? null : e.slice(n) || `/`
}

var be = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

function xe(e, t = `/`) {
    let {pathname: n, search: r = ``, hash: i = ``} = typeof e == `string` ? ee(e) : e, a;
    return n ? (n = De(n), a = n.startsWith(`/`) ? Se(n.substring(1), `/`) : Se(n, t)) : a = t, {
        pathname: a,
        search: je(r),
        hash: Me(i)
    }
}

function Se(e, t) {
    let n = ke(t).split(`/`);
    return e.split(`/`).forEach(e => {
        e === `..` ? n.length > 1 && n.pop() : e !== `.` && n.push(e)
    }), n.length > 1 ? n.join(`/`) : `/`
}

function Ce(e, t, n, r) {
    return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(r)}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`
}

function we(e) {
    return e.filter((e, t) => t === 0 || e.route.path && e.route.path.length > 0)
}

function Te(e) {
    let t = we(e);
    return t.map((e, n) => n === t.length - 1 ? e.pathname : e.pathnameBase)
}

function Ee(e, t, n, r = !1) {
    let i;
    typeof e == `string` ? i = ee(e) : (i = {...e}, y(!i.pathname || !i.pathname.includes(`?`), Ce(`?`, `pathname`, `search`, i)), y(!i.pathname || !i.pathname.includes(`#`), Ce(`#`, `pathname`, `hash`, i)), y(!i.search || !i.search.includes(`#`), Ce(`#`, `search`, `hash`, i)));
    let a = e === `` || i.pathname === ``, o = a ? `/` : i.pathname, s;
    if (o == null) s = n; else {
        let e = t.length - 1;
        if (!r && o.startsWith(`..`)) {
            let t = o.split(`/`);
            for (; t[0] === `..`;) t.shift(), --e;
            i.pathname = t.join(`/`)
        }
        s = e >= 0 ? t[e] : `/`
    }
    let c = xe(i, s), l = o && o !== `/` && o.endsWith(`/`), u = (a || o === `.`) && n.endsWith(`/`);
    return !c.pathname.endsWith(`/`) && (l || u) && (c.pathname += `/`), c
}

var De = e => e.replace(/\/\/+/g, `/`), Oe = e => De(e.join(`/`)), ke = e => e.replace(/\/+$/, ``),
    Ae = e => ke(e).replace(/^\/*/, `/`), je = e => !e || e === `?` ? `` : e.startsWith(`?`) ? e : `?` + e,
    Me = e => !e || e === `#` ? `` : e.startsWith(`#`) ? e : `#` + e, Ne = class {
        constructor(e, t, n, r = !1) {
            this.status = e, this.statusText = t || ``, this.internal = r, n instanceof Error ? (this.data = n.toString(), this.error = n) : this.data = n
        }
    };

function Pe(e) {
    return e != null && typeof e.status == `number` && typeof e.statusText == `string` && typeof e.internal == `boolean` && `data` in e
}

function Fe(e) {
    return Oe(e.map(e => e.route.path).filter(Boolean)) || `/`
}

var Ie = typeof window < `u` && window.document !== void 0 && window.document.createElement !== void 0;

function Le(e, t) {
    let n = e;
    if (typeof n != `string` || !be.test(n)) return {absoluteURL: void 0, isExternal: !1, to: n};
    let r = n, i = !1;
    if (Ie) try {
        let e = new URL(window.location.href), r = n.startsWith(`//`) ? new URL(e.protocol + n) : new URL(n),
            a = ye(r.pathname, t);
        r.origin === e.origin && a != null ? n = a + r.search + r.hash : i = !0
    } catch {
        b(!1, `<Link to="${n}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`)
    }
    return {absoluteURL: r, isExternal: i, to: n}
}

Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
var Re = [`POST`, `PUT`, `PATCH`, `DELETE`];
new Set(Re);
var ze = [`GET`, ...Re];
new Set(ze);
var Be = h.createContext(null);
Be.displayName = `DataRouter`;
var Ve = h.createContext(null);
Ve.displayName = `DataRouterState`;
var He = h.createContext(!1);

function Ue() {
    return h.useContext(He)
}

var We = h.createContext({isTransitioning: !1});
We.displayName = `ViewTransition`;
var Ge = h.createContext(new Map);
Ge.displayName = `Fetchers`;
var Ke = h.createContext(null);
Ke.displayName = `Await`;
var qe = h.createContext(null);
qe.displayName = `Navigation`;
var Je = h.createContext(null);
Je.displayName = `Location`;
var Ye = h.createContext({outlet: null, matches: [], isDataRoute: !1});
Ye.displayName = `Route`;
var Xe = h.createContext(null);
Xe.displayName = `RouteError`;
var Ze = `REACT_ROUTER_ERROR`, Qe = `REDIRECT`, $e = `ROUTE_ERROR_RESPONSE`;

function et(e) {
    if (e.startsWith(`${Ze}:${Qe}:{`)) try {
        let t = JSON.parse(e.slice(28));
        if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string` && typeof t.location == `string` && typeof t.reloadDocument == `boolean` && typeof t.replace == `boolean`) return t
    } catch {
    }
}

function tt(e) {
    if (e.startsWith(`${Ze}:${$e}:{`)) try {
        let t = JSON.parse(e.slice(40));
        if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string`) return new Ne(t.status, t.statusText, t.data)
    } catch {
    }
}

function nt(e, {relative: t} = {}) {
    y(rt(), `useHref() may be used only in the context of a <Router> component.`);
    let {basename: n, navigator: r} = h.useContext(qe), {hash: i, pathname: a, search: o} = lt(e, {relative: t}), s = a;
    return n !== `/` && (s = a === `/` ? n : Oe([n, a])), r.createHref({pathname: s, search: o, hash: i})
}

function rt() {
    return h.useContext(Je) != null
}

function it() {
    return y(rt(), `useLocation() may be used only in the context of a <Router> component.`), h.useContext(Je).location
}

var at = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;

function ot(e) {
    h.useContext(qe).static || h.useLayoutEffect(e)
}

function st() {
    let {isDataRoute: e} = h.useContext(Ye);
    return e ? Dt() : ct()
}

function ct() {
    y(rt(), `useNavigate() may be used only in the context of a <Router> component.`);
    let e = h.useContext(Be), {
            basename: t,
            navigator: n
        } = h.useContext(qe), {matches: r} = h.useContext(Ye), {pathname: i} = it(), a = JSON.stringify(Te(r)),
        o = h.useRef(!1);
    return ot(() => {
        o.current = !0
    }), h.useCallback((r, s = {}) => {
        if (b(o.current, at), !o.current) return;
        if (typeof r == `number`) {
            n.go(r);
            return
        }
        let c = Ee(r, JSON.parse(a), i, s.relative === `path`);
        e == null && t !== `/` && (c.pathname = c.pathname === `/` ? t : Oe([t, c.pathname])), (s.replace ? n.replace : n.push)(c, s.state, s)
    }, [t, n, a, i, e])
}

h.createContext(null);

function lt(e, {relative: t} = {}) {
    let {matches: n} = h.useContext(Ye), {pathname: r} = it(), i = JSON.stringify(Te(n));
    return h.useMemo(() => Ee(e, JSON.parse(i), r, t === `path`), [e, i, r, t])
}

function ut(e, t, n) {
    y(rt(), `useRoutes() may be used only in the context of a <Router> component.`);
    let {navigator: r} = h.useContext(qe), {matches: i} = h.useContext(Ye), a = i[i.length - 1], o = a ? a.params : {},
        s = a ? a.pathname : `/`, c = a ? a.pathnameBase : `/`, l = a && a.route;
    {
        let e = l && l.path || ``;
        kt(s, !l || e.endsWith(`*`) || e.endsWith(`*?`), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${s}" (under <Route path="${e}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${e}"> to <Route path="${e === `/` ? `*` : `${e}/*`}">.`)
    }
    let u = it(), d;
    if (t) {
        let e = typeof t == `string` ? ee(t) : t;
        y(c === `/` || e.pathname?.startsWith(c), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${c}" but pathname "${e.pathname}" was given in the \`location\` prop.`), d = e
    } else d = u;
    let f = d.pathname || `/`, p = f;
    if (c !== `/`) {
        let e = c.replace(/^\//, ``).split(`/`);
        p = `/` + f.replace(/^\//, ``).split(`/`).slice(e.length).join(`/`)
    }
    let m = n && n.state.matches.length ? n.state.matches.map(e => Object.assign(e, {route: n.manifest[e.route.id] || e.route})) : ne(e, {pathname: p});
    b(l || m != null, `No routes matched location "${d.pathname}${d.search}${d.hash}" `), b(m == null || m[m.length - 1].route.element !== void 0 || m[m.length - 1].route.Component !== void 0 || m[m.length - 1].route.lazy !== void 0, `Matched leaf route at location "${d.pathname}${d.search}${d.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    let g = _t(m && m.map(e => Object.assign({}, e, {
        params: Object.assign({}, o, e.params),
        pathname: Oe([c, r.encodeLocation ? r.encodeLocation(e.pathname.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathname]),
        pathnameBase: e.pathnameBase === `/` ? c : Oe([c, r.encodeLocation ? r.encodeLocation(e.pathnameBase.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathnameBase])
    })), i, n);
    return t && g ? h.createElement(Je.Provider, {
        value: {
            location: {
                pathname: `/`,
                search: ``,
                hash: ``,
                state: null,
                key: `default`,
                mask: void 0, ...d
            }, navigationType: `POP`
        }
    }, g) : g
}

function dt() {
    let e = Et(), t = Pe(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e),
        n = e instanceof Error ? e.stack : null, r = `rgba(200, 200, 200, 0.5)`,
        i = {padding: `0.5rem`, backgroundColor: r}, a = {padding: `2px 4px`, backgroundColor: r}, o = null;
    return console.error(`Error handled by React Router default ErrorBoundary:`, e), o = h.createElement(h.Fragment, null, h.createElement(`p`, null, `💿 Hey developer 👋`), h.createElement(`p`, null, `You can provide a way better UX than this when your app throws errors by providing your own `, h.createElement(`code`, {style: a}, `ErrorBoundary`), ` or`, ` `, h.createElement(`code`, {style: a}, `errorElement`), ` prop on your route.`)), h.createElement(h.Fragment, null, h.createElement(`h2`, null, `Unexpected Application Error!`), h.createElement(`h3`, {style: {fontStyle: `italic`}}, t), n ? h.createElement(`pre`, {style: i}, n) : null, o)
}

var ft = h.createElement(dt, null), pt = class extends h.Component {
    constructor(e) {
        super(e), this.state = {location: e.location, revalidation: e.revalidation, error: e.error}
    }

    static getDerivedStateFromError(e) {
        return {error: e}
    }

    static getDerivedStateFromProps(e, t) {
        return t.location !== e.location || t.revalidation !== `idle` && e.revalidation === `idle` ? {
            error: e.error,
            location: e.location,
            revalidation: e.revalidation
        } : {
            error: e.error === void 0 ? t.error : e.error,
            location: t.location,
            revalidation: e.revalidation || t.revalidation
        }
    }

    componentDidCatch(e, t) {
        this.props.onError ? this.props.onError(e, t) : console.error(`React Router caught the following error during render`, e)
    }

    render() {
        let e = this.state.error;
        if (this.context && typeof e == `object` && e && `digest` in e && typeof e.digest == `string`) {
            let t = tt(e.digest);
            t && (e = t)
        }
        let t = e === void 0 ? this.props.children : h.createElement(Ye.Provider, {value: this.props.routeContext}, h.createElement(Xe.Provider, {
            value: e,
            children: this.props.component
        }));
        return this.context ? h.createElement(ht, {error: e}, t) : t
    }
};
pt.contextType = He;
var mt = new WeakMap;

function ht({children: e, error: t}) {
    let {basename: n} = h.useContext(qe);
    if (typeof t == `object` && t && `digest` in t && typeof t.digest == `string`) {
        let e = et(t.digest);
        if (e) {
            let r = mt.get(t);
            if (r) throw r;
            let i = Le(e.location, n);
            if (Ie && !mt.get(t)) if (i.isExternal || e.reloadDocument) window.location.href = i.absoluteURL || i.to; else {
                let n = Promise.resolve().then(() => window.__reactRouterDataRouter.navigate(i.to, {replace: e.replace}));
                throw mt.set(t, n), n
            }
            return h.createElement(`meta`, {httpEquiv: `refresh`, content: `0;url=${i.absoluteURL || i.to}`})
        }
    }
    return e
}

function gt({routeContext: e, match: t, children: n}) {
    let r = h.useContext(Be);
    return r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (r.staticContext._deepestRenderedBoundaryId = t.route.id), h.createElement(Ye.Provider, {value: e}, n)
}

function _t(e, t = [], n) {
    let r = n?.state;
    if (e == null) {
        if (!r) return null;
        if (r.errors) e = r.matches; else if (t.length === 0 && !r.initialized && r.matches.length > 0) e = r.matches; else return null
    }
    let i = e, a = r?.errors;
    if (a != null) {
        let e = i.findIndex(e => e.route.id && a?.[e.route.id] !== void 0);
        y(e >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(a).join(`,`)}`), i = i.slice(0, Math.min(i.length, e + 1))
    }
    let o = !1, s = -1;
    if (n && r) {
        o = r.renderFallback;
        for (let e = 0; e < i.length; e++) {
            let t = i[e];
            if ((t.route.HydrateFallback || t.route.hydrateFallbackElement) && (s = e), t.route.id) {
                let {loaderData: e, errors: a} = r,
                    c = t.route.loader && !e.hasOwnProperty(t.route.id) && (!a || a[t.route.id] === void 0);
                if (t.route.lazy || c) {
                    n.isStatic && (o = !0), i = s >= 0 ? i.slice(0, s + 1) : [i[0]];
                    break
                }
            }
        }
    }
    let c = n?.onError, l = r && c ? (e, t) => {
        c(e, {location: r.location, params: r.matches?.[0]?.params ?? {}, pattern: Fe(r.matches), errorInfo: t})
    } : void 0;
    return i.reduceRight((e, n, c) => {
        let u, d = !1, f = null, p = null;
        r && (u = a && n.route.id ? a[n.route.id] : void 0, f = n.route.errorElement || ft, o && (s < 0 && c === 0 ? (kt(`route-fallback`, !1, "No `HydrateFallback` element provided to render during initial hydration"), d = !0, p = null) : s === c && (d = !0, p = n.route.hydrateFallbackElement || null)));
        let m = t.concat(i.slice(0, c + 1)), g = () => {
            let t;
            return t = u ? f : d ? p : n.route.Component ? h.createElement(n.route.Component, null) : n.route.element ? n.route.element : e, h.createElement(gt, {
                match: n,
                routeContext: {outlet: e, matches: m, isDataRoute: r != null},
                children: t
            })
        };
        return r && (n.route.ErrorBoundary || n.route.errorElement || c === 0) ? h.createElement(pt, {
            location: r.location,
            revalidation: r.revalidation,
            component: f,
            error: u,
            children: g(),
            routeContext: {outlet: null, matches: m, isDataRoute: !0},
            onError: l
        }) : g()
    }, null)
}

function vt(e) {
    return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`
}

function yt(e) {
    let t = h.useContext(Be);
    return y(t, vt(e)), t
}

function bt(e) {
    let t = h.useContext(Ve);
    return y(t, vt(e)), t
}

function xt(e) {
    let t = h.useContext(Ye);
    return y(t, vt(e)), t
}

function St(e) {
    let t = xt(e), n = t.matches[t.matches.length - 1];
    return y(n.route.id, `${e} can only be used on routes that contain a unique "id"`), n.route.id
}

function Ct() {
    return St(`useRouteId`)
}

function wt() {
    let e = bt(`useNavigation`);
    return h.useMemo(() => {
        let {matches: t, historyAction: n, ...r} = e.navigation;
        return r
    }, [e.navigation])
}

function Tt() {
    let {matches: e, loaderData: t} = bt(`useMatches`);
    return h.useMemo(() => e.map(e => ie(e, t)), [e, t])
}

function Et() {
    let e = h.useContext(Xe), t = bt(`useRouteError`), n = St(`useRouteError`);
    return e === void 0 ? t.errors?.[n] : e
}

function Dt() {
    let {router: e} = yt(`useNavigate`), t = St(`useNavigate`), n = h.useRef(!1);
    return ot(() => {
        n.current = !0
    }), h.useCallback(async (r, i = {}) => {
        b(n.current, at), n.current && (typeof r == `number` ? await e.navigate(r) : await e.navigate(r, {fromRouteId: t, ...i}))
    }, [e, t])
}

var Ot = {};

function kt(e, t, n) {
    !t && !Ot[e] && (Ot[e] = !0, b(!1, n))
}

h.memo(At);

function At({routes: e, manifest: t, future: n, state: r, isStatic: i, onError: a}) {
    return ut(e, void 0, {manifest: t, state: r, isStatic: i, onError: a, future: n})
}

function jt({
                basename: e = `/`,
                children: t = null,
                location: n,
                navigationType: r = `POP`,
                navigator: i,
                static: a = !1,
                useTransitions: o
            }) {
    y(!rt(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let s = e.replace(/^\/*/, `/`),
        c = h.useMemo(() => ({basename: s, navigator: i, static: a, useTransitions: o, future: {}}), [s, i, a, o]);
    typeof n == `string` && (n = ee(n));
    let {pathname: l = `/`, search: u = ``, hash: d = ``, state: f = null, key: p = `default`, mask: m} = n,
        g = h.useMemo(() => {
            let e = ye(l, s);
            return e == null ? null : {
                location: {pathname: e, search: u, hash: d, state: f, key: p, mask: m},
                navigationType: r
            }
        }, [s, l, u, d, f, p, r, m]);
    return b(g != null, `<Router basename="${s}"> is not able to match the URL "${l}${u}${d}" because it does not start with the basename, so the <Router> won't render anything.`), g == null ? null : h.createElement(qe.Provider, {value: c}, h.createElement(Je.Provider, {
        children: t,
        value: g
    }))
}

h.Component;
var Mt = `get`, Nt = `application/x-www-form-urlencoded`;

function Pt(e) {
    return typeof HTMLElement < `u` && e instanceof HTMLElement
}

function Ft(e) {
    return Pt(e) && e.tagName.toLowerCase() === `button`
}

function It(e) {
    return Pt(e) && e.tagName.toLowerCase() === `form`
}

function Lt(e) {
    return Pt(e) && e.tagName.toLowerCase() === `input`
}

function Rt(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey)
}

function zt(e, t) {
    return e.button === 0 && (!t || t === `_self`) && !Rt(e)
}

function Bt(e = ``) {
    return new URLSearchParams(typeof e == `string` || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
        let r = e[n];
        return t.concat(Array.isArray(r) ? r.map(e => [n, e]) : [[n, r]])
    }, []))
}

function Vt(e, t) {
    let n = Bt(e);
    return t && t.forEach((e, r) => {
        n.has(r) || t.getAll(r).forEach(e => {
            n.append(r, e)
        })
    }), n
}

var Ht = null;

function Ut() {
    if (Ht === null) try {
        new FormData(document.createElement(`form`), 0), Ht = !1
    } catch {
        Ht = !0
    }
    return Ht
}

var Wt = new Set([`application/x-www-form-urlencoded`, `multipart/form-data`, `text/plain`]);

function Gt(e) {
    return e != null && !Wt.has(e) ? (b(!1, `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${Nt}"`), null) : e
}

function Kt(e, t) {
    let n, r, i, a, o;
    if (It(e)) {
        let o = e.getAttribute(`action`);
        r = o ? ye(o, t) : null, n = e.getAttribute(`method`) || Mt, i = Gt(e.getAttribute(`enctype`)) || Nt, a = new FormData(e)
    } else if (Ft(e) || Lt(e) && (e.type === `submit` || e.type === `image`)) {
        let o = e.form;
        if (o == null) throw Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let s = e.getAttribute(`formaction`) || o.getAttribute(`action`);
        if (r = s ? ye(s, t) : null, n = e.getAttribute(`formmethod`) || o.getAttribute(`method`) || Mt, i = Gt(e.getAttribute(`formenctype`)) || Gt(o.getAttribute(`enctype`)) || Nt, a = new FormData(o, e), !Ut()) {
            let {name: t, type: n, value: r} = e;
            if (n === `image`) {
                let e = t ? `${t}.` : ``;
                a.append(`${e}x`, `0`), a.append(`${e}y`, `0`)
            } else t && a.append(t, r)
        }
    } else if (Pt(e)) throw Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`); else n = Mt, r = null, i = Nt, o = e;
    return a && i === `text/plain` && (o = a, a = void 0), {
        action: r,
        method: n.toLowerCase(),
        encType: i,
        formData: a,
        body: o
    }
}

Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
var qt = {"&": `\\u0026`, ">": `\\u003e`, "<": `\\u003c`, "\u2028": `\\u2028`, "\u2029": `\\u2029`},
    Jt = /[&><\u2028\u2029]/g;

function Yt(e) {
    return e.replace(Jt, e => qt[e])
}

function Xt(e, t) {
    if (e === !1 || e == null) throw Error(t)
}

function Zt(e, t, n, r) {
    let i = typeof e == `string` ? new URL(e, typeof window > `u` ? `server://singlefetch/` : window.location.origin) : e;
    return n ? i.pathname.endsWith(`/`) ? i.pathname = `${i.pathname}_.${r}` : i.pathname = `${i.pathname}.${r}` : i.pathname === `/` ? i.pathname = `_root.${r}` : t && ye(i.pathname, t) === `/` ? i.pathname = `${ke(t)}/_root.${r}` : i.pathname = `${ke(i.pathname)}.${r}`, i
}

async function Qt(e, t) {
    if (e.id in t) return t[e.id];
    try {
        let n = await m(() => import(e.module), [], import.meta.url);
        return t[e.id] = n, n
    } catch (t) {
        return console.error(`Error loading route module \`${e.module}\`, reloading page...`), console.error(t), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
        })
    }
}

function $t(e) {
    return e != null && typeof e.page == `string`
}

function en(e) {
    return e == null ? !1 : e.href == null ? e.rel === `preload` && typeof e.imageSrcSet == `string` && typeof e.imageSizes == `string` : typeof e.rel == `string` && typeof e.href == `string`
}

async function tn(e, t, n) {
    return sn((await Promise.all(e.map(async e => {
        let r = t.routes[e.route.id];
        if (r) {
            let e = await Qt(r, n);
            return e.links ? e.links() : []
        }
        return []
    }))).flat(1).filter(en).filter(e => e.rel === `stylesheet` || e.rel === `preload`).map(e => e.rel === `stylesheet` ? {
        ...e,
        rel: `prefetch`,
        as: `style`
    } : {...e, rel: `prefetch`}))
}

function nn(e, t, n, r, i, a) {
    let o = (e, t) => n[t] ? e.route.id !== n[t].route.id : !0,
        s = (e, t) => n[t].pathname !== e.pathname || n[t].route.path?.endsWith(`*`) && n[t].params[`*`] !== e.params[`*`];
    return a === `assets` ? t.filter((e, t) => o(e, t) || s(e, t)) : a === `data` ? t.filter((t, a) => {
        let c = r.routes[t.route.id];
        if (!c || !c.hasLoader) return !1;
        if (o(t, a) || s(t, a)) return !0;
        if (t.route.shouldRevalidate) {
            let r = t.route.shouldRevalidate({
                currentUrl: new URL(i.pathname + i.search + i.hash, window.origin),
                currentParams: n[0]?.params || {},
                nextUrl: new URL(e, window.origin),
                nextParams: t.params,
                defaultShouldRevalidate: !0
            });
            if (typeof r == `boolean`) return r
        }
        return !0
    }) : []
}

function rn(e, t, {includeHydrateFallback: n} = {}) {
    return an(e.map(e => {
        let r = t.routes[e.route.id];
        if (!r) return [];
        let i = [r.module];
        return r.clientActionModule && (i = i.concat(r.clientActionModule)), r.clientLoaderModule && (i = i.concat(r.clientLoaderModule)), n && r.hydrateFallbackModule && (i = i.concat(r.hydrateFallbackModule)), r.imports && (i = i.concat(r.imports)), i
    }).flat(1))
}

function an(e) {
    return [...new Set(e)]
}

function on(e) {
    let t = {}, n = Object.keys(e).sort();
    for (let r of n) t[r] = e[r];
    return t
}

function sn(e, t) {
    let n = new Set, r = new Set(t);
    return e.reduce((e, i) => {
        if (t && !$t(i) && i.as === `script` && i.href && r.has(i.href)) return e;
        let a = JSON.stringify(on(i));
        return n.has(a) || (n.add(a), e.push({key: a, link: i})), e
    }, [])
}

function cn() {
    let e = h.useContext(Be);
    return Xt(e, `You must render this element inside a <DataRouterContext.Provider> element`), e
}

function ln() {
    let e = h.useContext(Ve);
    return Xt(e, `You must render this element inside a <DataRouterStateContext.Provider> element`), e
}

var un = h.createContext(void 0);
un.displayName = `FrameworkContext`;

function dn() {
    let e = h.useContext(un);
    return Xt(e, `You must render this element inside a <HydratedRouter> element`), e
}

function fn(e, t) {
    let n = h.useContext(un), [r, i] = h.useState(!1), [a, o] = h.useState(!1), {
        onFocus: s,
        onBlur: c,
        onMouseEnter: l,
        onMouseLeave: u,
        onTouchStart: d
    } = t, f = h.useRef(null);
    h.useEffect(() => {
        if (e === `render` && o(!0), e === `viewport`) {
            let e = new IntersectionObserver(e => {
                e.forEach(e => {
                    o(e.isIntersecting)
                })
            }, {threshold: .5});
            return f.current && e.observe(f.current), () => {
                e.disconnect()
            }
        }
    }, [e]), h.useEffect(() => {
        if (r) {
            let e = setTimeout(() => {
                o(!0)
            }, 100);
            return () => {
                clearTimeout(e)
            }
        }
    }, [r]);
    let p = () => {
        i(!0)
    }, m = () => {
        i(!1), o(!1)
    };
    return n ? e === `intent` ? [a, f, {
        onFocus: pn(s, p),
        onBlur: pn(c, m),
        onMouseEnter: pn(l, p),
        onMouseLeave: pn(u, m),
        onTouchStart: pn(d, p)
    }] : [a, f, {}] : [!1, f, {}]
}

function pn(e, t) {
    return n => {
        e && e(n), n.defaultPrevented || t(n)
    }
}

function mn({page: e, ...t}) {
    let n = Ue(), {router: r} = cn(), i = h.useMemo(() => ne(r.routes, e, r.basename), [r.routes, e, r.basename]);
    return i ? n ? h.createElement(gn, {page: e, matches: i, ...t}) : h.createElement(_n, {
        page: e,
        matches: i, ...t
    }) : null
}

function hn(e) {
    let {manifest: t, routeModules: n} = dn(), [r, i] = h.useState([]);
    return h.useEffect(() => {
        let r = !1;
        return tn(e, t, n).then(e => {
            r || i(e)
        }), () => {
            r = !0
        }
    }, [e, t, n]), r
}

function gn({page: e, matches: t, ...n}) {
    let r = it(), {future: i} = dn(), {basename: a} = cn(), o = h.useMemo(() => {
        if (e === r.pathname + r.search + r.hash) return [];
        let n = Zt(e, a, i.v8_trailingSlashAwareDataRequests, `rsc`), o = !1, s = [];
        for (let e of t) typeof e.route.shouldRevalidate == `function` ? o = !0 : s.push(e.route.id);
        return o && s.length > 0 && n.searchParams.set(`_routes`, s.join(`,`)), [n.pathname + n.search]
    }, [a, i.v8_trailingSlashAwareDataRequests, e, r, t]);
    return h.createElement(h.Fragment, null, o.map(e => h.createElement(`link`, {
        key: e,
        rel: `prefetch`,
        as: `fetch`,
        href: e, ...n
    })))
}

function _n({page: e, matches: t, ...n}) {
    let r = it(), {future: i, manifest: a, routeModules: o} = dn(), {basename: s} = cn(), {
            loaderData: c,
            matches: l
        } = ln(), u = h.useMemo(() => nn(e, t, l, a, r, `data`), [e, t, l, a, r]),
        d = h.useMemo(() => nn(e, t, l, a, r, `assets`), [e, t, l, a, r]), f = h.useMemo(() => {
            if (e === r.pathname + r.search + r.hash) return [];
            let n = new Set, l = !1;
            if (t.forEach(e => {
                let t = a.routes[e.route.id];
                !t || !t.hasLoader || (!u.some(t => t.route.id === e.route.id) && e.route.id in c && o[e.route.id]?.shouldRevalidate || t.hasClientLoader ? l = !0 : n.add(e.route.id))
            }), n.size === 0) return [];
            let d = Zt(e, s, i.v8_trailingSlashAwareDataRequests, `data`);
            return l && n.size > 0 && d.searchParams.set(`_routes`, t.filter(e => n.has(e.route.id)).map(e => e.route.id).join(`,`)), [d.pathname + d.search]
        }, [s, i.v8_trailingSlashAwareDataRequests, c, r, a, u, t, e, o]), p = h.useMemo(() => rn(d, a), [d, a]), m = hn(d);
    return h.createElement(h.Fragment, null, f.map(e => h.createElement(`link`, {
        key: e,
        rel: `prefetch`,
        as: `fetch`,
        href: e, ...n
    })), p.map(e => h.createElement(`link`, {key: e, rel: `modulepreload`, href: e, ...n})), m.map(({
                                                                                                        key: e,
                                                                                                        link: t
                                                                                                    }) => h.createElement(`link`, {
        key: e,
        nonce: n.nonce, ...t,
        crossOrigin: t.crossOrigin ?? n.crossOrigin
    })))
}

function vn(...e) {
    return t => {
        e.forEach(e => {
            typeof e == `function` ? e(t) : e != null && (e.current = t)
        })
    }
}

h.Component;
var yn = typeof window < `u` && window.document !== void 0 && window.document.createElement !== void 0;
try {
    yn && (window.__reactRouterVersion = `7.17.0`)
} catch {
}

function bn({basename: e, children: t, useTransitions: n, window: r}) {
    let i = h.useRef();
    i.current ??= v({window: r, v5Compat: !0});
    let a = i.current, [o, s] = h.useState({action: a.action, location: a.location}), c = h.useCallback(e => {
        n === !1 ? s(e) : h.startTransition(() => s(e))
    }, [n]);
    return h.useLayoutEffect(() => a.listen(c), [a, c]), h.createElement(jt, {
        basename: e,
        children: t,
        location: o.location,
        navigationType: o.action,
        navigator: a,
        useTransitions: n
    })
}

function xn({basename: e, children: t, history: n, useTransitions: r}) {
    let [i, a] = h.useState({action: n.action, location: n.location}), o = h.useCallback(e => {
        r === !1 ? a(e) : h.startTransition(() => a(e))
    }, [r]);
    return h.useLayoutEffect(() => n.listen(o), [n, o]), h.createElement(jt, {
        basename: e,
        children: t,
        location: i.location,
        navigationType: i.action,
        navigator: n,
        useTransitions: r
    })
}

xn.displayName = `unstable_HistoryRouter`;
var Sn = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Cn = h.forwardRef(function ({
                                                                          onClick: e,
                                                                          discover: t = `render`,
                                                                          prefetch: n = `none`,
                                                                          relative: r,
                                                                          reloadDocument: i,
                                                                          replace: a,
                                                                          mask: o,
                                                                          state: s,
                                                                          target: c,
                                                                          to: l,
                                                                          preventScrollReset: u,
                                                                          viewTransition: d,
                                                                          defaultShouldRevalidate: f,
                                                                          ...p
                                                                      }, m) {
    let {basename: g, navigator: _, useTransitions: v} = h.useContext(qe), y = typeof l == `string` && Sn.test(l),
        b = Le(l, g);
    l = b.to;
    let x = nt(l, {relative: r}), S = it(), C = null;
    if (o) {
        let e = Ee(o, [], S.mask ? S.mask.pathname : `/`, !0);
        g !== `/` && (e.pathname = e.pathname === `/` ? g : Oe([g, e.pathname])), C = _.createHref(e)
    }
    let [w, ee, T] = fn(n, p), te = An(l, {
        replace: a,
        mask: o,
        state: s,
        target: c,
        preventScrollReset: u,
        relative: r,
        viewTransition: d,
        defaultShouldRevalidate: f,
        useTransitions: v
    });

    function ne(t) {
        e && e(t), t.defaultPrevented || te(t)
    }

    let re = !(b.isExternal || i), ie = h.createElement(`a`, {
        ...p, ...T,
        href: (re ? C : void 0) || b.absoluteURL || x,
        onClick: re ? ne : e,
        ref: vn(m, ee),
        target: c,
        "data-discover": !y && t === `render` ? `true` : void 0
    });
    return w && !y ? h.createElement(h.Fragment, null, ie, h.createElement(mn, {page: x})) : ie
});
Cn.displayName = `Link`;
var wn = h.forwardRef(function ({
                                    "aria-current": e = `page`,
                                    caseSensitive: t = !1,
                                    className: n = ``,
                                    end: r = !1,
                                    style: i,
                                    to: a,
                                    viewTransition: o,
                                    children: s,
                                    ...c
                                }, l) {
    let u = lt(a, {relative: c.relative}), d = it(), f = h.useContext(Ve), {
            navigator: p,
            basename: m
        } = h.useContext(qe), g = f != null && Vn(u) && o === !0,
        _ = p.encodeLocation ? p.encodeLocation(u).pathname : u.pathname, v = d.pathname,
        y = f && f.navigation && f.navigation.location ? f.navigation.location.pathname : null;
    t || (v = v.toLowerCase(), y = y ? y.toLowerCase() : null, _ = _.toLowerCase()), y && m && (y = ye(y, m) || y);
    let b = _ !== `/` && _.endsWith(`/`) ? _.length - 1 : _.length,
        x = v === _ || !r && v.startsWith(_) && v.charAt(b) === `/`,
        S = y != null && (y === _ || !r && y.startsWith(_) && y.charAt(_.length) === `/`),
        C = {isActive: x, isPending: S, isTransitioning: g}, w = x ? e : void 0, ee;
    ee = typeof n == `function` ? n(C) : [n, x ? `active` : null, S ? `pending` : null, g ? `transitioning` : null].filter(Boolean).join(` `);
    let T = typeof i == `function` ? i(C) : i;
    return h.createElement(Cn, {
        ...c,
        "aria-current": w,
        className: ee,
        ref: l,
        style: T,
        to: a,
        viewTransition: o
    }, typeof s == `function` ? s(C) : s)
});
wn.displayName = `NavLink`;
var Tn = h.forwardRef(({
                           discover: e = `render`,
                           fetcherKey: t,
                           navigate: n,
                           reloadDocument: r,
                           replace: i,
                           state: a,
                           method: o = Mt,
                           action: s,
                           onSubmit: c,
                           relative: l,
                           preventScrollReset: u,
                           viewTransition: d,
                           defaultShouldRevalidate: f,
                           ...p
                       }, m) => {
    let {useTransitions: g} = h.useContext(qe), _ = Pn(), v = Fn(s, {relative: l}),
        y = o.toLowerCase() === `get` ? `get` : `post`, b = typeof s == `string` && Sn.test(s);
    return h.createElement(`form`, {
        ref: m, method: y, action: v, onSubmit: r ? c : e => {
            if (c && c(e), e.defaultPrevented) return;
            e.preventDefault();
            let r = e.nativeEvent.submitter, s = r?.getAttribute(`formmethod`) || o, p = () => _(r || e.currentTarget, {
                fetcherKey: t,
                method: s,
                navigate: n,
                replace: i,
                state: a,
                relative: l,
                preventScrollReset: u,
                viewTransition: d,
                defaultShouldRevalidate: f
            });
            g && n !== !1 ? h.startTransition(() => p()) : p()
        }, ...p, "data-discover": !b && e === `render` ? `true` : void 0
    })
});
Tn.displayName = `Form`;

function En({getKey: e, storageKey: t, ...n}) {
    let r = h.useContext(un), {basename: i} = h.useContext(qe), a = it(), o = Tt();
    zn({getKey: e, storageKey: t});
    let s = h.useMemo(() => {
        if (!r || !e) return null;
        let t = Rn(a, o, i, e);
        return t === a.key ? null : t
    }, []);
    if (!r || r.isSpaMode) return null;
    let c = ((e, t) => {
        if (!window.history.state || !window.history.state.key) {
            let e = Math.random().toString(32).slice(2);
            window.history.replaceState({key: e}, ``)
        }
        try {
            let n = JSON.parse(sessionStorage.getItem(e) || `{}`)[t || window.history.state.key];
            typeof n == `number` && window.scrollTo(0, n)
        } catch (t) {
            console.error(t), sessionStorage.removeItem(e)
        }
    }).toString();
    return h.createElement(`script`, {
        ...n,
        suppressHydrationWarning: !0,
        dangerouslySetInnerHTML: {__html: `(${c})(${Yt(JSON.stringify(t || In))}, ${Yt(JSON.stringify(s))})`}
    })
}

En.displayName = `ScrollRestoration`;

function Dn(e) {
    return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`
}

function On(e) {
    let t = h.useContext(Be);
    return y(t, Dn(e)), t
}

function kn(e) {
    let t = h.useContext(Ve);
    return y(t, Dn(e)), t
}

function An(e, {
    target: t,
    replace: n,
    mask: r,
    state: i,
    preventScrollReset: a,
    relative: o,
    viewTransition: s,
    defaultShouldRevalidate: c,
    useTransitions: l
} = {}) {
    let u = st(), d = it(), f = lt(e, {relative: o});
    return h.useCallback(p => {
        if (zt(p, t)) {
            p.preventDefault();
            let t = n === void 0 ? w(d) === w(f) : n, m = () => u(e, {
                replace: t,
                mask: r,
                state: i,
                preventScrollReset: a,
                relative: o,
                viewTransition: s,
                defaultShouldRevalidate: c
            });
            l ? h.startTransition(() => m()) : m()
        }
    }, [d, u, f, n, r, i, t, e, a, o, s, c, l])
}

function jn(e) {
    b(typeof URLSearchParams < `u`, "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let t = h.useRef(Bt(e)), n = h.useRef(!1), r = it(),
        i = h.useMemo(() => Vt(r.search, n.current ? null : t.current), [r.search]), a = st();
    return [i, h.useCallback((e, t) => {
        let r = Bt(typeof e == `function` ? e(new URLSearchParams(i)) : e);
        n.current = !0, a(`?` + r, t)
    }, [a, i])]
}

var Mn = 0, Nn = () => `__${String(++Mn)}__`;

function Pn() {
    let {router: e} = On(`useSubmit`), {basename: t} = h.useContext(qe), n = Ct(), r = e.fetch, i = e.navigate;
    return h.useCallback(async (e, a = {}) => {
        let {action: o, method: s, encType: c, formData: l, body: u} = Kt(e, t);
        a.navigate === !1 ? await r(a.fetcherKey || Nn(), n, a.action || o, {
            defaultShouldRevalidate: a.defaultShouldRevalidate,
            preventScrollReset: a.preventScrollReset,
            formData: l,
            body: u,
            formMethod: a.method || s,
            formEncType: a.encType || c,
            flushSync: a.flushSync
        }) : await i(a.action || o, {
            defaultShouldRevalidate: a.defaultShouldRevalidate,
            preventScrollReset: a.preventScrollReset,
            formData: l,
            body: u,
            formMethod: a.method || s,
            formEncType: a.encType || c,
            replace: a.replace,
            state: a.state,
            fromRouteId: n,
            flushSync: a.flushSync,
            viewTransition: a.viewTransition
        })
    }, [r, i, t, n])
}

function Fn(e, {relative: t} = {}) {
    let {basename: n} = h.useContext(qe), r = h.useContext(Ye);
    y(r, `useFormAction must be used inside a RouteContext`);
    let [i] = r.matches.slice(-1), a = {...lt(e || `.`, {relative: t})}, o = it();
    if (e == null) {
        a.search = o.search;
        let e = new URLSearchParams(a.search), t = e.getAll(`index`);
        if (t.some(e => e === ``)) {
            e.delete(`index`), t.filter(e => e).forEach(t => e.append(`index`, t));
            let n = e.toString();
            a.search = n ? `?${n}` : ``
        }
    }
    return (!e || e === `.`) && i.route.index && (a.search = a.search ? a.search.replace(/^\?/, `?index&`) : `?index`), n !== `/` && (a.pathname = a.pathname === `/` ? n : Oe([n, a.pathname])), w(a)
}

var In = `react-router-scroll-positions`, Ln = {};

function Rn(e, t, n, r) {
    let i = null;
    return r && (i = r(n === `/` ? e : {...e, pathname: ye(e.pathname, n) || e.pathname}, t)), i ??= e.key, i
}

function zn({getKey: e, storageKey: t} = {}) {
    let {router: n} = On(`useScrollRestoration`), {
        restoreScrollPosition: r,
        preventScrollReset: i
    } = kn(`useScrollRestoration`), {basename: a} = h.useContext(qe), o = it(), s = Tt(), c = wt();
    h.useEffect(() => (window.history.scrollRestoration = `manual`, () => {
        window.history.scrollRestoration = `auto`
    }), []), Bn(h.useCallback(() => {
        if (c.state === `idle`) {
            let t = Rn(o, s, a, e);
            Ln[t] = window.scrollY
        }
        try {
            sessionStorage.setItem(t || In, JSON.stringify(Ln))
        } catch (e) {
            b(!1, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${e}).`)
        }
        window.history.scrollRestoration = `auto`
    }, [c.state, e, a, o, s, t])), typeof document < `u` && (h.useLayoutEffect(() => {
        try {
            let e = sessionStorage.getItem(t || In);
            e && (Ln = JSON.parse(e))
        } catch {
        }
    }, [t]), h.useLayoutEffect(() => {
        let t = n?.enableScrollRestoration(Ln, () => window.scrollY, e ? (t, n) => Rn(t, n, a, e) : void 0);
        return () => t && t()
    }, [n, a, e]), h.useLayoutEffect(() => {
        if (r !== !1) {
            if (typeof r == `number`) {
                window.scrollTo(0, r);
                return
            }
            try {
                if (o.hash) {
                    let e = document.getElementById(decodeURIComponent(o.hash.slice(1)));
                    if (e) {
                        e.scrollIntoView();
                        return
                    }
                }
            } catch {
                b(!1, `"${o.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`)
            }
            i !== !0 && window.scrollTo(0, 0)
        }
    }, [o, r, i]))
}

function Bn(e, t) {
    let {capture: n} = t || {};
    h.useEffect(() => {
        let t = n == null ? void 0 : {capture: n};
        return window.addEventListener(`pagehide`, e, t), () => {
            window.removeEventListener(`pagehide`, e, t)
        }
    }, [e, n])
}

function Vn(e, {relative: t} = {}) {
    let n = h.useContext(We);
    y(n != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let {basename: r} = On(`useViewTransitionState`), i = lt(e, {relative: t});
    if (!n.isTransitioning) return !1;
    let a = ye(n.currentLocation.pathname, r) || n.currentLocation.pathname,
        o = ye(n.nextLocation.pathname, r) || n.nextLocation.pathname;
    return ge(i.pathname, o) != null || ge(i.pathname, a) != null
}

var Hn = o((e => {
        var t = u();

        function n(e) {
            var t = `https://react.dev/errors/` + e;
            if (1 < arguments.length) {
                t += `?args[]=` + encodeURIComponent(arguments[1]);
                for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n])
            }
            return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`
        }

        function r() {
        }

        var i = {
            d: {
                f: r, r: function () {
                    throw Error(n(522))
                }, D: r, C: r, L: r, m: r, X: r, S: r, M: r
            }, p: 0, findDOMNode: null
        }, a = Symbol.for(`react.portal`);

        function o(e, t, n) {
            var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
            return {$$typeof: a, key: r == null ? null : `` + r, children: e, containerInfo: t, implementation: n}
        }

        var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;

        function c(e, t) {
            if (e === `font`) return ``;
            if (typeof t == `string`) return t === `use-credentials` ? t : ``
        }

        e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function (e, t) {
            var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
            if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
            return o(e, t, null, r)
        }, e.flushSync = function (e) {
            var t = s.T, n = i.p;
            try {
                if (s.T = null, i.p = 2, e) return e()
            } finally {
                s.T = t, i.p = n, i.d.f()
            }
        }, e.preconnect = function (e, t) {
            typeof e == `string` && (t ? (t = t.crossOrigin, t = typeof t == `string` ? t === `use-credentials` ? t : `` : void 0) : t = null, i.d.C(e, t))
        }, e.prefetchDNS = function (e) {
            typeof e == `string` && i.d.D(e)
        }, e.preinit = function (e, t) {
            if (typeof e == `string` && t && typeof t.as == `string`) {
                var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == `string` ? t.integrity : void 0,
                    o = typeof t.fetchPriority == `string` ? t.fetchPriority : void 0;
                n === `style` ? i.d.S(e, typeof t.precedence == `string` ? t.precedence : void 0, {
                    crossOrigin: r,
                    integrity: a,
                    fetchPriority: o
                }) : n === `script` && i.d.X(e, {
                    crossOrigin: r,
                    integrity: a,
                    fetchPriority: o,
                    nonce: typeof t.nonce == `string` ? t.nonce : void 0
                })
            }
        }, e.preinitModule = function (e, t) {
            if (typeof e == `string`) if (typeof t == `object` && t) {
                if (t.as == null || t.as === `script`) {
                    var n = c(t.as, t.crossOrigin);
                    i.d.M(e, {
                        crossOrigin: n,
                        integrity: typeof t.integrity == `string` ? t.integrity : void 0,
                        nonce: typeof t.nonce == `string` ? t.nonce : void 0
                    })
                }
            } else t ?? i.d.M(e)
        }, e.preload = function (e, t) {
            if (typeof e == `string` && typeof t == `object` && t && typeof t.as == `string`) {
                var n = t.as, r = c(n, t.crossOrigin);
                i.d.L(e, n, {
                    crossOrigin: r,
                    integrity: typeof t.integrity == `string` ? t.integrity : void 0,
                    nonce: typeof t.nonce == `string` ? t.nonce : void 0,
                    type: typeof t.type == `string` ? t.type : void 0,
                    fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : void 0,
                    referrerPolicy: typeof t.referrerPolicy == `string` ? t.referrerPolicy : void 0,
                    imageSrcSet: typeof t.imageSrcSet == `string` ? t.imageSrcSet : void 0,
                    imageSizes: typeof t.imageSizes == `string` ? t.imageSizes : void 0,
                    media: typeof t.media == `string` ? t.media : void 0
                })
            }
        }, e.preloadModule = function (e, t) {
            if (typeof e == `string`) if (t) {
                var n = c(t.as, t.crossOrigin);
                i.d.m(e, {
                    as: typeof t.as == `string` && t.as !== `script` ? t.as : void 0,
                    crossOrigin: n,
                    integrity: typeof t.integrity == `string` ? t.integrity : void 0
                })
            } else i.d.m(e)
        }, e.requestFormReset = function (e) {
            i.d.r(e)
        }, e.unstable_batchedUpdates = function (e, t) {
            return e(t)
        }, e.useFormState = function (e, t, n) {
            return s.H.useFormState(e, t, n)
        }, e.useFormStatus = function () {
            return s.H.useHostTransitionStatus()
        }, e.version = `19.2.6`
    })), Un = o(((e, t) => {
        function n() {
            if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
                __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n)
            } catch (e) {
                console.error(e)
            }
        }

        n(), t.exports = Hn()
    })), Wn = o((e => {
        function t(e, t) {
            var n = e.length;
            e.push(t);
            a:for (; 0 < n;) {
                var r = n - 1 >>> 1, a = e[r];
                if (0 < i(a, t)) e[r] = t, e[n] = a, n = r; else break a
            }
        }

        function n(e) {
            return e.length === 0 ? null : e[0]
        }

        function r(e) {
            if (e.length === 0) return null;
            var t = e[0], n = e.pop();
            if (n !== t) {
                e[0] = n;
                a:for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
                    var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
                    if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s); else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l; else break a
                }
            }
            return t
        }

        function i(e, t) {
            var n = e.sortIndex - t.sortIndex;
            return n === 0 ? e.id - t.id : n
        }

        if (e.unstable_now = void 0, typeof performance == `object` && typeof performance.now == `function`) {
            var a = performance;
            e.unstable_now = function () {
                return a.now()
            }
        } else {
            var o = Date, s = o.now();
            e.unstable_now = function () {
                return o.now() - s
            }
        }
        var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1,
            _ = typeof setTimeout == `function` ? setTimeout : null,
            v = typeof clearTimeout == `function` ? clearTimeout : null,
            y = typeof setImmediate < `u` ? setImmediate : null;

        function b(e) {
            for (var i = n(l); i !== null;) {
                if (i.callback === null) r(l); else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i); else break;
                i = n(l)
            }
        }

        function x(e) {
            if (h = !1, b(e), !m) if (n(c) !== null) m = !0, S || (S = !0, ne()); else {
                var t = n(l);
                t !== null && ae(x, t.startTime - e)
            }
        }

        var S = !1, C = -1, w = 5, ee = -1;

        function T() {
            return g ? !0 : !(e.unstable_now() - ee < w)
        }

        function te() {
            if (g = !1, S) {
                var t = e.unstable_now();
                ee = t;
                var i = !0;
                try {
                    a:{
                        m = !1, h && (h = !1, v(C), C = -1), p = !0;
                        var a = f;
                        try {
                            b:{
                                for (b(t), d = n(c); d !== null && !(d.expirationTime > t && T());) {
                                    var o = d.callback;
                                    if (typeof o == `function`) {
                                        d.callback = null, f = d.priorityLevel;
                                        var s = o(d.expirationTime <= t);
                                        if (t = e.unstable_now(), typeof s == `function`) {
                                            d.callback = s, b(t), i = !0;
                                            break b
                                        }
                                        d === n(c) && r(c), b(t)
                                    } else r(c);
                                    d = n(c)
                                }
                                if (d !== null) i = !0; else {
                                    var u = n(l);
                                    u !== null && ae(x, u.startTime - t), i = !1
                                }
                            }
                            break a
                        } finally {
                            d = null, f = a, p = !1
                        }
                        i = void 0
                    }
                } finally {
                    i ? ne() : S = !1
                }
            }
        }

        var ne;
        if (typeof y == `function`) ne = function () {
            y(te)
        }; else if (typeof MessageChannel < `u`) {
            var re = new MessageChannel, ie = re.port2;
            re.port1.onmessage = te, ne = function () {
                ie.postMessage(null)
            }
        } else ne = function () {
            _(te, 0)
        };

        function ae(t, n) {
            C = _(function () {
                t(e.unstable_now())
            }, n)
        }

        e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
            e.callback = null
        }, e.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e ? console.error(`forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported`) : w = 0 < e ? Math.floor(1e3 / e) : 5
        }, e.unstable_getCurrentPriorityLevel = function () {
            return f
        }, e.unstable_next = function (e) {
            switch (f) {
                case 1:
                case 2:
                case 3:
                    var t = 3;
                    break;
                default:
                    t = f
            }
            var n = f;
            f = t;
            try {
                return e()
            } finally {
                f = n
            }
        }, e.unstable_requestPaint = function () {
            g = !0
        }, e.unstable_runWithPriority = function (e, t) {
            switch (e) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    e = 3
            }
            var n = f;
            f = e;
            try {
                return t()
            } finally {
                f = n
            }
        }, e.unstable_scheduleCallback = function (r, i, a) {
            var o = e.unstable_now();
            switch (typeof a == `object` && a ? (a = a.delay, a = typeof a == `number` && 0 < a ? o + a : o) : a = o, r) {
                case 1:
                    var s = -1;
                    break;
                case 2:
                    s = 250;
                    break;
                case 5:
                    s = 1073741823;
                    break;
                case 4:
                    s = 1e4;
                    break;
                default:
                    s = 5e3
            }
            return s = a + s, r = {
                id: u++,
                callback: i,
                priorityLevel: r,
                startTime: a,
                expirationTime: s,
                sortIndex: -1
            }, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, ae(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, ne()))), r
        }, e.unstable_shouldYield = T, e.unstable_wrapCallback = function (e) {
            var t = f;
            return function () {
                var n = f;
                f = t;
                try {
                    return e.apply(this, arguments)
                } finally {
                    f = n
                }
            }
        }
    })), Gn = o(((e, t) => {
        t.exports = Wn()
    })), Kn = o((e => {
        var t = Gn(), n = u(), r = Un();

        function i(e) {
            var t = `https://react.dev/errors/` + e;
            if (1 < arguments.length) {
                t += `?args[]=` + encodeURIComponent(arguments[1]);
                for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n])
            }
            return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`
        }

        function a(e) {
            return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
        }

        function o(e) {
            var t = e, n = e;
            if (e.alternate) for (; t.return;) t = t.return; else {
                e = t;
                do t = e, t.flags & 4098 && (n = t.return), e = t.return; while (e)
            }
            return t.tag === 3 ? n : null
        }

        function s(e) {
            if (e.tag === 13) {
                var t = e.memoizedState;
                if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated
            }
            return null
        }

        function c(e) {
            if (e.tag === 31) {
                var t = e.memoizedState;
                if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated
            }
            return null
        }

        function l(e) {
            if (o(e) !== e) throw Error(i(188))
        }

        function d(e) {
            var t = e.alternate;
            if (!t) {
                if (t = o(e), t === null) throw Error(i(188));
                return t === e ? e : null
            }
            for (var n = e, r = t; ;) {
                var a = n.return;
                if (a === null) break;
                var s = a.alternate;
                if (s === null) {
                    if (r = a.return, r !== null) {
                        n = r;
                        continue
                    }
                    break
                }
                if (a.child === s.child) {
                    for (s = a.child; s;) {
                        if (s === n) return l(a), e;
                        if (s === r) return l(a), t;
                        s = s.sibling
                    }
                    throw Error(i(188))
                }
                if (n.return !== r.return) n = a, r = s; else {
                    for (var c = !1, u = a.child; u;) {
                        if (u === n) {
                            c = !0, n = a, r = s;
                            break
                        }
                        if (u === r) {
                            c = !0, r = a, n = s;
                            break
                        }
                        u = u.sibling
                    }
                    if (!c) {
                        for (u = s.child; u;) {
                            if (u === n) {
                                c = !0, n = s, r = a;
                                break
                            }
                            if (u === r) {
                                c = !0, r = s, n = a;
                                break
                            }
                            u = u.sibling
                        }
                        if (!c) throw Error(i(189))
                    }
                }
                if (n.alternate !== r) throw Error(i(190))
            }
            if (n.tag !== 3) throw Error(i(188));
            return n.stateNode.current === n ? e : t
        }

        function f(e) {
            var t = e.tag;
            if (t === 5 || t === 26 || t === 27 || t === 6) return e;
            for (e = e.child; e !== null;) {
                if (t = f(e), t !== null) return t;
                e = e.sibling
            }
            return null
        }

        var p = Object.assign, m = Symbol.for(`react.element`), h = Symbol.for(`react.transitional.element`),
            g = Symbol.for(`react.portal`), _ = Symbol.for(`react.fragment`), v = Symbol.for(`react.strict_mode`),
            y = Symbol.for(`react.profiler`), b = Symbol.for(`react.consumer`), x = Symbol.for(`react.context`),
            S = Symbol.for(`react.forward_ref`), C = Symbol.for(`react.suspense`), w = Symbol.for(`react.suspense_list`),
            ee = Symbol.for(`react.memo`), T = Symbol.for(`react.lazy`), te = Symbol.for(`react.activity`),
            ne = Symbol.for(`react.memo_cache_sentinel`), re = Symbol.iterator;

        function ie(e) {
            return typeof e != `object` || !e ? null : (e = re && e[re] || e[`@@iterator`], typeof e == `function` ? e : null)
        }

        var ae = Symbol.for(`react.client.reference`);

        function oe(e) {
            if (e == null) return null;
            if (typeof e == `function`) return e.$$typeof === ae ? null : e.displayName || e.name || null;
            if (typeof e == `string`) return e;
            switch (e) {
                case _:
                    return `Fragment`;
                case y:
                    return `Profiler`;
                case v:
                    return `StrictMode`;
                case C:
                    return `Suspense`;
                case w:
                    return `SuspenseList`;
                case te:
                    return `Activity`
            }
            if (typeof e == `object`) switch (e.$$typeof) {
                case g:
                    return `Portal`;
                case x:
                    return e.displayName || `Context`;
                case b:
                    return (e._context.displayName || `Context`) + `.Consumer`;
                case S:
                    var t = e.render;
                    return e = e.displayName, e ||= (e = t.displayName || t.name || ``, e === `` ? `ForwardRef` : `ForwardRef(` + e + `)`), e;
                case ee:
                    return t = e.displayName || null, t === null ? oe(e.type) || `Memo` : t;
                case T:
                    t = e._payload, e = e._init;
                    try {
                        return oe(e(t))
                    } catch {
                    }
            }
            return null
        }

        var se = Array.isArray, E = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
            D = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
            ce = {pending: !1, data: null, method: null, action: null}, le = [], ue = -1;

        function de(e) {
            return {current: e}
        }

        function fe(e) {
            0 > ue || (e.current = le[ue], le[ue] = null, ue--)
        }

        function O(e, t) {
            ue++, le[ue] = e.current, e.current = t
        }

        var pe = de(null), me = de(null), he = de(null), ge = de(null);

        function _e(e, t) {
            switch (O(he, t), O(me, e), O(pe, null), t.nodeType) {
                case 9:
                case 11:
                    e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
                    break;
                default:
                    if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e); else switch (e) {
                        case`svg`:
                            e = 1;
                            break;
                        case`math`:
                            e = 2;
                            break;
                        default:
                            e = 0
                    }
            }
            fe(pe), O(pe, e)
        }

        function ve() {
            fe(pe), fe(me), fe(he)
        }

        function ye(e) {
            e.memoizedState !== null && O(ge, e);
            var t = pe.current, n = Hd(t, e.type);
            t !== n && (O(me, e), O(pe, n))
        }

        function be(e) {
            me.current === e && (fe(pe), fe(me)), ge.current === e && (fe(ge), Qf._currentValue = ce)
        }

        var xe, Se;

        function Ce(e) {
            if (xe === void 0) try {
                throw Error()
            } catch (e) {
                var t = e.stack.trim().match(/\n( *(at )?)/);
                xe = t && t[1] || ``, Se = -1 < e.stack.indexOf(`
    at`) ? ` (<anonymous>)` : -1 < e.stack.indexOf(`@`) ? `@unknown:0:0` : ``
            }
            return `
` + xe + e + Se
        }

        var we = !1;

        function Te(e, t) {
            if (!e || we) return ``;
            we = !0;
            var n = Error.prepareStackTrace;
            Error.prepareStackTrace = void 0;
            try {
                var r = {
                    DetermineComponentFrameRoot: function () {
                        try {
                            if (t) {
                                var n = function () {
                                    throw Error()
                                };
                                if (Object.defineProperty(n.prototype, `props`, {
                                    set: function () {
                                        throw Error()
                                    }
                                }), typeof Reflect == `object` && Reflect.construct) {
                                    try {
                                        Reflect.construct(n, [])
                                    } catch (e) {
                                        var r = e
                                    }
                                    Reflect.construct(e, [], n)
                                } else {
                                    try {
                                        n.call()
                                    } catch (e) {
                                        r = e
                                    }
                                    e.call(n.prototype)
                                }
                            } else {
                                try {
                                    throw Error()
                                } catch (e) {
                                    r = e
                                }
                                (n = e()) && typeof n.catch == `function` && n.catch(function () {
                                })
                            }
                        } catch (e) {
                            if (e && r && typeof e.stack == `string`) return [e.stack, r.stack]
                        }
                        return [null, null]
                    }
                };
                r.DetermineComponentFrameRoot.displayName = `DetermineComponentFrameRoot`;
                var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, `name`);
                i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, `name`, {value: `DetermineComponentFrameRoot`});
                var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
                if (o && s) {
                    var c = o.split(`
`), l = s.split(`
`);
                    for (i = r = 0; r < c.length && !c[r].includes(`DetermineComponentFrameRoot`);) r++;
                    for (; i < l.length && !l[i].includes(`DetermineComponentFrameRoot`);) i++;
                    if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
                    for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
                        if (r !== 1 || i !== 1) do if (r--, i--, 0 > i || c[r] !== l[i]) {
                            var u = `
` + c[r].replace(` at new `, ` at `);
                            return e.displayName && u.includes(`<anonymous>`) && (u = u.replace(`<anonymous>`, e.displayName)), u
                        } while (1 <= r && 0 <= i);
                        break
                    }
                }
            } finally {
                we = !1, Error.prepareStackTrace = n
            }
            return (n = e ? e.displayName || e.name : ``) ? Ce(n) : ``
        }

        function Ee(e, t) {
            switch (e.tag) {
                case 26:
                case 27:
                case 5:
                    return Ce(e.type);
                case 16:
                    return Ce(`Lazy`);
                case 13:
                    return e.child !== t && t !== null ? Ce(`Suspense Fallback`) : Ce(`Suspense`);
                case 19:
                    return Ce(`SuspenseList`);
                case 0:
                case 15:
                    return Te(e.type, !1);
                case 11:
                    return Te(e.type.render, !1);
                case 1:
                    return Te(e.type, !0);
                case 31:
                    return Ce(`Activity`);
                default:
                    return ``
            }
        }

        function De(e) {
            try {
                var t = ``, n = null;
                do t += Ee(e, n), n = e, e = e.return; while (e);
                return t
            } catch (e) {
                return `
Error generating stack: ` + e.message + `
` + e.stack
            }
        }

        var Oe = Object.prototype.hasOwnProperty, ke = t.unstable_scheduleCallback, Ae = t.unstable_cancelCallback,
            je = t.unstable_shouldYield, Me = t.unstable_requestPaint, Ne = t.unstable_now,
            Pe = t.unstable_getCurrentPriorityLevel, Fe = t.unstable_ImmediatePriority,
            Ie = t.unstable_UserBlockingPriority, Le = t.unstable_NormalPriority, Re = t.unstable_LowPriority,
            ze = t.unstable_IdlePriority, Be = t.log, Ve = t.unstable_setDisableYieldValue, He = null, Ue = null;

        function We(e) {
            if (typeof Be == `function` && Ve(e), Ue && typeof Ue.setStrictMode == `function`) try {
                Ue.setStrictMode(He, e)
            } catch {
            }
        }

        var Ge = Math.clz32 ? Math.clz32 : Je, Ke = Math.log, qe = Math.LN2;

        function Je(e) {
            return e >>>= 0, e === 0 ? 32 : 31 - (Ke(e) / qe | 0) | 0
        }

        var Ye = 256, Xe = 262144, Ze = 4194304;

        function Qe(e) {
            var t = e & 42;
            if (t !== 0) return t;
            switch (e & -e) {
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 4:
                    return 4;
                case 8:
                    return 8;
                case 16:
                    return 16;
                case 32:
                    return 32;
                case 64:
                    return 64;
                case 128:
                    return 128;
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                    return e & 261888;
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return e & 3932160;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                    return e & 62914560;
                case 67108864:
                    return 67108864;
                case 134217728:
                    return 134217728;
                case 268435456:
                    return 268435456;
                case 536870912:
                    return 536870912;
                case 1073741824:
                    return 0;
                default:
                    return e
            }
        }

        function $e(e, t, n) {
            var r = e.pendingLanes;
            if (r === 0) return 0;
            var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
            e = e.warmLanes;
            var s = r & 134217727;
            return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Qe(n))) : i = Qe(o) : i = Qe(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Qe(n))) : i = Qe(o)) : i = Qe(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i
        }

        function et(e, t) {
            return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0
        }

        function tt(e, t) {
            switch (e) {
                case 1:
                case 2:
                case 4:
                case 8:
                case 64:
                    return t + 250;
                case 16:
                case 32:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return t + 5e3;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                    return -1;
                case 67108864:
                case 134217728:
                case 268435456:
                case 536870912:
                case 1073741824:
                    return -1;
                default:
                    return -1
            }
        }

        function nt() {
            var e = Ze;
            return Ze <<= 1, !(Ze & 62914560) && (Ze = 4194304), e
        }

        function rt(e) {
            for (var t = [], n = 0; 31 > n; n++) t.push(e);
            return t
        }

        function it(e, t) {
            e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0)
        }

        function at(e, t, n, r, i, a) {
            var o = e.pendingLanes;
            e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
            var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
            for (n = o & ~n; 0 < n;) {
                var u = 31 - Ge(n), d = 1 << u;
                s[u] = 0, c[u] = -1;
                var f = l[u];
                if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
                    var p = f[u];
                    p !== null && (p.lane &= -536870913)
                }
                n &= ~d
            }
            r !== 0 && ot(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t))
        }

        function ot(e, t, n) {
            e.pendingLanes |= t, e.suspendedLanes &= ~t;
            var r = 31 - Ge(t);
            e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930
        }

        function st(e, t) {
            var n = e.entangledLanes |= t;
            for (e = e.entanglements; n;) {
                var r = 31 - Ge(n), i = 1 << r;
                i & t | e[r] & t && (e[r] |= t), n &= ~i
            }
        }

        function ct(e, t) {
            var n = t & -t;
            return n = n & 42 ? 1 : lt(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0
        }

        function lt(e) {
            switch (e) {
                case 2:
                    e = 1;
                    break;
                case 8:
                    e = 4;
                    break;
                case 32:
                    e = 16;
                    break;
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                    e = 128;
                    break;
                case 268435456:
                    e = 134217728;
                    break;
                default:
                    e = 0
            }
            return e
        }

        function ut(e) {
            return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2
        }

        function dt() {
            var e = D.p;
            return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e
        }

        function ft(e, t) {
            var n = D.p;
            try {
                return D.p = e, t()
            } finally {
                D.p = n
            }
        }

        var pt = Math.random().toString(36).slice(2), mt = `__reactFiber$` + pt, ht = `__reactProps$` + pt,
            gt = `__reactContainer$` + pt, _t = `__reactEvents$` + pt, vt = `__reactListeners$` + pt,
            yt = `__reactHandles$` + pt, bt = `__reactResources$` + pt, xt = `__reactMarker$` + pt;

        function St(e) {
            delete e[mt], delete e[ht], delete e[_t], delete e[vt], delete e[yt]
        }

        function Ct(e) {
            var t = e[mt];
            if (t) return t;
            for (var n = e.parentNode; n;) {
                if (t = n[gt] || n[mt]) {
                    if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
                        if (n = e[mt]) return n;
                        e = df(e)
                    }
                    return t
                }
                e = n, n = e.parentNode
            }
            return null
        }

        function wt(e) {
            if (e = e[mt] || e[gt]) {
                var t = e.tag;
                if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e
            }
            return null
        }

        function Tt(e) {
            var t = e.tag;
            if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
            throw Error(i(33))
        }

        function Et(e) {
            var t = e[bt];
            return t ||= e[bt] = {hoistableStyles: new Map, hoistableScripts: new Map}, t
        }

        function Dt(e) {
            e[xt] = !0
        }

        var Ot = new Set, kt = {};

        function At(e, t) {
            jt(e, t), jt(e + `Capture`, t)
        }

        function jt(e, t) {
            for (kt[e] = t, e = 0; e < t.length; e++) Ot.add(t[e])
        }

        var Mt = RegExp(`^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$`),
            Nt = {}, Pt = {};

        function Ft(e) {
            return Oe.call(Pt, e) ? !0 : Oe.call(Nt, e) ? !1 : Mt.test(e) ? Pt[e] = !0 : (Nt[e] = !0, !1)
        }

        function It(e, t, n) {
            if (Ft(t)) if (n === null) e.removeAttribute(t); else {
                switch (typeof n) {
                    case`undefined`:
                    case`function`:
                    case`symbol`:
                        e.removeAttribute(t);
                        return;
                    case`boolean`:
                        var r = t.toLowerCase().slice(0, 5);
                        if (r !== `data-` && r !== `aria-`) {
                            e.removeAttribute(t);
                            return
                        }
                }
                e.setAttribute(t, `` + n)
            }
        }

        function Lt(e, t, n) {
            if (n === null) e.removeAttribute(t); else {
                switch (typeof n) {
                    case`undefined`:
                    case`function`:
                    case`symbol`:
                    case`boolean`:
                        e.removeAttribute(t);
                        return
                }
                e.setAttribute(t, `` + n)
            }
        }

        function Rt(e, t, n, r) {
            if (r === null) e.removeAttribute(n); else {
                switch (typeof r) {
                    case`undefined`:
                    case`function`:
                    case`symbol`:
                    case`boolean`:
                        e.removeAttribute(n);
                        return
                }
                e.setAttributeNS(t, n, `` + r)
            }
        }

        function zt(e) {
            switch (typeof e) {
                case`bigint`:
                case`boolean`:
                case`number`:
                case`string`:
                case`undefined`:
                    return e;
                case`object`:
                    return e;
                default:
                    return ``
            }
        }

        function Bt(e) {
            var t = e.type;
            return (e = e.nodeName) && e.toLowerCase() === `input` && (t === `checkbox` || t === `radio`)
        }

        function Vt(e, t, n) {
            var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
            if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == `function` && typeof r.set == `function`) {
                var i = r.get, a = r.set;
                return Object.defineProperty(e, t, {
                    configurable: !0, get: function () {
                        return i.call(this)
                    }, set: function (e) {
                        n = `` + e, a.call(this, e)
                    }
                }), Object.defineProperty(e, t, {enumerable: r.enumerable}), {
                    getValue: function () {
                        return n
                    }, setValue: function (e) {
                        n = `` + e
                    }, stopTracking: function () {
                        e._valueTracker = null, delete e[t]
                    }
                }
            }
        }

        function Ht(e) {
            if (!e._valueTracker) {
                var t = Bt(e) ? `checked` : `value`;
                e._valueTracker = Vt(e, t, `` + e[t])
            }
        }

        function Ut(e) {
            if (!e) return !1;
            var t = e._valueTracker;
            if (!t) return !0;
            var n = t.getValue(), r = ``;
            return e && (r = Bt(e) ? e.checked ? `true` : `false` : e.value), e = r, e === n ? !1 : (t.setValue(e), !0)
        }

        function Wt(e) {
            if (e ||= typeof document < `u` ? document : void 0, e === void 0) return null;
            try {
                return e.activeElement || e.body
            } catch {
                return e.body
            }
        }

        var Gt = /[\n"\\]/g;

        function Kt(e) {
            return e.replace(Gt, function (e) {
                return `\\` + e.charCodeAt(0).toString(16) + ` `
            })
        }

        function qt(e, t, n, r, i, a, o, s) {
            e.name = ``, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` ? e.type = o : e.removeAttribute(`type`), t == null ? o !== `submit` && o !== `reset` || e.removeAttribute(`value`) : o === `number` ? (t === 0 && e.value === `` || e.value != t) && (e.value = `` + zt(t)) : e.value !== `` + zt(t) && (e.value = `` + zt(t)), t == null ? n == null ? r != null && e.removeAttribute(`value`) : Yt(e, o, zt(n)) : Yt(e, o, zt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != `function` && typeof i != `symbol`), s != null && typeof s != `function` && typeof s != `symbol` && typeof s != `boolean` ? e.name = `` + zt(s) : e.removeAttribute(`name`)
        }

        function Jt(e, t, n, r, i, a, o, s) {
            if (a != null && typeof a != `function` && typeof a != `symbol` && typeof a != `boolean` && (e.type = a), t != null || n != null) {
                if (!(a !== `submit` && a !== `reset` || t != null)) {
                    Ht(e);
                    return
                }
                n = n == null ? `` : `` + zt(n), t = t == null ? n : `` + zt(t), s || t === e.value || (e.value = t), e.defaultValue = t
            }
            r ??= i, r = typeof r != `function` && typeof r != `symbol` && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` && (e.name = o), Ht(e)
        }

        function Yt(e, t, n) {
            t === `number` && Wt(e.ownerDocument) === e || e.defaultValue === `` + n || (e.defaultValue = `` + n)
        }

        function Xt(e, t, n, r) {
            if (e = e.options, t) {
                t = {};
                for (var i = 0; i < n.length; i++) t[`$` + n[i]] = !0;
                for (n = 0; n < e.length; n++) i = t.hasOwnProperty(`$` + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0)
            } else {
                for (n = `` + zt(n), t = null, i = 0; i < e.length; i++) {
                    if (e[i].value === n) {
                        e[i].selected = !0, r && (e[i].defaultSelected = !0);
                        return
                    }
                    t !== null || e[i].disabled || (t = e[i])
                }
                t !== null && (t.selected = !0)
            }
        }

        function Zt(e, t, n) {
            if (t != null && (t = `` + zt(t), t !== e.value && (e.value = t), n == null)) {
                e.defaultValue !== t && (e.defaultValue = t);
                return
            }
            e.defaultValue = n == null ? `` : `` + zt(n)
        }

        function Qt(e, t, n, r) {
            if (t == null) {
                if (r != null) {
                    if (n != null) throw Error(i(92));
                    if (se(r)) {
                        if (1 < r.length) throw Error(i(93));
                        r = r[0]
                    }
                    n = r
                }
                n ??= ``, t = n
            }
            n = zt(t), e.defaultValue = n, r = e.textContent, r === n && r !== `` && r !== null && (e.value = r), Ht(e)
        }

        function $t(e, t) {
            if (t) {
                var n = e.firstChild;
                if (n && n === e.lastChild && n.nodeType === 3) {
                    n.nodeValue = t;
                    return
                }
            }
            e.textContent = t
        }

        var en = new Set(`animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp`.split(` `));

        function tn(e, t, n) {
            var r = t.indexOf(`--`) === 0;
            n == null || typeof n == `boolean` || n === `` ? r ? e.setProperty(t, ``) : t === `float` ? e.cssFloat = `` : e[t] = `` : r ? e.setProperty(t, n) : typeof n != `number` || n === 0 || en.has(t) ? t === `float` ? e.cssFloat = n : e[t] = (`` + n).trim() : e[t] = n + `px`
        }

        function nn(e, t, n) {
            if (t != null && typeof t != `object`) throw Error(i(62));
            if (e = e.style, n != null) {
                for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf(`--`) === 0 ? e.setProperty(r, ``) : r === `float` ? e.cssFloat = `` : e[r] = ``);
                for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && tn(e, a, r)
            } else for (var o in t) t.hasOwnProperty(o) && tn(e, o, t[o])
        }

        function rn(e) {
            if (e.indexOf(`-`) === -1) return !1;
            switch (e) {
                case`annotation-xml`:
                case`color-profile`:
                case`font-face`:
                case`font-face-src`:
                case`font-face-uri`:
                case`font-face-format`:
                case`font-face-name`:
                case`missing-glyph`:
                    return !1;
                default:
                    return !0
            }
        }

        var an = new Map([[`acceptCharset`, `accept-charset`], [`htmlFor`, `for`], [`httpEquiv`, `http-equiv`], [`crossOrigin`, `crossorigin`], [`accentHeight`, `accent-height`], [`alignmentBaseline`, `alignment-baseline`], [`arabicForm`, `arabic-form`], [`baselineShift`, `baseline-shift`], [`capHeight`, `cap-height`], [`clipPath`, `clip-path`], [`clipRule`, `clip-rule`], [`colorInterpolation`, `color-interpolation`], [`colorInterpolationFilters`, `color-interpolation-filters`], [`colorProfile`, `color-profile`], [`colorRendering`, `color-rendering`], [`dominantBaseline`, `dominant-baseline`], [`enableBackground`, `enable-background`], [`fillOpacity`, `fill-opacity`], [`fillRule`, `fill-rule`], [`floodColor`, `flood-color`], [`floodOpacity`, `flood-opacity`], [`fontFamily`, `font-family`], [`fontSize`, `font-size`], [`fontSizeAdjust`, `font-size-adjust`], [`fontStretch`, `font-stretch`], [`fontStyle`, `font-style`], [`fontVariant`, `font-variant`], [`fontWeight`, `font-weight`], [`glyphName`, `glyph-name`], [`glyphOrientationHorizontal`, `glyph-orientation-horizontal`], [`glyphOrientationVertical`, `glyph-orientation-vertical`], [`horizAdvX`, `horiz-adv-x`], [`horizOriginX`, `horiz-origin-x`], [`imageRendering`, `image-rendering`], [`letterSpacing`, `letter-spacing`], [`lightingColor`, `lighting-color`], [`markerEnd`, `marker-end`], [`markerMid`, `marker-mid`], [`markerStart`, `marker-start`], [`overlinePosition`, `overline-position`], [`overlineThickness`, `overline-thickness`], [`paintOrder`, `paint-order`], [`panose-1`, `panose-1`], [`pointerEvents`, `pointer-events`], [`renderingIntent`, `rendering-intent`], [`shapeRendering`, `shape-rendering`], [`stopColor`, `stop-color`], [`stopOpacity`, `stop-opacity`], [`strikethroughPosition`, `strikethrough-position`], [`strikethroughThickness`, `strikethrough-thickness`], [`strokeDasharray`, `stroke-dasharray`], [`strokeDashoffset`, `stroke-dashoffset`], [`strokeLinecap`, `stroke-linecap`], [`strokeLinejoin`, `stroke-linejoin`], [`strokeMiterlimit`, `stroke-miterlimit`], [`strokeOpacity`, `stroke-opacity`], [`strokeWidth`, `stroke-width`], [`textAnchor`, `text-anchor`], [`textDecoration`, `text-decoration`], [`textRendering`, `text-rendering`], [`transformOrigin`, `transform-origin`], [`underlinePosition`, `underline-position`], [`underlineThickness`, `underline-thickness`], [`unicodeBidi`, `unicode-bidi`], [`unicodeRange`, `unicode-range`], [`unitsPerEm`, `units-per-em`], [`vAlphabetic`, `v-alphabetic`], [`vHanging`, `v-hanging`], [`vIdeographic`, `v-ideographic`], [`vMathematical`, `v-mathematical`], [`vectorEffect`, `vector-effect`], [`vertAdvY`, `vert-adv-y`], [`vertOriginX`, `vert-origin-x`], [`vertOriginY`, `vert-origin-y`], [`wordSpacing`, `word-spacing`], [`writingMode`, `writing-mode`], [`xmlnsXlink`, `xmlns:xlink`], [`xHeight`, `x-height`]]),
            on = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;

        function sn(e) {
            return on.test(`` + e) ? `javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')` : e
        }

        function cn() {
        }

        var ln = null;

        function un(e) {
            return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e
        }

        var dn = null, fn = null;

        function pn(e) {
            var t = wt(e);
            if (t && (e = t.stateNode)) {
                var n = e[ht] || null;
                a:switch (e = t.stateNode, t.type) {
                    case`input`:
                        if (qt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === `radio` && t != null) {
                            for (n = e; n.parentNode;) n = n.parentNode;
                            for (n = n.querySelectorAll(`input[name="` + Kt(`` + t) + `"][type="radio"]`), t = 0; t < n.length; t++) {
                                var r = n[t];
                                if (r !== e && r.form === e.form) {
                                    var a = r[ht] || null;
                                    if (!a) throw Error(i(90));
                                    qt(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name)
                                }
                            }
                            for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Ut(r)
                        }
                        break a;
                    case`textarea`:
                        Zt(e, n.value, n.defaultValue);
                        break a;
                    case`select`:
                        t = n.value, t != null && Xt(e, !!n.multiple, t, !1)
                }
            }
        }

        var mn = !1;

        function hn(e, t, n) {
            if (mn) return e(t, n);
            mn = !0;
            try {
                return e(t)
            } finally {
                if (mn = !1, (dn !== null || fn !== null) && (bu(), dn && (t = dn, e = fn, fn = dn = null, pn(t), e))) for (t = 0; t < e.length; t++) pn(e[t])
            }
        }

        function gn(e, t) {
            var n = e.stateNode;
            if (n === null) return null;
            var r = n[ht] || null;
            if (r === null) return null;
            n = r[t];
            a:switch (t) {
                case`onClick`:
                case`onClickCapture`:
                case`onDoubleClick`:
                case`onDoubleClickCapture`:
                case`onMouseDown`:
                case`onMouseDownCapture`:
                case`onMouseMove`:
                case`onMouseMoveCapture`:
                case`onMouseUp`:
                case`onMouseUpCapture`:
                case`onMouseEnter`:
                    (r = !r.disabled) || (e = e.type, r = !(e === `button` || e === `input` || e === `select` || e === `textarea`)), e = !r;
                    break a;
                default:
                    e = !1
            }
            if (e) return null;
            if (n && typeof n != `function`) throw Error(i(231, t, typeof n));
            return n
        }

        var _n = !(typeof window > `u` || window.document === void 0 || window.document.createElement === void 0), vn = !1;
        if (_n) try {
            var yn = {};
            Object.defineProperty(yn, `passive`, {
                get: function () {
                    vn = !0
                }
            }), window.addEventListener(`test`, yn, yn), window.removeEventListener(`test`, yn, yn)
        } catch {
            vn = !1
        }
        var bn = null, xn = null, Sn = null;

        function Cn() {
            if (Sn) return Sn;
            var e, t = xn, n = t.length, r, i = `value` in bn ? bn.value : bn.textContent, a = i.length;
            for (e = 0; e < n && t[e] === i[e]; e++) ;
            var o = n - e;
            for (r = 1; r <= o && t[n - r] === i[a - r]; r++) ;
            return Sn = i.slice(e, 1 < r ? 1 - r : void 0)
        }

        function wn(e) {
            var t = e.keyCode;
            return `charCode` in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0
        }

        function Tn() {
            return !0
        }

        function En() {
            return !1
        }

        function Dn(e) {
            function t(t, n, r, i, a) {
                for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
                return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? Tn : En, this.isPropagationStopped = En, this
            }

            return p(t.prototype, {
                preventDefault: function () {
                    this.defaultPrevented = !0;
                    var e = this.nativeEvent;
                    e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != `unknown` && (e.returnValue = !1), this.isDefaultPrevented = Tn)
                }, stopPropagation: function () {
                    var e = this.nativeEvent;
                    e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != `unknown` && (e.cancelBubble = !0), this.isPropagationStopped = Tn)
                }, persist: function () {
                }, isPersistent: Tn
            }), t
        }

        var On = {
                eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function (e) {
                    return e.timeStamp || Date.now()
                }, defaultPrevented: 0, isTrusted: 0
            }, kn = Dn(On), An = p({}, On, {view: 0, detail: 0}), jn = Dn(An), Mn, Nn, Pn, Fn = p({}, An, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: Jn,
                button: 0,
                buttons: 0,
                relatedTarget: function (e) {
                    return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget
                },
                movementX: function (e) {
                    return `movementX` in e ? e.movementX : (e !== Pn && (Pn && e.type === `mousemove` ? (Mn = e.screenX - Pn.screenX, Nn = e.screenY - Pn.screenY) : Nn = Mn = 0, Pn = e), Mn)
                },
                movementY: function (e) {
                    return `movementY` in e ? e.movementY : Nn
                }
            }), In = Dn(Fn), Ln = Dn(p({}, Fn, {dataTransfer: 0})), Rn = Dn(p({}, An, {relatedTarget: 0})),
            zn = Dn(p({}, On, {animationName: 0, elapsedTime: 0, pseudoElement: 0})), Bn = Dn(p({}, On, {
                clipboardData: function (e) {
                    return `clipboardData` in e ? e.clipboardData : window.clipboardData
                }
            })), Vn = Dn(p({}, On, {data: 0})), Hn = {
                Esc: `Escape`,
                Spacebar: ` `,
                Left: `ArrowLeft`,
                Up: `ArrowUp`,
                Right: `ArrowRight`,
                Down: `ArrowDown`,
                Del: `Delete`,
                Win: `OS`,
                Menu: `ContextMenu`,
                Apps: `ContextMenu`,
                Scroll: `ScrollLock`,
                MozPrintableKey: `Unidentified`
            }, Wn = {
                8: `Backspace`,
                9: `Tab`,
                12: `Clear`,
                13: `Enter`,
                16: `Shift`,
                17: `Control`,
                18: `Alt`,
                19: `Pause`,
                20: `CapsLock`,
                27: `Escape`,
                32: ` `,
                33: `PageUp`,
                34: `PageDown`,
                35: `End`,
                36: `Home`,
                37: `ArrowLeft`,
                38: `ArrowUp`,
                39: `ArrowRight`,
                40: `ArrowDown`,
                45: `Insert`,
                46: `Delete`,
                112: `F1`,
                113: `F2`,
                114: `F3`,
                115: `F4`,
                116: `F5`,
                117: `F6`,
                118: `F7`,
                119: `F8`,
                120: `F9`,
                121: `F10`,
                122: `F11`,
                123: `F12`,
                144: `NumLock`,
                145: `ScrollLock`,
                224: `Meta`
            }, Kn = {Alt: `altKey`, Control: `ctrlKey`, Meta: `metaKey`, Shift: `shiftKey`};

        function qn(e) {
            var t = this.nativeEvent;
            return t.getModifierState ? t.getModifierState(e) : (e = Kn[e]) ? !!t[e] : !1
        }

        function Jn() {
            return qn
        }

        var Yn = Dn(p({}, An, {
                key: function (e) {
                    if (e.key) {
                        var t = Hn[e.key] || e.key;
                        if (t !== `Unidentified`) return t
                    }
                    return e.type === `keypress` ? (e = wn(e), e === 13 ? `Enter` : String.fromCharCode(e)) : e.type === `keydown` || e.type === `keyup` ? Wn[e.keyCode] || `Unidentified` : ``
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: Jn,
                charCode: function (e) {
                    return e.type === `keypress` ? wn(e) : 0
                },
                keyCode: function (e) {
                    return e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0
                },
                which: function (e) {
                    return e.type === `keypress` ? wn(e) : e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0
                }
            })), Xn = Dn(p({}, Fn, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Zn = Dn(p({}, An, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: Jn
            })), Qn = Dn(p({}, On, {propertyName: 0, elapsedTime: 0, pseudoElement: 0})), $n = Dn(p({}, Fn, {
                deltaX: function (e) {
                    return `deltaX` in e ? e.deltaX : `wheelDeltaX` in e ? -e.wheelDeltaX : 0
                }, deltaY: function (e) {
                    return `deltaY` in e ? e.deltaY : `wheelDeltaY` in e ? -e.wheelDeltaY : `wheelDelta` in e ? -e.wheelDelta : 0
                }, deltaZ: 0, deltaMode: 0
            })), er = Dn(p({}, On, {newState: 0, oldState: 0})), tr = [9, 13, 27, 32], nr = _n && `CompositionEvent` in window,
            rr = null;
        _n && `documentMode` in document && (rr = document.documentMode);
        var ir = _n && `TextEvent` in window && !rr, ar = _n && (!nr || rr && 8 < rr && 11 >= rr), or = ` `, sr = !1;

        function cr(e, t) {
            switch (e) {
                case`keyup`:
                    return tr.indexOf(t.keyCode) !== -1;
                case`keydown`:
                    return t.keyCode !== 229;
                case`keypress`:
                case`mousedown`:
                case`focusout`:
                    return !0;
                default:
                    return !1
            }
        }

        function lr(e) {
            return e = e.detail, typeof e == `object` && `data` in e ? e.data : null
        }

        var ur = !1;

        function dr(e, t) {
            switch (e) {
                case`compositionend`:
                    return lr(t);
                case`keypress`:
                    return t.which === 32 ? (sr = !0, or) : null;
                case`textInput`:
                    return e = t.data, e === or && sr ? null : e;
                default:
                    return null
            }
        }

        function fr(e, t) {
            if (ur) return e === `compositionend` || !nr && cr(e, t) ? (e = Cn(), Sn = xn = bn = null, ur = !1, e) : null;
            switch (e) {
                case`paste`:
                    return null;
                case`keypress`:
                    if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                        if (t.char && 1 < t.char.length) return t.char;
                        if (t.which) return String.fromCharCode(t.which)
                    }
                    return null;
                case`compositionend`:
                    return ar && t.locale !== `ko` ? null : t.data;
                default:
                    return null
            }
        }

        var pr = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0
        };

        function mr(e) {
            var t = e && e.nodeName && e.nodeName.toLowerCase();
            return t === `input` ? !!pr[e.type] : t === `textarea`
        }

        function hr(e, t, n, r) {
            dn ? fn ? fn.push(r) : fn = [r] : dn = r, t = Ed(t, `onChange`), 0 < t.length && (n = new kn(`onChange`, `change`, null, n, r), e.push({
                event: n,
                listeners: t
            }))
        }

        var gr = null, _r = null;

        function vr(e) {
            yd(e, 0)
        }

        function yr(e) {
            if (Ut(Tt(e))) return e
        }

        function br(e, t) {
            if (e === `change`) return t
        }

        var xr = !1;
        if (_n) {
            var Sr;
            if (_n) {
                var Cr = `oninput` in document;
                if (!Cr) {
                    var wr = document.createElement(`div`);
                    wr.setAttribute(`oninput`, `return;`), Cr = typeof wr.oninput == `function`
                }
                Sr = Cr
            } else Sr = !1;
            xr = Sr && (!document.documentMode || 9 < document.documentMode)
        }

        function Tr() {
            gr && (gr.detachEvent(`onpropertychange`, Er), _r = gr = null)
        }

        function Er(e) {
            if (e.propertyName === `value` && yr(_r)) {
                var t = [];
                hr(t, _r, e, un(e)), hn(vr, t)
            }
        }

        function Dr(e, t, n) {
            e === `focusin` ? (Tr(), gr = t, _r = n, gr.attachEvent(`onpropertychange`, Er)) : e === `focusout` && Tr()
        }

        function Or(e) {
            if (e === `selectionchange` || e === `keyup` || e === `keydown`) return yr(_r)
        }

        function kr(e, t) {
            if (e === `click`) return yr(t)
        }

        function Ar(e, t) {
            if (e === `input` || e === `change`) return yr(t)
        }

        function jr(e, t) {
            return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t
        }

        var Mr = typeof Object.is == `function` ? Object.is : jr;

        function Nr(e, t) {
            if (Mr(e, t)) return !0;
            if (typeof e != `object` || !e || typeof t != `object` || !t) return !1;
            var n = Object.keys(e), r = Object.keys(t);
            if (n.length !== r.length) return !1;
            for (r = 0; r < n.length; r++) {
                var i = n[r];
                if (!Oe.call(t, i) || !Mr(e[i], t[i])) return !1
            }
            return !0
        }

        function Pr(e) {
            for (; e && e.firstChild;) e = e.firstChild;
            return e
        }

        function Fr(e, t) {
            var n = Pr(e);
            e = 0;
            for (var r; n;) {
                if (n.nodeType === 3) {
                    if (r = e + n.textContent.length, e <= t && r >= t) return {node: n, offset: t - e};
                    e = r
                }
                a:{
                    for (; n;) {
                        if (n.nextSibling) {
                            n = n.nextSibling;
                            break a
                        }
                        n = n.parentNode
                    }
                    n = void 0
                }
                n = Pr(n)
            }
        }

        function Ir(e, t) {
            return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Ir(e, t.parentNode) : `contains` in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1
        }

        function k(e) {
            e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
            for (var t = Wt(e.document); t instanceof e.HTMLIFrameElement;) {
                try {
                    var n = typeof t.contentWindow.location.href == `string`
                } catch {
                    n = !1
                }
                if (n) e = t.contentWindow; else break;
                t = Wt(e.document)
            }
            return t
        }

        function A(e) {
            var t = e && e.nodeName && e.nodeName.toLowerCase();
            return t && (t === `input` && (e.type === `text` || e.type === `search` || e.type === `tel` || e.type === `url` || e.type === `password`) || t === `textarea` || e.contentEditable === `true`)
        }

        var Lr = _n && `documentMode` in document && 11 >= document.documentMode, Rr = null, zr = null, Br = null, Vr = !1;

        function Hr(e, t, n) {
            var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
            Vr || Rr == null || Rr !== Wt(r) || (r = Rr, `selectionStart` in r && A(r) ? r = {
                start: r.selectionStart,
                end: r.selectionEnd
            } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
                anchorNode: r.anchorNode,
                anchorOffset: r.anchorOffset,
                focusNode: r.focusNode,
                focusOffset: r.focusOffset
            }), Br && Nr(Br, r) || (Br = r, r = Ed(zr, `onSelect`), 0 < r.length && (t = new kn(`onSelect`, `select`, null, t, n), e.push({
                event: t,
                listeners: r
            }), t.target = Rr)))
        }

        function Ur(e, t) {
            var n = {};
            return n[e.toLowerCase()] = t.toLowerCase(), n[`Webkit` + e] = `webkit` + t, n[`Moz` + e] = `moz` + t, n
        }

        var Wr = {
            animationend: Ur(`Animation`, `AnimationEnd`),
            animationiteration: Ur(`Animation`, `AnimationIteration`),
            animationstart: Ur(`Animation`, `AnimationStart`),
            transitionrun: Ur(`Transition`, `TransitionRun`),
            transitionstart: Ur(`Transition`, `TransitionStart`),
            transitioncancel: Ur(`Transition`, `TransitionCancel`),
            transitionend: Ur(`Transition`, `TransitionEnd`)
        }, Gr = {}, Kr = {};
        _n && (Kr = document.createElement(`div`).style, `AnimationEvent` in window || (delete Wr.animationend.animation, delete Wr.animationiteration.animation, delete Wr.animationstart.animation), `TransitionEvent` in window || delete Wr.transitionend.transition);

        function qr(e) {
            if (Gr[e]) return Gr[e];
            if (!Wr[e]) return e;
            var t = Wr[e], n;
            for (n in t) if (t.hasOwnProperty(n) && n in Kr) return Gr[e] = t[n];
            return e
        }

        var Jr = qr(`animationend`), Yr = qr(`animationiteration`), Xr = qr(`animationstart`), j = qr(`transitionrun`),
            Zr = qr(`transitionstart`), Qr = qr(`transitioncancel`), M = qr(`transitionend`), $r = new Map,
            ei = `abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel`.split(` `);
        ei.push(`scrollEnd`);

        function ti(e, t) {
            $r.set(e, t), At(t, [e])
        }

        var ni = typeof reportError == `function` ? reportError : function (e) {
            if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
                var t = new window.ErrorEvent(`error`, {
                    bubbles: !0,
                    cancelable: !0,
                    message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
                    error: e
                });
                if (!window.dispatchEvent(t)) return
            } else if (typeof process == `object` && typeof process.emit == `function`) {
                process.emit(`uncaughtException`, e);
                return
            }
            console.error(e)
        }, ri = [], ii = 0, ai = 0;

        function oi() {
            for (var e = ii, t = ai = ii = 0; t < e;) {
                var n = ri[t];
                ri[t++] = null;
                var r = ri[t];
                ri[t++] = null;
                var i = ri[t];
                ri[t++] = null;
                var a = ri[t];
                if (ri[t++] = null, r !== null && i !== null) {
                    var o = r.pending;
                    o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i
                }
                a !== 0 && ui(n, i, a)
            }
        }

        function si(e, t, n, r) {
            ri[ii++] = e, ri[ii++] = t, ri[ii++] = n, ri[ii++] = r, ai |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r)
        }

        function ci(e, t, n, r) {
            return si(e, t, n, r), di(e)
        }

        function li(e, t) {
            return si(e, null, null, t), di(e)
        }

        function ui(e, t, n) {
            e.lanes |= n;
            var r = e.alternate;
            r !== null && (r.lanes |= n);
            for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
            return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ge(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null
        }

        function di(e) {
            if (50 < du) throw du = 0, fu = null, Error(i(185));
            for (var t = e.return; t !== null;) e = t, t = e.return;
            return e.tag === 3 ? e.stateNode : null
        }

        var fi = {};

        function pi(e, t, n, r) {
            this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null
        }

        function mi(e, t, n, r) {
            return new pi(e, t, n, r)
        }

        function hi(e) {
            return e = e.prototype, !(!e || !e.isReactComponent)
        }

        function gi(e, t) {
            var n = e.alternate;
            return n === null ? (n = mi(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
                lanes: t.lanes,
                firstContext: t.firstContext
            }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n
        }

        function _i(e, t) {
            e.flags &= 65011714;
            var n = e.alternate;
            return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
                lanes: t.lanes,
                firstContext: t.firstContext
            }), e
        }

        function vi(e, t, n, r, a, o) {
            var s = 0;
            if (r = e, typeof e == `function`) hi(e) && (s = 1); else if (typeof e == `string`) s = Uf(e, n, pe.current) ? 26 : e === `html` || e === `head` || e === `body` ? 27 : 5; else a:switch (e) {
                case te:
                    return e = mi(31, n, t, a), e.elementType = te, e.lanes = o, e;
                case _:
                    return yi(n.children, a, o, t);
                case v:
                    s = 8, a |= 24;
                    break;
                case y:
                    return e = mi(12, n, t, a | 2), e.elementType = y, e.lanes = o, e;
                case C:
                    return e = mi(13, n, t, a), e.elementType = C, e.lanes = o, e;
                case w:
                    return e = mi(19, n, t, a), e.elementType = w, e.lanes = o, e;
                default:
                    if (typeof e == `object` && e) switch (e.$$typeof) {
                        case x:
                            s = 10;
                            break a;
                        case b:
                            s = 9;
                            break a;
                        case S:
                            s = 11;
                            break a;
                        case ee:
                            s = 14;
                            break a;
                        case T:
                            s = 16, r = null;
                            break a
                    }
                    s = 29, n = Error(i(130, e === null ? `null` : typeof e, ``)), r = null
            }
            return t = mi(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t
        }

        function yi(e, t, n, r) {
            return e = mi(7, e, r, t), e.lanes = n, e
        }

        function bi(e, t, n) {
            return e = mi(6, e, null, t), e.lanes = n, e
        }

        function xi(e) {
            var t = mi(18, null, null, 0);
            return t.stateNode = e, t
        }

        function Si(e, t, n) {
            return t = mi(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
                containerInfo: e.containerInfo,
                pendingChildren: null,
                implementation: e.implementation
            }, t
        }

        var Ci = new WeakMap;

        function wi(e, t) {
            if (typeof e == `object` && e) {
                var n = Ci.get(e);
                return n === void 0 ? (t = {value: e, source: t, stack: De(t)}, Ci.set(e, t), t) : n
            }
            return {value: e, source: t, stack: De(t)}
        }

        var Ti = [], Ei = 0, Di = null, Oi = 0, ki = [], Ai = 0, ji = null, Mi = 1, Ni = ``;

        function Pi(e, t) {
            Ti[Ei++] = Oi, Ti[Ei++] = Di, Di = e, Oi = t
        }

        function Fi(e, t, n) {
            ki[Ai++] = Mi, ki[Ai++] = Ni, ki[Ai++] = ji, ji = e;
            var r = Mi;
            e = Ni;
            var i = 32 - Ge(r) - 1;
            r &= ~(1 << i), n += 1;
            var a = 32 - Ge(t) + i;
            if (30 < a) {
                var o = i - i % 5;
                a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, Mi = 1 << 32 - Ge(t) + i | n << i | r, Ni = a + e
            } else Mi = 1 << a | n << i | r, Ni = e
        }

        function Ii(e) {
            e.return !== null && (Pi(e, 1), Fi(e, 1, 0))
        }

        function Li(e) {
            for (; e === Di;) Di = Ti[--Ei], Ti[Ei] = null, Oi = Ti[--Ei], Ti[Ei] = null;
            for (; e === ji;) ji = ki[--Ai], ki[Ai] = null, Ni = ki[--Ai], ki[Ai] = null, Mi = ki[--Ai], ki[Ai] = null
        }

        function Ri(e, t) {
            ki[Ai++] = Mi, ki[Ai++] = Ni, ki[Ai++] = ji, Mi = t.id, Ni = t.overflow, ji = e
        }

        var zi = null, N = null, P = !1, Bi = null, Vi = !1, Hi = Error(i(519));

        function Ui(e) {
            throw Yi(wi(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? `text` : `HTML`, ``)), e)), Hi
        }

        function Wi(e) {
            var t = e.stateNode, n = e.type, r = e.memoizedProps;
            switch (t[mt] = e, t[ht] = r, n) {
                case`dialog`:
                    Q(`cancel`, t), Q(`close`, t);
                    break;
                case`iframe`:
                case`object`:
                case`embed`:
                    Q(`load`, t);
                    break;
                case`video`:
                case`audio`:
                    for (n = 0; n < _d.length; n++) Q(_d[n], t);
                    break;
                case`source`:
                    Q(`error`, t);
                    break;
                case`img`:
                case`image`:
                case`link`:
                    Q(`error`, t), Q(`load`, t);
                    break;
                case`details`:
                    Q(`toggle`, t);
                    break;
                case`input`:
                    Q(`invalid`, t), Jt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
                    break;
                case`select`:
                    Q(`invalid`, t);
                    break;
                case`textarea`:
                    Q(`invalid`, t), Qt(t, r.value, r.defaultValue, r.children)
            }
            n = r.children, typeof n != `string` && typeof n != `number` && typeof n != `bigint` || t.textContent === `` + n || !0 === r.suppressHydrationWarning || Md(t.textContent, n) ? (r.popover != null && (Q(`beforetoggle`, t), Q(`toggle`, t)), r.onScroll != null && Q(`scroll`, t), r.onScrollEnd != null && Q(`scrollend`, t), r.onClick != null && (t.onclick = cn), t = !0) : t = !1, t || Ui(e, !0)
        }

        function Gi(e) {
            for (zi = e.return; zi;) switch (zi.tag) {
                case 5:
                case 31:
                case 13:
                    Vi = !1;
                    return;
                case 27:
                case 3:
                    Vi = !0;
                    return;
                default:
                    zi = zi.return
            }
        }

        function Ki(e) {
            if (e !== zi) return !1;
            if (!P) return Gi(e), P = !0, !1;
            var t = e.tag, n;
            if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== `form` && n !== `button`) || Ud(e.type, e.memoizedProps)), n = !n), n && N && Ui(e), Gi(e), t === 13) {
                if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
                N = uf(e)
            } else if (t === 31) {
                if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
                N = uf(e)
            } else t === 27 ? (t = N, Zd(e.type) ? (e = lf, lf = null, N = e) : N = t) : N = zi ? cf(e.stateNode.nextSibling) : null;
            return !0
        }

        function qi() {
            N = zi = null, P = !1
        }

        function Ji() {
            var e = Bi;
            return e !== null && (Zl === null ? Zl = e : Zl.push.apply(Zl, e), Bi = null), e
        }

        function Yi(e) {
            Bi === null ? Bi = [e] : Bi.push(e)
        }

        var Xi = de(null), Zi = null, Qi = null;

        function $i(e, t, n) {
            O(Xi, t._currentValue), t._currentValue = n
        }

        function ea(e) {
            e._currentValue = Xi.current, fe(Xi)
        }

        function ta(e, t, n) {
            for (; e !== null;) {
                var r = e.alternate;
                if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
                e = e.return
            }
        }

        function na(e, t, n, r) {
            var a = e.child;
            for (a !== null && (a.return = e); a !== null;) {
                var o = a.dependencies;
                if (o !== null) {
                    var s = a.child;
                    o = o.firstContext;
                    a:for (; o !== null;) {
                        var c = o;
                        o = a;
                        for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
                            o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), ta(o.return, n, e), r || (s = null);
                            break a
                        }
                        o = c.next
                    }
                } else if (a.tag === 18) {
                    if (s = a.return, s === null) throw Error(i(341));
                    s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), ta(s, n, e), s = null
                } else s = a.child;
                if (s !== null) s.return = a; else for (s = a; s !== null;) {
                    if (s === e) {
                        s = null;
                        break
                    }
                    if (a = s.sibling, a !== null) {
                        a.return = s.return, s = a;
                        break
                    }
                    s = s.return
                }
                a = s
            }
        }

        function ra(e, t, n, r) {
            e = null;
            for (var a = t, o = !1; a !== null;) {
                if (!o) {
                    if (a.flags & 524288) o = !0; else if (a.flags & 262144) break
                }
                if (a.tag === 10) {
                    var s = a.alternate;
                    if (s === null) throw Error(i(387));
                    if (s = s.memoizedProps, s !== null) {
                        var c = a.type;
                        Mr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c))
                    }
                } else if (a === ge.current) {
                    if (s = a.alternate, s === null) throw Error(i(387));
                    s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf))
                }
                a = a.return
            }
            e !== null && na(t, e, n, r), t.flags |= 262144
        }

        function ia(e) {
            for (e = e.firstContext; e !== null;) {
                if (!Mr(e.context._currentValue, e.memoizedValue)) return !0;
                e = e.next
            }
            return !1
        }

        function aa(e) {
            Zi = e, Qi = null, e = e.dependencies, e !== null && (e.firstContext = null)
        }

        function oa(e) {
            return ca(Zi, e)
        }

        function sa(e, t) {
            return Zi === null && aa(e), ca(e, t)
        }

        function ca(e, t) {
            var n = t._currentValue;
            if (t = {context: t, memoizedValue: n, next: null}, Qi === null) {
                if (e === null) throw Error(i(308));
                Qi = t, e.dependencies = {lanes: 0, firstContext: t}, e.flags |= 524288
            } else Qi = Qi.next = t;
            return n
        }

        var la = typeof AbortController < `u` ? AbortController : function () {
                var e = [], t = this.signal = {
                    aborted: !1, addEventListener: function (t, n) {
                        e.push(n)
                    }
                };
                this.abort = function () {
                    t.aborted = !0, e.forEach(function (e) {
                        return e()
                    })
                }
            }, ua = t.unstable_scheduleCallback, da = t.unstable_NormalPriority,
            F = {$$typeof: x, Consumer: null, Provider: null, _currentValue: null, _currentValue2: null, _threadCount: 0};

        function fa() {
            return {controller: new la, data: new Map, refCount: 0}
        }

        function pa(e) {
            e.refCount--, e.refCount === 0 && ua(da, function () {
                e.controller.abort()
            })
        }

        var ma = null, ha = 0, ga = 0, _a = null;

        function va(e, t) {
            if (ma === null) {
                var n = ma = [];
                ha = 0, ga = dd(), _a = {
                    status: `pending`, value: void 0, then: function (e) {
                        n.push(e)
                    }
                }
            }
            return ha++, t.then(ya, ya), t
        }

        function ya() {
            if (--ha === 0 && ma !== null) {
                _a !== null && (_a.status = `fulfilled`);
                var e = ma;
                ma = null, ga = 0, _a = null;
                for (var t = 0; t < e.length; t++) (0, e[t])()
            }
        }

        function ba(e, t) {
            var n = [], r = {
                status: `pending`, value: null, reason: null, then: function (e) {
                    n.push(e)
                }
            };
            return e.then(function () {
                r.status = `fulfilled`, r.value = t;
                for (var e = 0; e < n.length; e++) (0, n[e])(t)
            }, function (e) {
                for (r.status = `rejected`, r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0)
            }), r
        }

        var xa = E.S;
        E.S = function (e, t) {
            eu = Ne(), typeof t == `object` && t && typeof t.then == `function` && va(e, t), xa !== null && xa(e, t)
        };
        var Sa = de(null);

        function Ca() {
            var e = Sa.current;
            return e === null ? K.pooledCache : e
        }

        function wa(e, t) {
            t === null ? O(Sa, Sa.current) : O(Sa, t.pool)
        }

        function Ta() {
            var e = Ca();
            return e === null ? null : {parent: F._currentValue, pool: e}
        }

        var Ea = Error(i(460)), Da = Error(i(474)), Oa = Error(i(542)), ka = {
            then: function () {
            }
        };

        function Aa(e) {
            return e = e.status, e === `fulfilled` || e === `rejected`
        }

        function ja(e, t, n) {
            switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(cn, cn), t = n), t.status) {
                case`fulfilled`:
                    return t.value;
                case`rejected`:
                    throw e = t.reason, Fa(e), e;
                default:
                    if (typeof t.status == `string`) t.then(cn, cn); else {
                        if (e = K, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
                        e = t, e.status = `pending`, e.then(function (e) {
                            if (t.status === `pending`) {
                                var n = t;
                                n.status = `fulfilled`, n.value = e
                            }
                        }, function (e) {
                            if (t.status === `pending`) {
                                var n = t;
                                n.status = `rejected`, n.reason = e
                            }
                        })
                    }
                    switch (t.status) {
                        case`fulfilled`:
                            return t.value;
                        case`rejected`:
                            throw e = t.reason, Fa(e), e
                    }
                    throw Na = t, Ea
            }
        }

        function Ma(e) {
            try {
                var t = e._init;
                return t(e._payload)
            } catch (e) {
                throw typeof e == `object` && e && typeof e.then == `function` ? (Na = e, Ea) : e
            }
        }

        var Na = null;

        function Pa() {
            if (Na === null) throw Error(i(459));
            var e = Na;
            return Na = null, e
        }

        function Fa(e) {
            if (e === Ea || e === Oa) throw Error(i(483))
        }

        var Ia = null, La = 0;

        function Ra(e) {
            var t = La;
            return La += 1, Ia === null && (Ia = []), ja(Ia, e, t)
        }

        function za(e, t) {
            t = t.props.ref, e.ref = t === void 0 ? null : t
        }

        function Ba(e, t) {
            throw t.$$typeof === m ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === `[object Object]` ? `object with keys {` + Object.keys(t).join(`, `) + `}` : e)))
        }

        function Va(e) {
            function t(t, n) {
                if (e) {
                    var r = t.deletions;
                    r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n)
                }
            }

            function n(n, r) {
                if (!e) return null;
                for (; r !== null;) t(n, r), r = r.sibling;
                return null
            }

            function r(e) {
                for (var t = new Map; e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
                return t
            }

            function a(e, t) {
                return e = gi(e, t), e.index = 0, e.sibling = null, e
            }

            function o(t, n, r) {
                return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n)
            }

            function s(t) {
                return e && t.alternate === null && (t.flags |= 67108866), t
            }

            function c(e, t, n, r) {
                return t === null || t.tag !== 6 ? (t = bi(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t)
            }

            function l(e, t, n, r) {
                var i = n.type;
                return i === _ ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == `object` && i && i.$$typeof === T && Ma(i) === t.type) ? (t = a(t, n.props), za(t, n), t.return = e, t) : (t = vi(n.type, n.key, n.props, null, e.mode, r), za(t, n), t.return = e, t)
            }

            function u(e, t, n, r) {
                return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = Si(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t)
            }

            function d(e, t, n, r, i) {
                return t === null || t.tag !== 7 ? (t = yi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t)
            }

            function f(e, t, n) {
                if (typeof t == `string` && t !== `` || typeof t == `number` || typeof t == `bigint`) return t = bi(`` + t, e.mode, n), t.return = e, t;
                if (typeof t == `object` && t) {
                    switch (t.$$typeof) {
                        case h:
                            return n = vi(t.type, t.key, t.props, null, e.mode, n), za(n, t), n.return = e, n;
                        case g:
                            return t = Si(t, e.mode, n), t.return = e, t;
                        case T:
                            return t = Ma(t), f(e, t, n)
                    }
                    if (se(t) || ie(t)) return t = yi(t, e.mode, n, null), t.return = e, t;
                    if (typeof t.then == `function`) return f(e, Ra(t), n);
                    if (t.$$typeof === x) return f(e, sa(e, t), n);
                    Ba(e, t)
                }
                return null
            }

            function p(e, t, n, r) {
                var i = t === null ? null : t.key;
                if (typeof n == `string` && n !== `` || typeof n == `number` || typeof n == `bigint`) return i === null ? c(e, t, `` + n, r) : null;
                if (typeof n == `object` && n) {
                    switch (n.$$typeof) {
                        case h:
                            return n.key === i ? l(e, t, n, r) : null;
                        case g:
                            return n.key === i ? u(e, t, n, r) : null;
                        case T:
                            return n = Ma(n), p(e, t, n, r)
                    }
                    if (se(n) || ie(n)) return i === null ? d(e, t, n, r, null) : null;
                    if (typeof n.then == `function`) return p(e, t, Ra(n), r);
                    if (n.$$typeof === x) return p(e, t, sa(e, n), r);
                    Ba(e, n)
                }
                return null
            }

            function m(e, t, n, r, i) {
                if (typeof r == `string` && r !== `` || typeof r == `number` || typeof r == `bigint`) return e = e.get(n) || null, c(t, e, `` + r, i);
                if (typeof r == `object` && r) {
                    switch (r.$$typeof) {
                        case h:
                            return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
                        case g:
                            return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
                        case T:
                            return r = Ma(r), m(e, t, n, r, i)
                    }
                    if (se(r) || ie(r)) return e = e.get(n) || null, d(t, e, r, i, null);
                    if (typeof r.then == `function`) return m(e, t, n, Ra(r), i);
                    if (r.$$typeof === x) return m(e, t, n, sa(t, r), i);
                    Ba(t, r)
                }
                return null
            }

            function v(i, a, s, c) {
                for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
                    d.index > h ? (g = d, d = null) : g = d.sibling;
                    var _ = p(i, d, s[h], c);
                    if (_ === null) {
                        d === null && (d = g);
                        break
                    }
                    e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g
                }
                if (h === s.length) return n(i, d), P && Pi(i, h), l;
                if (d === null) {
                    for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
                    return P && Pi(i, h), l
                }
                for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
                return e && d.forEach(function (e) {
                    return t(i, e)
                }), P && Pi(i, h), l
            }

            function y(a, s, c, l) {
                if (c == null) throw Error(i(151));
                for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
                    h.index > g ? (_ = h, h = null) : _ = h.sibling;
                    var y = p(a, h, v.value, l);
                    if (y === null) {
                        h === null && (h = _);
                        break
                    }
                    e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _
                }
                if (v.done) return n(a, h), P && Pi(a, g), u;
                if (h === null) {
                    for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
                    return P && Pi(a, g), u
                }
                for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
                return e && h.forEach(function (e) {
                    return t(a, e)
                }), P && Pi(a, g), u
            }

            function b(e, r, o, c) {
                if (typeof o == `object` && o && o.type === _ && o.key === null && (o = o.props.children), typeof o == `object` && o) {
                    switch (o.$$typeof) {
                        case h:
                            a:{
                                for (var l = o.key; r !== null;) {
                                    if (r.key === l) {
                                        if (l = o.type, l === _) {
                                            if (r.tag === 7) {
                                                n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
                                                break a
                                            }
                                        } else if (r.elementType === l || typeof l == `object` && l && l.$$typeof === T && Ma(l) === r.type) {
                                            n(e, r.sibling), c = a(r, o.props), za(c, o), c.return = e, e = c;
                                            break a
                                        }
                                        n(e, r);
                                        break
                                    } else t(e, r);
                                    r = r.sibling
                                }
                                o.type === _ ? (c = yi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = vi(o.type, o.key, o.props, null, e.mode, c), za(c, o), c.return = e, e = c)
                            }
                            return s(e);
                        case g:
                            a:{
                                for (l = o.key; r !== null;) {
                                    if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
                                        n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
                                        break a
                                    } else {
                                        n(e, r);
                                        break
                                    } else t(e, r);
                                    r = r.sibling
                                }
                                c = Si(o, e.mode, c), c.return = e, e = c
                            }
                            return s(e);
                        case T:
                            return o = Ma(o), b(e, r, o, c)
                    }
                    if (se(o)) return v(e, r, o, c);
                    if (ie(o)) {
                        if (l = ie(o), typeof l != `function`) throw Error(i(150));
                        return o = l.call(o), y(e, r, o, c)
                    }
                    if (typeof o.then == `function`) return b(e, r, Ra(o), c);
                    if (o.$$typeof === x) return b(e, r, sa(e, o), c);
                    Ba(e, o)
                }
                return typeof o == `string` && o !== `` || typeof o == `number` || typeof o == `bigint` ? (o = `` + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = bi(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r)
            }

            return function (e, t, n, r) {
                try {
                    La = 0;
                    var i = b(e, t, n, r);
                    return Ia = null, i
                } catch (t) {
                    if (t === Ea || t === Oa) throw t;
                    var a = mi(29, t, null, e.mode);
                    return a.lanes = r, a.return = e, a
                }
            }
        }

        var Ha = Va(!0), Ua = Va(!1), Wa = !1;

        function Ga(e) {
            e.updateQueue = {
                baseState: e.memoizedState,
                firstBaseUpdate: null,
                lastBaseUpdate: null,
                shared: {pending: null, lanes: 0, hiddenCallbacks: null},
                callbacks: null
            }
        }

        function Ka(e, t) {
            e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null
            })
        }

        function qa(e) {
            return {lane: e, tag: 0, payload: null, callback: null, next: null}
        }

        function Ja(e, t, n) {
            var r = e.updateQueue;
            if (r === null) return null;
            if (r = r.shared, G & 2) {
                var i = r.pending;
                return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = di(e), ui(e, null, n), t
            }
            return si(e, r, t, n), di(e)
        }

        function Ya(e, t, n) {
            if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
                var r = t.lanes;
                r &= e.pendingLanes, n |= r, t.lanes = n, st(e, n)
            }
        }

        function Xa(e, t) {
            var n = e.updateQueue, r = e.alternate;
            if (r !== null && (r = r.updateQueue, n === r)) {
                var i = null, a = null;
                if (n = n.firstBaseUpdate, n !== null) {
                    do {
                        var o = {lane: n.lane, tag: n.tag, payload: n.payload, callback: null, next: null};
                        a === null ? i = a = o : a = a.next = o, n = n.next
                    } while (n !== null);
                    a === null ? i = a = t : a = a.next = t
                } else i = a = t;
                n = {
                    baseState: r.baseState,
                    firstBaseUpdate: i,
                    lastBaseUpdate: a,
                    shared: r.shared,
                    callbacks: r.callbacks
                }, e.updateQueue = n;
                return
            }
            e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t
        }

        var Za = !1;

        function Qa() {
            if (Za) {
                var e = _a;
                if (e !== null) throw e
            }
        }

        function $a(e, t, n, r) {
            Za = !1;
            var i = e.updateQueue;
            Wa = !1;
            var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
            if (s !== null) {
                i.shared.pending = null;
                var c = s, l = c.next;
                c.next = null, o === null ? a = l : o.next = l, o = c;
                var u = e.alternate;
                u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c))
            }
            if (a !== null) {
                var d = i.baseState;
                o = 0, u = l = c = null, s = a;
                do {
                    var f = s.lane & -536870913, m = f !== s.lane;
                    if (m ? (J & f) === f : (r & f) === f) {
                        f !== 0 && f === ga && (Za = !0), u !== null && (u = u.next = {
                            lane: 0,
                            tag: s.tag,
                            payload: s.payload,
                            callback: null,
                            next: null
                        });
                        a:{
                            var h = e, g = s;
                            f = t;
                            var _ = n;
                            switch (g.tag) {
                                case 1:
                                    if (h = g.payload, typeof h == `function`) {
                                        d = h.call(_, d, f);
                                        break a
                                    }
                                    d = h;
                                    break a;
                                case 3:
                                    h.flags = h.flags & -65537 | 128;
                                case 0:
                                    if (h = g.payload, f = typeof h == `function` ? h.call(_, d, f) : h, f == null) break a;
                                    d = p({}, d, f);
                                    break a;
                                case 2:
                                    Wa = !0
                            }
                        }
                        f = s.callback, f !== null && (e.flags |= 64, m && (e.flags |= 8192), m = i.callbacks, m === null ? i.callbacks = [f] : m.push(f))
                    } else m = {
                        lane: f,
                        tag: s.tag,
                        payload: s.payload,
                        callback: s.callback,
                        next: null
                    }, u === null ? (l = u = m, c = d) : u = u.next = m, o |= f;
                    if (s = s.next, s === null) {
                        if (s = i.shared.pending, s === null) break;
                        m = s, s = m.next, m.next = null, i.lastBaseUpdate = m, i.shared.pending = null
                    }
                } while (1);
                u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Gl |= o, e.lanes = o, e.memoizedState = d
            }
        }

        function eo(e, t) {
            if (typeof e != `function`) throw Error(i(191, e));
            e.call(t)
        }

        function to(e, t) {
            var n = e.callbacks;
            if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) eo(n[e], t)
        }

        var no = de(null), ro = de(0);

        function io(e, t) {
            e = Wl, O(ro, e), O(no, t), Wl = e | t.baseLanes
        }

        function ao() {
            O(ro, Wl), O(no, no.current)
        }

        function oo() {
            Wl = ro.current, fe(no), fe(ro)
        }

        var I = de(null), L = null;

        function so(e) {
            var t = e.alternate;
            O(R, R.current & 1), O(I, e), L === null && (t === null || no.current !== null || t.memoizedState !== null) && (L = e)
        }

        function co(e) {
            O(R, R.current), O(I, e), L === null && (L = e)
        }

        function lo(e) {
            e.tag === 22 ? (O(R, R.current), O(I, e), L === null && (L = e)) : uo(e)
        }

        function uo() {
            O(R, R.current), O(I, I.current)
        }

        function fo(e) {
            fe(I), L === e && (L = null), fe(R)
        }

        var R = de(0);

        function po(e) {
            for (var t = e; t !== null;) {
                if (t.tag === 13) {
                    var n = t.memoizedState;
                    if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t
                } else if (t.tag === 19 && (t.memoizedProps.revealOrder === `forwards` || t.memoizedProps.revealOrder === `backwards` || t.memoizedProps.revealOrder === `unstable_legacy-backwards` || t.memoizedProps.revealOrder === `together`)) {
                    if (t.flags & 128) return t
                } else if (t.child !== null) {
                    t.child.return = t, t = t.child;
                    continue
                }
                if (t === e) break;
                for (; t.sibling === null;) {
                    if (t.return === null || t.return === e) return null;
                    t = t.return
                }
                t.sibling.return = t.return, t = t.sibling
            }
            return null
        }

        var mo = 0, z = null, B = null, ho = null, go = !1, _o = !1, vo = !1, yo = 0, bo = 0, xo = null, So = 0;

        function V() {
            throw Error(i(321))
        }

        function Co(e, t) {
            if (t === null) return !1;
            for (var n = 0; n < t.length && n < e.length; n++) if (!Mr(e[n], t[n])) return !1;
            return !0
        }

        function wo(e, t, n, r, i, a) {
            return mo = a, z = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, E.H = e === null || e.memoizedState === null ? Bs : Vs, vo = !1, a = n(r, i), vo = !1, _o && (a = Eo(t, n, r, i)), To(e), a
        }

        function To(e) {
            E.H = zs;
            var t = B !== null && B.next !== null;
            if (mo = 0, ho = B = z = null, go = !1, bo = 0, xo = null, t) throw Error(i(300));
            e === null || ic || (e = e.dependencies, e !== null && ia(e) && (ic = !0))
        }

        function Eo(e, t, n, r) {
            z = e;
            var a = 0;
            do {
                if (_o && (xo = null), bo = 0, _o = !1, 25 <= a) throw Error(i(301));
                if (a += 1, ho = B = null, e.updateQueue != null) {
                    var o = e.updateQueue;
                    o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0)
                }
                E.H = Hs, o = t(n, r)
            } while (_o);
            return o
        }

        function Do() {
            var e = E.H, t = e.useState()[0];
            return t = typeof t.then == `function` ? No(t) : t, e = e.useState()[0], (B === null ? null : B.memoizedState) !== e && (z.flags |= 1024), t
        }

        function Oo() {
            var e = yo !== 0;
            return yo = 0, e
        }

        function ko(e, t, n) {
            t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n
        }

        function Ao(e) {
            if (go) {
                for (e = e.memoizedState; e !== null;) {
                    var t = e.queue;
                    t !== null && (t.pending = null), e = e.next
                }
                go = !1
            }
            mo = 0, ho = B = z = null, _o = !1, bo = yo = 0, xo = null
        }

        function jo() {
            var e = {memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null};
            return ho === null ? z.memoizedState = ho = e : ho = ho.next = e, ho
        }

        function H() {
            if (B === null) {
                var e = z.alternate;
                e = e === null ? null : e.memoizedState
            } else e = B.next;
            var t = ho === null ? z.memoizedState : ho.next;
            if (t !== null) ho = t, B = e; else {
                if (e === null) throw z.alternate === null ? Error(i(467)) : Error(i(310));
                B = e, e = {
                    memoizedState: B.memoizedState,
                    baseState: B.baseState,
                    baseQueue: B.baseQueue,
                    queue: B.queue,
                    next: null
                }, ho === null ? z.memoizedState = ho = e : ho = ho.next = e
            }
            return ho
        }

        function Mo() {
            return {lastEffect: null, events: null, stores: null, memoCache: null}
        }

        function No(e) {
            var t = bo;
            return bo += 1, xo === null && (xo = []), e = ja(xo, e, t), t = z, (ho === null ? t.memoizedState : ho.next) === null && (t = t.alternate, E.H = t === null || t.memoizedState === null ? Bs : Vs), e
        }

        function Po(e) {
            if (typeof e == `object` && e) {
                if (typeof e.then == `function`) return No(e);
                if (e.$$typeof === x) return oa(e)
            }
            throw Error(i(438, String(e)))
        }

        function Fo(e) {
            var t = null, n = z.updateQueue;
            if (n !== null && (t = n.memoCache), t == null) {
                var r = z.alternate;
                r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
                    data: r.data.map(function (e) {
                        return e.slice()
                    }), index: 0
                })))
            }
            if (t ??= {
                data: [],
                index: 0
            }, n === null && (n = Mo(), z.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = ne;
            return t.index++, n
        }

        function Io(e, t) {
            return typeof t == `function` ? t(e) : t
        }

        function Lo(e) {
            return Ro(H(), B, e)
        }

        function Ro(e, t, n) {
            var r = e.queue;
            if (r === null) throw Error(i(311));
            r.lastRenderedReducer = n;
            var a = e.baseQueue, o = r.pending;
            if (o !== null) {
                if (a !== null) {
                    var s = a.next;
                    a.next = o.next, o.next = s
                }
                t.baseQueue = a = o, r.pending = null
            }
            if (o = e.baseState, a === null) e.memoizedState = o; else {
                t = a.next;
                var c = s = null, l = null, u = t, d = !1;
                do {
                    var f = u.lane & -536870913;
                    if (f === u.lane ? (mo & f) === f : (J & f) === f) {
                        var p = u.revertLane;
                        if (p === 0) l !== null && (l = l.next = {
                            lane: 0,
                            revertLane: 0,
                            gesture: null,
                            action: u.action,
                            hasEagerState: u.hasEagerState,
                            eagerState: u.eagerState,
                            next: null
                        }), f === ga && (d = !0); else if ((mo & p) === p) {
                            u = u.next, p === ga && (d = !0);
                            continue
                        } else f = {
                            lane: 0,
                            revertLane: u.revertLane,
                            gesture: null,
                            action: u.action,
                            hasEagerState: u.hasEagerState,
                            eagerState: u.eagerState,
                            next: null
                        }, l === null ? (c = l = f, s = o) : l = l.next = f, z.lanes |= p, Gl |= p;
                        f = u.action, vo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f)
                    } else p = {
                        lane: f,
                        revertLane: u.revertLane,
                        gesture: u.gesture,
                        action: u.action,
                        hasEagerState: u.hasEagerState,
                        eagerState: u.eagerState,
                        next: null
                    }, l === null ? (c = l = p, s = o) : l = l.next = p, z.lanes |= f, Gl |= f;
                    u = u.next
                } while (u !== null && u !== t);
                if (l === null ? s = o : l.next = c, !Mr(o, e.memoizedState) && (ic = !0, d && (n = _a, n !== null))) throw n;
                e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o
            }
            return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch]
        }

        function zo(e) {
            var t = H(), n = t.queue;
            if (n === null) throw Error(i(311));
            n.lastRenderedReducer = e;
            var r = n.dispatch, a = n.pending, o = t.memoizedState;
            if (a !== null) {
                n.pending = null;
                var s = a = a.next;
                do o = e(o, s.action), s = s.next; while (s !== a);
                Mr(o, t.memoizedState) || (ic = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o
            }
            return [o, r]
        }

        function Bo(e, t, n) {
            var r = z, a = H(), o = P;
            if (o) {
                if (n === void 0) throw Error(i(407));
                n = n()
            } else n = t();
            var s = !Mr((B || a).memoizedState, n);
            if (s && (a.memoizedState = n, ic = !0), a = a.queue, ds(Uo.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || ho !== null && ho.memoizedState.tag & 1) {
                if (r.flags |= 2048, os(9, {destroy: void 0}, Ho.bind(null, r, a, n, t), null), K === null) throw Error(i(349));
                o || mo & 127 || Vo(r, t, n)
            }
            return n
        }

        function Vo(e, t, n) {
            e.flags |= 16384, e = {
                getSnapshot: t,
                value: n
            }, t = z.updateQueue, t === null ? (t = Mo(), z.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e))
        }

        function Ho(e, t, n, r) {
            t.value = n, t.getSnapshot = r, Wo(t) && Go(e)
        }

        function Uo(e, t, n) {
            return n(function () {
                Wo(t) && Go(e)
            })
        }

        function Wo(e) {
            var t = e.getSnapshot;
            e = e.value;
            try {
                var n = t();
                return !Mr(e, n)
            } catch {
                return !0
            }
        }

        function Go(e) {
            var t = li(e, 2);
            t !== null && hu(t, e, 2)
        }

        function Ko(e) {
            var t = jo();
            if (typeof e == `function`) {
                var n = e;
                if (e = n(), vo) {
                    We(!0);
                    try {
                        n()
                    } finally {
                        We(!1)
                    }
                }
            }
            return t.memoizedState = t.baseState = e, t.queue = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Io,
                lastRenderedState: e
            }, t
        }

        function qo(e, t, n, r) {
            return e.baseState = n, Ro(e, B, typeof r == `function` ? r : Io)
        }

        function Jo(e, t, n, r, a) {
            if (Is(e)) throw Error(i(485));
            if (e = t.action, e !== null) {
                var o = {
                    payload: a,
                    action: e,
                    next: null,
                    isTransition: !0,
                    status: `pending`,
                    value: null,
                    reason: null,
                    listeners: [],
                    then: function (e) {
                        o.listeners.push(e)
                    }
                };
                E.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Yo(t, o)) : (o.next = n.next, t.pending = n.next = o)
            }
        }

        function Yo(e, t) {
            var n = t.action, r = t.payload, i = e.state;
            if (t.isTransition) {
                var a = E.T, o = {};
                E.T = o;
                try {
                    var s = n(i, r), c = E.S;
                    c !== null && c(o, s), Xo(e, t, s)
                } catch (n) {
                    Qo(e, t, n)
                } finally {
                    a !== null && o.types !== null && (a.types = o.types), E.T = a
                }
            } else try {
                a = n(i, r), Xo(e, t, a)
            } catch (n) {
                Qo(e, t, n)
            }
        }

        function Xo(e, t, n) {
            typeof n == `object` && n && typeof n.then == `function` ? n.then(function (n) {
                Zo(e, t, n)
            }, function (n) {
                return Qo(e, t, n)
            }) : Zo(e, t, n)
        }

        function Zo(e, t, n) {
            t.status = `fulfilled`, t.value = n, $o(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Yo(e, n)))
        }

        function Qo(e, t, n) {
            var r = e.pending;
            if (e.pending = null, r !== null) {
                r = r.next;
                do t.status = `rejected`, t.reason = n, $o(t), t = t.next; while (t !== r)
            }
            e.action = null
        }

        function $o(e) {
            e = e.listeners;
            for (var t = 0; t < e.length; t++) (0, e[t])()
        }

        function es(e, t) {
            return t
        }

        function ts(e, t) {
            if (P) {
                var n = K.formState;
                if (n !== null) {
                    a:{
                        var r = z;
                        if (P) {
                            if (N) {
                                b:{
                                    for (var i = N, a = Vi; i.nodeType !== 8;) {
                                        if (!a) {
                                            i = null;
                                            break b
                                        }
                                        if (i = cf(i.nextSibling), i === null) {
                                            i = null;
                                            break b
                                        }
                                    }
                                    a = i.data, i = a === `F!` || a === `F` ? i : null
                                }
                                if (i) {
                                    N = cf(i.nextSibling), r = i.data === `F!`;
                                    break a
                                }
                            }
                            Ui(r)
                        }
                        r = !1
                    }
                    r && (t = n[0])
                }
            }
            return n = jo(), n.memoizedState = n.baseState = t, r = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: es,
                lastRenderedState: t
            }, n.queue = r, n = Ns.bind(null, z, r), r.dispatch = n, r = Ko(!1), a = Fs.bind(null, z, !1, r.queue), r = jo(), i = {
                state: t,
                dispatch: null,
                action: e,
                pending: null
            }, r.queue = i, n = Jo.bind(null, z, i, a, n), i.dispatch = n, r.memoizedState = e, [t, n, !1]
        }

        function ns(e) {
            return rs(H(), B, e)
        }

        function rs(e, t, n) {
            if (t = Ro(e, t, es)[0], e = Lo(Io)[0], typeof t == `object` && t && typeof t.then == `function`) try {
                var r = No(t)
            } catch (e) {
                throw e === Ea ? Oa : e
            } else r = t;
            t = H();
            var i = t.queue, a = i.dispatch;
            return n !== t.memoizedState && (z.flags |= 2048, os(9, {destroy: void 0}, is.bind(null, i, n), null)), [r, a, e]
        }

        function is(e, t) {
            e.action = t
        }

        function as(e) {
            var t = H(), n = B;
            if (n !== null) return rs(t, n, e);
            H(), t = t.memoizedState, n = H();
            var r = n.queue.dispatch;
            return n.memoizedState = e, [t, r, !1]
        }

        function os(e, t, n, r) {
            return e = {
                tag: e,
                create: n,
                deps: r,
                inst: t,
                next: null
            }, t = z.updateQueue, t === null && (t = Mo(), z.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e
        }

        function ss() {
            return H().memoizedState
        }

        function cs(e, t, n, r) {
            var i = jo();
            z.flags |= e, i.memoizedState = os(1 | t, {destroy: void 0}, n, r === void 0 ? null : r)
        }

        function ls(e, t, n, r) {
            var i = H();
            r = r === void 0 ? null : r;
            var a = i.memoizedState.inst;
            B !== null && r !== null && Co(r, B.memoizedState.deps) ? i.memoizedState = os(t, a, n, r) : (z.flags |= e, i.memoizedState = os(1 | t, a, n, r))
        }

        function us(e, t) {
            cs(8390656, 8, e, t)
        }

        function ds(e, t) {
            ls(2048, 8, e, t)
        }

        function fs(e) {
            z.flags |= 4;
            var t = z.updateQueue;
            if (t === null) t = Mo(), z.updateQueue = t, t.events = [e]; else {
                var n = t.events;
                n === null ? t.events = [e] : n.push(e)
            }
        }

        function ps(e) {
            var t = H().memoizedState;
            return fs({ref: t, nextImpl: e}), function () {
                if (G & 2) throw Error(i(440));
                return t.impl.apply(void 0, arguments)
            }
        }

        function ms(e, t) {
            return ls(4, 2, e, t)
        }

        function hs(e, t) {
            return ls(4, 4, e, t)
        }

        function gs(e, t) {
            if (typeof t == `function`) {
                e = e();
                var n = t(e);
                return function () {
                    typeof n == `function` ? n() : t(null)
                }
            }
            if (t != null) return e = e(), t.current = e, function () {
                t.current = null
            }
        }

        function _s(e, t, n) {
            n = n == null ? null : n.concat([e]), ls(4, 4, gs.bind(null, t, e), n)
        }

        function vs() {
        }

        function ys(e, t) {
            var n = H();
            t = t === void 0 ? null : t;
            var r = n.memoizedState;
            return t !== null && Co(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e)
        }

        function bs(e, t) {
            var n = H();
            t = t === void 0 ? null : t;
            var r = n.memoizedState;
            if (t !== null && Co(t, r[1])) return r[0];
            if (r = e(), vo) {
                We(!0);
                try {
                    e()
                } finally {
                    We(!1)
                }
            }
            return n.memoizedState = [r, t], r
        }

        function xs(e, t, n) {
            return n === void 0 || mo & 1073741824 && !(J & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = mu(), z.lanes |= e, Gl |= e, n)
        }

        function Ss(e, t, n, r) {
            return Mr(n, t) ? n : no.current === null ? !(mo & 42) || mo & 1073741824 && !(J & 261930) ? (ic = !0, e.memoizedState = n) : (e = mu(), z.lanes |= e, Gl |= e, t) : (e = xs(e, n, r), Mr(e, t) || (ic = !0), e)
        }

        function Cs(e, t, n, r, i) {
            var a = D.p;
            D.p = a !== 0 && 8 > a ? a : 8;
            var o = E.T, s = {};
            E.T = s, Fs(e, !1, t, n);
            try {
                var c = i(), l = E.S;
                l !== null && l(s, c), typeof c == `object` && c && typeof c.then == `function` ? Ps(e, t, ba(c, r), pu(e)) : Ps(e, t, r, pu(e))
            } catch (n) {
                Ps(e, t, {
                    then: function () {
                    }, status: `rejected`, reason: n
                }, pu())
            } finally {
                D.p = a, o !== null && s.types !== null && (o.types = s.types), E.T = o
            }
        }

        function ws() {
        }

        function Ts(e, t, n, r) {
            if (e.tag !== 5) throw Error(i(476));
            var a = Es(e).queue;
            Cs(e, a, t, ce, n === null ? ws : function () {
                return Ds(e), n(r)
            })
        }

        function Es(e) {
            var t = e.memoizedState;
            if (t !== null) return t;
            t = {
                memoizedState: ce,
                baseState: ce,
                baseQueue: null,
                queue: {pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Io, lastRenderedState: ce},
                next: null
            };
            var n = {};
            return t.next = {
                memoizedState: n,
                baseState: n,
                baseQueue: null,
                queue: {pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Io, lastRenderedState: n},
                next: null
            }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t
        }

        function Ds(e) {
            var t = Es(e);
            t.next === null && (t = e.alternate.memoizedState), Ps(e, t.next.queue, {}, pu())
        }

        function Os() {
            return oa(Qf)
        }

        function ks() {
            return H().memoizedState
        }

        function As() {
            return H().memoizedState
        }

        function js(e) {
            for (var t = e.return; t !== null;) {
                switch (t.tag) {
                    case 24:
                    case 3:
                        var n = pu();
                        e = qa(n);
                        var r = Ja(t, e, n);
                        r !== null && (hu(r, t, n), Ya(r, t, n)), t = {cache: fa()}, e.payload = t;
                        return
                }
                t = t.return
            }
        }

        function Ms(e, t, n) {
            var r = pu();
            n = {
                lane: r,
                revertLane: 0,
                gesture: null,
                action: n,
                hasEagerState: !1,
                eagerState: null,
                next: null
            }, Is(e) ? Ls(t, n) : (n = ci(e, t, n, r), n !== null && (hu(n, e, r), Rs(n, t, r)))
        }

        function Ns(e, t, n) {
            Ps(e, t, n, pu())
        }

        function Ps(e, t, n, r) {
            var i = {lane: r, revertLane: 0, gesture: null, action: n, hasEagerState: !1, eagerState: null, next: null};
            if (Is(e)) Ls(t, i); else {
                var a = e.alternate;
                if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
                    var o = t.lastRenderedState, s = a(o, n);
                    if (i.hasEagerState = !0, i.eagerState = s, Mr(s, o)) return si(e, t, i, 0), K === null && oi(), !1
                } catch {
                }
                if (n = ci(e, t, i, r), n !== null) return hu(n, e, r), Rs(n, t, r), !0
            }
            return !1
        }

        function Fs(e, t, n, r) {
            if (r = {
                lane: 2,
                revertLane: dd(),
                gesture: null,
                action: r,
                hasEagerState: !1,
                eagerState: null,
                next: null
            }, Is(e)) {
                if (t) throw Error(i(479))
            } else t = ci(e, n, r, 2), t !== null && hu(t, e, 2)
        }

        function Is(e) {
            var t = e.alternate;
            return e === z || t !== null && t === z
        }

        function Ls(e, t) {
            _o = go = !0;
            var n = e.pending;
            n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t
        }

        function Rs(e, t, n) {
            if (n & 4194048) {
                var r = t.lanes;
                r &= e.pendingLanes, n |= r, t.lanes = n, st(e, n)
            }
        }

        var zs = {
            readContext: oa,
            use: Po,
            useCallback: V,
            useContext: V,
            useEffect: V,
            useImperativeHandle: V,
            useLayoutEffect: V,
            useInsertionEffect: V,
            useMemo: V,
            useReducer: V,
            useRef: V,
            useState: V,
            useDebugValue: V,
            useDeferredValue: V,
            useTransition: V,
            useSyncExternalStore: V,
            useId: V,
            useHostTransitionStatus: V,
            useFormState: V,
            useActionState: V,
            useOptimistic: V,
            useMemoCache: V,
            useCacheRefresh: V
        };
        zs.useEffectEvent = V;
        var Bs = {
            readContext: oa, use: Po, useCallback: function (e, t) {
                return jo().memoizedState = [e, t === void 0 ? null : t], e
            }, useContext: oa, useEffect: us, useImperativeHandle: function (e, t, n) {
                n = n == null ? null : n.concat([e]), cs(4194308, 4, gs.bind(null, t, e), n)
            }, useLayoutEffect: function (e, t) {
                return cs(4194308, 4, e, t)
            }, useInsertionEffect: function (e, t) {
                cs(4, 2, e, t)
            }, useMemo: function (e, t) {
                var n = jo();
                t = t === void 0 ? null : t;
                var r = e();
                if (vo) {
                    We(!0);
                    try {
                        e()
                    } finally {
                        We(!1)
                    }
                }
                return n.memoizedState = [r, t], r
            }, useReducer: function (e, t, n) {
                var r = jo();
                if (n !== void 0) {
                    var i = n(t);
                    if (vo) {
                        We(!0);
                        try {
                            n(t)
                        } finally {
                            We(!1)
                        }
                    }
                } else i = t;
                return r.memoizedState = r.baseState = i, e = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: e,
                    lastRenderedState: i
                }, r.queue = e, e = e.dispatch = Ms.bind(null, z, e), [r.memoizedState, e]
            }, useRef: function (e) {
                var t = jo();
                return e = {current: e}, t.memoizedState = e
            }, useState: function (e) {
                e = Ko(e);
                var t = e.queue, n = Ns.bind(null, z, t);
                return t.dispatch = n, [e.memoizedState, n]
            }, useDebugValue: vs, useDeferredValue: function (e, t) {
                return xs(jo(), e, t)
            }, useTransition: function () {
                var e = Ko(!1);
                return e = Cs.bind(null, z, e.queue, !0, !1), jo().memoizedState = e, [!1, e]
            }, useSyncExternalStore: function (e, t, n) {
                var r = z, a = jo();
                if (P) {
                    if (n === void 0) throw Error(i(407));
                    n = n()
                } else {
                    if (n = t(), K === null) throw Error(i(349));
                    J & 127 || Vo(r, t, n)
                }
                a.memoizedState = n;
                var o = {value: n, getSnapshot: t};
                return a.queue = o, us(Uo.bind(null, r, o, e), [e]), r.flags |= 2048, os(9, {destroy: void 0}, Ho.bind(null, r, o, n, t), null), n
            }, useId: function () {
                var e = jo(), t = K.identifierPrefix;
                if (P) {
                    var n = Ni, r = Mi;
                    n = (r & ~(1 << 32 - Ge(r) - 1)).toString(32) + n, t = `_` + t + `R_` + n, n = yo++, 0 < n && (t += `H` + n.toString(32)), t += `_`
                } else n = So++, t = `_` + t + `r_` + n.toString(32) + `_`;
                return e.memoizedState = t
            }, useHostTransitionStatus: Os, useFormState: ts, useActionState: ts, useOptimistic: function (e) {
                var t = jo();
                t.memoizedState = t.baseState = e;
                var n = {pending: null, lanes: 0, dispatch: null, lastRenderedReducer: null, lastRenderedState: null};
                return t.queue = n, t = Fs.bind(null, z, !0, n), n.dispatch = t, [e, t]
            }, useMemoCache: Fo, useCacheRefresh: function () {
                return jo().memoizedState = js.bind(null, z)
            }, useEffectEvent: function (e) {
                var t = jo(), n = {impl: e};
                return t.memoizedState = n, function () {
                    if (G & 2) throw Error(i(440));
                    return n.impl.apply(void 0, arguments)
                }
            }
        }, Vs = {
            readContext: oa,
            use: Po,
            useCallback: ys,
            useContext: oa,
            useEffect: ds,
            useImperativeHandle: _s,
            useInsertionEffect: ms,
            useLayoutEffect: hs,
            useMemo: bs,
            useReducer: Lo,
            useRef: ss,
            useState: function () {
                return Lo(Io)
            },
            useDebugValue: vs,
            useDeferredValue: function (e, t) {
                return Ss(H(), B.memoizedState, e, t)
            },
            useTransition: function () {
                var e = Lo(Io)[0], t = H().memoizedState;
                return [typeof e == `boolean` ? e : No(e), t]
            },
            useSyncExternalStore: Bo,
            useId: ks,
            useHostTransitionStatus: Os,
            useFormState: ns,
            useActionState: ns,
            useOptimistic: function (e, t) {
                return qo(H(), B, e, t)
            },
            useMemoCache: Fo,
            useCacheRefresh: As
        };
        Vs.useEffectEvent = ps;
        var Hs = {
            readContext: oa,
            use: Po,
            useCallback: ys,
            useContext: oa,
            useEffect: ds,
            useImperativeHandle: _s,
            useInsertionEffect: ms,
            useLayoutEffect: hs,
            useMemo: bs,
            useReducer: zo,
            useRef: ss,
            useState: function () {
                return zo(Io)
            },
            useDebugValue: vs,
            useDeferredValue: function (e, t) {
                var n = H();
                return B === null ? xs(n, e, t) : Ss(n, B.memoizedState, e, t)
            },
            useTransition: function () {
                var e = zo(Io)[0], t = H().memoizedState;
                return [typeof e == `boolean` ? e : No(e), t]
            },
            useSyncExternalStore: Bo,
            useId: ks,
            useHostTransitionStatus: Os,
            useFormState: as,
            useActionState: as,
            useOptimistic: function (e, t) {
                var n = H();
                return B === null ? (n.baseState = e, [e, n.queue.dispatch]) : qo(n, B, e, t)
            },
            useMemoCache: Fo,
            useCacheRefresh: As
        };
        Hs.useEffectEvent = ps;

        function Us(e, t, n, r) {
            t = e.memoizedState, n = n(r, t), n = n == null ? t : p({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n)
        }

        var Ws = {
            enqueueSetState: function (e, t, n) {
                e = e._reactInternals;
                var r = pu(), i = qa(r);
                i.payload = t, n != null && (i.callback = n), t = Ja(e, i, r), t !== null && (hu(t, e, r), Ya(t, e, r))
            }, enqueueReplaceState: function (e, t, n) {
                e = e._reactInternals;
                var r = pu(), i = qa(r);
                i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ja(e, i, r), t !== null && (hu(t, e, r), Ya(t, e, r))
            }, enqueueForceUpdate: function (e, t) {
                e = e._reactInternals;
                var n = pu(), r = qa(n);
                r.tag = 2, t != null && (r.callback = t), t = Ja(e, r, n), t !== null && (hu(t, e, n), Ya(t, e, n))
            }
        };

        function Gs(e, t, n, r, i, a, o) {
            return e = e.stateNode, typeof e.shouldComponentUpdate == `function` ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !Nr(n, r) || !Nr(i, a) : !0
        }

        function Ks(e, t, n, r) {
            e = t.state, typeof t.componentWillReceiveProps == `function` && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == `function` && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ws.enqueueReplaceState(t, t.state, null)
        }

        function qs(e, t) {
            var n = t;
            if (`ref` in t) for (var r in n = {}, t) r !== `ref` && (n[r] = t[r]);
            if (e = e.defaultProps) for (var i in n === t && (n = p({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
            return n
        }

        function Js(e) {
            ni(e)
        }

        function Ys(e) {
            console.error(e)
        }

        function Xs(e) {
            ni(e)
        }

        function Zs(e, t) {
            try {
                var n = e.onUncaughtError;
                n(t.value, {componentStack: t.stack})
            } catch (e) {
                setTimeout(function () {
                    throw e
                })
            }
        }

        function Qs(e, t, n) {
            try {
                var r = e.onCaughtError;
                r(n.value, {componentStack: n.stack, errorBoundary: t.tag === 1 ? t.stateNode : null})
            } catch (e) {
                setTimeout(function () {
                    throw e
                })
            }
        }

        function $s(e, t, n) {
            return n = qa(n), n.tag = 3, n.payload = {element: null}, n.callback = function () {
                Zs(e, t)
            }, n
        }

        function ec(e) {
            return e = qa(e), e.tag = 3, e
        }

        function tc(e, t, n, r) {
            var i = n.type.getDerivedStateFromError;
            if (typeof i == `function`) {
                var a = r.value;
                e.payload = function () {
                    return i(a)
                }, e.callback = function () {
                    Qs(t, n, r)
                }
            }
            var o = n.stateNode;
            o !== null && typeof o.componentDidCatch == `function` && (e.callback = function () {
                Qs(t, n, r), typeof i != `function` && (ru === null ? ru = new Set([this]) : ru.add(this));
                var e = r.stack;
                this.componentDidCatch(r.value, {componentStack: e === null ? `` : e})
            })
        }

        function nc(e, t, n, r, a) {
            if (n.flags |= 32768, typeof r == `object` && r && typeof r.then == `function`) {
                if (t = n.alternate, t !== null && ra(t, n, a, !0), n = I.current, n !== null) {
                    switch (n.tag) {
                        case 31:
                        case 13:
                            return L === null ? Du() : n.alternate === null && X === 0 && (X = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === ka ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Gu(e, r, a)), !1;
                        case 22:
                            return n.flags |= 65536, r === ka ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
                                transitions: null,
                                markerInstances: null,
                                retryQueue: new Set([r])
                            }, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Gu(e, r, a)), !1
                    }
                    throw Error(i(435, n.tag))
                }
                return Gu(e, r, a), Du(), !1
            }
            if (P) return t = I.current, t === null ? (r !== Hi && (t = Error(i(423), {cause: r}), Yi(wi(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = wi(r, n), a = $s(e.stateNode, r, a), Xa(e, a), X !== 4 && (X = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== Hi && (e = Error(i(422), {cause: r}), Yi(wi(e, n)))), !1;
            var o = Error(i(520), {cause: r});
            if (o = wi(o, n), Xl === null ? Xl = [o] : Xl.push(o), X !== 4 && (X = 2), t === null) return !0;
            r = wi(r, n), n = t;
            do {
                switch (n.tag) {
                    case 3:
                        return n.flags |= 65536, e = a & -a, n.lanes |= e, e = $s(n.stateNode, r, e), Xa(n, e), !1;
                    case 1:
                        if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == `function` || o !== null && typeof o.componentDidCatch == `function` && (ru === null || !ru.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = ec(a), tc(a, e, n, r), Xa(n, a), !1
                }
                n = n.return
            } while (n !== null);
            return !1
        }

        var rc = Error(i(461)), ic = !1;

        function ac(e, t, n, r) {
            t.child = e === null ? Ua(t, null, n, r) : Ha(t, e.child, n, r)
        }

        function oc(e, t, n, r, i) {
            n = n.render;
            var a = t.ref;
            if (`ref` in r) {
                var o = {};
                for (var s in r) s !== `ref` && (o[s] = r[s])
            } else o = r;
            return aa(t), r = wo(e, t, n, o, a, i), s = Oo(), e !== null && !ic ? (ko(e, t, i), Ac(e, t, i)) : (P && s && Ii(t), t.flags |= 1, ac(e, t, r, i), t.child)
        }

        function sc(e, t, n, r, i) {
            if (e === null) {
                var a = n.type;
                return typeof a == `function` && !hi(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, cc(e, t, a, r, i)) : (e = vi(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e)
            }
            if (a = e.child, !jc(e, i)) {
                var o = a.memoizedProps;
                if (n = n.compare, n = n === null ? Nr : n, n(o, r) && e.ref === t.ref) return Ac(e, t, i)
            }
            return t.flags |= 1, e = gi(a, r), e.ref = t.ref, e.return = t, t.child = e
        }

        function cc(e, t, n, r, i) {
            if (e !== null) {
                var a = e.memoizedProps;
                if (Nr(a, r) && e.ref === t.ref) if (ic = !1, t.pendingProps = r = a, jc(e, i)) e.flags & 131072 && (ic = !0); else return t.lanes = e.lanes, Ac(e, t, i)
            }
            return gc(e, t, n, r, i)
        }

        function lc(e, t, n, r) {
            var i = r.children, a = e === null ? null : e.memoizedState;
            if (e === null && t.stateNode === null && (t.stateNode = {
                _visibility: 1,
                _pendingMarkers: null,
                _retryCache: null,
                _transitions: null
            }), r.mode === `hidden`) {
                if (t.flags & 128) {
                    if (a = a === null ? n : a.baseLanes | n, e !== null) {
                        for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
                        r = i & ~a
                    } else r = 0, t.child = null;
                    return dc(e, t, a, n, r)
                }
                if (n & 536870912) t.memoizedState = {
                    baseLanes: 0,
                    cachePool: null
                }, e !== null && wa(t, a === null ? null : a.cachePool), a === null ? ao() : io(t, a), lo(t); else return r = t.lanes = 536870912, dc(e, t, a === null ? n : a.baseLanes | n, n, r)
            } else a === null ? (e !== null && wa(t, null), ao(), uo(t)) : (wa(t, a.cachePool), io(t, a), uo(t), t.memoizedState = null);
            return ac(e, t, i, n), t.child
        }

        function uc(e, t) {
            return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
                _visibility: 1,
                _pendingMarkers: null,
                _retryCache: null,
                _transitions: null
            }), t.sibling
        }

        function dc(e, t, n, r, i) {
            var a = Ca();
            return a = a === null ? null : {parent: F._currentValue, pool: a}, t.memoizedState = {
                baseLanes: n,
                cachePool: a
            }, e !== null && wa(t, null), ao(), lo(t), e !== null && ra(e, t, r, !0), t.childLanes = i, null
        }

        function fc(e, t) {
            return t = Tc({mode: t.mode, children: t.children}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t
        }

        function pc(e, t, n) {
            return Ha(t, e.child, null, n), e = fc(t, t.pendingProps), e.flags |= 2, fo(t), t.memoizedState = null, e
        }

        function mc(e, t, n) {
            var r = t.pendingProps, a = (t.flags & 128) != 0;
            if (t.flags &= -129, e === null) {
                if (P) {
                    if (r.mode === `hidden`) return e = fc(t, r), t.lanes = 536870912, uc(null, e);
                    if (co(t), (e = N) ? (e = rf(e, Vi), e = e !== null && e.data === `&` ? e : null, e !== null && (t.memoizedState = {
                        dehydrated: e,
                        treeContext: ji === null ? null : {id: Mi, overflow: Ni},
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, n = xi(e), n.return = t, t.child = n, zi = t, N = null)) : e = null, e === null) throw Ui(t);
                    return t.lanes = 536870912, null
                }
                return fc(t, r)
            }
            var o = e.memoizedState;
            if (o !== null) {
                var s = o.dehydrated;
                if (co(t), a) if (t.flags & 256) t.flags &= -257, t = pc(e, t, n); else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null; else throw Error(i(558)); else if (ic || ra(e, t, n, !1), a = (n & e.childLanes) !== 0, ic || a) {
                    if (r = K, r !== null && (s = ct(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, li(e, s), hu(r, e, s), rc;
                    Du(), t = pc(e, t, n)
                } else e = o.treeContext, N = cf(s.nextSibling), zi = t, P = !0, Bi = null, Vi = !1, e !== null && Ri(t, e), t = fc(t, r), t.flags |= 4096;
                return t
            }
            return e = gi(e.child, {mode: r.mode, children: r.children}), e.ref = t.ref, t.child = e, e.return = t, e
        }

        function hc(e, t) {
            var n = t.ref;
            if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816); else {
                if (typeof n != `function` && typeof n != `object`) throw Error(i(284));
                (e === null || e.ref !== n) && (t.flags |= 4194816)
            }
        }

        function gc(e, t, n, r, i) {
            return aa(t), n = wo(e, t, n, r, void 0, i), r = Oo(), e !== null && !ic ? (ko(e, t, i), Ac(e, t, i)) : (P && r && Ii(t), t.flags |= 1, ac(e, t, n, i), t.child)
        }

        function _c(e, t, n, r, i, a) {
            return aa(t), t.updateQueue = null, n = Eo(t, r, n, i), To(e), r = Oo(), e !== null && !ic ? (ko(e, t, a), Ac(e, t, a)) : (P && r && Ii(t), t.flags |= 1, ac(e, t, n, a), t.child)
        }

        function vc(e, t, n, r, i) {
            if (aa(t), t.stateNode === null) {
                var a = fi, o = n.contextType;
                typeof o == `object` && o && (a = oa(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Ws, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Ga(t), o = n.contextType, a.context = typeof o == `object` && o ? oa(o) : fi, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == `function` && (Us(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == `function` || typeof a.getSnapshotBeforeUpdate == `function` || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (o = a.state, typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount(), o !== a.state && Ws.enqueueReplaceState(a, a.state, null), $a(t, r, a, i), Qa(), a.state = t.memoizedState), typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !0
            } else if (e === null) {
                a = t.stateNode;
                var s = t.memoizedProps, c = qs(n, s);
                a.props = c;
                var l = a.context, u = n.contextType;
                o = fi, typeof u == `object` && u && (o = oa(u));
                var d = n.getDerivedStateFromProps;
                u = typeof d == `function` || typeof a.getSnapshotBeforeUpdate == `function`, s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (s || l !== o) && Ks(t, a, r, o), Wa = !1;
                var f = t.memoizedState;
                a.state = f, $a(t, r, a, i), Qa(), l = t.memoizedState, s || f !== l || Wa ? (typeof d == `function` && (Us(t, n, d, r), l = t.memoizedState), (c = Wa || Gs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == `function` && (t.flags |= 4194308)) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !1)
            } else {
                a = t.stateNode, Ka(e, t), o = t.memoizedProps, u = qs(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = fi, typeof l == `object` && l && (c = oa(l)), s = n.getDerivedStateFromProps, (l = typeof s == `function` || typeof a.getSnapshotBeforeUpdate == `function`) || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (o !== d || f !== c) && Ks(t, a, r, c), Wa = !1, f = t.memoizedState, a.state = f, $a(t, r, a, i), Qa();
                var p = t.memoizedState;
                o !== d || f !== p || Wa || e !== null && e.dependencies !== null && ia(e.dependencies) ? (typeof s == `function` && (Us(t, n, s, r), p = t.memoizedState), (u = Wa || Gs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && ia(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != `function` && typeof a.componentWillUpdate != `function` || (typeof a.componentWillUpdate == `function` && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == `function` && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == `function` && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == `function` && (t.flags |= 1024)) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1)
            }
            return a = r, hc(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != `function` ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ha(t, e.child, null, i), t.child = Ha(t, null, n, i)) : ac(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ac(e, t, i), e
        }

        function yc(e, t, n, r) {
            return qi(), t.flags |= 256, ac(e, t, n, r), t.child
        }

        var bc = {dehydrated: null, treeContext: null, retryLane: 0, hydrationErrors: null};

        function xc(e) {
            return {baseLanes: e, cachePool: Ta()}
        }

        function Sc(e, t, n) {
            return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Jl), e
        }

        function Cc(e, t, n) {
            var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
            if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (R.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
                if (P) {
                    if (a ? so(t) : uo(t), (e = N) ? (e = rf(e, Vi), e = e !== null && e.data !== `&` ? e : null, e !== null && (t.memoizedState = {
                        dehydrated: e,
                        treeContext: ji === null ? null : {id: Mi, overflow: Ni},
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, n = xi(e), n.return = t, t.child = n, zi = t, N = null)) : e = null, e === null) throw Ui(t);
                    return of(e) ? t.lanes = 32 : t.lanes = 536870912, null
                }
                var c = r.children;
                return r = r.fallback, a ? (uo(t), a = t.mode, c = Tc({
                    mode: `hidden`,
                    children: c
                }, a), r = yi(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(null, r)) : (so(t), wc(t, c))
            }
            var l = e.memoizedState;
            if (l !== null && (c = l.dehydrated, c !== null)) {
                if (o) t.flags & 256 ? (so(t), t.flags &= -257, t = Ec(e, t, n)) : t.memoizedState === null ? (uo(t), c = r.fallback, a = t.mode, r = Tc({
                    mode: `visible`,
                    children: r.children
                }, a), c = yi(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ha(t, e.child, null, n), r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, t = uc(null, r)) : (uo(t), t.child = e.child, t.flags |= 128, t = null); else if (so(t), of(c)) {
                    if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
                    s = u, r = Error(i(419)), r.stack = ``, r.digest = s, Yi({
                        value: r,
                        source: null,
                        stack: null
                    }), t = Ec(e, t, n)
                } else if (ic || ra(e, t, n, !1), s = (n & e.childLanes) !== 0, ic || s) {
                    if (s = K, s !== null && (r = ct(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, li(e, r), hu(s, e, r), rc;
                    af(c) || Du(), t = Ec(e, t, n)
                } else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, N = cf(c.nextSibling), zi = t, P = !0, Bi = null, Vi = !1, e !== null && Ri(t, e), t = wc(t, r.children), t.flags |= 4096);
                return t
            }
            return a ? (uo(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = gi(l, {
                mode: `hidden`,
                children: r.children
            }), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = yi(c, a, n, null), c.flags |= 2) : c = gi(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, uc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = xc(n) : (a = c.cachePool, a === null ? a = Ta() : (l = F._currentValue, a = a.parent === l ? a : {
                parent: l,
                pool: l
            }), c = {
                baseLanes: c.baseLanes | n,
                cachePool: a
            }), r.memoizedState = c, r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(e.child, r)) : (so(t), n = e.child, e = n.sibling, n = gi(n, {
                mode: `visible`,
                children: r.children
            }), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n)
        }

        function wc(e, t) {
            return t = Tc({mode: `visible`, children: t}, e.mode), t.return = e, e.child = t
        }

        function Tc(e, t) {
            return e = mi(22, e, null, t), e.lanes = 0, e
        }

        function Ec(e, t, n) {
            return Ha(t, e.child, null, n), e = wc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e
        }

        function Dc(e, t, n) {
            e.lanes |= t;
            var r = e.alternate;
            r !== null && (r.lanes |= t), ta(e.return, t, n)
        }

        function Oc(e, t, n, r, i, a) {
            var o = e.memoizedState;
            o === null ? e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: i,
                treeForkCount: a
            } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a)
        }

        function kc(e, t, n) {
            var r = t.pendingProps, i = r.revealOrder, a = r.tail;
            r = r.children;
            var o = R.current, s = (o & 2) != 0;
            if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, O(R, o), ac(e, t, r, n), r = P ? Oi : 0, !s && e !== null && e.flags & 128) a:for (e = t.child; e !== null;) {
                if (e.tag === 13) e.memoizedState !== null && Dc(e, n, t); else if (e.tag === 19) Dc(e, n, t); else if (e.child !== null) {
                    e.child.return = e, e = e.child;
                    continue
                }
                if (e === t) break a;
                for (; e.sibling === null;) {
                    if (e.return === null || e.return === t) break a;
                    e = e.return
                }
                e.sibling.return = e.return, e = e.sibling
            }
            switch (i) {
                case`forwards`:
                    for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && po(e) === null && (i = n), n = n.sibling;
                    n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Oc(t, !1, i, n, a, r);
                    break;
                case`backwards`:
                case`unstable_legacy-backwards`:
                    for (n = null, i = t.child, t.child = null; i !== null;) {
                        if (e = i.alternate, e !== null && po(e) === null) {
                            t.child = i;
                            break
                        }
                        e = i.sibling, i.sibling = n, n = i, i = e
                    }
                    Oc(t, !0, n, null, a, r);
                    break;
                case`together`:
                    Oc(t, !1, null, null, void 0, r);
                    break;
                default:
                    t.memoizedState = null
            }
            return t.child
        }

        function Ac(e, t, n) {
            if (e !== null && (t.dependencies = e.dependencies), Gl |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
                if (ra(e, t, n, !1), (n & t.childLanes) === 0) return null
            } else return null;
            if (e !== null && t.child !== e.child) throw Error(i(153));
            if (t.child !== null) {
                for (e = t.child, n = gi(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = gi(e, e.pendingProps), n.return = t;
                n.sibling = null
            }
            return t.child
        }

        function jc(e, t) {
            return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && ia(e))) : !0
        }

        function Mc(e, t, n) {
            switch (t.tag) {
                case 3:
                    _e(t, t.stateNode.containerInfo), $i(t, F, e.memoizedState.cache), qi();
                    break;
                case 27:
                case 5:
                    ye(t);
                    break;
                case 4:
                    _e(t, t.stateNode.containerInfo);
                    break;
                case 10:
                    $i(t, t.type, t.memoizedProps.value);
                    break;
                case 31:
                    if (t.memoizedState !== null) return t.flags |= 128, co(t), null;
                    break;
                case 13:
                    var r = t.memoizedState;
                    if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (so(t), e = Ac(e, t, n), e === null ? null : e.sibling) : Cc(e, t, n) : (so(t), t.flags |= 128, null);
                    so(t);
                    break;
                case 19:
                    var i = (e.flags & 128) != 0;
                    if (r = (n & t.childLanes) !== 0, r ||= (ra(e, t, n, !1), (n & t.childLanes) !== 0), i) {
                        if (r) return kc(e, t, n);
                        t.flags |= 128
                    }
                    if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), O(R, R.current), r) break;
                    return null;
                case 22:
                    return t.lanes = 0, lc(e, t, n, t.pendingProps);
                case 24:
                    $i(t, F, e.memoizedState.cache)
            }
            return Ac(e, t, n)
        }

        function Nc(e, t, n) {
            if (e !== null) if (e.memoizedProps !== t.pendingProps) ic = !0; else {
                if (!jc(e, n) && !(t.flags & 128)) return ic = !1, Mc(e, t, n);
                ic = !!(e.flags & 131072)
            } else ic = !1, P && t.flags & 1048576 && Fi(t, Oi, t.index);
            switch (t.lanes = 0, t.tag) {
                case 16:
                    a:{
                        var r = t.pendingProps;
                        if (e = Ma(t.elementType), t.type = e, typeof e == `function`) hi(e) ? (r = qs(e, r), t.tag = 1, t = vc(null, t, e, r, n)) : (t.tag = 0, t = gc(null, t, e, r, n)); else {
                            if (e != null) {
                                var a = e.$$typeof;
                                if (a === S) {
                                    t.tag = 11, t = oc(null, t, e, r, n);
                                    break a
                                } else if (a === ee) {
                                    t.tag = 14, t = sc(null, t, e, r, n);
                                    break a
                                }
                            }
                            throw t = oe(e) || e, Error(i(306, t, ``))
                        }
                    }
                    return t;
                case 0:
                    return gc(e, t, t.type, t.pendingProps, n);
                case 1:
                    return r = t.type, a = qs(r, t.pendingProps), vc(e, t, r, a, n);
                case 3:
                    a:{
                        if (_e(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
                        r = t.pendingProps;
                        var o = t.memoizedState;
                        a = o.element, Ka(e, t), $a(t, r, null, n);
                        var s = t.memoizedState;
                        if (r = s.cache, $i(t, F, r), r !== o.cache && na(t, [F], n, !0), Qa(), r = s.element, o.isDehydrated) if (o = {
                            element: r,
                            isDehydrated: !1,
                            cache: s.cache
                        }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
                            t = yc(e, t, r, n);
                            break a
                        } else if (r !== a) {
                            a = wi(Error(i(424)), t), Yi(a), t = yc(e, t, r, n);
                            break a
                        } else {
                            switch (e = t.stateNode.containerInfo, e.nodeType) {
                                case 9:
                                    e = e.body;
                                    break;
                                default:
                                    e = e.nodeName === `HTML` ? e.ownerDocument.body : e
                            }
                            for (N = cf(e.firstChild), zi = t, P = !0, Bi = null, Vi = !0, n = Ua(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling
                        } else {
                            if (qi(), r === a) {
                                t = Ac(e, t, n);
                                break a
                            }
                            ac(e, t, r, n)
                        }
                        t = t.child
                    }
                    return t;
                case 26:
                    return hc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : P || (n = t.type, e = t.pendingProps, r = Bd(he.current).createElement(n), r[mt] = t, r[ht] = e, Pd(r, n, e), Dt(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
                case 27:
                    return ye(t), e === null && P && (r = t.stateNode = ff(t.type, t.pendingProps, he.current), zi = t, Vi = !0, a = N, Zd(t.type) ? (lf = a, N = cf(r.firstChild)) : N = a), ac(e, t, t.pendingProps.children, n), hc(e, t), e === null && (t.flags |= 4194304), t.child;
                case 5:
                    return e === null && P && ((a = r = N) && (r = tf(r, t.type, t.pendingProps, Vi), r === null ? a = !1 : (t.stateNode = r, zi = t, N = cf(r.firstChild), Vi = !1, a = !0)), a || Ui(t)), ye(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(a, o) ? r = null : s !== null && Ud(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = wo(e, t, Do, null, null, n), Qf._currentValue = a), hc(e, t), ac(e, t, r, n), t.child;
                case 6:
                    return e === null && P && ((e = n = N) && (n = nf(n, t.pendingProps, Vi), n === null ? e = !1 : (t.stateNode = n, zi = t, N = null, e = !0)), e || Ui(t)), null;
                case 13:
                    return Cc(e, t, n);
                case 4:
                    return _e(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ha(t, null, r, n) : ac(e, t, r, n), t.child;
                case 11:
                    return oc(e, t, t.type, t.pendingProps, n);
                case 7:
                    return ac(e, t, t.pendingProps, n), t.child;
                case 8:
                    return ac(e, t, t.pendingProps.children, n), t.child;
                case 12:
                    return ac(e, t, t.pendingProps.children, n), t.child;
                case 10:
                    return r = t.pendingProps, $i(t, t.type, r.value), ac(e, t, r.children, n), t.child;
                case 9:
                    return a = t.type._context, r = t.pendingProps.children, aa(t), a = oa(a), r = r(a), t.flags |= 1, ac(e, t, r, n), t.child;
                case 14:
                    return sc(e, t, t.type, t.pendingProps, n);
                case 15:
                    return cc(e, t, t.type, t.pendingProps, n);
                case 19:
                    return kc(e, t, n);
                case 31:
                    return mc(e, t, n);
                case 22:
                    return lc(e, t, n, t.pendingProps);
                case 24:
                    return aa(t), r = oa(F), e === null ? (a = Ca(), a === null && (a = K, o = fa(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
                        parent: r,
                        cache: a
                    }, Ga(t), $i(t, F, a)) : ((e.lanes & n) !== 0 && (Ka(e, t), $a(t, null, null, n), Qa()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, $i(t, F, r), r !== a.cache && na(t, [F], n, !0)) : (a = {
                        parent: r,
                        cache: r
                    }, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), $i(t, F, r))), ac(e, t, t.pendingProps.children, n), t.child;
                case 29:
                    throw t.pendingProps
            }
            throw Error(i(156, t.tag))
        }

        function Pc(e) {
            e.flags |= 4
        }

        function Fc(e, t, n, r, i) {
            if ((t = (e.mode & 32) != 0) && (t = !1), t) {
                if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192; else if (wu()) e.flags |= 8192; else throw Na = ka, Da
            } else e.flags &= -16777217
        }

        function Ic(e, t) {
            if (t.type !== `stylesheet` || t.state.loading & 4) e.flags &= -16777217; else if (e.flags |= 16777216, !Wf(t)) if (wu()) e.flags |= 8192; else throw Na = ka, Da
        }

        function Lc(e, t) {
            t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : nt(), e.lanes |= t, Yl |= t)
        }

        function Rc(e, t) {
            if (!P) switch (e.tailMode) {
                case`hidden`:
                    t = e.tail;
                    for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
                    n === null ? e.tail = null : n.sibling = null;
                    break;
                case`collapsed`:
                    n = e.tail;
                    for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
                    r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null
            }
        }

        function U(e) {
            var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
            if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling; else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
            return e.subtreeFlags |= r, e.childLanes = n, t
        }

        function zc(e, t, n) {
            var r = t.pendingProps;
            switch (Li(t), t.tag) {
                case 16:
                case 15:
                case 0:
                case 11:
                case 7:
                case 8:
                case 12:
                case 9:
                case 14:
                    return U(t), null;
                case 1:
                    return U(t), null;
                case 3:
                    return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), ea(F), ve(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ki(t) ? Pc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ji())), U(t), null;
                case 26:
                    var a = t.type, o = t.memoizedState;
                    return e === null ? (Pc(t), o === null ? (U(t), Fc(t, a, null, r, n)) : (U(t), Ic(t, o))) : o ? o === e.memoizedState ? (U(t), t.flags &= -16777217) : (Pc(t), U(t), Ic(t, o)) : (e = e.memoizedProps, e !== r && Pc(t), U(t), Fc(t, a, e, r, n)), null;
                case 27:
                    if (be(t), n = he.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t); else {
                        if (!r) {
                            if (t.stateNode === null) throw Error(i(166));
                            return U(t), null
                        }
                        e = pe.current, Ki(t) ? Wi(t, e) : (e = ff(a, r, n), t.stateNode = e, Pc(t))
                    }
                    return U(t), null;
                case 5:
                    if (be(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t); else {
                        if (!r) {
                            if (t.stateNode === null) throw Error(i(166));
                            return U(t), null
                        }
                        if (o = pe.current, Ki(t)) Wi(t, o); else {
                            var s = Bd(he.current);
                            switch (o) {
                                case 1:
                                    o = s.createElementNS(`http://www.w3.org/2000/svg`, a);
                                    break;
                                case 2:
                                    o = s.createElementNS(`http://www.w3.org/1998/Math/MathML`, a);
                                    break;
                                default:
                                    switch (a) {
                                        case`svg`:
                                            o = s.createElementNS(`http://www.w3.org/2000/svg`, a);
                                            break;
                                        case`math`:
                                            o = s.createElementNS(`http://www.w3.org/1998/Math/MathML`, a);
                                            break;
                                        case`script`:
                                            o = s.createElement(`div`), o.innerHTML = `<script><\/script>`, o = o.removeChild(o.firstChild);
                                            break;
                                        case`select`:
                                            o = typeof r.is == `string` ? s.createElement(`select`, {is: r.is}) : s.createElement(`select`), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
                                            break;
                                        default:
                                            o = typeof r.is == `string` ? s.createElement(a, {is: r.is}) : s.createElement(a)
                                    }
                            }
                            o[mt] = t, o[ht] = r;
                            a:for (s = t.child; s !== null;) {
                                if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode); else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
                                    s.child.return = s, s = s.child;
                                    continue
                                }
                                if (s === t) break a;
                                for (; s.sibling === null;) {
                                    if (s.return === null || s.return === t) break a;
                                    s = s.return
                                }
                                s.sibling.return = s.return, s = s.sibling
                            }
                            t.stateNode = o;
                            a:switch (Pd(o, a, r), a) {
                                case`button`:
                                case`input`:
                                case`select`:
                                case`textarea`:
                                    r = !!r.autoFocus;
                                    break a;
                                case`img`:
                                    r = !0;
                                    break a;
                                default:
                                    r = !1
                            }
                            r && Pc(t)
                        }
                    }
                    return U(t), Fc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
                case 6:
                    if (e && t.stateNode != null) e.memoizedProps !== r && Pc(t); else {
                        if (typeof r != `string` && t.stateNode === null) throw Error(i(166));
                        if (e = he.current, Ki(t)) {
                            if (e = t.stateNode, n = t.memoizedProps, r = null, a = zi, a !== null) switch (a.tag) {
                                case 27:
                                case 5:
                                    r = a.memoizedProps
                            }
                            e[mt] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Md(e.nodeValue, n)), e || Ui(t, !0)
                        } else e = Bd(e).createTextNode(r), e[mt] = t, t.stateNode = e
                    }
                    return U(t), null;
                case 31:
                    if (n = t.memoizedState, e === null || e.memoizedState !== null) {
                        if (r = Ki(t), n !== null) {
                            if (e === null) {
                                if (!r) throw Error(i(318));
                                if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
                                e[mt] = t
                            } else qi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
                            U(t), e = !1
                        } else n = Ji(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
                        if (!e) return t.flags & 256 ? (fo(t), t) : (fo(t), null);
                        if (t.flags & 128) throw Error(i(558))
                    }
                    return U(t), null;
                case 13:
                    if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
                        if (a = Ki(t), r !== null && r.dehydrated !== null) {
                            if (e === null) {
                                if (!a) throw Error(i(318));
                                if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
                                a[mt] = t
                            } else qi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
                            U(t), a = !1
                        } else a = Ji(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
                        if (!a) return t.flags & 256 ? (fo(t), t) : (fo(t), null)
                    }
                    return fo(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Lc(t, t.updateQueue), U(t), null);
                case 4:
                    return ve(), e === null && Sd(t.stateNode.containerInfo), U(t), null;
                case 10:
                    return ea(t.type), U(t), null;
                case 19:
                    if (fe(R), r = t.memoizedState, r === null) return U(t), null;
                    if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) Rc(r, !1); else {
                        if (X !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
                            if (o = po(e), o !== null) {
                                for (t.flags |= 128, Rc(r, !1), e = o.updateQueue, t.updateQueue = e, Lc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) _i(n, e), n = n.sibling;
                                return O(R, R.current & 1 | 2), P && Pi(t, r.treeForkCount), t.child
                            }
                            e = e.sibling
                        }
                        r.tail !== null && Ne() > tu && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304)
                    } else {
                        if (!a) if (e = po(o), e !== null) {
                            if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Lc(t, e), Rc(r, !0), r.tail === null && r.tailMode === `hidden` && !o.alternate && !P) return U(t), null
                        } else 2 * Ne() - r.renderingStartTime > tu && n !== 536870912 && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304);
                        r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o)
                    }
                    return r.tail === null ? (U(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = Ne(), e.sibling = null, n = R.current, O(R, a ? n & 1 | 2 : n & 1), P && Pi(t, r.treeForkCount), e);
                case 22:
                case 23:
                    return fo(t), oo(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (U(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : U(t), n = t.updateQueue, n !== null && Lc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && fe(Sa), null;
                case 24:
                    return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), ea(F), U(t), null;
                case 25:
                    return null;
                case 30:
                    return null
            }
            throw Error(i(156, t.tag))
        }

        function Bc(e, t) {
            switch (Li(t), t.tag) {
                case 1:
                    return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
                case 3:
                    return ea(F), ve(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
                case 26:
                case 27:
                case 5:
                    return be(t), null;
                case 31:
                    if (t.memoizedState !== null) {
                        if (fo(t), t.alternate === null) throw Error(i(340));
                        qi()
                    }
                    return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
                case 13:
                    if (fo(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
                        if (t.alternate === null) throw Error(i(340));
                        qi()
                    }
                    return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
                case 19:
                    return fe(R), null;
                case 4:
                    return ve(), null;
                case 10:
                    return ea(t.type), null;
                case 22:
                case 23:
                    return fo(t), oo(), e !== null && fe(Sa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
                case 24:
                    return ea(F), null;
                case 25:
                    return null;
                default:
                    return null
            }
        }

        function Vc(e, t) {
            switch (Li(t), t.tag) {
                case 3:
                    ea(F), ve();
                    break;
                case 26:
                case 27:
                case 5:
                    be(t);
                    break;
                case 4:
                    ve();
                    break;
                case 31:
                    t.memoizedState !== null && fo(t);
                    break;
                case 13:
                    fo(t);
                    break;
                case 19:
                    fe(R);
                    break;
                case 10:
                    ea(t.type);
                    break;
                case 22:
                case 23:
                    fo(t), oo(), e !== null && fe(Sa);
                    break;
                case 24:
                    ea(F)
            }
        }

        function Hc(e, t) {
            try {
                var n = t.updateQueue, r = n === null ? null : n.lastEffect;
                if (r !== null) {
                    var i = r.next;
                    n = i;
                    do {
                        if ((n.tag & e) === e) {
                            r = void 0;
                            var a = n.create, o = n.inst;
                            r = a(), o.destroy = r
                        }
                        n = n.next
                    } while (n !== i)
                }
            } catch (e) {
                Z(t, t.return, e)
            }
        }

        function Uc(e, t, n) {
            try {
                var r = t.updateQueue, i = r === null ? null : r.lastEffect;
                if (i !== null) {
                    var a = i.next;
                    r = a;
                    do {
                        if ((r.tag & e) === e) {
                            var o = r.inst, s = o.destroy;
                            if (s !== void 0) {
                                o.destroy = void 0, i = t;
                                var c = n, l = s;
                                try {
                                    l()
                                } catch (e) {
                                    Z(i, c, e)
                                }
                            }
                        }
                        r = r.next
                    } while (r !== a)
                }
            } catch (e) {
                Z(t, t.return, e)
            }
        }

        function Wc(e) {
            var t = e.updateQueue;
            if (t !== null) {
                var n = e.stateNode;
                try {
                    to(t, n)
                } catch (t) {
                    Z(e, e.return, t)
                }
            }
        }

        function Gc(e, t, n) {
            n.props = qs(e.type, e.memoizedProps), n.state = e.memoizedState;
            try {
                n.componentWillUnmount()
            } catch (n) {
                Z(e, t, n)
            }
        }

        function Kc(e, t) {
            try {
                var n = e.ref;
                if (n !== null) {
                    switch (e.tag) {
                        case 26:
                        case 27:
                        case 5:
                            var r = e.stateNode;
                            break;
                        case 30:
                            r = e.stateNode;
                            break;
                        default:
                            r = e.stateNode
                    }
                    typeof n == `function` ? e.refCleanup = n(r) : n.current = r
                }
            } catch (n) {
                Z(e, t, n)
            }
        }

        function qc(e, t) {
            var n = e.ref, r = e.refCleanup;
            if (n !== null) if (typeof r == `function`) try {
                r()
            } catch (n) {
                Z(e, t, n)
            } finally {
                e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null)
            } else if (typeof n == `function`) try {
                n(null)
            } catch (n) {
                Z(e, t, n)
            } else n.current = null
        }

        function Jc(e) {
            var t = e.type, n = e.memoizedProps, r = e.stateNode;
            try {
                a:switch (t) {
                    case`button`:
                    case`input`:
                    case`select`:
                    case`textarea`:
                        n.autoFocus && r.focus();
                        break a;
                    case`img`:
                        n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet)
                }
            } catch (t) {
                Z(e, e.return, t)
            }
        }

        function Yc(e, t, n) {
            try {
                var r = e.stateNode;
                Fd(r, e.type, n, t), r[ht] = t
            } catch (t) {
                Z(e, e.return, t)
            }
        }

        function Xc(e) {
            return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4
        }

        function Zc(e) {
            a:for (; ;) {
                for (; e.sibling === null;) {
                    if (e.return === null || Xc(e.return)) return null;
                    e = e.return
                }
                for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
                    if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
                    e.child.return = e, e = e.child
                }
                if (!(e.flags & 2)) return e.stateNode
            }
        }

        function Qc(e, t, n) {
            var r = e.tag;
            if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = cn)); else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Qc(e, t, n), e = e.sibling; e !== null;) Qc(e, t, n), e = e.sibling
        }

        function $c(e, t, n) {
            var r = e.tag;
            if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e); else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for ($c(e, t, n), e = e.sibling; e !== null;) $c(e, t, n), e = e.sibling
        }

        function el(e) {
            var t = e.stateNode, n = e.memoizedProps;
            try {
                for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
                Pd(t, r, n), t[mt] = e, t[ht] = n
            } catch (t) {
                Z(e, e.return, t)
            }
        }

        var tl = !1, nl = !1, rl = !1, il = typeof WeakSet == `function` ? WeakSet : Set, al = null;

        function ol(e, t) {
            if (e = e.containerInfo, Rd = sp, e = k(e), A(e)) {
                if (`selectionStart` in e) var n = {start: e.selectionStart, end: e.selectionEnd}; else a:{
                    n = (n = e.ownerDocument) && n.defaultView || window;
                    var r = n.getSelection && n.getSelection();
                    if (r && r.rangeCount !== 0) {
                        n = r.anchorNode;
                        var a = r.anchorOffset, o = r.focusNode;
                        r = r.focusOffset;
                        try {
                            n.nodeType, o.nodeType
                        } catch {
                            n = null;
                            break a
                        }
                        var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
                        b:for (; ;) {
                            for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
                            for (; ;) {
                                if (f === e) break b;
                                if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
                                f = p, p = f.parentNode
                            }
                            f = m
                        }
                        n = c === -1 || l === -1 ? null : {start: c, end: l}
                    } else n = null
                }
                n ||= {start: 0, end: 0}
            } else n = null;
            for (zd = {
                focusedElem: e,
                selectionRange: n
            }, sp = !1, al = t; al !== null;) if (t = al, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, al = e; else for (; al !== null;) {
                switch (t = al, o = t.alternate, e = t.flags, t.tag) {
                    case 0:
                        if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
                        break;
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (e & 1024 && o !== null) {
                            e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
                            try {
                                var h = qs(n.type, a);
                                e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e
                            } catch (e) {
                                Z(n, n.return, e)
                            }
                        }
                        break;
                    case 3:
                        if (e & 1024) {
                            if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e); else if (n === 1) switch (e.nodeName) {
                                case`HEAD`:
                                case`HTML`:
                                case`BODY`:
                                    ef(e);
                                    break;
                                default:
                                    e.textContent = ``
                            }
                        }
                        break;
                    case 5:
                    case 26:
                    case 27:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        if (e & 1024) throw Error(i(163))
                }
                if (e = t.sibling, e !== null) {
                    e.return = t.return, al = e;
                    break
                }
                al = t.return
            }
        }

        function sl(e, t, n) {
            var r = n.flags;
            switch (n.tag) {
                case 0:
                case 11:
                case 15:
                    xl(e, n), r & 4 && Hc(5, n);
                    break;
                case 1:
                    if (xl(e, n), r & 4) if (e = n.stateNode, t === null) try {
                        e.componentDidMount()
                    } catch (e) {
                        Z(n, n.return, e)
                    } else {
                        var i = qs(n.type, t.memoizedProps);
                        t = t.memoizedState;
                        try {
                            e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate)
                        } catch (e) {
                            Z(n, n.return, e)
                        }
                    }
                    r & 64 && Wc(n), r & 512 && Kc(n, n.return);
                    break;
                case 3:
                    if (xl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
                        if (t = null, n.child !== null) switch (n.child.tag) {
                            case 27:
                            case 5:
                                t = n.child.stateNode;
                                break;
                            case 1:
                                t = n.child.stateNode
                        }
                        try {
                            to(e, t)
                        } catch (e) {
                            Z(n, n.return, e)
                        }
                    }
                    break;
                case 27:
                    t === null && r & 4 && el(n);
                case 26:
                case 5:
                    xl(e, n), t === null && r & 4 && Jc(n), r & 512 && Kc(n, n.return);
                    break;
                case 12:
                    xl(e, n);
                    break;
                case 31:
                    xl(e, n), r & 4 && fl(e, n);
                    break;
                case 13:
                    xl(e, n), r & 4 && pl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Ju.bind(null, n), sf(e, n))));
                    break;
                case 22:
                    if (r = n.memoizedState !== null || tl, !r) {
                        t = t !== null && t.memoizedState !== null || nl, i = tl;
                        var a = nl;
                        tl = r, (nl = t) && !a ? Cl(e, n, (n.subtreeFlags & 8772) != 0) : xl(e, n), tl = i, nl = a
                    }
                    break;
                case 30:
                    break;
                default:
                    xl(e, n)
            }
        }

        function cl(e) {
            var t = e.alternate;
            t !== null && (e.alternate = null, cl(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && St(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null
        }

        var W = null, ll = !1;

        function ul(e, t, n) {
            for (n = n.child; n !== null;) dl(e, t, n), n = n.sibling
        }

        function dl(e, t, n) {
            if (Ue && typeof Ue.onCommitFiberUnmount == `function`) try {
                Ue.onCommitFiberUnmount(He, n)
            } catch {
            }
            switch (n.tag) {
                case 26:
                    nl || qc(n, t), ul(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
                    break;
                case 27:
                    nl || qc(n, t);
                    var r = W, i = ll;
                    Zd(n.type) && (W = n.stateNode, ll = !1), ul(e, t, n), pf(n.stateNode), W = r, ll = i;
                    break;
                case 5:
                    nl || qc(n, t);
                case 6:
                    if (r = W, i = ll, W = null, ul(e, t, n), W = r, ll = i, W !== null) if (ll) try {
                        (W.nodeType === 9 ? W.body : W.nodeName === `HTML` ? W.ownerDocument.body : W).removeChild(n.stateNode)
                    } catch (e) {
                        Z(n, t, e)
                    } else try {
                        W.removeChild(n.stateNode)
                    } catch (e) {
                        Z(n, t, e)
                    }
                    break;
                case 18:
                    W !== null && (ll ? (e = W, Qd(e.nodeType === 9 ? e.body : e.nodeName === `HTML` ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(W, n.stateNode));
                    break;
                case 4:
                    r = W, i = ll, W = n.stateNode.containerInfo, ll = !0, ul(e, t, n), W = r, ll = i;
                    break;
                case 0:
                case 11:
                case 14:
                case 15:
                    Uc(2, n, t), nl || Uc(4, n, t), ul(e, t, n);
                    break;
                case 1:
                    nl || (qc(n, t), r = n.stateNode, typeof r.componentWillUnmount == `function` && Gc(n, t, r)), ul(e, t, n);
                    break;
                case 21:
                    ul(e, t, n);
                    break;
                case 22:
                    nl = (r = nl) || n.memoizedState !== null, ul(e, t, n), nl = r;
                    break;
                default:
                    ul(e, t, n)
            }
        }

        function fl(e, t) {
            if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
                e = e.dehydrated;
                try {
                    Np(e)
                } catch (e) {
                    Z(t, t.return, e)
                }
            }
        }

        function pl(e, t) {
            if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
                Np(e)
            } catch (e) {
                Z(t, t.return, e)
            }
        }

        function ml(e) {
            switch (e.tag) {
                case 31:
                case 13:
                case 19:
                    var t = e.stateNode;
                    return t === null && (t = e.stateNode = new il), t;
                case 22:
                    return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new il), t;
                default:
                    throw Error(i(435, e.tag))
            }
        }

        function hl(e, t) {
            var n = ml(e);
            t.forEach(function (t) {
                if (!n.has(t)) {
                    n.add(t);
                    var r = Yu.bind(null, e, t);
                    t.then(r, r)
                }
            })
        }

        function gl(e, t) {
            var n = t.deletions;
            if (n !== null) for (var r = 0; r < n.length; r++) {
                var a = n[r], o = e, s = t, c = s;
                a:for (; c !== null;) {
                    switch (c.tag) {
                        case 27:
                            if (Zd(c.type)) {
                                W = c.stateNode, ll = !1;
                                break a
                            }
                            break;
                        case 5:
                            W = c.stateNode, ll = !1;
                            break a;
                        case 3:
                        case 4:
                            W = c.stateNode.containerInfo, ll = !0;
                            break a
                    }
                    c = c.return
                }
                if (W === null) throw Error(i(160));
                dl(o, s, a), W = null, ll = !1, o = a.alternate, o !== null && (o.return = null), a.return = null
            }
            if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) vl(t, e), t = t.sibling
        }

        var _l = null;

        function vl(e, t) {
            var n = e.alternate, r = e.flags;
            switch (e.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                    gl(t, e), yl(e), r & 4 && (Uc(3, e, e.return), Hc(3, e), Uc(5, e, e.return));
                    break;
                case 1:
                    gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 64 && tl && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
                    break;
                case 26:
                    var a = _l;
                    if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 4) {
                        var o = n === null ? null : n.memoizedState;
                        if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
                            a:{
                                r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
                                b:switch (r) {
                                    case`title`:
                                        o = a.getElementsByTagName(`title`)[0], (!o || o[xt] || o[mt] || o.namespaceURI === `http://www.w3.org/2000/svg` || o.hasAttribute(`itemprop`)) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector(`head > title`))), Pd(o, r, n), o[mt] = e, Dt(o), r = o;
                                        break a;
                                    case`link`:
                                        var s = Vf(`link`, `href`, a).get(r + (n.href || ``));
                                        if (s) {
                                            for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute(`href`) === (n.href == null || n.href === `` ? null : n.href) && o.getAttribute(`rel`) === (n.rel == null ? null : n.rel) && o.getAttribute(`title`) === (n.title == null ? null : n.title) && o.getAttribute(`crossorigin`) === (n.crossOrigin == null ? null : n.crossOrigin)) {
                                                s.splice(c, 1);
                                                break b
                                            }
                                        }
                                        o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
                                        break;
                                    case`meta`:
                                        if (s = Vf(`meta`, `content`, a).get(r + (n.content || ``))) {
                                            for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute(`content`) === (n.content == null ? null : `` + n.content) && o.getAttribute(`name`) === (n.name == null ? null : n.name) && o.getAttribute(`property`) === (n.property == null ? null : n.property) && o.getAttribute(`http-equiv`) === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute(`charset`) === (n.charSet == null ? null : n.charSet)) {
                                                s.splice(c, 1);
                                                break b
                                            }
                                        }
                                        o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
                                        break;
                                    default:
                                        throw Error(i(468, r))
                                }
                                o[mt] = e, Dt(o), r = o
                            }
                            e.stateNode = r
                        } else Hf(a, e.type, e.stateNode); else e.stateNode = If(a, r, e.memoizedProps); else o === r ? r === null && e.stateNode !== null && Yc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps))
                    }
                    break;
                case 27:
                    gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), n !== null && r & 4 && Yc(e, e.memoizedProps, n.memoizedProps);
                    break;
                case 5:
                    if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), e.flags & 32) {
                        a = e.stateNode;
                        try {
                            $t(a, ``)
                        } catch (t) {
                            Z(e, e.return, t)
                        }
                    }
                    r & 4 && e.stateNode != null && (a = e.memoizedProps, Yc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (rl = !0);
                    break;
                case 6:
                    if (gl(t, e), yl(e), r & 4) {
                        if (e.stateNode === null) throw Error(i(162));
                        r = e.memoizedProps, n = e.stateNode;
                        try {
                            n.nodeValue = r
                        } catch (t) {
                            Z(e, e.return, t)
                        }
                    }
                    break;
                case 3:
                    if (Bf = null, a = _l, _l = gf(t.containerInfo), gl(t, e), _l = a, yl(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
                        Np(t.containerInfo)
                    } catch (t) {
                        Z(e, e.return, t)
                    }
                    rl && (rl = !1, bl(e));
                    break;
                case 4:
                    r = _l, _l = gf(e.stateNode.containerInfo), gl(t, e), yl(e), _l = r;
                    break;
                case 12:
                    gl(t, e), yl(e);
                    break;
                case 31:
                    gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
                    break;
                case 13:
                    gl(t, e), yl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && ($l = Ne()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
                    break;
                case 22:
                    a = e.memoizedState !== null;
                    var l = n !== null && n.memoizedState !== null, u = tl, d = nl;
                    if (tl = u || a, nl = d || l, gl(t, e), nl = d, tl = u, yl(e), r & 8192) a:for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || tl || nl || Sl(e)), n = null, t = e; ;) {
                        if (t.tag === 5 || t.tag === 26) {
                            if (n === null) {
                                l = n = t;
                                try {
                                    if (o = l.stateNode, a) s = o.style, typeof s.setProperty == `function` ? s.setProperty(`display`, `none`, `important`) : s.display = `none`; else {
                                        c = l.stateNode;
                                        var f = l.memoizedProps.style,
                                            p = f != null && f.hasOwnProperty(`display`) ? f.display : null;
                                        c.style.display = p == null || typeof p == `boolean` ? `` : (`` + p).trim()
                                    }
                                } catch (e) {
                                    Z(l, l.return, e)
                                }
                            }
                        } else if (t.tag === 6) {
                            if (n === null) {
                                l = t;
                                try {
                                    l.stateNode.nodeValue = a ? `` : l.memoizedProps
                                } catch (e) {
                                    Z(l, l.return, e)
                                }
                            }
                        } else if (t.tag === 18) {
                            if (n === null) {
                                l = t;
                                try {
                                    var m = l.stateNode;
                                    a ? $d(m, !0) : $d(l.stateNode, !1)
                                } catch (e) {
                                    Z(l, l.return, e)
                                }
                            }
                        } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
                            t.child.return = t, t = t.child;
                            continue
                        }
                        if (t === e) break a;
                        for (; t.sibling === null;) {
                            if (t.return === null || t.return === e) break a;
                            n === t && (n = null), t = t.return
                        }
                        n === t && (n = null), t.sibling.return = t.return, t = t.sibling
                    }
                    r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, hl(e, n))));
                    break;
                case 19:
                    gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
                    break;
                case 30:
                    break;
                case 21:
                    break;
                default:
                    gl(t, e), yl(e)
            }
        }

        function yl(e) {
            var t = e.flags;
            if (t & 2) {
                try {
                    for (var n, r = e.return; r !== null;) {
                        if (Xc(r)) {
                            n = r;
                            break
                        }
                        r = r.return
                    }
                    if (n == null) throw Error(i(160));
                    switch (n.tag) {
                        case 27:
                            var a = n.stateNode;
                            $c(e, Zc(e), a);
                            break;
                        case 5:
                            var o = n.stateNode;
                            n.flags & 32 && ($t(o, ``), n.flags &= -33), $c(e, Zc(e), o);
                            break;
                        case 3:
                        case 4:
                            var s = n.stateNode.containerInfo;
                            Qc(e, Zc(e), s);
                            break;
                        default:
                            throw Error(i(161))
                    }
                } catch (t) {
                    Z(e, e.return, t)
                }
                e.flags &= -3
            }
            t & 4096 && (e.flags &= -4097)
        }

        function bl(e) {
            if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
                var t = e;
                bl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling
            }
        }

        function xl(e, t) {
            if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) sl(e, t.alternate, t), t = t.sibling
        }

        function Sl(e) {
            for (e = e.child; e !== null;) {
                var t = e;
                switch (t.tag) {
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Uc(4, t, t.return), Sl(t);
                        break;
                    case 1:
                        qc(t, t.return);
                        var n = t.stateNode;
                        typeof n.componentWillUnmount == `function` && Gc(t, t.return, n), Sl(t);
                        break;
                    case 27:
                        pf(t.stateNode);
                    case 26:
                    case 5:
                        qc(t, t.return), Sl(t);
                        break;
                    case 22:
                        t.memoizedState === null && Sl(t);
                        break;
                    case 30:
                        Sl(t);
                        break;
                    default:
                        Sl(t)
                }
                e = e.sibling
            }
        }

        function Cl(e, t, n) {
            for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
                var r = t.alternate, i = e, a = t, o = a.flags;
                switch (a.tag) {
                    case 0:
                    case 11:
                    case 15:
                        Cl(i, a, n), Hc(4, a);
                        break;
                    case 1:
                        if (Cl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == `function`) try {
                            i.componentDidMount()
                        } catch (e) {
                            Z(r, r.return, e)
                        }
                        if (r = a, i = r.updateQueue, i !== null) {
                            var s = r.stateNode;
                            try {
                                var c = i.shared.hiddenCallbacks;
                                if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) eo(c[i], s)
                            } catch (e) {
                                Z(r, r.return, e)
                            }
                        }
                        n && o & 64 && Wc(a), Kc(a, a.return);
                        break;
                    case 27:
                        el(a);
                    case 26:
                    case 5:
                        Cl(i, a, n), n && r === null && o & 4 && Jc(a), Kc(a, a.return);
                        break;
                    case 12:
                        Cl(i, a, n);
                        break;
                    case 31:
                        Cl(i, a, n), n && o & 4 && fl(i, a);
                        break;
                    case 13:
                        Cl(i, a, n), n && o & 4 && pl(i, a);
                        break;
                    case 22:
                        a.memoizedState === null && Cl(i, a, n), Kc(a, a.return);
                        break;
                    case 30:
                        break;
                    default:
                        Cl(i, a, n)
                }
                t = t.sibling
            }
        }

        function wl(e, t) {
            var n = null;
            e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && pa(n))
        }

        function Tl(e, t) {
            e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && pa(e))
        }

        function El(e, t, n, r) {
            if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Dl(e, t, n, r), t = t.sibling
        }

        function Dl(e, t, n, r) {
            var i = t.flags;
            switch (t.tag) {
                case 0:
                case 11:
                case 15:
                    El(e, t, n, r), i & 2048 && Hc(9, t);
                    break;
                case 1:
                    El(e, t, n, r);
                    break;
                case 3:
                    El(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && pa(e)));
                    break;
                case 12:
                    if (i & 2048) {
                        El(e, t, n, r), e = t.stateNode;
                        try {
                            var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
                            typeof s == `function` && s(o, t.alternate === null ? `mount` : `update`, e.passiveEffectDuration, -0)
                        } catch (e) {
                            Z(t, t.return, e)
                        }
                    } else El(e, t, n, r);
                    break;
                case 31:
                    El(e, t, n, r);
                    break;
                case 13:
                    El(e, t, n, r);
                    break;
                case 23:
                    break;
                case 22:
                    a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? El(e, t, n, r) : (a._visibility |= 2, Ol(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? El(e, t, n, r) : kl(e, t), i & 2048 && wl(o, t);
                    break;
                case 24:
                    El(e, t, n, r), i & 2048 && Tl(t.alternate, t);
                    break;
                default:
                    El(e, t, n, r)
            }
        }

        function Ol(e, t, n, r, i) {
            for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
                var a = e, o = t, s = n, c = r, l = o.flags;
                switch (o.tag) {
                    case 0:
                    case 11:
                    case 15:
                        Ol(a, o, s, c, i), Hc(8, o);
                        break;
                    case 23:
                        break;
                    case 22:
                        var u = o.stateNode;
                        o.memoizedState === null ? (u._visibility |= 2, Ol(a, o, s, c, i)) : u._visibility & 2 ? Ol(a, o, s, c, i) : kl(a, o), i && l & 2048 && wl(o.alternate, o);
                        break;
                    case 24:
                        Ol(a, o, s, c, i), i && l & 2048 && Tl(o.alternate, o);
                        break;
                    default:
                        Ol(a, o, s, c, i)
                }
                t = t.sibling
            }
        }

        function kl(e, t) {
            if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
                var n = e, r = t, i = r.flags;
                switch (r.tag) {
                    case 22:
                        kl(n, r), i & 2048 && wl(r.alternate, r);
                        break;
                    case 24:
                        kl(n, r), i & 2048 && Tl(r.alternate, r);
                        break;
                    default:
                        kl(n, r)
                }
                t = t.sibling
            }
        }

        var Al = 8192;

        function jl(e, t, n) {
            if (e.subtreeFlags & Al) for (e = e.child; e !== null;) Ml(e, t, n), e = e.sibling
        }

        function Ml(e, t, n) {
            switch (e.tag) {
                case 26:
                    jl(e, t, n), e.flags & Al && e.memoizedState !== null && Gf(n, _l, e.memoizedState, e.memoizedProps);
                    break;
                case 5:
                    jl(e, t, n);
                    break;
                case 3:
                case 4:
                    var r = _l;
                    _l = gf(e.stateNode.containerInfo), jl(e, t, n), _l = r;
                    break;
                case 22:
                    e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Al, Al = 16777216, jl(e, t, n), Al = r) : jl(e, t, n));
                    break;
                default:
                    jl(e, t, n)
            }
        }

        function Nl(e) {
            var t = e.alternate;
            if (t !== null && (e = t.child, e !== null)) {
                t.child = null;
                do t = e.sibling, e.sibling = null, e = t; while (e !== null)
            }
        }

        function Pl(e) {
            var t = e.deletions;
            if (e.flags & 16) {
                if (t !== null) for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    al = r, Ll(r, e)
                }
                Nl(e)
            }
            if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Fl(e), e = e.sibling
        }

        function Fl(e) {
            switch (e.tag) {
                case 0:
                case 11:
                case 15:
                    Pl(e), e.flags & 2048 && Uc(9, e, e.return);
                    break;
                case 3:
                    Pl(e);
                    break;
                case 12:
                    Pl(e);
                    break;
                case 22:
                    var t = e.stateNode;
                    e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Il(e)) : Pl(e);
                    break;
                default:
                    Pl(e)
            }
        }

        function Il(e) {
            var t = e.deletions;
            if (e.flags & 16) {
                if (t !== null) for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    al = r, Ll(r, e)
                }
                Nl(e)
            }
            for (e = e.child; e !== null;) {
                switch (t = e, t.tag) {
                    case 0:
                    case 11:
                    case 15:
                        Uc(8, t, t.return), Il(t);
                        break;
                    case 22:
                        n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Il(t));
                        break;
                    default:
                        Il(t)
                }
                e = e.sibling
            }
        }

        function Ll(e, t) {
            for (; al !== null;) {
                var n = al;
                switch (n.tag) {
                    case 0:
                    case 11:
                    case 15:
                        Uc(8, n, t);
                        break;
                    case 23:
                    case 22:
                        if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
                            var r = n.memoizedState.cachePool.pool;
                            r != null && r.refCount++
                        }
                        break;
                    case 24:
                        pa(n.memoizedState.cache)
                }
                if (r = n.child, r !== null) r.return = n, al = r; else a:for (n = e; al !== null;) {
                    r = al;
                    var i = r.sibling, a = r.return;
                    if (cl(r), r === n) {
                        al = null;
                        break a
                    }
                    if (i !== null) {
                        i.return = a, al = i;
                        break a
                    }
                    al = a
                }
            }
        }

        var Rl = {
                getCacheForType: function (e) {
                    var t = oa(F), n = t.data.get(e);
                    return n === void 0 && (n = e(), t.data.set(e, n)), n
                }, cacheSignal: function () {
                    return oa(F).controller.signal
                }
            }, zl = typeof WeakMap == `function` ? WeakMap : Map, G = 0, K = null, q = null, J = 0, Y = 0, Bl = null, Vl = !1,
            Hl = !1, Ul = !1, Wl = 0, X = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = 0, Xl = null, Zl = null, Ql = !1, $l = 0,
            eu = 0, tu = 1 / 0, nu = null, ru = null, iu = 0, au = null, ou = null, su = 0, cu = 0, lu = null, uu = null,
            du = 0, fu = null;

        function pu() {
            return G & 2 && J !== 0 ? J & -J : E.T === null ? dt() : dd()
        }

        function mu() {
            if (Jl === 0) if (!(J & 536870912) || P) {
                var e = Xe;
                Xe <<= 1, !(Xe & 3932160) && (Xe = 262144), Jl = e
            } else Jl = 536870912;
            return e = I.current, e !== null && (e.flags |= 32), Jl
        }

        function hu(e, t, n) {
            (e === K && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) && (Su(e, 0), yu(e, J, Jl, !1)), it(e, n), (!(G & 2) || e !== K) && (e === K && (!(G & 2) && (Kl |= n), X === 4 && yu(e, J, Jl, !1)), rd(e))
        }

        function gu(e, t, n) {
            if (G & 6) throw Error(i(327));
            var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || et(e, t), a = r ? Au(e, t) : Ou(e, t, !0), o = r;
            do {
                if (a === 0) {
                    Hl && !r && yu(e, t, 0, !1);
                    break
                } else {
                    if (n = e.current.alternate, o && !vu(n)) {
                        a = Ou(e, t, !1), o = !1;
                        continue
                    }
                    if (a === 2) {
                        if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0; else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
                        if (s !== 0) {
                            t = s;
                            a:{
                                var c = e;
                                a = Xl;
                                var l = c.current.memoizedState.isDehydrated;
                                if (l && (Su(c, s).flags |= 256), s = Ou(c, s, !1), s !== 2) {
                                    if (Ul && !l) {
                                        c.errorRecoveryDisabledLanes |= o, Kl |= o, a = 4;
                                        break a
                                    }
                                    o = Zl, Zl = a, o !== null && (Zl === null ? Zl = o : Zl.push.apply(Zl, o))
                                }
                                a = s
                            }
                            if (o = !1, a !== 2) continue
                        }
                    }
                    if (a === 1) {
                        Su(e, 0), yu(e, t, 0, !0);
                        break
                    }
                    a:{
                        switch (r = e, o = a, o) {
                            case 0:
                            case 1:
                                throw Error(i(345));
                            case 4:
                                if ((t & 4194048) !== t) break;
                            case 6:
                                yu(r, t, Jl, !Vl);
                                break a;
                            case 2:
                                Zl = null;
                                break;
                            case 3:
                            case 5:
                                break;
                            default:
                                throw Error(i(329))
                        }
                        if ((t & 62914560) === t && (a = $l + 300 - Ne(), 10 < a)) {
                            if (yu(r, t, Jl, !Vl), $e(r, 0, !0) !== 0) break a;
                            su = t, r.timeoutHandle = Kd(_u.bind(null, r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, `Throttled`, -0, 0), a);
                            break a
                        }
                        _u(r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, null, -0, 0)
                    }
                }
                break
            } while (1);
            rd(e)
        }

        function _u(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
            if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
                d = {
                    stylesheets: null,
                    count: 0,
                    imgCount: 0,
                    imgBytes: 0,
                    suspenseyImages: [],
                    waitingForImages: !0,
                    waitingForViewTransition: !1,
                    unsuspend: cn
                }, Ml(t, a, d);
                var m = (a & 62914560) === a ? $l - Ne() : (a & 4194048) === a ? eu - Ne() : 0;
                if (m = qf(d, m), m !== null) {
                    su = a, e.cancelPendingCommit = m(Lu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), yu(e, a, o, !l);
                    return
                }
            }
            Lu(e, t, a, n, r, i, o, s, c)
        }

        function vu(e) {
            for (var t = e; ;) {
                var n = t.tag;
                if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
                    var i = n[r], a = i.getSnapshot;
                    i = i.value;
                    try {
                        if (!Mr(a(), i)) return !1
                    } catch {
                        return !1
                    }
                }
                if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n; else {
                    if (t === e) break;
                    for (; t.sibling === null;) {
                        if (t.return === null || t.return === e) return !0;
                        t = t.return
                    }
                    t.sibling.return = t.return, t = t.sibling
                }
            }
            return !0
        }

        function yu(e, t, n, r) {
            t &= ~ql, t &= ~Kl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
            for (var i = t; 0 < i;) {
                var a = 31 - Ge(i), o = 1 << a;
                r[a] = -1, i &= ~o
            }
            n !== 0 && ot(e, n, t)
        }

        function bu() {
            return G & 6 ? !0 : (id(0, !1), !1)
        }

        function xu() {
            if (q !== null) {
                if (Y === 0) var e = q.return; else e = q, Qi = Zi = null, Ao(e), Ia = null, La = 0, e = q;
                for (; e !== null;) Vc(e.alternate, e), e = e.return;
                q = null
            }
        }

        function Su(e, t) {
            var n = e.timeoutHandle;
            n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), su = 0, xu(), K = e, q = n = gi(e.current, null), J = t, Y = 0, Bl = null, Vl = !1, Hl = et(e, t), Ul = !1, Yl = Jl = ql = Kl = Gl = X = 0, Zl = Xl = null, Ql = !1, t & 8 && (t |= t & 32);
            var r = e.entangledLanes;
            if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
                var i = 31 - Ge(r), a = 1 << i;
                t |= e[i], r &= ~a
            }
            return Wl = t, oi(), n
        }

        function Cu(e, t) {
            z = null, E.H = zs, t === Ea || t === Oa ? (t = Pa(), Y = 3) : t === Da ? (t = Pa(), Y = 4) : Y = t === rc ? 8 : typeof t == `object` && t && typeof t.then == `function` ? 6 : 1, Bl = t, q === null && (X = 1, Zs(e, wi(t, e.current)))
        }

        function wu() {
            var e = I.current;
            return e === null ? !0 : (J & 4194048) === J ? L === null : (J & 62914560) === J || J & 536870912 ? e === L : !1
        }

        function Tu() {
            var e = E.H;
            return E.H = zs, e === null ? zs : e
        }

        function Eu() {
            var e = E.A;
            return E.A = Rl, e
        }

        function Du() {
            X = 4, Vl || (J & 4194048) !== J && I.current !== null || (Hl = !0), !(Gl & 134217727) && !(Kl & 134217727) || K === null || yu(K, J, Jl, !1)
        }

        function Ou(e, t, n) {
            var r = G;
            G |= 2;
            var i = Tu(), a = Eu();
            (K !== e || J !== t) && (nu = null, Su(e, t)), t = !1;
            var o = X;
            a:do try {
                if (Y !== 0 && q !== null) {
                    var s = q, c = Bl;
                    switch (Y) {
                        case 8:
                            xu(), o = 6;
                            break a;
                        case 3:
                        case 2:
                        case 9:
                        case 6:
                            I.current === null && (t = !0);
                            var l = Y;
                            if (Y = 0, Bl = null, Pu(e, s, c, l), n && Hl) {
                                o = 0;
                                break a
                            }
                            break;
                        default:
                            l = Y, Y = 0, Bl = null, Pu(e, s, c, l)
                    }
                }
                ku(), o = X;
                break
            } catch (t) {
                Cu(e, t)
            } while (1);
            return t && e.shellSuspendCounter++, Qi = Zi = null, G = r, E.H = i, E.A = a, q === null && (K = null, J = 0, oi()), o
        }

        function ku() {
            for (; q !== null;) Mu(q)
        }

        function Au(e, t) {
            var n = G;
            G |= 2;
            var r = Tu(), a = Eu();
            K !== e || J !== t ? (nu = null, tu = Ne() + 500, Su(e, t)) : Hl = et(e, t);
            a:do try {
                if (Y !== 0 && q !== null) {
                    t = q;
                    var o = Bl;
                    b:switch (Y) {
                        case 1:
                            Y = 0, Bl = null, Pu(e, t, o, 1);
                            break;
                        case 2:
                        case 9:
                            if (Aa(o)) {
                                Y = 0, Bl = null, Nu(t);
                                break
                            }
                            t = function () {
                                Y !== 2 && Y !== 9 || K !== e || (Y = 7), rd(e)
                            }, o.then(t, t);
                            break a;
                        case 3:
                            Y = 7;
                            break a;
                        case 4:
                            Y = 5;
                            break a;
                        case 7:
                            Aa(o) ? (Y = 0, Bl = null, Nu(t)) : (Y = 0, Bl = null, Pu(e, t, o, 7));
                            break;
                        case 5:
                            var s = null;
                            switch (q.tag) {
                                case 26:
                                    s = q.memoizedState;
                                case 5:
                                case 27:
                                    var c = q;
                                    if (s ? Wf(s) : c.stateNode.complete) {
                                        Y = 0, Bl = null;
                                        var l = c.sibling;
                                        if (l !== null) q = l; else {
                                            var u = c.return;
                                            u === null ? q = null : (q = u, Fu(u))
                                        }
                                        break b
                                    }
                            }
                            Y = 0, Bl = null, Pu(e, t, o, 5);
                            break;
                        case 6:
                            Y = 0, Bl = null, Pu(e, t, o, 6);
                            break;
                        case 8:
                            xu(), X = 6;
                            break a;
                        default:
                            throw Error(i(462))
                    }
                }
                ju();
                break
            } catch (t) {
                Cu(e, t)
            } while (1);
            return Qi = Zi = null, E.H = r, E.A = a, G = n, q === null ? (K = null, J = 0, oi(), X) : 0
        }

        function ju() {
            for (; q !== null && !je();) Mu(q)
        }

        function Mu(e) {
            var t = Nc(e.alternate, e, Wl);
            e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t
        }

        function Nu(e) {
            var t = e, n = t.alternate;
            switch (t.tag) {
                case 15:
                case 0:
                    t = _c(n, t, t.pendingProps, t.type, void 0, J);
                    break;
                case 11:
                    t = _c(n, t, t.pendingProps, t.type.render, t.ref, J);
                    break;
                case 5:
                    Ao(t);
                default:
                    Vc(n, t), t = q = _i(t, Wl), t = Nc(n, t, Wl)
            }
            e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t
        }

        function Pu(e, t, n, r) {
            Qi = Zi = null, Ao(t), Ia = null, La = 0;
            var i = t.return;
            try {
                if (nc(e, i, t, n, J)) {
                    X = 1, Zs(e, wi(n, e.current)), q = null;
                    return
                }
            } catch (t) {
                if (i !== null) throw q = i, t;
                X = 1, Zs(e, wi(n, e.current)), q = null;
                return
            }
            t.flags & 32768 ? (P || r === 1 ? e = !0 : Hl || J & 536870912 ? e = !1 : (Vl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = I.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Iu(t, e)) : Fu(t)
        }

        function Fu(e) {
            var t = e;
            do {
                if (t.flags & 32768) {
                    Iu(t, Vl);
                    return
                }
                e = t.return;
                var n = zc(t.alternate, t, Wl);
                if (n !== null) {
                    q = n;
                    return
                }
                if (t = t.sibling, t !== null) {
                    q = t;
                    return
                }
                q = t = e
            } while (t !== null);
            X === 0 && (X = 5)
        }

        function Iu(e, t) {
            do {
                var n = Bc(e.alternate, e);
                if (n !== null) {
                    n.flags &= 32767, q = n;
                    return
                }
                if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
                    q = e;
                    return
                }
                q = e = n
            } while (e !== null);
            X = 6, q = null
        }

        function Lu(e, t, n, r, a, o, s, c, l) {
            e.cancelPendingCommit = null;
            do Hu(); while (iu !== 0);
            if (G & 6) throw Error(i(327));
            if (t !== null) {
                if (t === e.current) throw Error(i(177));
                if (o = t.lanes | t.childLanes, o |= ai, at(e, n, o, s, c, l), e === K && (q = K = null, J = 0), ou = t, au = e, su = n, cu = o, lu = a, uu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Xu(Le, function () {
                    return Uu(), null
                })) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
                    r = E.T, E.T = null, a = D.p, D.p = 2, s = G, G |= 4;
                    try {
                        ol(e, t, n)
                    } finally {
                        G = s, D.p = a, E.T = r
                    }
                }
                iu = 1, Ru(), zu(), Bu()
            }
        }

        function Ru() {
            if (iu === 1) {
                iu = 0;
                var e = au, t = ou, n = (t.flags & 13878) != 0;
                if (t.subtreeFlags & 13878 || n) {
                    n = E.T, E.T = null;
                    var r = D.p;
                    D.p = 2;
                    var i = G;
                    G |= 4;
                    try {
                        vl(t, e);
                        var a = zd, o = k(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
                        if (o !== s && s && s.ownerDocument && Ir(s.ownerDocument.documentElement, s)) {
                            if (c !== null && A(s)) {
                                var l = c.start, u = c.end;
                                if (u === void 0 && (u = l), `selectionStart` in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length); else {
                                    var d = s.ownerDocument || document, f = d && d.defaultView || window;
                                    if (f.getSelection) {
                                        var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m),
                                            g = c.end === void 0 ? h : Math.min(c.end, m);
                                        !p.extend && h > g && (o = g, g = h, h = o);
                                        var _ = Fr(s, h), v = Fr(s, g);
                                        if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
                                            var y = d.createRange();
                                            y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y))
                                        }
                                    }
                                }
                            }
                            for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
                                element: p,
                                left: p.scrollLeft,
                                top: p.scrollTop
                            });
                            for (typeof s.focus == `function` && s.focus(), s = 0; s < d.length; s++) {
                                var b = d[s];
                                b.element.scrollLeft = b.left, b.element.scrollTop = b.top
                            }
                        }
                        sp = !!Rd, zd = Rd = null
                    } finally {
                        G = i, D.p = r, E.T = n
                    }
                }
                e.current = t, iu = 2
            }
        }

        function zu() {
            if (iu === 2) {
                iu = 0;
                var e = au, t = ou, n = (t.flags & 8772) != 0;
                if (t.subtreeFlags & 8772 || n) {
                    n = E.T, E.T = null;
                    var r = D.p;
                    D.p = 2;
                    var i = G;
                    G |= 4;
                    try {
                        sl(e, t.alternate, t)
                    } finally {
                        G = i, D.p = r, E.T = n
                    }
                }
                iu = 3
            }
        }

        function Bu() {
            if (iu === 4 || iu === 3) {
                iu = 0, Me();
                var e = au, t = ou, n = su, r = uu;
                t.subtreeFlags & 10256 || t.flags & 10256 ? iu = 5 : (iu = 0, ou = au = null, Vu(e, e.pendingLanes));
                var i = e.pendingLanes;
                if (i === 0 && (ru = null), ut(n), t = t.stateNode, Ue && typeof Ue.onCommitFiberRoot == `function`) try {
                    Ue.onCommitFiberRoot(He, t, void 0, (t.current.flags & 128) == 128)
                } catch {
                }
                if (r !== null) {
                    t = E.T, i = D.p, D.p = 2, E.T = null;
                    try {
                        for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
                            var s = r[o];
                            a(s.value, {componentStack: s.stack})
                        }
                    } finally {
                        E.T = t, D.p = i
                    }
                }
                su & 3 && Hu(), rd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === fu ? du++ : (du = 0, fu = e) : du = 0, id(0, !1)
            }
        }

        function Vu(e, t) {
            (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, pa(t)))
        }

        function Hu() {
            return Ru(), zu(), Bu(), Uu()
        }

        function Uu() {
            if (iu !== 5) return !1;
            var e = au, t = cu;
            cu = 0;
            var n = ut(su), r = E.T, a = D.p;
            try {
                D.p = 32 > n ? 32 : n, E.T = null, n = lu, lu = null;
                var o = au, s = su;
                if (iu = 0, ou = au = null, su = 0, G & 6) throw Error(i(331));
                var c = G;
                if (G |= 4, Fl(o.current), Dl(o, o.current, s, n), G = c, id(0, !1), Ue && typeof Ue.onPostCommitFiberRoot == `function`) try {
                    Ue.onPostCommitFiberRoot(He, o)
                } catch {
                }
                return !0
            } finally {
                D.p = a, E.T = r, Vu(e, t)
            }
        }

        function Wu(e, t, n) {
            t = wi(n, t), t = $s(e.stateNode, t, 2), e = Ja(e, t, 2), e !== null && (it(e, 2), rd(e))
        }

        function Z(e, t, n) {
            if (e.tag === 3) Wu(e, e, n); else for (; t !== null;) {
                if (t.tag === 3) {
                    Wu(t, e, n);
                    break
                } else if (t.tag === 1) {
                    var r = t.stateNode;
                    if (typeof t.type.getDerivedStateFromError == `function` || typeof r.componentDidCatch == `function` && (ru === null || !ru.has(r))) {
                        e = wi(n, e), n = ec(2), r = Ja(t, n, 2), r !== null && (tc(n, r, t, e), it(r, 2), rd(r));
                        break
                    }
                }
                t = t.return
            }
        }

        function Gu(e, t, n) {
            var r = e.pingCache;
            if (r === null) {
                r = e.pingCache = new zl;
                var i = new Set;
                r.set(t, i)
            } else i = r.get(t), i === void 0 && (i = new Set, r.set(t, i));
            i.has(n) || (Ul = !0, i.add(n), e = Ku.bind(null, e, t, n), t.then(e, e))
        }

        function Ku(e, t, n) {
            var r = e.pingCache;
            r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, K === e && (J & n) === n && (X === 4 || X === 3 && (J & 62914560) === J && 300 > Ne() - $l ? !(G & 2) && Su(e, 0) : ql |= n, Yl === J && (Yl = 0)), rd(e)
        }

        function qu(e, t) {
            t === 0 && (t = nt()), e = li(e, t), e !== null && (it(e, t), rd(e))
        }

        function Ju(e) {
            var t = e.memoizedState, n = 0;
            t !== null && (n = t.retryLane), qu(e, n)
        }

        function Yu(e, t) {
            var n = 0;
            switch (e.tag) {
                case 31:
                case 13:
                    var r = e.stateNode, a = e.memoizedState;
                    a !== null && (n = a.retryLane);
                    break;
                case 19:
                    r = e.stateNode;
                    break;
                case 22:
                    r = e.stateNode._retryCache;
                    break;
                default:
                    throw Error(i(314))
            }
            r !== null && r.delete(t), qu(e, n)
        }

        function Xu(e, t) {
            return ke(e, t)
        }

        var Zu = null, Qu = null, $u = !1, ed = !1, td = !1, nd = 0;

        function rd(e) {
            e !== Qu && e.next === null && (Qu === null ? Zu = Qu = e : Qu = Qu.next = e), ed = !0, $u || ($u = !0, ud())
        }

        function id(e, t) {
            if (!td && ed) {
                td = !0;
                do for (var n = !1, r = Zu; r !== null;) {
                    if (!t) if (e !== 0) {
                        var i = r.pendingLanes;
                        if (i === 0) var a = 0; else {
                            var o = r.suspendedLanes, s = r.pingedLanes;
                            a = (1 << 31 - Ge(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0
                        }
                        a !== 0 && (n = !0, ld(r, a))
                    } else a = J, a = $e(r, r === K ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || et(r, a) || (n = !0, ld(r, a));
                    r = r.next
                } while (n);
                td = !1
            }
        }

        function ad() {
            od()
        }

        function od() {
            ed = $u = !1;
            var e = 0;
            nd !== 0 && Gd() && (e = nd);
            for (var t = Ne(), n = null, r = Zu; r !== null;) {
                var i = r.next, a = sd(r, t);
                a === 0 ? (r.next = null, n === null ? Zu = i : n.next = i, i === null && (Qu = n)) : (n = r, (e !== 0 || a & 3) && (ed = !0)), r = i
            }
            iu !== 0 && iu !== 5 || id(e, !1), nd !== 0 && (nd = 0)
        }

        function sd(e, t) {
            for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
                var o = 31 - Ge(a), s = 1 << o, c = i[o];
                c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = tt(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s
            }
            if (t = K, n = J, n = $e(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && Ae(r), e.callbackNode = null, e.callbackPriority = 0;
            if (!(n & 3) || et(e, n)) {
                if (t = n & -n, t === e.callbackPriority) return t;
                switch (r !== null && Ae(r), ut(n)) {
                    case 2:
                    case 8:
                        n = Ie;
                        break;
                    case 32:
                        n = Le;
                        break;
                    case 268435456:
                        n = ze;
                        break;
                    default:
                        n = Le
                }
                return r = cd.bind(null, e), n = ke(n, r), e.callbackPriority = t, e.callbackNode = n, t
            }
            return r !== null && r !== null && Ae(r), e.callbackPriority = 2, e.callbackNode = null, 2
        }

        function cd(e, t) {
            if (iu !== 0 && iu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
            var n = e.callbackNode;
            if (Hu() && e.callbackNode !== n) return null;
            var r = J;
            return r = $e(e, e === K ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (gu(e, r, t), sd(e, Ne()), e.callbackNode != null && e.callbackNode === n ? cd.bind(null, e) : null)
        }

        function ld(e, t) {
            if (Hu()) return null;
            gu(e, t, !0)
        }

        function ud() {
            Yd(function () {
                G & 6 ? ke(Fe, ad) : od()
            })
        }

        function dd() {
            if (nd === 0) {
                var e = ga;
                e === 0 && (e = Ye, Ye <<= 1, !(Ye & 261888) && (Ye = 256)), nd = e
            }
            return nd
        }

        function fd(e) {
            return e == null || typeof e == `symbol` || typeof e == `boolean` ? null : typeof e == `function` ? e : sn(`` + e)
        }

        function pd(e, t) {
            var n = t.ownerDocument.createElement(`input`);
            return n.name = t.name, n.value = t.value, e.id && n.setAttribute(`form`, e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e
        }

        function md(e, t, n, r, i) {
            if (t === `submit` && n && n.stateNode === i) {
                var a = fd((i[ht] || null).action), o = r.submitter;
                o && (t = (t = o[ht] || null) ? fd(t.formAction) : o.getAttribute(`formAction`), t !== null && (a = t, o = null));
                var s = new kn(`action`, `action`, null, r, i);
                e.push({
                    event: s, listeners: [{
                        instance: null, listener: function () {
                            if (r.defaultPrevented) {
                                if (nd !== 0) {
                                    var e = o ? pd(i, o) : new FormData(i);
                                    Ts(n, {pending: !0, data: e, method: i.method, action: a}, null, e)
                                }
                            } else typeof a == `function` && (s.preventDefault(), e = o ? pd(i, o) : new FormData(i), Ts(n, {
                                pending: !0,
                                data: e,
                                method: i.method,
                                action: a
                            }, a, e))
                        }, currentTarget: i
                    }]
                })
            }
        }

        for (var hd = 0; hd < ei.length; hd++) {
            var gd = ei[hd];
            ti(gd.toLowerCase(), `on` + (gd[0].toUpperCase() + gd.slice(1)))
        }
        ti(Jr, `onAnimationEnd`), ti(Yr, `onAnimationIteration`), ti(Xr, `onAnimationStart`), ti(`dblclick`, `onDoubleClick`), ti(`focusin`, `onFocus`), ti(`focusout`, `onBlur`), ti(j, `onTransitionRun`), ti(Zr, `onTransitionStart`), ti(Qr, `onTransitionCancel`), ti(M, `onTransitionEnd`), jt(`onMouseEnter`, [`mouseout`, `mouseover`]), jt(`onMouseLeave`, [`mouseout`, `mouseover`]), jt(`onPointerEnter`, [`pointerout`, `pointerover`]), jt(`onPointerLeave`, [`pointerout`, `pointerover`]), At(`onChange`, `change click focusin focusout input keydown keyup selectionchange`.split(` `)), At(`onSelect`, `focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange`.split(` `)), At(`onBeforeInput`, [`compositionend`, `keypress`, `textInput`, `paste`]), At(`onCompositionEnd`, `compositionend focusout keydown keypress keyup mousedown`.split(` `)), At(`onCompositionStart`, `compositionstart focusout keydown keypress keyup mousedown`.split(` `)), At(`onCompositionUpdate`, `compositionupdate focusout keydown keypress keyup mousedown`.split(` `));
        var _d = `abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting`.split(` `),
            vd = new Set(`beforetoggle cancel close invalid load scroll scrollend toggle`.split(` `).concat(_d));

        function yd(e, t) {
            t = (t & 4) != 0;
            for (var n = 0; n < e.length; n++) {
                var r = e[n], i = r.event;
                r = r.listeners;
                a:{
                    var a = void 0;
                    if (t) for (var o = r.length - 1; 0 <= o; o--) {
                        var s = r[o], c = s.instance, l = s.currentTarget;
                        if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
                        a = s, i.currentTarget = l;
                        try {
                            a(i)
                        } catch (e) {
                            ni(e)
                        }
                        i.currentTarget = null, a = c
                    } else for (o = 0; o < r.length; o++) {
                        if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
                        a = s, i.currentTarget = l;
                        try {
                            a(i)
                        } catch (e) {
                            ni(e)
                        }
                        i.currentTarget = null, a = c
                    }
                }
            }
        }

        function Q(e, t) {
            var n = t[_t];
            n === void 0 && (n = t[_t] = new Set);
            var r = e + `__bubble`;
            n.has(r) || (Cd(t, e, 2, !1), n.add(r))
        }

        function bd(e, t, n) {
            var r = 0;
            t && (r |= 4), Cd(n, e, r, t)
        }

        var xd = `_reactListening` + Math.random().toString(36).slice(2);

        function Sd(e) {
            if (!e[xd]) {
                e[xd] = !0, Ot.forEach(function (t) {
                    t !== `selectionchange` && (vd.has(t) || bd(t, !1, e), bd(t, !0, e))
                });
                var t = e.nodeType === 9 ? e : e.ownerDocument;
                t === null || t[xd] || (t[xd] = !0, bd(`selectionchange`, !1, t))
            }
        }

        function Cd(e, t, n, r) {
            switch (mp(t)) {
                case 2:
                    var i = cp;
                    break;
                case 8:
                    i = lp;
                    break;
                default:
                    i = up
            }
            n = i.bind(null, t, n, e), i = void 0, !vn || t !== `touchstart` && t !== `touchmove` && t !== `wheel` || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
                capture: !0,
                passive: i
            }) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, {passive: i})
        }

        function wd(e, t, n, r, i) {
            var a = r;
            if (!(t & 1) && !(t & 2) && r !== null) a:for (; ;) {
                if (r === null) return;
                var s = r.tag;
                if (s === 3 || s === 4) {
                    var c = r.stateNode.containerInfo;
                    if (c === i) break;
                    if (s === 4) for (s = r.return; s !== null;) {
                        var l = s.tag;
                        if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
                        s = s.return
                    }
                    for (; c !== null;) {
                        if (s = Ct(c), s === null) return;
                        if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
                            r = a = s;
                            continue a
                        }
                        c = c.parentNode
                    }
                }
                r = r.return
            }
            hn(function () {
                var r = a, i = un(n), s = [];
                a:{
                    var c = $r.get(e);
                    if (c !== void 0) {
                        var l = kn, u = e;
                        switch (e) {
                            case`keypress`:
                                if (wn(n) === 0) break a;
                            case`keydown`:
                            case`keyup`:
                                l = Yn;
                                break;
                            case`focusin`:
                                u = `focus`, l = Rn;
                                break;
                            case`focusout`:
                                u = `blur`, l = Rn;
                                break;
                            case`beforeblur`:
                            case`afterblur`:
                                l = Rn;
                                break;
                            case`click`:
                                if (n.button === 2) break a;
                            case`auxclick`:
                            case`dblclick`:
                            case`mousedown`:
                            case`mousemove`:
                            case`mouseup`:
                            case`mouseout`:
                            case`mouseover`:
                            case`contextmenu`:
                                l = In;
                                break;
                            case`drag`:
                            case`dragend`:
                            case`dragenter`:
                            case`dragexit`:
                            case`dragleave`:
                            case`dragover`:
                            case`dragstart`:
                            case`drop`:
                                l = Ln;
                                break;
                            case`touchcancel`:
                            case`touchend`:
                            case`touchmove`:
                            case`touchstart`:
                                l = Zn;
                                break;
                            case Jr:
                            case Yr:
                            case Xr:
                                l = zn;
                                break;
                            case M:
                                l = Qn;
                                break;
                            case`scroll`:
                            case`scrollend`:
                                l = jn;
                                break;
                            case`wheel`:
                                l = $n;
                                break;
                            case`copy`:
                            case`cut`:
                            case`paste`:
                                l = Bn;
                                break;
                            case`gotpointercapture`:
                            case`lostpointercapture`:
                            case`pointercancel`:
                            case`pointerdown`:
                            case`pointermove`:
                            case`pointerout`:
                            case`pointerover`:
                            case`pointerup`:
                                l = Xn;
                                break;
                            case`toggle`:
                            case`beforetoggle`:
                                l = er
                        }
                        var d = (t & 4) != 0, f = !d && (e === `scroll` || e === `scrollend`),
                            p = d ? c === null ? null : c + `Capture` : c;
                        d = [];
                        for (var m = r, h; m !== null;) {
                            var g = m;
                            if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = gn(m, p), g != null && d.push(Td(m, g, h))), f) break;
                            m = m.return
                        }
                        0 < d.length && (c = new l(c, u, null, n, i), s.push({event: c, listeners: d}))
                    }
                }
                if (!(t & 7)) {
                    a:{
                        if (c = e === `mouseover` || e === `pointerover`, l = e === `mouseout` || e === `pointerout`, c && n !== ln && (u = n.relatedTarget || n.fromElement) && (Ct(u) || u[gt])) break a;
                        if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? Ct(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
                            if (d = In, g = `onMouseLeave`, p = `onMouseEnter`, m = `mouse`, (e === `pointerout` || e === `pointerover`) && (d = Xn, g = `onPointerLeave`, p = `onPointerEnter`, m = `pointer`), f = l == null ? c : Tt(l), h = u == null ? c : Tt(u), c = new d(g, m + `leave`, l, n, i), c.target = f, c.relatedTarget = h, g = null, Ct(i) === r && (d = new d(p, m + `enter`, u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b:{
                                for (d = Dd, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
                                g = 0;
                                for (var _ = m; _; _ = d(_)) g++;
                                for (; 0 < h - g;) p = d(p), h--;
                                for (; 0 < g - h;) m = d(m), g--;
                                for (; h--;) {
                                    if (p === m || m !== null && p === m.alternate) {
                                        d = p;
                                        break b
                                    }
                                    p = d(p), m = d(m)
                                }
                                d = null
                            } else d = null;
                            l !== null && Od(s, c, l, d, !1), u !== null && f !== null && Od(s, f, u, d, !0)
                        }
                    }
                    a:{
                        if (c = r ? Tt(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === `select` || l === `input` && c.type === `file`) var v = br; else if (mr(c)) if (xr) v = Ar; else {
                            v = Or;
                            var y = Dr
                        } else l = c.nodeName, !l || l.toLowerCase() !== `input` || c.type !== `checkbox` && c.type !== `radio` ? r && rn(r.elementType) && (v = br) : v = kr;
                        if (v &&= v(e, r)) {
                            hr(s, v, n, i);
                            break a
                        }
                        y && y(e, c, r), e === `focusout` && r && c.type === `number` && r.memoizedProps.value != null && Yt(c, `number`, c.value)
                    }
                    switch (y = r ? Tt(r) : window, e) {
                        case`focusin`:
                            (mr(y) || y.contentEditable === `true`) && (Rr = y, zr = r, Br = null);
                            break;
                        case`focusout`:
                            Br = zr = Rr = null;
                            break;
                        case`mousedown`:
                            Vr = !0;
                            break;
                        case`contextmenu`:
                        case`mouseup`:
                        case`dragend`:
                            Vr = !1, Hr(s, n, i);
                            break;
                        case`selectionchange`:
                            if (Lr) break;
                        case`keydown`:
                        case`keyup`:
                            Hr(s, n, i)
                    }
                    var b;
                    if (nr) b:{
                        switch (e) {
                            case`compositionstart`:
                                var x = `onCompositionStart`;
                                break b;
                            case`compositionend`:
                                x = `onCompositionEnd`;
                                break b;
                            case`compositionupdate`:
                                x = `onCompositionUpdate`;
                                break b
                        }
                        x = void 0
                    } else ur ? cr(e, n) && (x = `onCompositionEnd`) : e === `keydown` && n.keyCode === 229 && (x = `onCompositionStart`);
                    x && (ar && n.locale !== `ko` && (ur || x !== `onCompositionStart` ? x === `onCompositionEnd` && ur && (b = Cn()) : (bn = i, xn = `value` in bn ? bn.value : bn.textContent, ur = !0)), y = Ed(r, x), 0 < y.length && (x = new Vn(x, e, null, n, i), s.push({
                        event: x,
                        listeners: y
                    }), b ? x.data = b : (b = lr(n), b !== null && (x.data = b)))), (b = ir ? dr(e, n) : fr(e, n)) && (x = Ed(r, `onBeforeInput`), 0 < x.length && (y = new Vn(`onBeforeInput`, `beforeinput`, null, n, i), s.push({
                        event: y,
                        listeners: x
                    }), y.data = b)), md(s, e, r, n, i)
                }
                yd(s, t)
            })
        }

        function Td(e, t, n) {
            return {instance: e, listener: t, currentTarget: n}
        }

        function Ed(e, t) {
            for (var n = t + `Capture`, r = []; e !== null;) {
                var i = e, a = i.stateNode;
                if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = gn(e, n), i != null && r.unshift(Td(e, i, a)), i = gn(e, t), i != null && r.push(Td(e, i, a))), e.tag === 3) return r;
                e = e.return
            }
            return []
        }

        function Dd(e) {
            if (e === null) return null;
            do e = e.return; while (e && e.tag !== 5 && e.tag !== 27);
            return e || null
        }

        function Od(e, t, n, r, i) {
            for (var a = t._reactName, o = []; n !== null && n !== r;) {
                var s = n, c = s.alternate, l = s.stateNode;
                if (s = s.tag, c !== null && c === r) break;
                s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = gn(n, a), l != null && o.unshift(Td(n, l, c))) : i || (l = gn(n, a), l != null && o.push(Td(n, l, c)))), n = n.return
            }
            o.length !== 0 && e.push({event: t, listeners: o})
        }

        var kd = /\r\n?/g, Ad = /\u0000|\uFFFD/g;

        function jd(e) {
            return (typeof e == `string` ? e : `` + e).replace(kd, `
`).replace(Ad, ``)
        }

        function Md(e, t) {
            return t = jd(t), jd(e) === t
        }

        function $(e, t, n, r, a, o) {
            switch (n) {
                case`children`:
                    typeof r == `string` ? t === `body` || t === `textarea` && r === `` || $t(e, r) : (typeof r == `number` || typeof r == `bigint`) && t !== `body` && $t(e, `` + r);
                    break;
                case`className`:
                    Lt(e, `class`, r);
                    break;
                case`tabIndex`:
                    Lt(e, `tabindex`, r);
                    break;
                case`dir`:
                case`role`:
                case`viewBox`:
                case`width`:
                case`height`:
                    Lt(e, n, r);
                    break;
                case`style`:
                    nn(e, r, o);
                    break;
                case`data`:
                    if (t !== `object`) {
                        Lt(e, `data`, r);
                        break
                    }
                case`src`:
                case`href`:
                    if (r === `` && (t !== `a` || n !== `href`)) {
                        e.removeAttribute(n);
                        break
                    }
                    if (r == null || typeof r == `function` || typeof r == `symbol` || typeof r == `boolean`) {
                        e.removeAttribute(n);
                        break
                    }
                    r = sn(`` + r), e.setAttribute(n, r);
                    break;
                case`action`:
                case`formAction`:
                    if (typeof r == `function`) {
                        e.setAttribute(n, `javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')`);
                        break
                    } else typeof o == `function` && (n === `formAction` ? (t !== `input` && $(e, t, `name`, a.name, a, null), $(e, t, `formEncType`, a.formEncType, a, null), $(e, t, `formMethod`, a.formMethod, a, null), $(e, t, `formTarget`, a.formTarget, a, null)) : ($(e, t, `encType`, a.encType, a, null), $(e, t, `method`, a.method, a, null), $(e, t, `target`, a.target, a, null)));
                    if (r == null || typeof r == `symbol` || typeof r == `boolean`) {
                        e.removeAttribute(n);
                        break
                    }
                    r = sn(`` + r), e.setAttribute(n, r);
                    break;
                case`onClick`:
                    r != null && (e.onclick = cn);
                    break;
                case`onScroll`:
                    r != null && Q(`scroll`, e);
                    break;
                case`onScrollEnd`:
                    r != null && Q(`scrollend`, e);
                    break;
                case`dangerouslySetInnerHTML`:
                    if (r != null) {
                        if (typeof r != `object` || !(`__html` in r)) throw Error(i(61));
                        if (n = r.__html, n != null) {
                            if (a.children != null) throw Error(i(60));
                            e.innerHTML = n
                        }
                    }
                    break;
                case`multiple`:
                    e.multiple = r && typeof r != `function` && typeof r != `symbol`;
                    break;
                case`muted`:
                    e.muted = r && typeof r != `function` && typeof r != `symbol`;
                    break;
                case`suppressContentEditableWarning`:
                case`suppressHydrationWarning`:
                case`defaultValue`:
                case`defaultChecked`:
                case`innerHTML`:
                case`ref`:
                    break;
                case`autoFocus`:
                    break;
                case`xlinkHref`:
                    if (r == null || typeof r == `function` || typeof r == `boolean` || typeof r == `symbol`) {
                        e.removeAttribute(`xlink:href`);
                        break
                    }
                    n = sn(`` + r), e.setAttributeNS(`http://www.w3.org/1999/xlink`, `xlink:href`, n);
                    break;
                case`contentEditable`:
                case`spellCheck`:
                case`draggable`:
                case`value`:
                case`autoReverse`:
                case`externalResourcesRequired`:
                case`focusable`:
                case`preserveAlpha`:
                    r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, `` + r) : e.removeAttribute(n);
                    break;
                case`inert`:
                case`allowFullScreen`:
                case`async`:
                case`autoPlay`:
                case`controls`:
                case`default`:
                case`defer`:
                case`disabled`:
                case`disablePictureInPicture`:
                case`disableRemotePlayback`:
                case`formNoValidate`:
                case`hidden`:
                case`loop`:
                case`noModule`:
                case`noValidate`:
                case`open`:
                case`playsInline`:
                case`readOnly`:
                case`required`:
                case`reversed`:
                case`scoped`:
                case`seamless`:
                case`itemScope`:
                    r && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, ``) : e.removeAttribute(n);
                    break;
                case`capture`:
                case`download`:
                    !0 === r ? e.setAttribute(n, ``) : !1 !== r && r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, r) : e.removeAttribute(n);
                    break;
                case`cols`:
                case`rows`:
                case`size`:
                case`span`:
                    r != null && typeof r != `function` && typeof r != `symbol` && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
                    break;
                case`rowSpan`:
                case`start`:
                    r == null || typeof r == `function` || typeof r == `symbol` || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
                    break;
                case`popover`:
                    Q(`beforetoggle`, e), Q(`toggle`, e), It(e, `popover`, r);
                    break;
                case`xlinkActuate`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:actuate`, r);
                    break;
                case`xlinkArcrole`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:arcrole`, r);
                    break;
                case`xlinkRole`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:role`, r);
                    break;
                case`xlinkShow`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:show`, r);
                    break;
                case`xlinkTitle`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:title`, r);
                    break;
                case`xlinkType`:
                    Rt(e, `http://www.w3.org/1999/xlink`, `xlink:type`, r);
                    break;
                case`xmlBase`:
                    Rt(e, `http://www.w3.org/XML/1998/namespace`, `xml:base`, r);
                    break;
                case`xmlLang`:
                    Rt(e, `http://www.w3.org/XML/1998/namespace`, `xml:lang`, r);
                    break;
                case`xmlSpace`:
                    Rt(e, `http://www.w3.org/XML/1998/namespace`, `xml:space`, r);
                    break;
                case`is`:
                    It(e, `is`, r);
                    break;
                case`innerText`:
                case`textContent`:
                    break;
                default:
                    (!(2 < n.length) || n[0] !== `o` && n[0] !== `O` || n[1] !== `n` && n[1] !== `N`) && (n = an.get(n) || n, It(e, n, r))
            }
        }

        function Nd(e, t, n, r, a, o) {
            switch (n) {
                case`style`:
                    nn(e, r, o);
                    break;
                case`dangerouslySetInnerHTML`:
                    if (r != null) {
                        if (typeof r != `object` || !(`__html` in r)) throw Error(i(61));
                        if (n = r.__html, n != null) {
                            if (a.children != null) throw Error(i(60));
                            e.innerHTML = n
                        }
                    }
                    break;
                case`children`:
                    typeof r == `string` ? $t(e, r) : (typeof r == `number` || typeof r == `bigint`) && $t(e, `` + r);
                    break;
                case`onScroll`:
                    r != null && Q(`scroll`, e);
                    break;
                case`onScrollEnd`:
                    r != null && Q(`scrollend`, e);
                    break;
                case`onClick`:
                    r != null && (e.onclick = cn);
                    break;
                case`suppressContentEditableWarning`:
                case`suppressHydrationWarning`:
                case`innerHTML`:
                case`ref`:
                    break;
                case`innerText`:
                case`textContent`:
                    break;
                default:
                    if (!kt.hasOwnProperty(n)) a:{
                        if (n[0] === `o` && n[1] === `n` && (a = n.endsWith(`Capture`), t = n.slice(2, a ? n.length - 7 : void 0), o = e[ht] || null, o = o == null ? null : o[n], typeof o == `function` && e.removeEventListener(t, o, a), typeof r == `function`)) {
                            typeof o != `function` && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
                            break a
                        }
                        n in e ? e[n] = r : !0 === r ? e.setAttribute(n, ``) : It(e, n, r)
                    }
            }
        }

        function Pd(e, t, n) {
            switch (t) {
                case`div`:
                case`span`:
                case`svg`:
                case`path`:
                case`a`:
                case`g`:
                case`p`:
                case`li`:
                    break;
                case`img`:
                    Q(`error`, e), Q(`load`, e);
                    var r = !1, a = !1, o;
                    for (o in n) if (n.hasOwnProperty(o)) {
                        var s = n[o];
                        if (s != null) switch (o) {
                            case`src`:
                                r = !0;
                                break;
                            case`srcSet`:
                                a = !0;
                                break;
                            case`children`:
                            case`dangerouslySetInnerHTML`:
                                throw Error(i(137, t));
                            default:
                                $(e, t, o, s, n, null)
                        }
                    }
                    a && $(e, t, `srcSet`, n.srcSet, n, null), r && $(e, t, `src`, n.src, n, null);
                    return;
                case`input`:
                    Q(`invalid`, e);
                    var c = o = s = a = null, l = null, u = null;
                    for (r in n) if (n.hasOwnProperty(r)) {
                        var d = n[r];
                        if (d != null) switch (r) {
                            case`name`:
                                a = d;
                                break;
                            case`type`:
                                s = d;
                                break;
                            case`checked`:
                                l = d;
                                break;
                            case`defaultChecked`:
                                u = d;
                                break;
                            case`value`:
                                o = d;
                                break;
                            case`defaultValue`:
                                c = d;
                                break;
                            case`children`:
                            case`dangerouslySetInnerHTML`:
                                if (d != null) throw Error(i(137, t));
                                break;
                            default:
                                $(e, t, r, d, n, null)
                        }
                    }
                    Jt(e, o, c, l, u, s, a, !1);
                    return;
                case`select`:
                    for (a in Q(`invalid`, e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
                        case`value`:
                            o = c;
                            break;
                        case`defaultValue`:
                            s = c;
                            break;
                        case`multiple`:
                            r = c;
                        default:
                            $(e, t, a, c, n, null)
                    }
                    t = o, n = s, e.multiple = !!r, t == null ? n != null && Xt(e, !!r, n, !0) : Xt(e, !!r, t, !1);
                    return;
                case`textarea`:
                    for (s in Q(`invalid`, e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
                        case`value`:
                            r = c;
                            break;
                        case`defaultValue`:
                            a = c;
                            break;
                        case`children`:
                            o = c;
                            break;
                        case`dangerouslySetInnerHTML`:
                            if (c != null) throw Error(i(91));
                            break;
                        default:
                            $(e, t, s, c, n, null)
                    }
                    Qt(e, r, a, o);
                    return;
                case`option`:
                    for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
                        case`selected`:
                            e.selected = r && typeof r != `function` && typeof r != `symbol`;
                            break;
                        default:
                            $(e, t, l, r, n, null)
                    }
                    return;
                case`dialog`:
                    Q(`beforetoggle`, e), Q(`toggle`, e), Q(`cancel`, e), Q(`close`, e);
                    break;
                case`iframe`:
                case`object`:
                    Q(`load`, e);
                    break;
                case`video`:
                case`audio`:
                    for (r = 0; r < _d.length; r++) Q(_d[r], e);
                    break;
                case`image`:
                    Q(`error`, e), Q(`load`, e);
                    break;
                case`details`:
                    Q(`toggle`, e);
                    break;
                case`embed`:
                case`source`:
                case`link`:
                    Q(`error`, e), Q(`load`, e);
                case`area`:
                case`base`:
                case`br`:
                case`col`:
                case`hr`:
                case`keygen`:
                case`meta`:
                case`param`:
                case`track`:
                case`wbr`:
                case`menuitem`:
                    for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
                        case`children`:
                        case`dangerouslySetInnerHTML`:
                            throw Error(i(137, t));
                        default:
                            $(e, t, u, r, n, null)
                    }
                    return;
                default:
                    if (rn(t)) {
                        for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
                        return
                    }
            }
            for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && $(e, t, c, r, n, null))
        }

        function Fd(e, t, n, r) {
            switch (t) {
                case`div`:
                case`span`:
                case`svg`:
                case`path`:
                case`a`:
                case`g`:
                case`p`:
                case`li`:
                    break;
                case`input`:
                    var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
                    for (m in n) {
                        var f = n[m];
                        if (n.hasOwnProperty(m) && f != null) switch (m) {
                            case`checked`:
                                break;
                            case`value`:
                                break;
                            case`defaultValue`:
                                l = f;
                            default:
                                r.hasOwnProperty(m) || $(e, t, m, null, r, f)
                        }
                    }
                    for (var p in r) {
                        var m = r[p];
                        if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
                            case`type`:
                                o = m;
                                break;
                            case`name`:
                                a = m;
                                break;
                            case`checked`:
                                u = m;
                                break;
                            case`defaultChecked`:
                                d = m;
                                break;
                            case`value`:
                                s = m;
                                break;
                            case`defaultValue`:
                                c = m;
                                break;
                            case`children`:
                            case`dangerouslySetInnerHTML`:
                                if (m != null) throw Error(i(137, t));
                                break;
                            default:
                                m !== f && $(e, t, p, m, r, f)
                        }
                    }
                    qt(e, s, c, l, u, d, o, a);
                    return;
                case`select`:
                    for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
                        case`value`:
                            break;
                        case`multiple`:
                            m = l;
                        default:
                            r.hasOwnProperty(o) || $(e, t, o, null, r, l)
                    }
                    for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
                        case`value`:
                            p = o;
                            break;
                        case`defaultValue`:
                            c = o;
                            break;
                        case`multiple`:
                            s = o;
                        default:
                            o !== l && $(e, t, a, o, r, l)
                    }
                    t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Xt(e, !!n, n ? [] : ``, !1) : Xt(e, !!n, t, !0)) : Xt(e, !!n, p, !1);
                    return;
                case`textarea`:
                    for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
                        case`value`:
                            break;
                        case`children`:
                            break;
                        default:
                            $(e, t, c, null, r, a)
                    }
                    for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
                        case`value`:
                            p = a;
                            break;
                        case`defaultValue`:
                            m = a;
                            break;
                        case`children`:
                            break;
                        case`dangerouslySetInnerHTML`:
                            if (a != null) throw Error(i(91));
                            break;
                        default:
                            a !== o && $(e, t, s, a, r, o)
                    }
                    Zt(e, p, m);
                    return;
                case`option`:
                    for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
                        case`selected`:
                            e.selected = !1;
                            break;
                        default:
                            $(e, t, h, null, r, p)
                    }
                    for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
                        case`selected`:
                            e.selected = p && typeof p != `function` && typeof p != `symbol`;
                            break;
                        default:
                            $(e, t, l, p, r, m)
                    }
                    return;
                case`img`:
                case`link`:
                case`area`:
                case`base`:
                case`br`:
                case`col`:
                case`embed`:
                case`hr`:
                case`keygen`:
                case`meta`:
                case`param`:
                case`source`:
                case`track`:
                case`wbr`:
                case`menuitem`:
                    for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && $(e, t, g, null, r, p);
                    for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
                        case`children`:
                        case`dangerouslySetInnerHTML`:
                            if (p != null) throw Error(i(137, t));
                            break;
                        default:
                            $(e, t, u, p, r, m)
                    }
                    return;
                default:
                    if (rn(t)) {
                        for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
                        for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
                        return
                    }
            }
            for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && $(e, t, v, null, r, p);
            for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || $(e, t, f, p, r, m)
        }

        function Id(e) {
            switch (e) {
                case`css`:
                case`script`:
                case`font`:
                case`img`:
                case`image`:
                case`input`:
                case`link`:
                    return !0;
                default:
                    return !1
            }
        }

        function Ld() {
            if (typeof performance.getEntriesByType == `function`) {
                for (var e = 0, t = 0, n = performance.getEntriesByType(`resource`), r = 0; r < n.length; r++) {
                    var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
                    if (a && s && Id(o)) {
                        for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
                            var c = n[r], l = c.startTime;
                            if (l > s) break;
                            var u = c.transferSize, d = c.initiatorType;
                            u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)))
                        }
                        if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break
                    }
                }
                if (0 < e) return t / e / 1e6
            }
            return navigator.connection && (e = navigator.connection.downlink, typeof e == `number`) ? e : 5
        }

        var Rd = null, zd = null;

        function Bd(e) {
            return e.nodeType === 9 ? e : e.ownerDocument
        }

        function Vd(e) {
            switch (e) {
                case`http://www.w3.org/2000/svg`:
                    return 1;
                case`http://www.w3.org/1998/Math/MathML`:
                    return 2;
                default:
                    return 0
            }
        }

        function Hd(e, t) {
            if (e === 0) switch (t) {
                case`svg`:
                    return 1;
                case`math`:
                    return 2;
                default:
                    return 0
            }
            return e === 1 && t === `foreignObject` ? 0 : e
        }

        function Ud(e, t) {
            return e === `textarea` || e === `noscript` || typeof t.children == `string` || typeof t.children == `number` || typeof t.children == `bigint` || typeof t.dangerouslySetInnerHTML == `object` && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null
        }

        var Wd = null;

        function Gd() {
            var e = window.event;
            return e && e.type === `popstate` ? e === Wd ? !1 : (Wd = e, !0) : (Wd = null, !1)
        }

        var Kd = typeof setTimeout == `function` ? setTimeout : void 0,
            qd = typeof clearTimeout == `function` ? clearTimeout : void 0,
            Jd = typeof Promise == `function` ? Promise : void 0,
            Yd = typeof queueMicrotask == `function` ? queueMicrotask : Jd === void 0 ? Kd : function (e) {
                return Jd.resolve(null).then(e).catch(Xd)
            };

        function Xd(e) {
            setTimeout(function () {
                throw e
            })
        }

        function Zd(e) {
            return e === `head`
        }

        function Qd(e, t) {
            var n = t, r = 0;
            do {
                var i = n.nextSibling;
                if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === `/$` || n === `/&`) {
                    if (r === 0) {
                        e.removeChild(i), Np(t);
                        return
                    }
                    r--
                } else if (n === `$` || n === `$?` || n === `$~` || n === `$!` || n === `&`) r++; else if (n === `html`) pf(e.ownerDocument.documentElement); else if (n === `head`) {
                    n = e.ownerDocument.head, pf(n);
                    for (var a = n.firstChild; a;) {
                        var o = a.nextSibling, s = a.nodeName;
                        a[xt] || s === `SCRIPT` || s === `STYLE` || s === `LINK` && a.rel.toLowerCase() === `stylesheet` || n.removeChild(a), a = o
                    }
                } else n === `body` && pf(e.ownerDocument.body);
                n = i
            } while (n);
            Np(t)
        }

        function $d(e, t) {
            var n = e;
            e = 0;
            do {
                var r = n.nextSibling;
                if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = `none`) : (n.style.display = n._stashedDisplay || ``, n.getAttribute(`style`) === `` && n.removeAttribute(`style`)) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = ``) : n.nodeValue = n._stashedText || ``), r && r.nodeType === 8) if (n = r.data, n === `/$`) {
                    if (e === 0) break;
                    e--
                } else n !== `$` && n !== `$?` && n !== `$~` && n !== `$!` || e++;
                n = r
            } while (n)
        }

        function ef(e) {
            var t = e.firstChild;
            for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
                var n = t;
                switch (t = t.nextSibling, n.nodeName) {
                    case`HTML`:
                    case`HEAD`:
                    case`BODY`:
                        ef(n), St(n);
                        continue;
                    case`SCRIPT`:
                    case`STYLE`:
                        continue;
                    case`LINK`:
                        if (n.rel.toLowerCase() === `stylesheet`) continue
                }
                e.removeChild(n)
            }
        }

        function tf(e, t, n, r) {
            for (; e.nodeType === 1;) {
                var i = n;
                if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                    if (!r && (e.nodeName !== `INPUT` || e.type !== `hidden`)) break
                } else if (!r) if (t === `input` && e.type === `hidden`) {
                    var a = i.name == null ? null : `` + i.name;
                    if (i.type === `hidden` && e.getAttribute(`name`) === a) return e
                } else return e; else if (!e[xt]) switch (t) {
                    case`meta`:
                        if (!e.hasAttribute(`itemprop`)) break;
                        return e;
                    case`link`:
                        if (a = e.getAttribute(`rel`), a === `stylesheet` && e.hasAttribute(`data-precedence`) || a !== i.rel || e.getAttribute(`href`) !== (i.href == null || i.href === `` ? null : i.href) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute(`title`) !== (i.title == null ? null : i.title)) break;
                        return e;
                    case`style`:
                        if (e.hasAttribute(`data-precedence`)) break;
                        return e;
                    case`script`:
                        if (a = e.getAttribute(`src`), (a !== (i.src == null ? null : i.src) || e.getAttribute(`type`) !== (i.type == null ? null : i.type) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute(`async`) && !e.hasAttribute(`itemprop`)) break;
                        return e;
                    default:
                        return e
                }
                if (e = cf(e.nextSibling), e === null) break
            }
            return null
        }

        function nf(e, t, n) {
            if (t === ``) return null;
            for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !n || (e = cf(e.nextSibling), e === null)) return null;
            return e
        }

        function rf(e, t) {
            for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !t || (e = cf(e.nextSibling), e === null)) return null;
            return e
        }

        function af(e) {
            return e.data === `$?` || e.data === `$~`
        }

        function of(e) {
            return e.data === `$!` || e.data === `$?` && e.ownerDocument.readyState !== `loading`
        }

        function sf(e, t) {
            var n = e.ownerDocument;
            if (e.data === `$~`) e._reactRetry = t; else if (e.data !== `$?` || n.readyState !== `loading`) t(); else {
                var r = function () {
                    t(), n.removeEventListener(`DOMContentLoaded`, r)
                };
                n.addEventListener(`DOMContentLoaded`, r), e._reactRetry = r
            }
        }

        function cf(e) {
            for (; e != null; e = e.nextSibling) {
                var t = e.nodeType;
                if (t === 1 || t === 3) break;
                if (t === 8) {
                    if (t = e.data, t === `$` || t === `$!` || t === `$?` || t === `$~` || t === `&` || t === `F!` || t === `F`) break;
                    if (t === `/$` || t === `/&`) return null
                }
            }
            return e
        }

        var lf = null;

        function uf(e) {
            e = e.nextSibling;
            for (var t = 0; e;) {
                if (e.nodeType === 8) {
                    var n = e.data;
                    if (n === `/$` || n === `/&`) {
                        if (t === 0) return cf(e.nextSibling);
                        t--
                    } else n !== `$` && n !== `$!` && n !== `$?` && n !== `$~` && n !== `&` || t++
                }
                e = e.nextSibling
            }
            return null
        }

        function df(e) {
            e = e.previousSibling;
            for (var t = 0; e;) {
                if (e.nodeType === 8) {
                    var n = e.data;
                    if (n === `$` || n === `$!` || n === `$?` || n === `$~` || n === `&`) {
                        if (t === 0) return e;
                        t--
                    } else n !== `/$` && n !== `/&` || t++
                }
                e = e.previousSibling
            }
            return null
        }

        function ff(e, t, n) {
            switch (t = Bd(n), e) {
                case`html`:
                    if (e = t.documentElement, !e) throw Error(i(452));
                    return e;
                case`head`:
                    if (e = t.head, !e) throw Error(i(453));
                    return e;
                case`body`:
                    if (e = t.body, !e) throw Error(i(454));
                    return e;
                default:
                    throw Error(i(451))
            }
        }

        function pf(e) {
            for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
            St(e)
        }

        var mf = new Map, hf = new Set;

        function gf(e) {
            return typeof e.getRootNode == `function` ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument
        }

        var _f = D.d;
        D.d = {f: vf, r: yf, D: Sf, C: Cf, L: wf, m: Tf, X: Df, S: Ef, M: Of};

        function vf() {
            var e = _f.f(), t = bu();
            return e || t
        }

        function yf(e) {
            var t = wt(e);
            t !== null && t.tag === 5 && t.type === `form` ? Ds(t) : _f.r(e)
        }

        var bf = typeof document > `u` ? null : document;

        function xf(e, t, n) {
            var r = bf;
            if (r && typeof t == `string` && t) {
                var i = Kt(t);
                i = `link[rel="` + e + `"][href="` + i + `"]`, typeof n == `string` && (i += `[crossorigin="` + n + `"]`), hf.has(i) || (hf.add(i), e = {
                    rel: e,
                    crossOrigin: n,
                    href: t
                }, r.querySelector(i) === null && (t = r.createElement(`link`), Pd(t, `link`, e), Dt(t), r.head.appendChild(t)))
            }
        }

        function Sf(e) {
            _f.D(e), xf(`dns-prefetch`, e, null)
        }

        function Cf(e, t) {
            _f.C(e, t), xf(`preconnect`, e, t)
        }

        function wf(e, t, n) {
            _f.L(e, t, n);
            var r = bf;
            if (r && e && t) {
                var i = `link[rel="preload"][as="` + Kt(t) + `"]`;
                t === `image` && n && n.imageSrcSet ? (i += `[imagesrcset="` + Kt(n.imageSrcSet) + `"]`, typeof n.imageSizes == `string` && (i += `[imagesizes="` + Kt(n.imageSizes) + `"]`)) : i += `[href="` + Kt(e) + `"]`;
                var a = i;
                switch (t) {
                    case`style`:
                        a = Af(e);
                        break;
                    case`script`:
                        a = Pf(e)
                }
                mf.has(a) || (e = p({
                    rel: `preload`,
                    href: t === `image` && n && n.imageSrcSet ? void 0 : e,
                    as: t
                }, n), mf.set(a, e), r.querySelector(i) !== null || t === `style` && r.querySelector(jf(a)) || t === `script` && r.querySelector(Ff(a)) || (t = r.createElement(`link`), Pd(t, `link`, e), Dt(t), r.head.appendChild(t)))
            }
        }

        function Tf(e, t) {
            _f.m(e, t);
            var n = bf;
            if (n && e) {
                var r = t && typeof t.as == `string` ? t.as : `script`,
                    i = `link[rel="modulepreload"][as="` + Kt(r) + `"][href="` + Kt(e) + `"]`, a = i;
                switch (r) {
                    case`audioworklet`:
                    case`paintworklet`:
                    case`serviceworker`:
                    case`sharedworker`:
                    case`worker`:
                    case`script`:
                        a = Pf(e)
                }
                if (!mf.has(a) && (e = p({rel: `modulepreload`, href: e}, t), mf.set(a, e), n.querySelector(i) === null)) {
                    switch (r) {
                        case`audioworklet`:
                        case`paintworklet`:
                        case`serviceworker`:
                        case`sharedworker`:
                        case`worker`:
                        case`script`:
                            if (n.querySelector(Ff(a))) return
                    }
                    r = n.createElement(`link`), Pd(r, `link`, e), Dt(r), n.head.appendChild(r)
                }
            }
        }

        function Ef(e, t, n) {
            _f.S(e, t, n);
            var r = bf;
            if (r && e) {
                var i = Et(r).hoistableStyles, a = Af(e);
                t ||= `default`;
                var o = i.get(a);
                if (!o) {
                    var s = {loading: 0, preload: null};
                    if (o = r.querySelector(jf(a))) s.loading = 5; else {
                        e = p({rel: `stylesheet`, href: e, "data-precedence": t}, n), (n = mf.get(a)) && Rf(e, n);
                        var c = o = r.createElement(`link`);
                        Dt(c), Pd(c, `link`, e), c._p = new Promise(function (e, t) {
                            c.onload = e, c.onerror = t
                        }), c.addEventListener(`load`, function () {
                            s.loading |= 1
                        }), c.addEventListener(`error`, function () {
                            s.loading |= 2
                        }), s.loading |= 4, Lf(o, t, r)
                    }
                    o = {type: `stylesheet`, instance: o, count: 1, state: s}, i.set(a, o)
                }
            }
        }

        function Df(e, t) {
            _f.X(e, t);
            var n = bf;
            if (n && e) {
                var r = Et(n).hoistableScripts, i = Pf(e), a = r.get(i);
                a || (a = n.querySelector(Ff(i)), a || (e = p({
                    src: e,
                    async: !0
                }, t), (t = mf.get(i)) && zf(e, t), a = n.createElement(`script`), Dt(a), Pd(a, `link`, e), n.head.appendChild(a)), a = {
                    type: `script`,
                    instance: a,
                    count: 1,
                    state: null
                }, r.set(i, a))
            }
        }

        function Of(e, t) {
            _f.M(e, t);
            var n = bf;
            if (n && e) {
                var r = Et(n).hoistableScripts, i = Pf(e), a = r.get(i);
                a || (a = n.querySelector(Ff(i)), a || (e = p({
                    src: e,
                    async: !0,
                    type: `module`
                }, t), (t = mf.get(i)) && zf(e, t), a = n.createElement(`script`), Dt(a), Pd(a, `link`, e), n.head.appendChild(a)), a = {
                    type: `script`,
                    instance: a,
                    count: 1,
                    state: null
                }, r.set(i, a))
            }
        }

        function kf(e, t, n, r) {
            var a = (a = he.current) ? gf(a) : null;
            if (!a) throw Error(i(446));
            switch (e) {
                case`meta`:
                case`title`:
                    return null;
                case`style`:
                    return typeof n.precedence == `string` && typeof n.href == `string` ? (t = Af(n.href), n = Et(a).hoistableStyles, r = n.get(t), r || (r = {
                        type: `style`,
                        instance: null,
                        count: 0,
                        state: null
                    }, n.set(t, r)), r) : {type: `void`, instance: null, count: 0, state: null};
                case`link`:
                    if (n.rel === `stylesheet` && typeof n.href == `string` && typeof n.precedence == `string`) {
                        e = Af(n.href);
                        var o = Et(a).hoistableStyles, s = o.get(e);
                        if (s || (a = a.ownerDocument || a, s = {
                            type: `stylesheet`,
                            instance: null,
                            count: 0,
                            state: {loading: 0, preload: null}
                        }, o.set(e, s), (o = a.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
                            rel: `preload`,
                            as: `style`,
                            href: n.href,
                            crossOrigin: n.crossOrigin,
                            integrity: n.integrity,
                            media: n.media,
                            hrefLang: n.hrefLang,
                            referrerPolicy: n.referrerPolicy
                        }, mf.set(e, n), o || Nf(a, e, n, s.state))), t && r === null) throw Error(i(528, ``));
                        return s
                    }
                    if (t && r !== null) throw Error(i(529, ``));
                    return null;
                case`script`:
                    return t = n.async, n = n.src, typeof n == `string` && t && typeof t != `function` && typeof t != `symbol` ? (t = Pf(n), n = Et(a).hoistableScripts, r = n.get(t), r || (r = {
                        type: `script`,
                        instance: null,
                        count: 0,
                        state: null
                    }, n.set(t, r)), r) : {type: `void`, instance: null, count: 0, state: null};
                default:
                    throw Error(i(444, e))
            }
        }

        function Af(e) {
            return `href="` + Kt(e) + `"`
        }

        function jf(e) {
            return `link[rel="stylesheet"][` + e + `]`
        }

        function Mf(e) {
            return p({}, e, {"data-precedence": e.precedence, precedence: null})
        }

        function Nf(e, t, n, r) {
            e.querySelector(`link[rel="preload"][as="style"][` + t + `]`) ? r.loading = 1 : (t = e.createElement(`link`), r.preload = t, t.addEventListener(`load`, function () {
                return r.loading |= 1
            }), t.addEventListener(`error`, function () {
                return r.loading |= 2
            }), Pd(t, `link`, n), Dt(t), e.head.appendChild(t))
        }

        function Pf(e) {
            return `[src="` + Kt(e) + `"]`
        }

        function Ff(e) {
            return `script[async]` + e
        }

        function If(e, t, n) {
            if (t.count++, t.instance === null) switch (t.type) {
                case`style`:
                    var r = e.querySelector(`style[data-href~="` + Kt(n.href) + `"]`);
                    if (r) return t.instance = r, Dt(r), r;
                    var a = p({}, n, {"data-href": n.href, "data-precedence": n.precedence, href: null, precedence: null});
                    return r = (e.ownerDocument || e).createElement(`style`), Dt(r), Pd(r, `style`, a), Lf(r, n.precedence, e), t.instance = r;
                case`stylesheet`:
                    a = Af(n.href);
                    var o = e.querySelector(jf(a));
                    if (o) return t.state.loading |= 4, t.instance = o, Dt(o), o;
                    r = Mf(n), (a = mf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement(`link`), Dt(o);
                    var s = o;
                    return s._p = new Promise(function (e, t) {
                        s.onload = e, s.onerror = t
                    }), Pd(o, `link`, r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
                case`script`:
                    return o = Pf(n.src), (a = e.querySelector(Ff(o))) ? (t.instance = a, Dt(a), a) : (r = n, (a = mf.get(o)) && (r = p({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement(`script`), Dt(a), Pd(a, `link`, r), e.head.appendChild(a), t.instance = a);
                case`void`:
                    return null;
                default:
                    throw Error(i(443, t.type))
            } else t.type === `stylesheet` && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
            return t.instance
        }

        function Lf(e, t, n) {
            for (var r = n.querySelectorAll(`link[rel="stylesheet"][data-precedence],style[data-precedence]`), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
                var s = r[o];
                if (s.dataset.precedence === t) a = s; else if (a !== i) break
            }
            a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild))
        }

        function Rf(e, t) {
            e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title
        }

        function zf(e, t) {
            e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity
        }

        var Bf = null;

        function Vf(e, t, n) {
            if (Bf === null) {
                var r = new Map, i = Bf = new Map;
                i.set(n, r)
            } else i = Bf, r = i.get(n), r || (r = new Map, i.set(n, r));
            if (r.has(e)) return r;
            for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
                var a = n[i];
                if (!(a[xt] || a[mt] || e === `link` && a.getAttribute(`rel`) === `stylesheet`) && a.namespaceURI !== `http://www.w3.org/2000/svg`) {
                    var o = a.getAttribute(t) || ``;
                    o = e + o;
                    var s = r.get(o);
                    s ? s.push(a) : r.set(o, [a])
                }
            }
            return r
        }

        function Hf(e, t, n) {
            e = e.ownerDocument || e, e.head.insertBefore(n, t === `title` ? e.querySelector(`head > title`) : null)
        }

        function Uf(e, t, n) {
            if (n === 1 || t.itemProp != null) return !1;
            switch (e) {
                case`meta`:
                case`title`:
                    return !0;
                case`style`:
                    if (typeof t.precedence != `string` || typeof t.href != `string` || t.href === ``) break;
                    return !0;
                case`link`:
                    if (typeof t.rel != `string` || typeof t.href != `string` || t.href === `` || t.onLoad || t.onError) break;
                    switch (t.rel) {
                        case`stylesheet`:
                            return e = t.disabled, typeof t.precedence == `string` && e == null;
                        default:
                            return !0
                    }
                case`script`:
                    if (t.async && typeof t.async != `function` && typeof t.async != `symbol` && !t.onLoad && !t.onError && t.src && typeof t.src == `string`) return !0
            }
            return !1
        }

        function Wf(e) {
            return !(e.type === `stylesheet` && !(e.state.loading & 3))
        }

        function Gf(e, t, n, r) {
            if (n.type === `stylesheet` && (typeof r.media != `string` || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
                if (n.instance === null) {
                    var i = Af(r.href), a = t.querySelector(jf(i));
                    if (a) {
                        t = a._p, typeof t == `object` && t && typeof t.then == `function` && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, Dt(a);
                        return
                    }
                    a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement(`link`), Dt(a);
                    var o = a;
                    o._p = new Promise(function (e, t) {
                        o.onload = e, o.onerror = t
                    }), Pd(a, `link`, r), n.instance = a
                }
                e.stylesheets === null && (e.stylesheets = new Map), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener(`load`, n), t.addEventListener(`error`, n))
            }
        }

        var Kf = 0;

        function qf(e, t) {
            return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function (n) {
                var r = setTimeout(function () {
                    if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
                        var t = e.unsuspend;
                        e.unsuspend = null, t()
                    }
                }, 6e4 + t);
                0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
                var i = setTimeout(function () {
                    if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
                        var t = e.unsuspend;
                        e.unsuspend = null, t()
                    }
                }, (e.imgBytes > Kf ? 50 : 800) + t);
                return e.unsuspend = n, function () {
                    e.unsuspend = null, clearTimeout(r), clearTimeout(i)
                }
            } : null
        }

        function Jf() {
            if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
                if (this.stylesheets) Xf(this, this.stylesheets); else if (this.unsuspend) {
                    var e = this.unsuspend;
                    this.unsuspend = null, e()
                }
            }
        }

        var Yf = null;

        function Xf(e, t) {
            e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = new Map, t.forEach(Zf, e), Yf = null, Jf.call(e))
        }

        function Zf(e, t) {
            if (!(t.state.loading & 4)) {
                var n = Yf.get(e);
                if (n) var r = n.get(null); else {
                    n = new Map, Yf.set(e, n);
                    for (var i = e.querySelectorAll(`link[data-precedence],style[data-precedence]`), a = 0; a < i.length; a++) {
                        var o = i[a];
                        (o.nodeName === `LINK` || o.getAttribute(`media`) !== `not all`) && (n.set(o.dataset.precedence, o), r = o)
                    }
                    r && n.set(null, r)
                }
                i = t.instance, o = i.getAttribute(`data-precedence`), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener(`load`, r), i.addEventListener(`error`, r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4
            }
        }

        var Qf = {$$typeof: x, Provider: null, Consumer: null, _currentValue: ce, _currentValue2: ce, _threadCount: 0};

        function $f(e, t, n, r, i, a, o, s, c) {
            this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = rt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = rt(0), this.hiddenUpdates = rt(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = new Map
        }

        function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
            return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = mi(3, null, null, t), e.current = a, a.stateNode = e, t = fa(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
                element: r,
                isDehydrated: n,
                cache: t
            }, Ga(a), e
        }

        function tp(e) {
            return e ? (e = fi, e) : fi
        }

        function np(e, t, n, r, i, a) {
            i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = qa(t), r.payload = {element: n}, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ja(e, r, t), n !== null && (hu(n, e, t), Ya(n, e, t))
        }

        function rp(e, t) {
            if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
                var n = e.retryLane;
                e.retryLane = n !== 0 && n < t ? n : t
            }
        }

        function ip(e, t) {
            rp(e, t), (e = e.alternate) && rp(e, t)
        }

        function ap(e) {
            if (e.tag === 13 || e.tag === 31) {
                var t = li(e, 67108864);
                t !== null && hu(t, e, 67108864), ip(e, 67108864)
            }
        }

        function op(e) {
            if (e.tag === 13 || e.tag === 31) {
                var t = pu();
                t = lt(t);
                var n = li(e, t);
                n !== null && hu(n, e, t), ip(e, t)
            }
        }

        var sp = !0;

        function cp(e, t, n, r) {
            var i = E.T;
            E.T = null;
            var a = D.p;
            try {
                D.p = 2, up(e, t, n, r)
            } finally {
                D.p = a, E.T = i
            }
        }

        function lp(e, t, n, r) {
            var i = E.T;
            E.T = null;
            var a = D.p;
            try {
                D.p = 8, up(e, t, n, r)
            } finally {
                D.p = a, E.T = i
            }
        }

        function up(e, t, n, r) {
            if (sp) {
                var i = dp(r);
                if (i === null) wd(e, t, r, fp, n), Cp(e, r); else if (Tp(i, e, t, n, r)) r.stopPropagation(); else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
                    for (; i !== null;) {
                        var a = wt(i);
                        if (a !== null) switch (a.tag) {
                            case 3:
                                if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
                                    var o = Qe(a.pendingLanes);
                                    if (o !== 0) {
                                        var s = a;
                                        for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
                                            var c = 1 << 31 - Ge(o);
                                            s.entanglements[1] |= c, o &= ~c
                                        }
                                        rd(a), !(G & 6) && (tu = Ne() + 500, id(0, !1))
                                    }
                                }
                                break;
                            case 31:
                            case 13:
                                s = li(a, 2), s !== null && hu(s, a, 2), bu(), ip(a, 2)
                        }
                        if (a = dp(r), a === null && wd(e, t, r, fp, n), a === i) break;
                        i = a
                    }
                    i !== null && r.stopPropagation()
                } else wd(e, t, r, null, n)
            }
        }

        function dp(e) {
            return e = un(e), pp(e)
        }

        var fp = null;

        function pp(e) {
            if (fp = null, e = Ct(e), e !== null) {
                var t = o(e);
                if (t === null) e = null; else {
                    var n = t.tag;
                    if (n === 13) {
                        if (e = s(t), e !== null) return e;
                        e = null
                    } else if (n === 31) {
                        if (e = c(t), e !== null) return e;
                        e = null
                    } else if (n === 3) {
                        if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
                        e = null
                    } else t !== e && (e = null)
                }
            }
            return fp = e, null
        }

        function mp(e) {
            switch (e) {
                case`beforetoggle`:
                case`cancel`:
                case`click`:
                case`close`:
                case`contextmenu`:
                case`copy`:
                case`cut`:
                case`auxclick`:
                case`dblclick`:
                case`dragend`:
                case`dragstart`:
                case`drop`:
                case`focusin`:
                case`focusout`:
                case`input`:
                case`invalid`:
                case`keydown`:
                case`keypress`:
                case`keyup`:
                case`mousedown`:
                case`mouseup`:
                case`paste`:
                case`pause`:
                case`play`:
                case`pointercancel`:
                case`pointerdown`:
                case`pointerup`:
                case`ratechange`:
                case`reset`:
                case`resize`:
                case`seeked`:
                case`submit`:
                case`toggle`:
                case`touchcancel`:
                case`touchend`:
                case`touchstart`:
                case`volumechange`:
                case`change`:
                case`selectionchange`:
                case`textInput`:
                case`compositionstart`:
                case`compositionend`:
                case`compositionupdate`:
                case`beforeblur`:
                case`afterblur`:
                case`beforeinput`:
                case`blur`:
                case`fullscreenchange`:
                case`focus`:
                case`hashchange`:
                case`popstate`:
                case`select`:
                case`selectstart`:
                    return 2;
                case`drag`:
                case`dragenter`:
                case`dragexit`:
                case`dragleave`:
                case`dragover`:
                case`mousemove`:
                case`mouseout`:
                case`mouseover`:
                case`pointermove`:
                case`pointerout`:
                case`pointerover`:
                case`scroll`:
                case`touchmove`:
                case`wheel`:
                case`mouseenter`:
                case`mouseleave`:
                case`pointerenter`:
                case`pointerleave`:
                    return 8;
                case`message`:
                    switch (Pe()) {
                        case Fe:
                            return 2;
                        case Ie:
                            return 8;
                        case Le:
                        case Re:
                            return 32;
                        case ze:
                            return 268435456;
                        default:
                            return 32
                    }
                default:
                    return 32
            }
        }

        var hp = !1, gp = null, _p = null, vp = null, yp = new Map, bp = new Map, xp = [],
            Sp = `mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset`.split(` `);

        function Cp(e, t) {
            switch (e) {
                case`focusin`:
                case`focusout`:
                    gp = null;
                    break;
                case`dragenter`:
                case`dragleave`:
                    _p = null;
                    break;
                case`mouseover`:
                case`mouseout`:
                    vp = null;
                    break;
                case`pointerover`:
                case`pointerout`:
                    yp.delete(t.pointerId);
                    break;
                case`gotpointercapture`:
                case`lostpointercapture`:
                    bp.delete(t.pointerId)
            }
        }

        function wp(e, t, n, r, i, a) {
            return e === null || e.nativeEvent !== a ? (e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: a,
                targetContainers: [i]
            }, t !== null && (t = wt(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e)
        }

        function Tp(e, t, n, r, i) {
            switch (t) {
                case`focusin`:
                    return gp = wp(gp, e, t, n, r, i), !0;
                case`dragenter`:
                    return _p = wp(_p, e, t, n, r, i), !0;
                case`mouseover`:
                    return vp = wp(vp, e, t, n, r, i), !0;
                case`pointerover`:
                    var a = i.pointerId;
                    return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
                case`gotpointercapture`:
                    return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0
            }
            return !1
        }

        function Ep(e) {
            var t = Ct(e.target);
            if (t !== null) {
                var n = o(t);
                if (n !== null) {
                    if (t = n.tag, t === 13) {
                        if (t = s(n), t !== null) {
                            e.blockedOn = t, ft(e.priority, function () {
                                op(n)
                            });
                            return
                        }
                    } else if (t === 31) {
                        if (t = c(n), t !== null) {
                            e.blockedOn = t, ft(e.priority, function () {
                                op(n)
                            });
                            return
                        }
                    } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
                        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
                        return
                    }
                }
            }
            e.blockedOn = null
        }

        function Dp(e) {
            if (e.blockedOn !== null) return !1;
            for (var t = e.targetContainers; 0 < t.length;) {
                var n = dp(e.nativeEvent);
                if (n === null) {
                    n = e.nativeEvent;
                    var r = new n.constructor(n.type, n);
                    ln = r, n.target.dispatchEvent(r), ln = null
                } else return t = wt(n), t !== null && ap(t), e.blockedOn = n, !1;
                t.shift()
            }
            return !0
        }

        function Op(e, t, n) {
            Dp(e) && n.delete(t)
        }

        function kp() {
            hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op)
        }

        function Ap(e, n) {
            e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)))
        }

        var jp = null;

        function Mp(e) {
            jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function () {
                jp === e && (jp = null);
                for (var t = 0; t < e.length; t += 3) {
                    var n = e[t], r = e[t + 1], i = e[t + 2];
                    if (typeof r != `function`) {
                        if (pp(r || n) === null) continue;
                        break
                    }
                    var a = wt(n);
                    a !== null && (e.splice(t, 3), t -= 3, Ts(a, {pending: !0, data: i, method: n.method, action: r}, r, i))
                }
            }))
        }

        function Np(e) {
            function t(t) {
                return Ap(t, e)
            }

            gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
            for (var n = 0; n < xp.length; n++) {
                var r = xp[n];
                r.blockedOn === e && (r.blockedOn = null)
            }
            for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
            if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
                var i = n[r], a = n[r + 1], o = i[ht] || null;
                if (typeof a == `function`) o || Mp(n); else if (o) {
                    var s = null;
                    if (a && a.hasAttribute(`formAction`)) {
                        if (i = a, o = a[ht] || null) s = o.formAction; else if (pp(i) !== null) continue
                    } else s = o.action;
                    typeof s == `function` ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n)
                }
            }
        }

        function Pp() {
            function e(e) {
                e.canIntercept && e.info === `react-transition` && e.intercept({
                    handler: function () {
                        return new Promise(function (e) {
                            return i = e
                        })
                    }, focusReset: `manual`, scroll: `manual`
                })
            }

            function t() {
                i !== null && (i(), i = null), r || setTimeout(n, 20)
            }

            function n() {
                if (!r && !navigation.transition) {
                    var e = navigation.currentEntry;
                    e && e.url != null && navigation.navigate(e.url, {
                        state: e.getState(),
                        info: `react-transition`,
                        history: `replace`
                    })
                }
            }

            if (typeof navigation == `object`) {
                var r = !1, i = null;
                return navigation.addEventListener(`navigate`, e), navigation.addEventListener(`navigatesuccess`, t), navigation.addEventListener(`navigateerror`, t), setTimeout(n, 100), function () {
                    r = !0, navigation.removeEventListener(`navigate`, e), navigation.removeEventListener(`navigatesuccess`, t), navigation.removeEventListener(`navigateerror`, t), i !== null && (i(), i = null)
                }
            }
        }

        function Fp(e) {
            this._internalRoot = e
        }

        Ip.prototype.render = Fp.prototype.render = function (e) {
            var t = this._internalRoot;
            if (t === null) throw Error(i(409));
            var n = t.current;
            np(n, pu(), e, t, null, null)
        }, Ip.prototype.unmount = Fp.prototype.unmount = function () {
            var e = this._internalRoot;
            if (e !== null) {
                this._internalRoot = null;
                var t = e.containerInfo;
                np(e.current, 2, null, e, null, null), bu(), t[gt] = null
            }
        };

        function Ip(e) {
            this._internalRoot = e
        }

        Ip.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
                var t = dt();
                e = {blockedOn: null, target: e, priority: t};
                for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++) ;
                xp.splice(n, 0, e), n === 0 && Ep(e)
            }
        };
        var Lp = n.version;
        if (Lp !== `19.2.6`) throw Error(i(527, Lp, `19.2.6`));
        D.findDOMNode = function (e) {
            var t = e._reactInternals;
            if (t === void 0) throw typeof e.render == `function` ? Error(i(188)) : (e = Object.keys(e).join(`,`), Error(i(268, e)));
            return e = d(t), e = e === null ? null : f(e), e = e === null ? null : e.stateNode, e
        };
        var Rp = {
            bundleType: 0,
            version: `19.2.6`,
            rendererPackageName: `react-dom`,
            currentDispatcherRef: E,
            reconcilerVersion: `19.2.6`
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u`) {
            var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (!zp.isDisabled && zp.supportsFiber) try {
                He = zp.inject(Rp), Ue = zp
            } catch {
            }
        }
        e.createRoot = function (e, t) {
            if (!a(e)) throw Error(i(299));
            var n = !1, r = ``, o = Js, s = Ys, c = Xs;
            return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, o, s, c, Pp), e[gt] = t.current, Sd(e), new Fp(t)
        }
    })), qn = o(((e, t) => {
        function n() {
            if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
                __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n)
            } catch (e) {
                console.error(e)
            }
        }

        n(), t.exports = Kn()
    }))(), Jn = `` + new URL(`heart_logo.png`, import.meta.url).href,
    Yn = `` + new URL(`card_left.png`, import.meta.url).href, Xn = `` + new URL(`card_right.png`, import.meta.url).href,
    Zn = `` + new URL(`bottles_magnesium.png`, import.meta.url).href,
    Qn = `` + new URL(`bottles_magnesium_mobile.png`, import.meta.url).href,
    $n = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAATBAMAAAB8awA1AAAAIVBMVEX/AAD/AAD/AAD/AAD/////5+f/tbX/4OD/nJz/+fn/q6t5XVPYAAAAA3RSTlNA3xifIAiYAAAAQElEQVQY02MQNkYAQwZjZICNZ7GqGYln6hJMFM8iLcVlWlozlGfuAgLFWHmmCB7CFOJ4MyE8fH5A860CAwIwAQCYczQsbX5T2gAAAABJRU5ErkJggg==`,
    er = `data:image/png;base64,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`,
    tr = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAMFBMVEUAAAC8mE+7l1C7mE+7mE+7mE+6n1C7l1C7l0+8mE+7l1C7l1C7l1C7mU+8mE+7mE/lezx8AAAAD3RSTlMAnyC/kN8QMIDvQHBgz69h4hiYAAABY0lEQVQoz2IAgxzZ+T8vHmOAA5X5/0FACMZP+f95ewLbavv/bhA+U/xHreaITpMi+a8KYIHSr1X2/3/0//+8KD4cokDI////LyCsB1aS+o/xPxQIyIcBBfyDxGEChapfgDr+q/yHA/f/CgyMH9dDeZ/v//8l78CQ/8kewp+RIP//s/40hvPmEL5V9iMgufgPg/wWEPdn05L5p4F090eG+4tBAmGb//9XBdLmfxnmZ4IEZD7KfzwPkvjJ8J+jBchQFi/8DjTco+E/YBCBz/XihUb/IQLzU4GMP/If5Q+CtE77yXC/GEgH/f9vnQq2/C+D/A4gveenlwY41Lw/Mpy3AtJ62xZDnFf8hyET6PSPbJ1Q7+h/Y2ABeu4v1DtAzwkAvV+C8L7TfwXMAGJI/YgIwvdh4EB+BAtkxa8KkGjQgkTD8vhwWESpO89otVgEjCh4VO5KYKsGRSUUKIKN/OkEYmMkBwBTMTUvFtRkOQAAAABJRU5ErkJggg==`,
    nr = `` + new URL(`process_flow.png`, import.meta.url).href,
    rr = `` + new URL(`process_flow_mobile.png`, import.meta.url).href,
    ir = `` + new URL(`bottle_day.png`, import.meta.url).href,
    ar = `` + new URL(`bottle_night.png`, import.meta.url).href,
    or = `` + new URL(`magnesium_graph.png`, import.meta.url).href,
    sr = `` + new URL(`magnesium_graph_mobile.png`, import.meta.url).href,
    cr = `` + new URL(`ultimate_magnesium_complex_box.png`, import.meta.url).href,
    lr = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAMAAADDR10IAAAAOVBMVEUAAAC8mE+8l1C7mE+7l1C8mFC7l1C8mE+7mFC/n1C7mE+9l1C6l1C6llC7mVCvn1C8mFC7mU67mE+SA7qhAAAAEnRSTlMA3yC/QJ+A73AQkGBgMFAQr3+tN6HxAAAAmUlEQVQoz33TWw4DIQgF0EHxrdP27n+xfYzRmhHu7wkICR73nHwosc7IaAIp6qFogqYWsCIWAFFCAyAkSYNWSlBetfgkaViUtvAC4hu3N9bQa0g/zEpXVKUQbWf1MtofAsR5DOGKEUwo5G6bO0m5Ux+V06D2CsNif8PmwlyiI8zUpdUSan9L00LBP9a/8xxkJ81w9NnHc1ngDRLIDc986d7LAAAAAElFTkSuQmCC`,
    ur = `` + new URL(`ultimate_magnesium_complex.png`, import.meta.url).href,
    dr = `` + new URL(`ultimate_magnesium_complex_mobile.png`, import.meta.url).href,
    fr = `` + new URL(`seaweed_left.png`, import.meta.url).href,
    pr = `` + new URL(`seaweed_left_mobile.png`, import.meta.url).href,
    mr = `` + new URL(`seaweed_right.png`, import.meta.url).href,
    hr = `` + new URL(`seaweed_right_mobile.png`, import.meta.url).href, gr = new Set([`style`]),
    _r = {srcset: `srcSet`, fetchpriority: `use` in h ? `fetchPriority` : `fetchpriority`},
    vr = e => e.startsWith(`data-`) || e.startsWith(`aria-`) ? e : _r[e] || e.replace(/-./g, e => e[1].toUpperCase());

function yr(e) {
    return Object.fromEntries(Object.entries(e).map(([e, t]) => [vr(e), gr.has(e) && t && typeof t != `string` ? yr(t) : t]))
}

var br = (e, t) => {
        if (!(!e || !t)) switch (t) {
            case`constrained`:
                return `(min-width: ${e}px) ${e}px, 100vw`;
            case`fixed`:
                return `${e}px`;
            case`fullWidth`:
                return `100vw`;
            default:
                return
        }
    }, xr = e => e || e === 0 ? `${e}px` : void 0,
    Sr = ({width: e, height: t, aspectRatio: n, layout: r, objectFit: i = `cover`, background: a}) => {
        let o = [[`object-fit`, i]];
        return a?.startsWith(`https:`) || a?.startsWith(`http:`) || a?.startsWith(`data:`) || a?.startsWith(`/`) ? (o.push([`background-image`, `url(${a})`]), o.push([`background-size`, `cover`]), o.push([`background-repeat`, `no-repeat`])) : o.push([`background`, a]), r === `fixed` && (o.push([`width`, xr(e)]), o.push([`height`, xr(t)])), r === `constrained` && (o.push([`max-width`, xr(e)]), o.push([`max-height`, xr(t)]), o.push([`aspect-ratio`, n ? `${n}` : void 0]), o.push([`width`, `100%`])), r === `fullWidth` && (o.push([`width`, `100%`]), o.push([`aspect-ratio`, n ? `${n}` : void 0]), o.push([`height`, xr(t)])), Object.fromEntries(o.filter(([, e]) => e))
    }, Cr = [6016, 5120, 4480, 3840, 3200, 2560, 2048, 1920, 1668, 1280, 1080, 960, 828, 750, 640], wr = 24,
    Tr = ({width: e, layout: t, resolutions: n = Cr}) => {
        if (t === `fullWidth`) return n;
        if (!e) return [];
        let r = e * 2;
        return t === `fixed` ? [e, r] : t === `constrained` ? [e, r, ...n.filter(e => e < r)] : []
    }, Er = ({
                 src: e,
                 width: t,
                 layout: n = `constrained`,
                 height: r,
                 aspectRatio: i,
                 breakpoints: a,
                 format: o
             }) => (a ||= Tr({width: t, layout: n}), a.sort((e, t) => e - t).map(t => {
        let n;
        return r && i && (n = Math.round(t / i)), {url: e, width: t, height: n, format: o}
    })), Dr = e => {
        let {src: t, transformer: n, operations: r} = e;
        return n ? Er(e).map(({url: i, ...a}) => `${n(t, {...r, ...a}, e.options)?.toString()} ${a.width}w`).join(`,
`) : ``
    };

function Or({width: e, height: t, priority: n, layout: r = `constrained`, aspectRatio: i, ...a}) {
    return e = e && Number(e) || void 0, t = t && Number(t) || void 0, n ? (a.loading ||= `eager`, a.fetchpriority ||= `high`) : (a.loading ||= `lazy`, a.decoding ||= `async`), a.alt === `` && (a.role ||= `presentation`), i ? e ? t ||= Math.round(e / i) : t && (e = Math.round(t * i)) : e && t && (i = e / t), {
        width: e,
        height: t,
        aspectRatio: i,
        layout: r, ...a
    }
}

function kr(e) {
    let {
        src: t,
        transformer: n,
        background: r,
        layout: i,
        objectFit: a,
        breakpoints: o,
        width: s,
        height: c,
        aspectRatio: l,
        unstyled: u,
        operations: d,
        options: f,
        ...p
    } = Or(e);
    if (n && r === `auto`) {
        let e = l ? Math.round(wr / l) : void 0, i = n(t, {width: wr, height: e}, f);
        i && (r = i.toString())
    }
    let m = {width: s, height: c, aspectRatio: l, layout: i, objectFit: a, background: r};
    if (p.sizes ||= br(s, i), u || (p.style = {...Sr(m), ...p.style}), n) {
        p.srcset = Dr({
            src: t,
            width: s,
            height: c,
            aspectRatio: l,
            layout: i,
            breakpoints: o,
            transformer: n,
            operations: d,
            options: f
        });
        let e = n(t, {...d, width: s, height: c}, f);
        e && (t = e), (i === `fullWidth` || i === `constrained`) && (s = void 0, c = void 0)
    }
    return {...p, src: t?.toString(), width: s, height: c}
}

function Ar(e) {
    return e ? e.startsWith(`image/`) ? {format: e.slice(6), mimeType: e} : {
        format: e,
        mimeType: `image/${e === `jpg` ? `jpeg` : e}`
    } : {}
}

function jr({media: e, type: t, ...n}) {
    let {
        src: r,
        transformer: i,
        layout: a,
        breakpoints: o,
        width: s,
        height: c,
        aspectRatio: l,
        sizes: u,
        loading: d,
        decoding: f,
        operations: p,
        options: m,
        ...h
    } = Or(n);
    if (!i) return {};
    let {format: g, mimeType: _} = Ar(t);
    u ||= br(s, a);
    let v = Dr({
        src: r,
        width: s,
        height: c,
        aspectRatio: l,
        layout: a,
        breakpoints: o,
        transformer: i,
        format: g,
        operations: p,
        options: m
    }), y = i(r, {...p, width: s, height: c}, m);
    y && (r = y);
    let b = {...h, sizes: u, srcset: v};
    return e && (b.media = e), _ && (b.type = _), b
}

var Mr = {
    "images.ctfassets.net": `contentful`,
    "cdn.builder.io": `builder.io`,
    "images.prismic.io": `imgix`,
    "www.datocms-assets.com": `imgix`,
    "cdn.sanity.io": `imgix`,
    "images.unsplash.com": `imgix`,
    "cdn.shopify.com": `shopify`,
    "s7d1.scene7.com": `scene7`,
    "ip.keycdn.com": `keycdn`,
    "assets.caisy.io": `bunny`,
    "images.contentstack.io": `contentstack`,
    "ucarecdn.com": `uploadcare`,
    "imagedelivery.net": `cloudflare_images`,
    "wsrv.nl": `wsrv`
}, Nr = {
    "imgix.net": `imgix`,
    "wp.com": `wordpress`,
    "files.wordpress.com": `wordpress`,
    "b-cdn.net": `bunny`,
    "storyblok.com": `storyblok`,
    "kc-usercontent.com": `kontent.ai`,
    "cloudinary.com": `cloudinary`,
    "kxcdn.com": `keycdn`,
    "imgeng.in": `imageengine`,
    "imagekit.io": `imagekit`,
    "cloudimg.io": `cloudimage`,
    "ucarecdn.com": `uploadcare`,
    "supabase.co": `supabase`,
    "graphassets.com": `hygraph`
}, Pr = {
    "/cdn-cgi/image/": `cloudflare`,
    "/cdn-cgi/imagedelivery/": `cloudflare_images`,
    "/_next/image": `nextjs`,
    "/_vercel/image": `vercel`,
    "/is/image": `scene7`,
    "/_ipx/": `ipx`,
    "/_image": `astro`,
    "/.netlify/images": `netlify`,
    "/storage/v1/object/public/": `supabase`,
    "/storage/v1/render/image/public/": `supabase`,
    "/v1/storage/buckets/": `appwrite`
};

function Fr(e) {
    if (!e) return e;
    let t = Number(e);
    return isNaN(t) ? e : Math.round(t)
}

var Ir = e => {
        let {pathname: t, search: n} = e;
        return `${t}${n}`
    }, k = e => e.hostname === `n` ? Ir(e) : e.toString(),
    A = (e, t) => typeof e == `string` ? new URL(e, t ?? `http://n/`) : e,
    Lr = e => e === ` ` ? `+` : `%` + e.charCodeAt(0).toString(16).toUpperCase().padStart(2, `0`),
    Rr = e => e?.startsWith(`/`) ? e.slice(1) : e, zr = e => e?.endsWith(`/`) ? e.slice(0, -1) : e,
    Br = e => e?.endsWith(`/`) ? e : `${e}/`, Vr = (e, t) => {
        let n = Lr(e), r = Lr(t);

        function i(i) {
            return encodeURIComponent(i).replaceAll(e, n).replaceAll(t, r)
        }

        function a(t, n) {
            return `${i(t)}${e}${i(String(n))}`
        }

        return e => (Array.isArray(e) ? e : Object.entries(e)).flatMap(([e, t]) => t == null ? [] : Array.isArray(t) ? t.map(t => a(e, t)) : a(e, t)).join(t)
    }, Hr = (e, t) => e === `=` && t === `&` ? Jr : n => {
        let r = n.toString();
        return Object.fromEntries(r.split(t).map(t => {
            let [n, r] = t.split(e);
            return [decodeURI(n), decodeURI(r)]
        }))
    };

function Ur(e, t = 4e3, n = 4e3) {
    let {width: r, height: i} = e;
    return r = Number(r) || void 0, i = Number(i) || void 0, r && r > t && (i &&= Math.round(i * t / r), r = t), i && i > n && (r &&= Math.round(r * n / i), i = n), {
        width: r,
        height: i
    }
}

function Wr(e) {
    let t = A(e), n = Object.fromEntries(t.searchParams.entries());
    for (let e in [`width`, `height`, `quality`]) {
        let t = n[e];
        if (t) {
            let r = Number(t);
            isNaN(r) || (n[e] = r)
        }
    }
    return t.search = ``, {operations: n, src: k(t)}
}

function Gr({keyMap: e = {}, formatMap: t = {}, defaults: n = {}}, r) {
    r.format && r.format in t && (r.format = t[r.format]), r.width &&= Fr(r.width), r.height &&= Fr(r.height);
    for (let t in e) {
        if (!Object.prototype.hasOwnProperty.call(e, t)) continue;
        let n = t;
        if (e[n] === !1) {
            delete r[n];
            continue
        }
        e[n] && r[n] && (r[e[n]] = r[n], delete r[n])
    }
    for (let t in n) {
        if (!Object.prototype.hasOwnProperty.call(n, t)) continue;
        let i = t, a = n[i];
        if (!r[i] && a !== void 0) {
            if (e[i] === !1) continue;
            let t = e[i] ?? i;
            if (t in r) continue;
            r[t] = a
        }
    }
    return r
}

var Kr = e => Object.fromEntries(Object.entries(e).map(([e, t]) => [t, e]));

function qr({keyMap: e = {}, formatMap: t = {}, defaults: n = {}}, r) {
    let i = Gr({keyMap: Kr(e), formatMap: Kr(t), defaults: n}, r);
    i.width &&= Fr(i.width), i.height &&= Fr(i.height);
    let a = Number(i.quality);
    return isNaN(a) || (i.quality = a), i
}

var Jr = e => {
    let t = A(e);
    return Object.fromEntries(t.searchParams.entries())
};

function Yr({kvSeparator: e = `=`, paramSeparator: t = `&`, ...n} = {}) {
    let r = Vr(e, t);
    return e => r(Gr(n, e))
}

function Xr({kvSeparator: e = `=`, paramSeparator: t = `&`, defaults: n, ...r} = {}) {
    let i = Hr(e, t);
    return e => qr(r, e ? i(e) : {})
}

function j(e) {
    return {operationsGenerator: Yr(e), operationsParser: Xr(e)}
}

function Zr(e) {
    if (e != null) try {
        return !!JSON.parse(e?.toString())
    } catch {
        return !!e
    }
}

var Qr = e => Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0));

function M(e, t) {
    return ((n, r, i) => {
        let a = e(n, i);
        return a ? t(a.src, {...a.operations, ...Qr(r)}, {...a.options, ...i}) : t(n, r, i)
    })
}

var $r = new Map(Object.entries(Mr)), ei = Object.entries(Nr), ti = Object.entries(Pr);

function ni(e) {
    return ri(e) || ii(e)
}

function ri(e) {
    if (typeof e == `string` && !e.startsWith(`https://`)) return !1;
    let {hostname: t} = A(e);
    return $r.get(t) || ei.find(([e]) => t.endsWith(e))?.[1] || !1
}

function ii(e) {
    let {pathname: t} = A(e);
    return ti.find(([e]) => t.startsWith(e))?.[1] || !1
}

var ai = `/view?`, oi = `/preview?`, {operationsGenerator: si, operationsParser: ci} = j({
        keyMap: {format: `output`},
        kvSeparator: `=`,
        paramSeparator: `&`
    }), li = M(e => {
        if (ii(e) !== `appwrite`) return null;
        let t = A(e), n = ci(t);
        delete n.project;
        let r = t.searchParams.get(`project`) ?? ``;
        return t.search = ``, t.searchParams.append(`project`, r), {src: t.href, operations: n}
    }, (e, t) => {
        let n = A(e.toString().replace(ai, oi)), r = n.searchParams.get(`project`) ?? ``;
        return n.search = si(t), n.searchParams.append(`project`, r), k(n)
    }), ui = `/_image`, {operationsParser: di, operationsGenerator: fi} = j({
        keyMap: {
            format: `f`,
            width: `w`,
            height: `h`,
            quality: `q`
        }, defaults: {fit: `cover`}
    }), pi = (e, t, n) => {
        let r = A(`${zr(n?.baseUrl ?? ``)}${n?.endpoint ?? ui}`);
        return r.search = fi(t), r.searchParams.set(`href`, e.toString()), k(r)
    }, mi = e => {
        let t = A(e), n = t.searchParams.get(`href`);
        return n ? (t.searchParams.delete(`href`), {src: n, operations: di(t), options: {baseUrl: t.origin}}) : null
    }, hi = (e, t, n = {}) => {
        if (A(e).pathname !== (n?.endpoint ?? ui)) return pi(e, t, n);
        let r = mi(e);
        return r ? (n.baseUrl ??= r.options.baseUrl, pi(r.src, {...r.operations, ...t}, n)) : pi(e, t, n)
    }, gi = Yr({defaults: {fit: `cover`, format: `webp`, sharp: !0}}), _i = M(Wr, (e, t) => {
        let n = gi(t), r = A(e);
        return r.search = n, k(r)
    }), vi = Yr({keyMap: {format: `output`}}), yi = M(Wr, (e, t) => {
        let n = vi(t), r = A(e);
        return r.search = n, k(r)
    }), bi = (e, t) => {
        let {width: n, height: r} = t;
        return n && r && (t.aspect_ratio ??= `${Math.round(Number(n))}:${Math.round(Number(r))}`), yi(e, t)
    }, {operationsGenerator: xi, operationsParser: Si} = j({
        keyMap: {format: `f`},
        defaults: {format: `auto`, fit: `cover`},
        formatMap: {jpg: `jpeg`},
        kvSeparator: `=`,
        paramSeparator: `,`
    }), Ci = M((e, t) => {
        if (ii(e) !== `cloudflare`) return null;
        let n = A(e), [, , , r, ...i] = n.pathname.split(`/`), a = Si(r);
        return {
            src: k(A(i.join(`/`))),
            operations: a,
            options: {domain: t?.domain ?? (n.hostname === `n` ? void 0 : n.hostname)}
        }
    }, (e, t, n) => {
        let r = xi(t), i = A(n?.domain ? `https://${n.domain}` : `/`);
        return i.pathname = `/cdn-cgi/image/${r}/${Rr(e.toString())}`, k(i)
    }),
    wi = /https?:\/\/(?<host>[^\/]+)\/cdn-cgi\/imagedelivery\/(?<accountHash>[^\/]+)\/(?<imageId>[^\/]+)\/*(?<transformations>[^\/]+)*$/g,
    Ti = /https?:\/\/(?<host>imagedelivery.net)\/(?<accountHash>[^\/]+)\/(?<imageId>[^\/]+)\/*(?<transformations>[^\/]+)*$/g, {
        operationsGenerator: Ei,
        operationsParser: Di
    } = j({
        keyMap: {width: `w`, height: `h`, format: `f`},
        defaults: {fit: `cover`},
        kvSeparator: `=`,
        paramSeparator: `,`
    });

function Oi(e, t) {
    let {host: n, accountHash: r, imageId: i} = e;
    if (!n || !r || !i) throw Error(`Missing required Cloudflare Images options`);
    return [`https:/`, ...n === `imagedelivery.net` ? [n] : [n, `cdn-cgi`, `imagedelivery`], r, i, t].filter(Boolean).join(`/`)
}

var ki = (e, t, n = {}) => k(A(Oi(n, Ei(t)))), Ai = e => {
        let t = A(e), n = [...t.toString().matchAll(wi), ...t.toString().matchAll(Ti)];
        if (!n[0]?.groups) return null;
        let {host: r, accountHash: i, imageId: a, transformations: o} = n[0].groups, s = Di(o || ``),
            c = {host: r, accountHash: i, imageId: a};
        return {src: Oi(c), operations: s, options: c}
    }, ji = (e, t, n = {}) => {
        let r = Ai(e);
        if (!r) throw Error(`Invalid Cloudflare Images URL`);
        let i = {...r.operations, ...t};
        return ki(r.src, i, {...r.options, ...n})
    }, {operationsGenerator: Mi, operationsParser: Ni} = j({
        keyMap: {
            format: `force_format`,
            width: `w`,
            height: `h`,
            quality: `q`
        }, defaults: {org_if_sml: 1}
    }), Pi = M((e, t = {}) => {
        let n = A(e);
        if (ni(n) !== `cloudimage`) return null;
        let r = Ni(n), i = n.pathname;
        return r.ci_url_encoded && (i = decodeURIComponent(i), delete r.ci_url_encoded), t.token ??= n.hostname.replace(`.cloudimg.io`, ``), {
            src: `${n.protocol}/${i}`,
            operations: r,
            options: t
        }
    }, (e, t = {}, {token: n} = {}) => {
        if (!n) throw Error(`Token is required for Cloudimage URLs` + e);
        let r = e.toString();
        r = r.replace(/^https?:\/\//, ``), r.includes(`?`) && (t.ci_url_encoded = 1, r = encodeURIComponent(r));
        let i = Mi(t), a = new URL(`https://${n}.cloudimg.io/`);
        return a.pathname = r, a.search = i, a.toString()
    }),
    Fi = /https?:\/\/(?<host>res\.cloudinary\.com)\/(?<cloudName>[a-zA-Z0-9-]+)\/(?<assetType>image|video|raw)\/(?<deliveryType>upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/?(?<signature>s\-\-[a-zA-Z0-9]+\-\-)?\/?(?<transformations>(?:[^_\/]+_[^,\/]+,?)*)?\/(?:(?<version>v\d+)\/)?(?<id>(?:[^\s\/]+\/)*[^\s\/]+(?:\.[a-zA-Z0-9]+)?)$/,
    Ii = /https?:\/\/(?<host>(?<cloudName>[a-zA-Z0-9-]+)-res\.cloudinary\.com|[a-zA-Z0-9.-]+)\/(?<assetType>image|video|raw)\/(?<deliveryType>upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/?(?<signature>s\-\-[a-zA-Z0-9]+\-\-)?\/?(?<transformations>(?:[^_\/]+_[^,\/]+,?)*)?\/(?:(?<version>v\d+)\/)?(?<id>(?:[^\s\/]+\/)*[^\s\/]+(?:\.[a-zA-Z0-9]+)?)$/, {
        operationsGenerator: Li,
        operationsParser: Ri
    } = j({
        keyMap: {width: `w`, height: `h`, format: `f`, quality: `q`},
        defaults: {format: `auto`, c: `lfill`},
        kvSeparator: `_`,
        paramSeparator: `,`
    });

function zi({
                host: e,
                cloudName: t,
                assetType: n,
                deliveryType: r,
                signature: i,
                transformations: a,
                version: o,
                id: s
            }) {
    return [`https:/`, e, e === `res.cloudinary.com` ? t : void 0, n, r, i, a, o, s].filter(Boolean).join(`/`)
}

function N(e) {
    let t = e.toString().match(Fi);
    return t?.length || (t = e.toString().match(Ii)), t?.length ? t.groups || {} : null
}

var P = (e, t) => {
        let n = N(e.toString());
        return n ? (n.transformations = Li({...Ri(n.transformations || ``), ...t}), zi(n)) : e.toString()
    }, Bi = Yr({keyMap: {format: `fm`, width: `w`, height: `h`, quality: `q`}, defaults: {fit: `fill`}}),
    Vi = M(Wr, (e, t) => {
        let n = Bi(t), r = new URL(e);
        return r.search = n, k(r)
    }), Hi = (e, t) => {
        let {width: n, height: r} = Ur(t, 4e3, 4e3);
        return Vi(e, {...t, width: n, height: r})
    }, Ui = Yr({defaults: {auto: `webp`, disable: `upscale`}}), Wi = M(e => {
        let {src: t, operations: n} = Wr(e) ?? {};
        if (!n || !t) return null;
        let {origin: r} = A(e);
        return {src: t, operations: n, options: {baseURL: r}}
    }, (e, t, {baseURL: n = `https://images.contentstack.io/`} = {}) => {
        t.width && t.height && (t.fit ??= `crop`);
        let r = Ui(t), i = A(e);
        return i.hostname === `n` && (i.protocol = `https:`, i.hostname = new URL(n).hostname), i.search = r, k(i)
    }), Gi = Yr({defaults: {withoutEnlargement: !0, fit: `cover`}}), Ki = M(e => {
        let t = Wr(e);
        if (t?.operations?.transforms && typeof t.operations.transforms == `string`) try {
            t.operations.transforms = JSON.parse(t.operations.transforms)
        } catch {
            return null
        }
        return t
    }, (e, t) => {
        Array.isArray(t.transforms) && (t.transforms = JSON.stringify(t.transforms));
        let n = Gi(t), r = A(e);
        return r.search = n, k(r)
    }),
    qi = /https:\/\/(?<region>[a-z0-9-]+)\.graphassets\.com\/(?<envId>[a-zA-Z0-9]+)(?:\/(?<transformations>.*?))?\/(?<handle>[a-zA-Z0-9]+)$/, {
        operationsGenerator: Ji,
        operationsParser: Yi
    } = j({keyMap: {width: `width`, height: `height`, format: `format`}, defaults: {format: `auto`, fit: `crop`}}),
    Xi = e => {
        let t = A(e).toString().match(qi);
        if (!t?.groups) return null;
        let {region: n, envId: r, handle: i, transformations: a} = t.groups, o = {};
        return a && a.split(`/`).forEach(e => {
            let [t, n] = e.split(`=`);
            t === `resize` && n ? n.split(`,`).forEach(e => {
                let [t, n] = e.split(`:`);
                t === `width` || t === `height` ? o[t] = Number(n) : t === `fit` && (o.fit = n)
            }) : t === `output` && n ? n.split(`,`).forEach(e => {
                let [t, n] = e.split(`:`);
                t === `format` && (o.format = n)
            }) : t === `auto_image` && (o.format = `auto`)
        }), {src: `https://${n}.graphassets.com/${r}/${i}`, operations: o, options: {region: n, envId: r, handle: i}}
    }, Zi = M(Xi, (e, t, n = {}) => {
        let r = Xi(e);
        if (!r) throw Error(`Invalid Hygraph URL`);
        let {region: i, envId: a, handle: o} = {...r.options, ...n}, s = [];
        if (t.width || t.height) {
            let e = [];
            t.width && t.height ? e.push(`fit:crop`) : t.fit && e.push(`fit:${t.fit}`), t.width && e.push(`width:${t.width}`), t.height && e.push(`height:${t.height}`), e.length && s.push(`resize=${e.join(`,`)}`)
        }
        return t.format === `auto` || !t.format && !r.operations.format ? s.push(`auto_image`) : t.format && s.push(`output=format:${t.format}`), k(A(`${`https://${i}.graphassets.com/${a}`}${s.length > 0 ? `/` + s.join(`/`) : ``}/${o}`))
    }), {operationsGenerator: Qi, operationsParser: $i} = j({
        keyMap: {width: `w`, height: `h`, format: `f`},
        defaults: {m: `cropbox`},
        kvSeparator: `_`,
        paramSeparator: `/`
    }), ea = M(e => {
        let t = A(e), n = t.searchParams.get(`imgeng`);
        if (!n) return null;
        let r = $i(n);
        return t.searchParams.delete(`imgeng`), {src: k(t), operations: r}
    }, (e, t) => {
        let n = Qi(t), r = A(e);
        return r.searchParams.set(`imgeng`, n), k(r)
    }), {operationsGenerator: ta, operationsParser: na} = j({
        keyMap: {width: `w`, height: `h`, format: `f`, quality: `q`},
        defaults: {c: `maintain_ratio`, fo: `auto`},
        kvSeparator: `-`,
        paramSeparator: `,`
    }), ra = M(e => {
        let t = A(e), n = null, r = t.pathname;
        if (t.searchParams.has(`tr`)) n = t.searchParams.get(`tr`), t.searchParams.delete(`tr`); else {
            let e = t.pathname.split(`/`), i = e.findIndex(e => e.startsWith(`tr:`));
            i !== -1 && (n = e[i].slice(3), r = e.slice(0, i).concat(e.slice(i + 1)).join(`/`))
        }
        if (!n) return null;
        t.pathname = r;
        let i = na(n);
        return {src: k(t), operations: i}
    }, (e, t) => {
        let n = ta(t), r = A(e);
        return r.searchParams.set(`tr`, n), k(r)
    }), {operationsGenerator: ia, operationsParser: aa} = j({
        keyMap: {format: `fm`, width: `w`, height: `h`, quality: `q`},
        defaults: {fit: `min`, auto: `format`}
    }), oa = M(e => {
        let t = A(e), n = aa(e);
        return t.search = ``, {src: k(t), operations: n}
    }, (e, t) => {
        let n = ia(t), r = A(e);
        return r.search = n, r.searchParams.has(`fm`) && r.searchParams.get(`auto`) === `format` && r.searchParams.delete(`auto`), k(r)
    }), {operationsGenerator: sa, operationsParser: ca} = j({
        keyMap: {width: `w`, height: `h`, quality: `q`, format: `f`},
        defaults: {f: `auto`},
        kvSeparator: `_`,
        paramSeparator: `,`
    }), la = (e, t, n) => {
        t.width && t.height && (t.s = `${t.width}x${t.height}`, delete t.width, delete t.height);
        let r = sa(t), i = A(n?.baseURL ?? `/_ipx`);
        return i.pathname = `${zr(i.pathname)}/${r}/${Rr(e.toString())}`, k(i)
    }, ua = e => {
        let t = A(e), [, n, r, ...i] = t.pathname.split(`/`);
        if (!r || !i.length) return null;
        let a = ca(r);
        if (a.s) {
            let [e, t] = a.s.split(`x`).map(Number);
            a.width = e, a.height = t, delete a.s
        }
        return {src: `/` + i.join(`/`), operations: a, options: {baseURL: `${t.origin}/${n}`}}
    }, da = (e, t, n) => {
        let r = A(e), i = n?.baseURL;
        if (i && r.toString().startsWith(i) || r.pathname.startsWith(`/_ipx`)) {
            let n = ua(e);
            if (n) return la(n.src, {...n.operations, ...t}, {baseURL: n.options.baseURL})
        }
        return la(e, t, {baseURL: i})
    },
    F = [`enlarge`, `flip`, `flop`, `negate`, `normalize`, `grayscale`, `removealpha`, `olrepeat`, `progressive`, `adaptive`, `lossless`, `nearlossless`, `metadata`], {
        operationsGenerator: fa,
        operationsParser: pa
    } = j({defaults: {fit: `cover`}, formatMap: {jpg: `jpeg`}}), ma = M(e => {
        let t = A(e), n = pa(t);
        for (let e of F) n[e] !== void 0 && (n[e] = Zr(n[e]));
        return t.search = ``, {src: k(t), operations: n}
    }, (e, t) => {
        let n = A(e);
        for (let e of F) t[e] !== void 0 && (t[e] = +!!t[e]);
        return n.search = fa(t), k(n)
    }), {operationsGenerator: ha, operationsParser: ga} = j({
        formatMap: {jpg: `jpeg`},
        keyMap: {format: `fm`, width: `w`, height: `h`, quality: `q`}
    }), _a = M(e => {
        let t = A(e), n = ga(t);
        return n.lossless !== void 0 && (n.lossless = Zr(n.lossless)), t.search = ``, {src: k(t), operations: n}
    }, (e, t) => {
        let n = A(e);
        return t.lossless !== void 0 && (t.lossless = +!!t.lossless), t.width && t.height && (t.fit = `crop`), n.search = ha(t), k(n)
    }), {operationsGenerator: va, operationsParser: ya} = j({
        defaults: {fit: `cover`},
        keyMap: {format: `fm`, width: `w`, height: `h`, quality: `q`}
    }), ba = M(e => {
        if (ii(e) !== `netlify`) return null;
        let t = A(e), n = ya(t);
        delete n.url;
        let r = t.searchParams.get(`url`) || ``;
        return t.search = ``, {src: r, operations: n, options: {baseUrl: t.hostname === `n` ? void 0 : t.origin}}
    }, (e, t, n = {}) => {
        let r = A(`${n.baseUrl || ``}/.netlify/images`);
        return r.search = va(t), r.searchParams.set(`url`, e.toString()), k(r)
    }), {operationsGenerator: xa, operationsParser: Sa} = j({
        keyMap: {width: `w`, quality: `q`, height: !1, format: !1},
        defaults: {q: 75}
    }), Ca = (e, t, n = {}) => {
        let r = A(`${n.baseUrl || ``}/${n.prefix || `_vercel`}/image`);
        return r.search = xa(t), r.searchParams.append(`url`, e.toString()), k(r)
    }, wa = (e, t = {}) => {
        if (![`vercel`, `nextjs`].includes(ii(e) || ``)) return null;
        let n = A(e), r = n.searchParams.get(`url`) || ``;
        n.searchParams.delete(`url`);
        let i = Sa(n);
        return n.search = ``, {src: r, operations: i, options: {baseUrl: t.baseUrl ?? n.origin}}
    }, Ta = M(wa, Ca), Ea = M((e, t) => wa(e, t), (e, t, n = {}) => Ca(e, t, {...n, prefix: `_next`})), {
        operationsGenerator: Da,
        operationsParser: Oa
    } = j({keyMap: {width: `wid`, height: `hei`, quality: `qlt`, format: `fmt`}, defaults: {fit: `crop,0`}}),
    ka = `https://s7d1.scene7.com/is/image/`, Aa = M(e => {
        if (ni(e) !== `scene7`) return null;
        let t = new URL(e, ka), n = Oa(t);
        return t.search = ``, {src: t.toString(), operations: n}
    }, (e, t) => {
        let n = new URL(e, ka);
        return n.search = Da(t), k(n)
    }),
    ja = /(.+?)(?:_(?:(pico|icon|thumb|small|compact|medium|large|grande|original|master)|(\d*)x(\d*)))?(?:_crop_([a-z]+))?(\.[a-zA-Z]+)(\.png|\.jpg|\.webp|\.avif)?$/, {
        operationsGenerator: Ma,
        operationsParser: Na
    } = j({keyMap: {format: !1}}), Pa = M(e => {
        let t = A(e), n = ja.exec(t.pathname), r = Na(t);
        if (n) {
            let [, , , e, t, i] = n;
            e && t && !r.width && !r.height && (r.width = parseInt(e, 10), r.height = parseInt(t, 10)), i && (r.crop ??= i)
        }
        t.pathname = t.pathname.replace(ja, `$1$6`);
        for (let e of [`width`, `height`, `crop`, `pad_color`, `format`]) t.searchParams.delete(e);
        return {src: t.toString(), operations: r}
    }, (e, t) => {
        let n = A(e);
        return n.pathname = n.pathname.replace(ja, `$1$6`), n.search = Ma(t), k(n)
    }),
    Fa = /(?<id>\/f\/\d+\/\d+x\d+\/\w+\/[^\/]+)\/?(?<modifiers>m\/?(?<crop>\d+x\d+:\d+x\d+)?\/?(?<resize>(?<flipx>\-)?(?<width>\d+)x(?<flipy>\-)?(?<height>\d+))?\/?(filters\:(?<filters>[^\/]+))?)?$/,
    Ia = /^(?<modifiers>\/(?<crop>\d+x\d+:\d+x\d+)?\/?(?<resize>(?<flipx>\-)?(?<width>\d+)x(?<flipy>\-)?(?<height>\d+))?\/?(filters\:(?<filters>[^\/]+))?\/?)?(?<id>\/f\/.+)$/,
    La = /:(?![^(]*\))/, Ra = e => e ? Object.fromEntries(e.split(La).map(e => {
        if (!e) return [];
        let [t, n] = e.split(`(`);
        return [t, n.replace(`)`, ``)]
    })) : {}, za = e => {
        if (!e) return;
        let t = Object.entries(e).map(([e, t]) => `${e}(${t ?? ``})`);
        if (t.length !== 0) return `filters:${t.join(`:`)}`
    }, Ba = M(e => {
        let t = A(e), n = (t.hostname === `img2.storyblok.com` ? Ia : Fa).exec(t.pathname);
        if (!n || !n.groups) return null;
        let {id: r, crop: i, width: a, height: o, filters: s, flipx: c, flipy: l} = n.groups, {
            format: u,
            ...d
        } = Ra(s ?? ``);
        t.hostname === `img2.storyblok.com` && (t.hostname = `a.storyblok.com`);
        let f = Object.fromEntries([[`width`, Number(a) || void 0], [`height`, Number(o) || void 0], [`format`, u], [`crop`, i], [`filters`, d], [`flipx`, c], [`flipy`, l]].filter(([e, t]) => t !== void 0));
        return {src: `${t.origin}${r}`, operations: f}
    }, (e, t) => {
        let n = A(e), {width: r = 0, height: i = 0, format: a, crop: o, filters: s = {}, flipx: c = ``, flipy: l = ``} = t,
            u = `${c}${r}x${l}${i}`;
        return a && (s.format = a), n.pathname = [n.pathname, `m`, o, u, za(s)].filter(Boolean).join(`/`), k(n)
    }), Va = `/storage/v1/object/public/`, Ha = `/storage/v1/render/image/public/`,
    Ua = e => e.pathname.startsWith(Ha), {operationsGenerator: Wa, operationsParser: Ga} = j({}), Ka = M(e => {
        let t = A(e), n = Ga(t), r = Ua(t), i = t.pathname.replace(Ha, ``).replace(Va, ``);
        return r ? {src: `${t.origin}${Va}${i}`, operations: n} : {src: k(t), operations: n}
    }, (e, t) => {
        let n = A(e);
        return n.pathname = n.pathname.replace(Ha, Va), t.format && t.format !== `origin` && delete t.format, n.search = Wa(t), k(n).replace(Va, Ha)
    }), qa = /^https?:\/\/(?<host>[^\/]+)\/(?<uuid>[^\/]+)(?:\/(?<filename>[^\/]+)?)?/, {
        operationsGenerator: Ja,
        operationsParser: Ya
    } = j({keyMap: {width: !1, height: !1}, defaults: {format: `auto`}, kvSeparator: `/`, paramSeparator: `/-/`}),
    Xa = M(e => {
        let t = A(e), n = qa.exec(t.toString());
        if (!n || !n.groups) return null;
        let {host: r, uuid: i} = n.groups, [, ...a] = t.pathname.split(`/-/`), o = Ya(a.join(`/-/`) || ``);
        if (o.resize) {
            let [e, t] = o.resize.split(`x`);
            e && (o.width = parseInt(e)), t && (o.height = parseInt(t)), delete o.resize
        }
        return {src: `https://${r}/${i}/`, operations: o, options: {host: r}}
    }, (e, t, n = {}) => {
        let r = A(e), i = n.host || r.hostname, a = qa.exec(r.toString());
        a?.groups && (r.pathname = `/${a.groups.uuid}/`), t.resize = t.resize || `${t.width ?? ``}x${t.height ?? ``}`, delete t.width, delete t.height;
        let o = Br(Ja(t));
        return r.hostname = i, r.pathname = zr(r.pathname) + (o ? `/-/${o}` : ``) + (a?.groups?.filename ?? ``), k(r)
    }), {operationsGenerator: Za, operationsParser: Qa} = j({keyMap: {width: `w`, height: `h`}, defaults: {crop: `1`}}),
    $a = M(e => {
        let t = A(e), n = Qa(t);
        return n.crop !== void 0 && (n.crop = n.crop === `1`), t.search = ``, {src: k(t), operations: n}
    }, (e, t) => {
        let n = A(e), {crop: r} = t;
        return r !== void 0 && r !== `0` && (t.crop = r ? `1` : `0`), n.search = Za(t), k(n)
    }), {operationsGenerator: eo, operationsParser: to} = j({
        keyMap: {
            width: `w`,
            height: `h`,
            format: `output`,
            quality: `q`
        }, defaults: {fit: `cover`}
    }), no = {
        appwrite: li,
        astro: hi,
        "builder.io": _i,
        bunny: bi,
        cloudflare: Ci,
        cloudflare_images: ji,
        cloudimage: Pi,
        cloudinary: P,
        contentful: Hi,
        contentstack: Wi,
        directus: Ki,
        hygraph: Zi,
        imageengine: ea,
        imagekit: ra,
        imgix: oa,
        ipx: da,
        keycdn: ma,
        "kontent.ai": _a,
        netlify: ba,
        nextjs: Ea,
        scene7: Aa,
        shopify: Pa,
        storyblok: Ba,
        supabase: Ka,
        uploadcare: Xa,
        vercel: Ta,
        wordpress: $a,
        wsrv: M(e => {
            let t = A(e), n = t.searchParams.get(`url`);
            if (!n) return null;
            let r = n;
            !r.startsWith(`http://`) && !r.startsWith(`https://`) && (r = `https://` + r), t.searchParams.delete(`url`);
            let i = to(t);
            return {src: r, operations: i}
        }, (e, t) => {
            let n = new URL(`https://wsrv.nl/`), r = (typeof e == `string` ? e : e.toString()).replace(/^https?:\/\//, ``);
            n.searchParams.set(`url`, r);
            let i = eo(t), a = new URLSearchParams(i);
            for (let [e, t] of a) e !== `url` && n.searchParams.set(e, t);
            return k(n)
        })
    };

function ro(e) {
    if (e) return no[e]
}

function io({cdn: e, fallback: t, operations: n = {}, options: r, ...i}) {
    if (e ??= ni(i.src) || t, !e) return i;
    let a = ro(e);
    return a ? kr({...i, operations: n?.[e], options: r?.[e], transformer: a}) : i
}

function ao({cdn: e, fallback: t, operations: n, options: r, ...i}) {
    if (e ??= ni(i.src) || t, !e) return i;
    let a = ro(e);
    return a ? jr({...i, operations: n?.[e], options: r?.[e], transformer: a}) : i
}

var oo = o((e => {
    var t = Symbol.for(`react.transitional.element`);

    function n(e, n, r) {
        var i = null;
        if (r !== void 0 && (i = `` + r), n.key !== void 0 && (i = `` + n.key), `key` in n) for (var a in r = {}, n) a !== `key` && (r[a] = n[a]); else r = n;
        return n = r.ref, {$$typeof: t, type: e, key: i, ref: n === void 0 ? null : n, props: r}
    }

    e.jsx = n, e.jsxs = n
})), I = o(((e, t) => {
    t.exports = oo()
}))(), L = h.forwardRef(function (e, t) {
    return (0, I.jsx)(`img`, {...yr(io(e)), ref: t})
});
h.forwardRef(function (e, t) {
    return (0, I.jsx)(`source`, {...yr(ao(e)), ref: t})
});
var so = c(o(((e, t) => {
    (function (n, r) {
        typeof e == `object` && typeof t == `object` ? t.exports = r() : typeof define == `function` && define.amd ? define([], r) : typeof e == `object` ? e.AOS = r() : n.AOS = r()
    })(e, function () {
        return function (e) {
            function t(r) {
                if (n[r]) return n[r].exports;
                var i = n[r] = {exports: {}, id: r, loaded: !1};
                return e[r].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports
            }

            var n = {};
            return t.m = e, t.c = n, t.p = `dist/`, t(0)
        }([function (e, t, n) {
            function r(e) {
                return e && e.__esModule ? e : {default: e}
            }

            var i = Object.assign || function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                    }
                    return e
                }, a = r((r(n(1)), n(6))), o = r(n(7)), s = r(n(8)), c = r(n(9)), l = r(n(10)), u = r(n(11)), d = r(n(14)),
                f = [], p = !1, m = {
                    offset: 120,
                    delay: 0,
                    easing: `ease`,
                    duration: 400,
                    disable: !1,
                    once: !1,
                    startEvent: `DOMContentLoaded`,
                    throttleDelay: 99,
                    debounceDelay: 50,
                    disableMutationObserver: !1
                }, h = function () {
                    if (arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (p = !0), p) return f = (0, u.default)(f, m), (0, l.default)(f, m.once), f
                }, g = function () {
                    f = (0, d.default)(), h()
                }, _ = function () {
                    f.forEach(function (e, t) {
                        e.node.removeAttribute(`data-aos`), e.node.removeAttribute(`data-aos-easing`), e.node.removeAttribute(`data-aos-duration`), e.node.removeAttribute(`data-aos-delay`)
                    })
                }, v = function (e) {
                    return e === !0 || e === `mobile` && c.default.mobile() || e === `phone` && c.default.phone() || e === `tablet` && c.default.tablet() || typeof e == `function` && e() === !0
                };
            e.exports = {
                init: function (e) {
                    m = i(m, e), f = (0, d.default)();
                    var t = document.all && !window.atob;
                    return v(m.disable) || t ? _() : (m.disableMutationObserver || s.default.isSupported() || (console.info(`
      aos: MutationObserver is not supported on this browser,
      code mutations observing has been disabled.
      You may have to call "refreshHard()" by yourself.
    `), m.disableMutationObserver = !0), document.querySelector(`body`).setAttribute(`data-aos-easing`, m.easing), document.querySelector(`body`).setAttribute(`data-aos-duration`, m.duration), document.querySelector(`body`).setAttribute(`data-aos-delay`, m.delay), m.startEvent === `DOMContentLoaded` && [`complete`, `interactive`].indexOf(document.readyState) > -1 ? h(!0) : m.startEvent === `load` ? window.addEventListener(m.startEvent, function () {
                        h(!0)
                    }) : document.addEventListener(m.startEvent, function () {
                        h(!0)
                    }), window.addEventListener(`resize`, (0, o.default)(h, m.debounceDelay, !0)), window.addEventListener(`orientationchange`, (0, o.default)(h, m.debounceDelay, !0)), window.addEventListener(`scroll`, (0, a.default)(function () {
                        (0, l.default)(f, m.once)
                    }, m.throttleDelay)), m.disableMutationObserver || s.default.ready(`[data-aos]`, g), f)
                }, refresh: h, refreshHard: g
            }
        }, function (e, t) {
        }, , , , , function (e, t) {
            (function (t) {
                function n(e, t, n) {
                    function r(t) {
                        var n = h, r = g;
                        return h = g = void 0, w = t, v = e.apply(r, n)
                    }

                    function a(e) {
                        return w = e, y = setTimeout(u, t), ee ? r(e) : v
                    }

                    function o(e) {
                        var n = e - b, r = e - w, i = t - n;
                        return T ? S(i, _ - r) : i
                    }

                    function c(e) {
                        var n = e - b, r = e - w;
                        return b === void 0 || n >= t || n < 0 || T && r >= _
                    }

                    function u() {
                        var e = C();
                        return c(e) ? d(e) : void (y = setTimeout(u, o(e)))
                    }

                    function d(e) {
                        return y = void 0, te && h ? r(e) : (h = g = void 0, v)
                    }

                    function f() {
                        y !== void 0 && clearTimeout(y), w = 0, h = b = g = y = void 0
                    }

                    function p() {
                        return y === void 0 ? v : d(C())
                    }

                    function m() {
                        var e = C(), n = c(e);
                        if (h = arguments, g = this, b = e, n) {
                            if (y === void 0) return a(b);
                            if (T) return y = setTimeout(u, t), r(b)
                        }
                        return y === void 0 && (y = setTimeout(u, t)), v
                    }

                    var h, g, _, v, y, b, w = 0, ee = !1, T = !1, te = !0;
                    if (typeof e != `function`) throw TypeError(l);
                    return t = s(t) || 0, i(n) && (ee = !!n.leading, T = `maxWait` in n, _ = T ? x(s(n.maxWait) || 0, t) : _, te = `trailing` in n ? !!n.trailing : te), m.cancel = f, m.flush = p, m
                }

                function r(e, t, r) {
                    var a = !0, o = !0;
                    if (typeof e != `function`) throw TypeError(l);
                    return i(r) && (a = `leading` in r ? !!r.leading : a, o = `trailing` in r ? !!r.trailing : o), n(e, t, {
                        leading: a,
                        maxWait: t,
                        trailing: o
                    })
                }

                function i(e) {
                    var t = e === void 0 ? `undefined` : c(e);
                    return !!e && (t == `object` || t == `function`)
                }

                function a(e) {
                    return !!e && (e === void 0 ? `undefined` : c(e)) == `object`
                }

                function o(e) {
                    return (e === void 0 ? `undefined` : c(e)) == `symbol` || a(e) && b.call(e) == d
                }

                function s(e) {
                    if (typeof e == `number`) return e;
                    if (o(e)) return u;
                    if (i(e)) {
                        var t = typeof e.valueOf == `function` ? e.valueOf() : e;
                        e = i(t) ? t + `` : t
                    }
                    if (typeof e != `string`) return e === 0 ? e : +e;
                    e = e.replace(f, ``);
                    var n = m.test(e);
                    return n || h.test(e) ? g(e.slice(2), n ? 2 : 8) : p.test(e) ? u : +e
                }

                var c = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function (e) {
                        return typeof e
                    } : function (e) {
                        return e && typeof Symbol == `function` && e.constructor === Symbol && e !== Symbol.prototype ? `symbol` : typeof e
                    }, l = `Expected a function`, u = NaN, d = `[object Symbol]`, f = /^\s+|\s+$/g,
                    p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, h = /^0o[0-7]+$/i, g = parseInt,
                    _ = (t === void 0 ? `undefined` : c(t)) == `object` && t && t.Object === Object && t,
                    v = (typeof self > `u` ? `undefined` : c(self)) == `object` && self && self.Object === Object && self,
                    y = _ || v || Function(`return this`)(), b = Object.prototype.toString, x = Math.max, S = Math.min,
                    C = function () {
                        return y.Date.now()
                    };
                e.exports = r
            }).call(t, function () {
                return this
            }())
        }, function (e, t) {
            (function (t) {
                function n(e, t, n) {
                    function i(t) {
                        var n = h, r = g;
                        return h = g = void 0, w = t, v = e.apply(r, n)
                    }

                    function a(e) {
                        return w = e, y = setTimeout(u, t), ee ? i(e) : v
                    }

                    function s(e) {
                        var n = e - C, r = e - w, i = t - n;
                        return T ? x(i, _ - r) : i
                    }

                    function l(e) {
                        var n = e - C, r = e - w;
                        return C === void 0 || n >= t || n < 0 || T && r >= _
                    }

                    function u() {
                        var e = S();
                        return l(e) ? d(e) : void (y = setTimeout(u, s(e)))
                    }

                    function d(e) {
                        return y = void 0, te && h ? i(e) : (h = g = void 0, v)
                    }

                    function f() {
                        y !== void 0 && clearTimeout(y), w = 0, h = C = g = y = void 0
                    }

                    function p() {
                        return y === void 0 ? v : d(S())
                    }

                    function m() {
                        var e = S(), n = l(e);
                        if (h = arguments, g = this, C = e, n) {
                            if (y === void 0) return a(C);
                            if (T) return y = setTimeout(u, t), i(C)
                        }
                        return y === void 0 && (y = setTimeout(u, t)), v
                    }

                    var h, g, _, v, y, C, w = 0, ee = !1, T = !1, te = !0;
                    if (typeof e != `function`) throw TypeError(c);
                    return t = o(t) || 0, r(n) && (ee = !!n.leading, T = `maxWait` in n, _ = T ? b(o(n.maxWait) || 0, t) : _, te = `trailing` in n ? !!n.trailing : te), m.cancel = f, m.flush = p, m
                }

                function r(e) {
                    var t = e === void 0 ? `undefined` : s(e);
                    return !!e && (t == `object` || t == `function`)
                }

                function i(e) {
                    return !!e && (e === void 0 ? `undefined` : s(e)) == `object`
                }

                function a(e) {
                    return (e === void 0 ? `undefined` : s(e)) == `symbol` || i(e) && y.call(e) == u
                }

                function o(e) {
                    if (typeof e == `number`) return e;
                    if (a(e)) return l;
                    if (r(e)) {
                        var t = typeof e.valueOf == `function` ? e.valueOf() : e;
                        e = r(t) ? t + `` : t
                    }
                    if (typeof e != `string`) return e === 0 ? e : +e;
                    e = e.replace(d, ``);
                    var n = p.test(e);
                    return n || m.test(e) ? h(e.slice(2), n ? 2 : 8) : f.test(e) ? l : +e
                }

                var s = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function (e) {
                        return typeof e
                    } : function (e) {
                        return e && typeof Symbol == `function` && e.constructor === Symbol && e !== Symbol.prototype ? `symbol` : typeof e
                    }, c = `Expected a function`, l = NaN, u = `[object Symbol]`, d = /^\s+|\s+$/g,
                    f = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, h = parseInt,
                    g = (t === void 0 ? `undefined` : s(t)) == `object` && t && t.Object === Object && t,
                    _ = (typeof self > `u` ? `undefined` : s(self)) == `object` && self && self.Object === Object && self,
                    v = g || _ || Function(`return this`)(), y = Object.prototype.toString, b = Math.max, x = Math.min,
                    S = function () {
                        return v.Date.now()
                    };
                e.exports = n
            }).call(t, function () {
                return this
            }())
        }, function (e, t) {
            function n(e) {
                var t = void 0, r = void 0;
                for (t = 0; t < e.length; t += 1) if (r = e[t], r.dataset && r.dataset.aos || r.children && n(r.children)) return !0;
                return !1
            }

            function r() {
                return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
            }

            function i() {
                return !!r()
            }

            function a(e, t) {
                var n = window.document, i = new (r())(o);
                s = t, i.observe(n.documentElement, {childList: !0, subtree: !0, removedNodes: !0})
            }

            function o(e) {
                e && e.forEach(function (e) {
                    var t = Array.prototype.slice.call(e.addedNodes), r = Array.prototype.slice.call(e.removedNodes);
                    if (n(t.concat(r))) return s()
                })
            }

            Object.defineProperty(t, `__esModule`, {value: !0});
            var s = function () {
            };
            t.default = {isSupported: i, ready: a}
        }, function (e, t) {
            function n(e, t) {
                if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`)
            }

            function r() {
                return navigator.userAgent || navigator.vendor || window.opera || ``
            }

            Object.defineProperty(t, `__esModule`, {value: !0});
            var i = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, `value` in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
                        }
                    }

                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t
                    }
                }(),
                a = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
                o = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
                s = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
                c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
            t.default = new (function () {
                function e() {
                    n(this, e)
                }

                return i(e, [{
                    key: `phone`, value: function () {
                        var e = r();
                        return !(!a.test(e) && !o.test(e.substr(0, 4)))
                    }
                }, {
                    key: `mobile`, value: function () {
                        var e = r();
                        return !(!s.test(e) && !c.test(e.substr(0, 4)))
                    }
                }, {
                    key: `tablet`, value: function () {
                        return this.mobile() && !this.phone()
                    }
                }]), e
            }())
        }, function (e, t) {
            Object.defineProperty(t, `__esModule`, {value: !0});
            var n = function (e, t, n) {
                var r = e.node.getAttribute(`data-aos-once`);
                t > e.position ? e.node.classList.add(`aos-animate`) : r !== void 0 && (r === `false` || !n && r !== `true`) && e.node.classList.remove(`aos-animate`)
            };
            t.default = function (e, t) {
                var r = window.pageYOffset, i = window.innerHeight;
                e.forEach(function (e, a) {
                    n(e, i + r, t)
                })
            }
        }, function (e, t, n) {
            function r(e) {
                return e && e.__esModule ? e : {default: e}
            }

            Object.defineProperty(t, `__esModule`, {value: !0});
            var i = r(n(12));
            t.default = function (e, t) {
                return e.forEach(function (e, n) {
                    e.node.classList.add(`aos-init`), e.position = (0, i.default)(e.node, t.offset)
                }), e
            }
        }, function (e, t, n) {
            function r(e) {
                return e && e.__esModule ? e : {default: e}
            }

            Object.defineProperty(t, `__esModule`, {value: !0});
            var i = r(n(13));
            t.default = function (e, t) {
                var n = 0, r = 0, a = window.innerHeight, o = {
                    offset: e.getAttribute(`data-aos-offset`),
                    anchor: e.getAttribute(`data-aos-anchor`),
                    anchorPlacement: e.getAttribute(`data-aos-anchor-placement`)
                };
                switch (o.offset && !isNaN(o.offset) && (r = parseInt(o.offset)), o.anchor && document.querySelectorAll(o.anchor) && (e = document.querySelectorAll(o.anchor)[0]), n = (0, i.default)(e).top, o.anchorPlacement) {
                    case`top-bottom`:
                        break;
                    case`center-bottom`:
                        n += e.offsetHeight / 2;
                        break;
                    case`bottom-bottom`:
                        n += e.offsetHeight;
                        break;
                    case`top-center`:
                        n += a / 2;
                        break;
                    case`bottom-center`:
                        n += a / 2 + e.offsetHeight;
                        break;
                    case`center-center`:
                        n += a / 2 + e.offsetHeight / 2;
                        break;
                    case`top-top`:
                        n += a;
                        break;
                    case`bottom-top`:
                        n += e.offsetHeight + a;
                        break;
                    case`center-top`:
                        n += e.offsetHeight / 2 + a
                }
                return o.anchorPlacement || o.offset || isNaN(t) || (r = t), n + r
            }
        }, function (e, t) {
            Object.defineProperty(t, `__esModule`, {value: !0}), t.default = function (e) {
                for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) t += e.offsetLeft - (e.tagName == `BODY` ? 0 : e.scrollLeft), n += e.offsetTop - (e.tagName == `BODY` ? 0 : e.scrollTop), e = e.offsetParent;
                return {top: n, left: t}
            }
        }, function (e, t) {
            Object.defineProperty(t, `__esModule`, {value: !0}), t.default = function (e) {
                return e ||= document.querySelectorAll(`[data-aos]`), Array.prototype.map.call(e, function (e) {
                    return {node: e}
                })
            }
        }])
    })
}))(), 1);

function co() {
    let [e] = jn(), t = e.get(`aid`) ?? ``;
    return (0, h.useEffect)(() => {
        so.default.init({duration: 800, once: !1})
    }, []), (0, I.jsxs)(`div`, {
        className: `tw:overflow-x-hidden tw:overflow-y-hidden`, children: [(0, I.jsxs)(`div`, {
            className: `tw:bg-linear-to-b tw:from-[#F2F5F9] tw:to-[#CED3DE]`, children: [(0, I.jsxs)(`div`, {
                className: `tw:xl:px-24 tw:px-3`, children: [(0, I.jsxs)(`section`, {
                    className: `relative tw:xl:pb-96 tw:md:pb-72 tw:pb-56`, children: [(0, I.jsxs)(`div`, {
                        children: [(0, I.jsx)(`div`, {
                            className: `tw:flex tw:flex-row tw:justify-center tw:pt-3`,
                            children: (0, I.jsx)(L, {
                                src: Jn,
                                alt: `heart logo`,
                                layout: `constrained`,
                                className: `tw:md:w-fit tw:md:h-fit tw:w-[80px]`
                            })
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex tw:flex-col tw:items-center tw:gap-y-4 tw:md:mt-32 tw:mt-20`,
                            children: [(0, I.jsxs)(`p`, {
                                className: `tw:uppercase tw:text-base tw:text-[#AB8856] tw:tracking-[0.25rem] tw:text-center`,
                                children: [`Vítejte v testovacím`, (0, I.jsx)(`br`, {className: `tw:md:hidden tw:block`}), ` programu`]
                            }), (0, I.jsx)(`div`, {
                                children: (0, I.jsxs)(`div`, {
                                    className: `tw:flex tw:flex-col tw:items-center tw:md:pt-0 tw:pt-8 tw:text-center`,
                                    children: [(0, I.jsx)(`h2`, {
                                        className: `tw:xl:text-9xl tw:md:text-7xl tw:text-5xl tw:font-medium tw:xl:tracking-[-0.50rem] tw:tracking-[-0.25rem] tw:xl:translate-x-[-7.3rem] tw:md:translate-x-[-4rem] tw:p-0 tw:text-[#132438] tw:whitespace-nowrap`,
                                        "data-aos": `fade-up`,
                                        children: `Vaše Srdcové Eso`
                                    }), (0, I.jsx)(`h2`, {
                                        className: `tw:xl:text-9xl tw:md:text-7xl tw:text-5xl tw:font-medium tw:xl:tracking-[-0.50rem] tw:tracking-[-0.25rem] tw:xl:translate-x-[13.8rem] tw:md:translate-x-[9.45rem] tw:p-0 tw:xl:-mt-4 tw:md:-mt-3 tw:-mt-2 tw:text-[#132438]`,
                                        "data-aos": `fade-up`,
                                        children: `bylo ověřeno.`
                                    })]
                                })
                            })]
                        })]
                    }), (0, I.jsx)(`img`, {
                        src: Yn,
                        alt: `heart left card`,
                        className: `tw:absolute tw:left-0 tw:z-[999] tw:top-[10%] tw:xl:h-96 tw:md:h-64 tw:h-32`,
                        "data-aos": `fade-right`,
                        "data-aos-duration": `1200`
                    }), (0, I.jsx)(`img`, {
                        src: Xn,
                        alt: `heart left card`,
                        className: `tw:absolute tw:right-0 tw:top-0 tw:z-[999] tw:xl:h-96 tw:md:h-64 tw:h-32`,
                        "data-aos": `fade-left`,
                        "data-aos-duration": `1200`
                    })]
                }), (0, I.jsx)(`section`, {
                    children: (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:md:flex-row tw:flex-col tw:gap-x-6 tw:h-full tw:md:gap-y-6 tw:gap-y-3`,
                        children: [(0, I.jsxs)(`div`, {
                            className: `iceberg-box tw:relative tw:md:w-1/2 tw:w-full tw:flex tw:flex-col tw:justify-end tw:rounded-3xl tw:overflow-visible tw:bg-white tw:pt-32 tw:h-[400px] tw:md:h-auto`,
                            children: [(0, I.jsxs)(`picture`, {
                                children: [(0, I.jsx)(`source`, {
                                    media: `(max-width:768px)`,
                                    srcSet: dr
                                }), (0, I.jsx)(L, {
                                    src: ur,
                                    layout: `constrained`,
                                    className: `tw:absolute tw:left-1/2 tw:top-0 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:w-[80%] tw:md:w-auto tw:z-10`
                                })]
                            }), (0, I.jsx)(`h3`, {
                                className: `tw:text-[#80CCDB] tw:font-semibold tw:xl:text-[64px] tw:lg:text-[48px] tw:text-[32px] tw:leading-tight tw:tracking-[-0.05em] tw:md:p-10 tw:p-6`,
                                "data-aos": `fade-up`,
                                children: `Přečtěte si, proč tento program vznikl a jaká jsou jeho pravidla.`
                            })]
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex tw:flex-col tw:md:w-1/2 tw:w-full tw:md:gap-y-6 tw:gap-y-3`,
                            children: [(0, I.jsxs)(`div`, {
                                className: `tw:md:h-1/2 tw:bg-[#FFFFFF] tw:rounded-3xl tw:md:p-10 tw:p-6 tw:flex tw:flex-col tw:justify-between tw:lg:gap-y-0 tw:md:gap-y-6 tw:gap-y-12 tw:h-[300px]`,
                                children: [(0, I.jsxs)(`p`, {
                                    className: `tw:xl:text-[24px] tw:xl:leading-[31px] tw:text-[#132438] tw:lg:text-[20px] tw:md:text-[16px] tw:text-[18px] tw:tracking-[-0.05em]`,
                                    "data-aos": `fade-up`,
                                    children: [`Právě jste získali přístup na uplatnění 50% dotace z ceny unikátního hořčíkového systému `, (0, I.jsx)(`span`, {
                                        className: `tw:font-bold tw:text-[#132438]`,
                                        children: `Ultimate Magnesium Complex`
                                    })]
                                }), (0, I.jsxs)(`p`, {
                                    className: `tw:text-[#8A8A8A] tw:text-right tw:lg:text-base tw:md:text-xs  tw:text-sm tw:tracking-[-0.05em]`,
                                    children: [(0, I.jsxs)(`span`, {
                                        className: `tw:flex tw:flex-row tw:justify-end tw:items-center tw:gap-x-2 `,
                                        children: [`Váš „švýcarský nůž“`, (0, I.jsx)(L, {
                                            src: $n,
                                            alt: `swiss flag`,
                                            className: `tw:pt-1`,
                                            layout: `constrained`
                                        })]
                                    }), `v oblasti suplementace hořčíku.`]
                                })]
                            }), (0, I.jsx)(`div`, {
                                className: `tw:flex tw:justify-center tw:items-center tw:overflow-hidden tw:bg-linear-to-b tw:from-[#CFD4DF] tw:to-[#FAFAFA] tw:md:flex-1 tw:rounded-3xl tw:md:min-h-0 tw:min-h-[222px] tw:md:p-10 tw:p-6`,
                                children: (0, I.jsxs)(`picture`, {
                                    className: `tw:flex tw:justify-center tw:items-center tw:w-full tw:h-full`,
                                    children: [(0, I.jsx)(`source`, {
                                        media: `(max-width:768px)`,
                                        srcSet: Qn
                                    }),
                                    (0, I.jsx)(L, {
                                        src: Zn,
                                        alt: `two bottles of ultimate magnesium complex`,
                                        className: `tw:block tw:w-full tw:h-auto tw:max-w-[520px] tw:max-h-full tw:object-contain tw:mx-auto tw:self-center tw:shrink-0`,
                                        style: {width: `100%`, height: `auto`, objectFit: `contain`, alignSelf: `center`}
                                    })
                                ]
                                })
                            })]
                        })]
                    })
                }), (0, I.jsxs)(`section`, {
                    className: `tw:md:pt-12 tw:py-8 tw:flex tw:flex-col tw:md:gap-y-6 tw:gap-y-8`,
                    children: [(0, I.jsxs)(`div`, {
                        className: `tw:flex tw:md:flex-row tw:flex-col tw:bg-[#FAFAFA] tw:rounded-3xl`,
                        children: [(0, I.jsxs)(`div`, {
                            className: `tw:md:w-1/2 tw:w-full tw:flex tw:flex-col tw:bg-[#FFFFFF] tw:md:p-10 tw:p-6 tw:rounded-3xl tw:lg:gap-y-8 tw:gap-y-4 tw:shadow-[2px_0_15px_rgba(0,0,0,0.25)] tw:justify-between tw:md:h-auto tw:h-[450px]`,
                            children: [(0, I.jsx)(`h4`, {
                                className: `tw:lg:text-5xl tw:text-3xl tw:text-[#132438] tw:font-semibold tw:tracking-[-0.05em]`,
                                children: `Logika testování`
                            }), (0, I.jsxs)(`p`, {
                                className: `tw:lg:leading-loose tw:leading-relaxed tw:text-[#132438] tw:md:text-lg tw:text-base tw:tracking-[-0.05em] tw:font-light`,
                                "data-aos": `fade-up`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `Místo TV reklamy investujeme do Vás`
                                }), `. Uvedení prémiového produktu na trh obvykle provází masivní televizní kampaně. Švýcarská centrála se však rozhodla pro odlišný přístup. Rozpočet na reklamu jsme přesměrovali přímo k Vám – koncovým uživatelům.`]
                            }), (0, I.jsxs)(`div`, {
                                className: `tw:flex tw:flex-row tw:justify-between tw:items-end`,
                                children: [(0, I.jsx)(`h6`, {
                                    className: `tw:text-[#F2F5F9] tw:lg:text-[220px] tw:md:text-[110px]  tw:text-[150px] tw:leading-none tw:lg:tracking-[-1rem] tw:md:tracking-[-0.5rem] tw:tracking-[-0.9rem]`,
                                    children: `01`
                                }), (0, I.jsx)(`p`, {
                                    className: `tw:uppercase tw:md:text-base tw:text-sm tw:text-[#AB8856] tw:tracking-[0.15em] tw:text-right`,
                                    children: `proč to děláme?`
                                })]
                            })]
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex tw:flex-col tw:md:w-1/2 tw:md:p-10 tw:p-6 tw:pl-6 tw:lg:gap-y-8 tw:gap-y-4 `,
                            children: [(0, I.jsx)(`div`, {
                                className: `tw:flex tw:flex-row tw:justify-end tw:xl:mb-12 tw:md:mb-0 tw:mb-3 tw:mt-3 tw:md:mt-0`,
                                children: (0, I.jsx)(`img`, {src: er, className: `tw:lg:w-12 tw:w-6`})
                            }), (0, I.jsx)(`h5`, {
                                className: `tw:lg:text-3xl tw:text-xl tw:text-[#132438] tw:font-semibold tw:tracking-[-0.05em]`,
                                children: `Proč potřebujeme „zkušební jezdce“ tohoto Rolls-Royce mezi hořčíky?`
                            }), (0, I.jsxs)(`p`, {
                                className: `tw:lg:leading-loose tw:leading-relaxed tw:text-[#132438] tw:md:text-lg tw:text-base tw:font-light tw:tracking-[-0.05em]`,
                                "data-aos": `fade-up`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `Náš cíl je jednoduchý:`
                                }), ` Získat reálná data od reálných uživatelů. Vaše upřímná zpětná vazba a pocity z užívání nám v budoucnu pomohou mnohem přesněji a autentičtěji cílit náš marketing. My Vám poskytneme `, (0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `50%`
                                }), ` dotaci na špičkový produkt, Vy nám po využívání produktu poskytnete svůj upřímný názor a recenzi. Je to transparentní, oboustranně výhodná win-win dohoda bez jakýchkoliv skrytých podmínek.`]
                            })]
                        })]
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:md:flex-row tw:flex-col tw:bg-[#FAFAFA] tw:rounded-3xl tw:relative tw:z-[999]`,
                        children: [(0, I.jsxs)(`div`, {
                            className: `tw:md:w-1/2 tw:w-full tw:flex tw:flex-col tw:bg-[#FFFFFF] tw:md:p-10 tw:p-6 tw:rounded-3xl tw:lg:gap-y-8 tw:gap-y-4 tw:shadow-[2px_0_15px_rgba(0,0,0,0.25)] tw:justify-between tw:md:h-auto tw:h-[450px]`,
                            children: [(0, I.jsx)(`h4`, {
                                className: `tw:lg:text-5xl tw:text-3xl tw:text-[#132438] tw:font-semibold tw:text-[#132438] tw:tracking-[-0.05em]`,
                                children: `Produkt`
                            }), (0, I.jsxs)(`p`, {
                                className: `tw:lg:leading-loose tw:leading-relaxed tw:text-[#132438] tw:md:text-lg tw:text-base tw:tracking-[-0.05em] tw:font-light`,
                                "data-aos": `fade-up`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `Receptura, která mění pravidla hry.`
                                }), ` Většina levných hořčíků končí bez většího užitku vyloučena z těla. Výrobci často používaní levné oxidy, sírany, uhličitany hořčíku, které mají velmi nízkou vstřebatelnost (do 10%) a často způsobují průjem, protože jde o anorganické sloučeniny a tělo si s nimi jednoduše neumí poradit.`]
                            }), (0, I.jsxs)(`div`, {
                                className: `tw:flex tw:flex-row tw:justify-between tw:items-end`,
                                children: [(0, I.jsx)(`h6`, {
                                    className: `tw:text-[#EEEAEC] tw:lg:text-[220px] tw:md:text-[110px]  tw:text-[150px] tw:leading-none tw:lg:tracking-[-1rem] tw:md:tracking-[-0.5rem] tw:tracking-[-1.2rem]`,
                                    children: `02`
                                }), (0, I.jsx)(`p`, {
                                    className: `tw:uppercase tw:md:text-base tw:text-sm tw:text-[#AB8856] tw:tracking-[0.15em] tw:text-right tw:md:pl-0 tw:pl-4`,
                                    children: `ultimátní magnésium`
                                })]
                            })]
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex tw:flex-col tw:md:w-1/2 tw:md:p-10 tw:p-6 tw:pl-6 tw:lg:gap-y-8 tw:gap-y-4`,
                            children: [(0, I.jsx)(`div`, {
                                className: `tw:flex tw:flex-row tw:justify-end tw:xl:mb-12 tw:md:mb-0 tw:mb-3 tw:mt-3 tw:md:mt-0`,
                                children: (0, I.jsx)(`img`, {src: er, className: `tw:lg:w-12 tw:w-6`})
                            }), (0, I.jsx)(`h5`, {
                                className: `tw:lg:text-3xl tw:text-xl tw:text-[#132438] tw:font-semibold tw:tracking-[-0.05em]`,
                                children: `Proč je Ultimate Magnesium Complex Rolls-Royce mezi hořčíkovými doplňky?`
                            }), (0, I.jsxs)(`p`, {
                                className: `tw:lg:leading-loose tw:leading-relaxed tw:text-[#132438] tw:md:text-lg tw:text-base tw:tracking-[-0.05em] tw:font-light`,
                                "data-aos": `fade-up`,
                                children: [`Receptura `, (0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `Ultimate Magnesium Complex`
                                }), ` je postavena na nejnovějších poznatcích moderní vědy. Respektuje fakt, že Vaše tělo potřebuje různé druhy chelátových forem hořčíku a také se liší efektivita příjmu různých druhů v určitou denní dobu. Proto byl vyvinut `, (0, I.jsx)(`strong`, {
                                    className: `tw:font-bold`,
                                    children: `dvoufázový hořčíkový systém s celkem 8 formami hořčíku s vysokou mírou vstřebatelnosti do organizmu - Ultimate Magnesium Complex (Day&Night Formula).`
                                })]
                            })]
                        })]
                    })]
                })]
            }), (0, I.jsxs)(`section`, {
                className: `iceberg-bg tw:md:py-0 tw:py-[70px] tw:xl:-mt-36`, children: [(0, I.jsxs)(`div`, {
                    className: `tw:relative tw:z-[999] tw:flex tw:flex-col tw:items-center tw:xl:h-[30%] tw:xl:pt-48 tw:lg:h-[29%] tw:md:h-[29%] tw:lg:pt-12 tw:md:pt-8 tw:md:mt-[0px] tw:mt-[-45px] tw:md:mb-0 tw:mb-[55px]`,
                    children: [(0, I.jsx)(`div`, {
                        className: `tw:flex tw:md:justify-center`,
                        children: (0, I.jsxs)(`picture`, {
                            children: [(0, I.jsx)(`source`, {
                                media: `(max-width:768px)`,
                                srcSet: rr
                            }), (0, I.jsx)(L, {
                                src: nr,
                                alt: `process flow`,
                                layout: `constrained`,
                                className: `tw:relative tw:top-0 tw:xl:w-full tw:md:w-[90%] tw:md:h-[70%] tw:lg:h-auto`
                            })]
                        })
                    }), (0, I.jsxs)(`h4`, {
                        className: `tw:lg:text-4xl tw:text-2xl tw:text-[#132438] tw:font-normal tw:text-[#132438] tw:tracking-[-0.05em] tw:md:pt-0 tw:pt-6 tw:text-center`,
                        children: [`Unikátní `, (0, I.jsx)(`span`, {
                            className: `tw:font-bold tw:italic`,
                            children: `dvou-fázové`
                        }), ` dávkování`]
                    }), (0, I.jsxs)(`h5`, {
                        className: `tw:lg:text-2xl tw:text-lg tw:text-[#132438] tw:font-normal tw:text-[#132438] tw:tracking-[-0.05em] tw:text-center`,
                        children: [`rozděluje účinné složky podle biologických`, (0, I.jsx)(`br`, {}), ` potřeb těla ve dne a v noci`]
                    })]
                }), (0, I.jsx)(`div`, {
                    className: `tw:relative tw:z-[999] tw:xl:h-1/5 tw:lg:h-[28%] tw:md:h-[28%] tw:h-auto tw:md:mt-0 tw:mt-24`,
                    children: (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:md:flex-row tw:flex-col  tw:h-full tw:w-auto tw:relative`,
                        children: [(0, I.jsx)(`div`, {className: `tw:inset-0 tw:w-full tw:absolute tw:bg-[#F2F5F9]/1 tw:backdrop-blur-[3px] tw:xl:h-[62.8%] tw:xl:top-[29%] tw:top-[21.6%] tw:h-[47.2%] tw:border-t-1 tw:border-b-1 tw:border-[#DCDCDC] tw:md:block tw:hidden`}), (0, I.jsx)(`div`, {
                            className: `flex-initial tw:md:h-auto tw:md:relative tw:absolute tw:h-[200px] tw:right-0 tw:md:top-0 tw:top-[-65px] tw:xl:pl-24 tw:pl-0`,
                            children: (0, I.jsx)(L, {
                                "data-aos": `fade-right`,
                                src: ir,
                                className: `tw:block tw:w-auto tw:h-auto tw:max-w-full tw:max-h-full tw:object-contain tw:relative tw:z-[999] tw:shrink-0`,
                                style: {width: `auto`, height: `auto`, maxWidth: `100%`, maxHeight: `100%`, objectFit: `contain`, flexShrink: 0},
                                layout: `constrained`
                            })
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex-1 tw:flex tw:flex-col tw:relative
            tw:xl:top-[29%] tw:xl:h-[62.8%]
            tw:top-[21.6%] tw:h-[47.2%]
            tw:xl:py-6 tw:lg:py-3 tw:md:py-1.5 tw:py-6
            tw:xl:gap-y-6 tw:lg:gap-y-3 tw:md:gap-y-0 tw:gap-y-3
            tw:bg-[#F2F5F9]/1 tw:md:backdrop-blur-[0px] tw:backdrop-blur-[3px] tw:xl:py-24 tw:xl:pr-24 tw:py-6 tw:pr-3 tw:md:pl-0 tw:pl-3 tw:border-t-1 tw:border-b-1 tw:border-[#DCDCDC] tw:md:border-t-0 tw:justify-center
            `, children: [(0, I.jsxs)(`div`, {
                                className: `tw:flex tw:flex-row tw:md:flex-col tw:gap-2 tw:lg:gap-4 tw:md:items-start tw:items-start`,
                                children: [(0, I.jsx)(`div`, {
                                    className: `tw:rounded-full
                    tw:w-[32px] tw:h-[32px] tw:bg-[#BB984F]`
                                }), (0, I.jsxs)(`div`, {
                                    className: `tw:w-[200px] tw:md:w-full tw:tracking-[-0.05em]`,
                                    children: [(0, I.jsx)(`h6`, {
                                        className: `tw:xl:text-3xl tw:lg:text-2xl tw:text-2xl
                       tw:text-[#132438] tw:font-medium`, children: `Day Formula`
                                    }), (0, I.jsx)(`p`, {
                                        className: `tw:xl:text-xl tw:text-lg
                      tw:font-medium tw:text-[#132438]`, children: `Ranní fokus a energie`
                                    })]
                                })]
                            }), (0, I.jsx)(`div`, {
                                children: (0, I.jsxs)(`p`, {
                                    className: `tw:text-[#132438] tw:lg:font-light tw:lg:text-lg tw:md:text-sm tw:text-base
                  tw:xl:leading-loose tw:lg:leading-relaxed
                  tw:md:leading-loose tw:leading-relaxed tw:tracking-[-0.05em]`,
                                    children: [`Základem je patentovaný přírodní `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `hořčík Aquamin Mg®`
                                    }), `, který se získává z mořské vody, doplněný o energizující formy hořčíku (`, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `malát, pidolát, pyruvát, sukcinát`
                                    }), `). Formule je obohacena o `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `extrakt z Ashwagandhy`
                                    }), ` pro odolnost vůči stresu a aktivní `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `vitamín B6 (P-5-P)`
                                    }), ` pro nastartování nervové soustavy.`]
                                })
                            })]
                        })]
                    })
                }), (0, I.jsx)(`div`, {
                    className: `tw:relative tw:z-[999] tw:w-full tw:xl:h-[7%] tw:lg:h-[10%] tw:md:h-[11%] tw:xl:mt-0 tw:lg:-mt-28 tw:md:-mt-12 tw:mt-24`,
                    children: (0, I.jsx)(`div`, {
                        className: `tw:flex tw:flex-row tw:justify-end tw:xl:px-24 tw:px-3 tw:w-full`,
                        children: (0, I.jsxs)(`div`, {
                            className: `tw:flex tw:flex-col tw:xl:gap-y-6 tw:lg:gap-y-3 tw:md:gap-y-1.5 tw:gap-y-3 tw:bg-[#FFFFFF] tw:rounded-3xl tw:md:p-10 tw:p-6 tw:md:w-[60%] tw:md:items-start tw:items-center tw:justify-center`,
                            children: [(0, I.jsx)(`div`, {
                                children: (0, I.jsx)(L, {
                                    src: tr,
                                    className: `tw:w-[32px] tw:h-[32px]`
                                })
                            }), (0, I.jsxs)(`div`, {
                                className: `tw:tracking-[-0.05em]`,
                                children: [(0, I.jsx)(`h6`, {
                                    className: `tw:xl:text-3xl tw:lg:text-2xl tw:text-2xl tw:text-[#132438] tw:font-medium tw:lg:pt-0 tw:pt-2`,
                                    children: `D3 + K2 jako navigace`
                                }), (0, I.jsx)(`p`, {
                                    className: `tw:xl:text-xl tw:text-lg tw:font-medium tw:text-[#132438] tw:md:text-left tw:text-center`,
                                    children: `Unikátní obsah obou dávek`
                                })]
                            }), (0, I.jsx)(`div`, {
                                children: (0, I.jsxs)(`p`, {
                                    className: `tw:text-[#132438] tw:lg:font-light tw:lg:text-lg tw:md:text-sm tw:text-base
                  tw:xl:leading-loose tw:lg:leading-relaxed
                  tw:md:leading-loose tw:leading-relaxed tw:tracking-[-0.05em]`,
                                    children: [`Obě dávky také obsahují klíčové `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `vitamíny D3+K2`
                                    }), `, které zajišťují, že se `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `hořčík a vápník`
                                    }), ` dostanou přesně tam, kam mají, tedy do buněk a kostí a neusazují se v cévách.`]
                                })
                            })]
                        })
                    })
                }), (0, I.jsx)(`div`, {
                    className: `tw:relative tw:z-[999] tw:xl:h-1/5 tw:lg:h-[28%] tw:md:h-[28%] tw:xl:mt-0 tw:lg:mt-16 tw:md:mt-12 tw:md:pt-0 tw:pt-24`,
                    children: (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:md:flex-row tw:flex-col  tw:h-full tw:w-auto tw:relative`,
                        children: [(0, I.jsx)(`div`, {className: `tw:inset-0 tw:w-full tw:absolute tw:bg-[#F2F5F9]/1 tw:backdrop-blur-[3px] tw:xl:h-[62.8%] tw:xl:top-[29%] tw:top-[21.6%] tw:h-[47.2%] tw:border-t-1 tw:border-b-1 tw:border-[#005075] tw:md:block tw:hidden`}), (0, I.jsx)(`div`, {
                            className: `flex-initial tw:md:h-auto tw:md:relative tw:absolute tw:h-[200px] tw:right-0 tw:md:top-0 tw:top-[-65px] tw:xl:pl-24 tw:xl:pr-8 tw:px-3`,
                            children: (0, I.jsx)(L, {
                                "data-aos": `fade-right`,
                                src: ar,
                                className: `tw:block tw:w-auto tw:h-auto tw:max-w-full tw:max-h-full tw:object-contain tw:relative tw:z-[999] tw:shrink-0`,
                                style: {width: `auto`, height: `auto`, maxWidth: `100%`, maxHeight: `100%`, objectFit: `contain`, flexShrink: 0},
                                layout: `constrained`
                            })
                        }), (0, I.jsxs)(`div`, {
                            className: `tw:flex-1 tw:flex tw:flex-col tw:relative
            tw:xl:top-[29%] tw:xl:h-[62.8%]
            tw:top-[21.6%] tw:h-[47.2%]
            tw:xl:py-6 tw:lg:py-3 tw:md:py-1.5 tw:py-6
            tw:xl:gap-y-6 tw:lg:gap-y-3 tw:md:gap-y-0 tw:gap-y-3
            tw:bg-[#F2F5F9]/1 tw:md:backdrop-blur-[0px] tw:backdrop-blur-[3px] tw:xl:pr-24 tw:xl:py-24 tw:pr-3 tw:md:pl-0 tw:pl-3 tw:py-6  tw:border-t-1 tw:border-b-1 tw:border-[#005075] tw:md:border-t-0 tw:justify-center
            `, children: [(0, I.jsxs)(`div`, {
                                className: `tw:flex tw:flex-row tw:md:flex-col tw:gap-2 tw:lg:gap-4 tw:md:items-start tw:items-start`,
                                children: [(0, I.jsx)(`div`, {
                                    children: (0, I.jsx)(L, {
                                        src: lr,
                                        className: `tw:w-[32px] tw:h-[32px]`
                                    })
                                }), (0, I.jsxs)(`div`, {
                                    className: `tw:w-[200px] tw:md:w-full tw:tracking-[-0.05em]`,
                                    children: [(0, I.jsx)(`h6`, {
                                        className: `tw:xl:text-3xl tw:lg:text-2xl tw:text-2xl
                       tw:text-[#FFFFFF] tw:font-medium`, children: `Night Formula`
                                    }), (0, I.jsx)(`p`, {
                                        className: `tw:xl:text-xl tw:text-lg
                      tw:font-medium tw:text-[#FFFFFF]`, children: `Hluboká regenerace`
                                    })]
                                })]
                            }), (0, I.jsx)(`div`, {
                                children: (0, I.jsxs)(`p`, {
                                    className: `tw:text-[#FFFFFF] tw:lg:font-light tw:lg:text-lg tw:md:text-sm tw:text-base
                  tw:xl:leading-loose tw:lg:leading-relaxed
                  tw:md:leading-loose tw:leading-relaxed tw:tracking-[-0.05em]`,
                                    children: [`Večerní pohodu a relaxaci zajišťují zklidňující formy hořčíku `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `bisglycinát, taurát a laktát`
                                    }), `. Pro dokonalé uvolnění hlavy a svalů před spánkem receptura také obsahuje `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `L-Tryptofan`
                                    }), ` a extrakt z `, (0, I.jsx)(`strong`, {
                                        className: `tw:font-semibold`,
                                        children: `Meduňky lékařské`
                                    }), `.`]
                                })
                            })]
                        })]
                    })
                })]
            })]
        }), (0, I.jsxs)(`div`, {
            className: `tw:relative tw:xl:px-24 tw:bg-linear-to-b tw:from-[#000B16] tw:to-[#050D14]`,
            children: [(0, I.jsxs)(`div`, {
                className: `tw:mb-24 tw:xl:-mt-96 tw:md:-mt-32 tw:md:pt-0 tw:pt-12 tw:relative`,
                children: [(0, I.jsxs)(`picture`, {
                    children: [(0, I.jsx)(`source`, {
                        media: `(max-width:1280px)`,
                        srcSet: pr
                    }), (0, I.jsx)(L, {
                        src: fr,
                        alt: `seaweed left`,
                        className: `tw:absolute tw:z-[1000] tw:left-0 tw:xl:-ml-24 tw:xl:h-[784px] tw:h-[327px] tw:top-[-100px]`
                    })]
                }), (0, I.jsxs)(`picture`, {
                    children: [(0, I.jsx)(`source`, {
                        media: `(max-width:1280px)`,
                        srcSet: hr
                    }), (0, I.jsx)(L, {
                        src: mr,
                        alt: `seaweed left`,
                        className: `tw:absolute tw:z-[1002] tw:right-0 tw:xl:-mr-24 tw:xl:h-[784px] tw:h-[327px] tw:bottom-[-215px]`
                    })]
                }), (0, I.jsx)(`section`, {
                    className: `tw:flex tw:lg:justify-center`,
                    children: (0, I.jsxs)(`picture`, {
                        className: `tw:w-full`,
                        children: [(0, I.jsx)(`source`, {
                            media: `(max-width:768px)`,
                            srcSet: sr
                        }), (0, I.jsx)(L, {
                            src: or,
                            alt: `magnesium graph`,
                            className: `tw:relative tw:z-[1001] tw:w-full tw:lg:w-auto tw:mx-auto`
                        })]
                    })
                })]
            }), (0, I.jsxs)(`div`, {
                className: `tw:flex tw:md:flex-row tw:flex-col tw:bg-[#FAFAFA] tw:rounded-3xl tw:relative tw:z-[999] tw:mx-3 `,
                children: [(0, I.jsxs)(`div`, {
                    className: `tw:md:w-1/2 tw:w-full tw:flex tw:flex-col tw:bg-[#FFFFFF] tw:md:p-10 tw:p-6 tw:rounded-3xl tw:lg:gap-y-8 tw:gap-y-4 tw:shadow-[2px_0_15px_rgba(0,0,0,0.25)] tw:justify-between tw:md:h-auto tw:h-[450px]`,
                    children: [(0, I.jsx)(`h4`, {
                        className: `tw:lg:text-5xl tw:text-3xl tw:text-[#132438] tw:font-semibold tw:text-[#132438] tw:tracking-[-0.05em]`,
                        children: `Pravidla spolupráce`
                    }), (0, I.jsxs)(`p`, {
                        className: `tw:lg:leading-loose tw:leading-relaxed tw:text-[#132438] tw:md:text-lg tw:text-base tw:tracking-[-0.05em] tw:font-light`,
                        "data-aos": `fade-up`,
                        children: [(0, I.jsx)(`strong`, {
                            className: `tw:font-bold`,
                            children: `Pravidla a proces získání dotace`
                        }), ` je velmi jednoduchý a plně ve vašich rukou:`]
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:flex-row tw:justify-between tw:items-end tw:lg:mt-24 tw:mt-12 tw:w-full`,
                        children: [(0, I.jsx)(`h6`, {
                            className: `tw:text-[#F2F5F9] tw:lg:text-[220px] tw:md:text-[110px]  tw:text-[150px] tw:leading-none tw:lg:tracking-[-1rem] tw:md:tracking-[-0.5rem] tw:tracking-[-1.2rem]`,
                            children: `03`
                        }), (0, I.jsx)(`p`, {
                            className: `tw:uppercase tw:md:text-base tw:text-sm tw:text-[#AB8856] tw:tracking-[0.15em] tw:text-right tw:md:pl-0 tw:pl-4`,
                            children: `Jak dotaci uplatnit`
                        })]
                    })]
                }), (0, I.jsxs)(`div`, {
                    className: `tw:flex tw:flex-col tw:lg:gap-y-8 tw:gap-y-4 tw:md:w-1/2 tw:w-full tw:md:p-10 tw:p-6`,
                    children: [(0, I.jsx)(`div`, {
                        className: `tw:flex tw:flex-row tw:justify-end tw:xl:mb-12 tw:md:mb-0 tw:mb-3 tw:mt-3 tw:md:mt-0`,
                        children: (0, I.jsx)(`img`, {src: er, className: `tw:lg:w-12 tw:w-6`})
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:flex-row tw:gap-x-8`,
                        "data-aos": `fade-up`,
                        children: [(0, I.jsxs)(`div`, {
                            className: `tw:relative`,
                            children: [(0, I.jsx)(`div`, {
                                className: `tw:bg-[#BB984F] tw:h-[32px] tw:w-[32px] tw:flex tw:justify-center tw:items-center tw:text-[#FFFFFF] tw:rounded-full`,
                                children: `1`
                            }), (0, I.jsx)(`div`, {className: `tw:w-[1px] tw:h-full tw:bg-[#BB984F] tw:absolute tw:left-1/2 tw:-translate-x-1/2`})]
                        }), (0, I.jsx)(`div`, {
                            children: (0, I.jsxs)(`p`, {
                                className: `tw:text-[#132438] tw:font-light tw:md:text-base tw:text-sm tw:tracking-[-0.05em]`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-semibold`,
                                  children: `Výběr produktu:`
                                        }), ` Na e-shopu si zvolíte `, (0, I.jsx)(`strong`, {
                                     className: `tw:font-semibold`,
                                     children: `Ultimate Magnesium Complex 2×60 kapslí`
                                    }), ` (měsíční kúra) nebo `, (0, I.jsx)(`strong`, {
                                    className: `tw:font-semibold`,
                                     children: `Ultimate Magnesium Complex 2×120 kapslí`
                                    }), ` (dvouměsíční kúra). Na vybrané balení lze v rámci testování uplatnit `, (0, I.jsx)(`strong`, {
                                     className: `tw:font-semibold`,
                                    children: `50% dotaci.`
                                    }), ` Dotaci je možné využít `, (0, I.jsx)(`strong`, {
                                       className: `tw:font-semibold`,
                                     children: `pouze jednou na osobu.`
                                    })]
                            })
                        })]
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:flex-row tw:gap-x-8`,
                        "data-aos": `fade-up`,
                        children: [(0, I.jsxs)(`div`, {
                            className: `tw:relative`,
                            children: [(0, I.jsx)(`div`, {
                                className: `tw:bg-[#BB984F] tw:h-[32px] tw:w-[32px] tw:flex tw:justify-center tw:items-center tw:text-[#FFFFFF] tw:rounded-full`,
                                children: `2`
                            }), (0, I.jsx)(`div`, {className: `tw:w-[1px] tw:h-full tw:bg-[#BB984F] tw:absolute tw:left-1/2 tw:-translate-x-1/2`})]
                        }), (0, I.jsx)(`div`, {
                            children: (0, I.jsxs)(`p`, {
                                className: `tw:text-[#132438] tw:font-light tw:md:text-base tw:text-sm tw:tracking-[-0.05em]`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-semibold`,
                                    children: `Aktivace dotace:`
                                }), ` Ve spodní části této stránky se prokliknete do partnerského e-shopu SwissMedicus. Vyberete produkt `, (0, I.jsx)(`strong`, {
                                    className: `tw:font-semibold`,
                                    children: `Ultimate Magnesium Complex `
                                }), ` a sleva se Vám`,(0, I.jsx)(`strong`, {className: `tw:font-semibold`, children: ` automaticky aplikuje v košíku. `}), `Dotace se vztahuje výhradně na `, (0, I.jsx)(`strong`, {className: `tw:font-semibold`, children: `1 balení na osobu.`})]
                            })
                        })]
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:flex tw:flex-row tw:gap-x-8`,
                        "data-aos": `fade-up`,
                        children: [(0, I.jsx)(`div`, {
                            children: (0, I.jsx)(`div`, {
                                className: `tw:bg-[#BB984F] tw:h-[32px] tw:w-[32px] tw:flex tw:justify-center tw:items-center tw:text-[#FFFFFF] tw:rounded-full`,
                                children: `3`
                            })
                        }), (0, I.jsx)(`div`, {
                            children: (0, I.jsxs)(`p`, {
                                className: `tw:text-[#132438] tw:font-light tw:md:text-base tw:text-sm tw:tracking-[-0.05em]`,
                                children: [(0, I.jsx)(`strong`, {
                                    className: `tw:font-semibold`,
                                    children: `Váš závazek:`
                                }), ` Před dokončením objednávky Vás požádáme o souhlas s testováním. Po dobrání produktu se tím zavazujete věnovat nám cca 5 minut času – vyplnit krátký dotazník (10 otázek) a zanechat nám Vaši upřímnou recenzi.`]
                            })
                        })]
                    })]
                })]
            })]
        }), (0, I.jsx)(`div`, {
            className: `bg-blue-white tw:lg:pb-32 tw:md:pb-16 tw:pb-8 tw:pt-16 tw:relative tw:lg:px-24 tw:px-3`,
            children: (0, I.jsx)(`section`, {
                className: `tw:relative tw:w-full`, children: (0, I.jsxs)(`div`, {
                    className: `tw:w-full`,
                    children: [(0, I.jsx)(`h3`, {
                        className: `tw:text-[#AB8856] tw:font-semibold tw:xl:text-[64px] tw:lg:text-[48px] tw:md:text-[46px] tw:text-[44px] tw:font-medium tw:leading-none tw:lg:p-6 tw:text-center tw:tracking-[-0.05em]`,
                        children: `Rozhodnutí je nyní na Vás`
                    }), (0, I.jsxs)(`p`, {
                        className: `tw:lg:text-2xl tw:md:text-xl tw:text-lg tw: tw:text-[#FFFFFF] tw:text-center tw:font-light tw:lg:leading-loose tw:leading-relaxed tw:lg:mt-8 tw:mt-4 tw:tracking-[-0.05em]`,
                        children: [`Máte zájem stát se součástí našeho testovacího programu a`, (0, I.jsx)(`br`, {className: `tw:md:block tw:hidden`}), ` vyzkoušet rozdíl, který přináší širokospektrální hořčíkový komplex?`]
                    }), (0, I.jsx)(`div`, {
                        className: `tw:flex tw:flex-row tw:justify-center tw:items-center`,
                        children: (0, I.jsx)(L, {
                            src: cr,
                            alt: `ultimate magnesium complex box`,
                            layout: `constrained`,
                            className: `tw:scale-75`
                        })
                    }), (0, I.jsxs)(`div`, {
                        className: `tw:grid tw:grid-rows-2 tw:grid-cols-2 tw:lg:grid-rows-1 tw:lg:grid-cols-3 tw:gap-y-4 tw:lg:gap-x-4 tw:items-center`,
                        children: [(0, I.jsx)(`div`, {
                            className: `tw:order-2 tw:lg:order-1 tw:flex tw:justify-center tw:w-full`,
                            children: (0, I.jsxs)(`p`, {
                                className: `tw:font-light tw:text-[#FFFFFF] tw:opacity-[0.7] tw:text-center tw:lg:text-base tw:text-xs tw:tracking-[-0.05em] tw:lg:w-full tw:w-[50%]`,
                                children: [`nemám zájem o `, (0, I.jsx)(`br`, {className: `tw:lg:block tw:hidden`}), `testování`]
                            })
                        }), (0, I.jsx)(`div`, {
                            className: `tw:order-1 tw:lg:order-2 tw:col-span-2 tw:lg:col-span-1`,
                            children: (0, I.jsxs)(`div`, {
                                className: `tw:w-full tw:flex`,
                                children: [(0, I.jsx)(`a`, {
                                    href: `/`,
                                    className: `tw:w-1/2 tw:text-center tw:rounded-s-4xl tw:border tw:border-[#FFFFFF] tw:lg:py-4 tw:py-4 tw:opacity-[0.7] tw:hover:opacity-[1]`,
                                    children: (0, I.jsx)(`div`, {
                                        children: (0, I.jsx)(`p`, {
                                            className: `tw:uppercase tw:font-light tw:text-[#FFFFFF] tw:lg:text-base tw:text-xs tw:tracking-[-0.05em]`,
                                            children: `Odejít`
                                        })
                                    })
                                }), (0, I.jsx)(`a`, {
                                    href: `https://www.swissmedicus.cz/products/ultimate-magnesium-complex?variant=52549638750555&tid=2497110acbbcd22151cb472b511db7db&aid=${t}`,
                                    className: `tw:w-1/2 tw:text-center tw:bg-[#FFFFFF] tw:rounded-e-4xl tw:border tw:border-[#FFFFFF] tw:lg:py-4 tw:py-4 tw:transition-all tw:duration-300 tw:hover:shadow-[0_0_30px_rgba(255,255,255,1)]`,
                                    children: (0, I.jsx)(`div`, {
                                        children: (0, I.jsx)(`p`, {
                                            className: `tw:uppercase tw:font-medium tw:lg:text-base tw:text-xs tw:tracking-[-0.05em]`,
                                            children: `Vstoupit`
                                        })
                                    })
                                })]
                            })
                        }), (0, I.jsx)(`div`, {
                            className: `tw:order-3 tw:flex tw:justify-center`,
                            children: (0, I.jsxs)(`p`, {
                                className: `tw:lg:font-light tw:font-regular tw:text-[#FFFFFF] tw:text-center tw:lg:text-base tw:text-xs tw:tracking-[-0.05em] tw:lg:w-full tw:w-[80%]`,
                                children: [`chci být “zkušebním jezdcem” a`, (0, I.jsx)(`br`, {className: `tw:lg:block tw:hidden`}), ` získat 50% dotaci`]
                            })
                        })]
                    })]
                })
            })
        })]
    })
}

(0, qn.createRoot)(document.getElementsByTagName(`body`)[0]).render((0, I.jsx)(bn, {children: (0, I.jsx)(co, {})}));